module.exports = {
    BubblesData: () => {
        return [
            [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[607.924,436.917],[607.924,333.17],[427.461,443.152],[427.461,345.728]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[607.924,554.589],[607.924,450.842],[427.461,553.654],[427.461,456.23]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[607.924,571.896],[607.924,675.642],[427.461,569.907],[427.461,667.331]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[607.924,687.612],[607.924,791.359],[427.461,678.572],[427.461,775.997]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[607.924,810.571],[607.924,914.317],[427.461,794.038],[427.461,891.463]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[462.874,781.137],[462.874,873.629],[432.635,778.54],[432.635,870.039]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[464.649,448.098],[464.649,355.687],[435.49,449.041],[435.49,357.586]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[464.649,568.329],[464.649,660.74],[435.49,568.029],[435.49,659.484]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[464.649,671.403],[464.649,763.814],[435.49,670.035],[435.49,761.491]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[524.081,452.771],[524.081,365.097],[475.685,454.225],[475.685,368.026]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[524.081,566.839],[524.081,654.512],[475.685,566.375],[475.685,652.574]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[524.081,664.628],[524.081,752.302],[475.685,662.52],[475.685,748.719]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[524.051,768.704],[524.051,856.442],[475.82,764.859],[475.82,851.126]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[564.652,324.343],[564.652,228.615],[524.023,327.336],[524.023,232.94]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[570.289,317.34],[570.289,218.492],[538.861,321.591],[538.861,224.636]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[594.995,314.3],[594.995,214.098],[570.289,317.34],[570.289,218.492]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[636.505,309.958],[636.505,207.822],[594.995,314.3],[594.995,214.098]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[814.697,429.772],[814.697,318.782],[609.029,436.878],[609.029,333.093]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[814.697,555.659],[814.697,444.67],[609.029,554.594],[609.029,450.809]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[814.697,574.175],[814.697,685.165],[609.029,571.908],[609.029,675.693]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[814.697,697.971],[814.697,808.96],[609.029,687.668],[609.029,791.453]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[815.511,829.589],[815.511,940.607],[609.742,810.738],[609.742,914.548]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[694.429,306.551],[694.429,202.897],[639.145,309.594],[639.145,207.295]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[734.182,304.738],[734.182,200.276],[694.429,306.551],[694.429,202.897]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[791.797,302.393],[791.797,196.888],[734.181,304.738],[734.181,200.276]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[791.797,302.393],[791.797,196.888],[816.354,305.65],[816.354,201.594]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,429.864],[814.697,429.772],[904.366,318.968],[814.697,318.782]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,555.646],[904.366,444.749],[814.697,555.659],[814.697,444.67]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,574.146],[814.697,574.175],[904.366,685.042],[814.697,685.165]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,697.837],[814.697,697.971],[904.366,808.733],[814.697,808.96]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[905.436,829.29],[815.511,829.589],[905.436,940.195],[815.511,940.607]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[865.763,302.009],[865.763,196.331],[816.354,305.65],[816.354,201.594]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[865.763,302.009],[952.498,303.536],[865.763,196.331],[952.498,198.54]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,429.864],[904.366,318.968],[945.426,432.547],[945.426,324.372]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,555.646],[904.366,444.749],[945.426,555.243],[945.426,447.068]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,574.146],[904.366,685.042],[945.426,573.29],[945.426,681.465]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[904.366,697.837],[904.366,808.733],[945.426,693.947],[945.426,802.122]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[905.436,829.29],[905.436,940.195],[944.566,822.505],[944.566,930.815]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[987.023,826.152],[987.023,935.856],[944.566,822.505],[944.566,930.815]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,431.225],[986.3,321.709],[945.426,432.547],[945.426,324.372]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,555.441],[986.3,445.926],[945.426,555.243],[945.426,447.068]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,573.711],[986.3,683.227],[945.426,573.29],[945.426,681.465]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,695.863],[986.3,805.379],[945.426,693.946],[945.426,802.122]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[952.498,303.536],[952.498,198.54],[1038.52,307.91],[1038.52,204.862]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,431.225],[986.3,321.71],[1064.48,436.531],[1064.48,332.393]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,555.442],[986.3,445.926],[1064.48,554.646],[1064.48,450.509]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,573.711],[986.3,683.227],[1064.48,572.019],[1064.48,676.157]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[986.3,695.863],[986.3,805.379],[1064.48,688.172],[1064.48,792.309]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[987.023,826.152],[987.023,935.856],[1070.41,811.115],[1070.41,915.07]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1038.52,307.91],[1038.52,204.862],[1144.35,315.632],[1144.35,216.023]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,434.401],[1135.36,328.103],[1064.48,436.531],[1064.48,332.393]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,554.966],[1135.36,448.669],[1064.48,554.647],[1064.48,450.509]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,572.699],[1135.36,678.996],[1064.48,572.019],[1064.48,676.157]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,691.26],[1135.36,797.557],[1064.48,688.172],[1064.48,792.309]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1133.91,817.331],[1133.91,923.663],[1063.32,811.703],[1063.32,915.882]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1133.91,817.331],[1133.91,923.663],[1203.27,803.977],[1203.27,905.202]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,434.401],[1135.36,328.103],[1238.06,438.166],[1238.06,335.687]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,554.966],[1135.36,448.669],[1238.06,554.401],[1238.06,451.922]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,572.699],[1135.36,678.996],[1238.06,571.497],[1238.06,673.976]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1135.36,691.26],[1135.36,797.557],[1238.06,685.8],[1238.06,788.28]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1145.14,315.712],[1145.14,216.139],[1230.06,324.584],[1230.06,228.962]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1218.6,805.118],[1203.27,803.977],[1218.6,906.779],[1203.27,905.202]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1218.6,805.118],[1218.6,906.779],[1282.53,792.616],[1282.53,889.497]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1219.73,442.069],[1219.73,340.138],[1399.06,454.899],[1399.06,366.425]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1219.73,557.682],[1219.73,455.751],[1399.06,555.249],[1399.06,466.775]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1219.73,574.687],[1219.73,676.618],[1399.06,570.009],[1399.06,658.483]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1230.06,324.584],[1230.06,228.962],[1297.49,335.322],[1297.49,244.484]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1219.73,688.378],[1219.73,790.31],[1399.06,668.691],[1399.06,757.165]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1277.1,366.743],[1277.1,289.901],[1290.18,368.477],[1290.18,292.407]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1297.49,335.322],[1297.49,244.484],[1304.61,337.576],[1304.61,247.74]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1304.61,337.576],[1304.61,247.74],[1329.01,344.722],[1329.01,258.069]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1332.52,344.98],[1332.52,258.443],[1344.64,353.909],[1344.64,271.35]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1345.23,780.354],[1345.23,872.546],[1398.03,770.028],[1398.03,858.271]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1370.27,757.046],[1370.27,840.326],[1418.94,748.27],[1418.94,828.194]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1371.34,457.356],[1371.34,374.33],[1416.81,460.441],[1416.81,380.544]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1371.34,565.376],[1371.34,648.402],[1416.81,564.392],[1416.81,644.289]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1371.34,657.981],[1371.34,741.007],[1416.81,653.508],[1416.81,733.405]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1383.03,461.147],[1383.03,381.966],[1404.11,462.525],[1404.11,384.74]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1383.03,564.167],[1383.03,643.348],[1404.11,563.727],[1404.11,641.512]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1384.05,769.167],[1384.05,857.082],[1431.86,759.962],[1431.86,844.356]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1371.34,551.526],[1371.34,468.5],[1416.81,551.063],[1416.81,471.166]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1383.03,652.484],[1383.03,731.666],[1404.11,650.487],[1404.11,728.271]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1383.89,746.328],[1383.89,825.51],[1403.97,742.846],[1403.97,820.696]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1420.67,451.941],[1420.67,363.426],[1432.67,456.007],[1432.67,371.615]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1420.67,552.337],[1420.67,463.822],[1432.67,551.728],[1432.67,467.335]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1420.67,567.103],[1420.67,655.618],[1432.67,565.806],[1432.67,650.199]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:1,
                    verts:[[1420.67,665.831],[1420.67,754.346],[1432.67,659.936],[1432.67,744.329]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[471.627,783.561],[471.627,876.979],[438.209,781.25],[438.209,873.785]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[473.252,447.189],[473.252,353.858],[441.037,448.029],[441.037,355.547]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[473.252,568.619],[473.252,661.951],[441.037,568.351],[441.037,660.833]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[473.252,672.719],[473.252,766.051],[441.037,671.503],[441.037,763.984]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[646.089,436.618],[646.089,332.568],[447.181,442.124],[447.181,343.658]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[646.089,554.633],[646.089,450.584],[447.181,553.808],[447.181,455.342]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[646.089,571.991],[646.089,676.041],[447.181,570.235],[447.181,668.701]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[646.089,688.046],[646.089,792.095],[447.181,680.062],[447.181,778.529]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[646.089,811.364],[646.089,915.413],[447.181,796.764],[447.181,895.23]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[522.68,452.05],[522.68,363.645],[469.626,453.341],[469.626,366.245]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[522.68,567.069],[522.68,655.473],[469.626,566.657],[469.626,653.753]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[522.68,665.674],[522.68,754.078],[469.626,663.802],[469.626,750.898]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[522.801,770.616],[522.801,859.084],[469.927,767.203],[469.927,854.366]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[538.692,325.765],[538.692,230.67],[531.922,332.581],[531.922,240.522]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[583.222,323.125],[583.222,226.853],[538.692,325.765],[538.692,230.67]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[596.362,316.225],[596.362,216.88],[559.914,320.179],[559.914,222.595]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[624.622,313.423],[624.622,212.83],[596.362,316.225],[596.362,216.88]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[671.156,309.486],[671.156,207.139],[624.622,313.423],[624.622,212.83]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,430.411],[870.266,320.07],[647.298,436.584],[647.298,332.501]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,555.564],[870.266,445.222],[647.298,554.639],[647.298,450.555]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,573.971],[870.266,684.312],[647.298,572.002],[647.298,676.085]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,697.044],[870.266,807.385],[647.298,688.094],[647.298,792.178]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[871.141,827.883],[871.141,938.249],[648.077,811.51],[648.077,915.615]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[733.038,306.63],[733.038,203.011],[674.202,309.149],[674.202,206.653]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[774.79,305.194],[774.79,200.935],[733.038,306.63],[733.038,203.011]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[834.773,303.399],[834.773,198.341],[774.79,305.194],[774.79,200.935]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[834.773,303.399],[834.773,198.341],[855.866,306.81],[855.866,203.271]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[908.68,303.676],[908.68,198.741],[855.866,306.81],[855.866,203.271]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,430.411],[870.266,320.07],[958.856,430.866],[958.856,320.986]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,555.564],[870.266,445.222],[958.856,555.495],[958.856,445.615]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,573.971],[870.266,684.312],[958.856,573.826],[958.856,683.706]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[870.266,697.044],[958.856,696.384],[870.266,807.385],[958.856,806.264]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[871.141,827.883],[959.931,826.622],[871.141,938.249],[959.931,936.505]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[908.68,303.676],[908.68,198.741],[992.806,305.93],[992.806,201.999]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[958.856,430.866],[958.856,320.986],[993.108,433.648],[993.108,326.588]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[958.856,555.495],[958.856,445.615],[993.108,555.078],[993.108,448.019]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[958.856,573.826],[958.856,683.706],[993.108,572.939],[993.108,679.998]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[958.856,696.384],[958.856,806.264],[993.108,692.351],[993.108,799.41]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[959.931,826.622],[959.931,936.505],[992.568,819.587],[992.568,926.781]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1037.48,822.693],[1037.48,931.075],[992.568,819.587],[992.568,926.781]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[992.806,305.929],[992.806,201.999],[1072.83,310.932],[1072.83,209.23]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,432.522],[1036.34,324.32],[993.108,433.648],[993.108,326.588]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,555.247],[1036.34,447.046],[993.108,555.078],[993.108,448.019]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,573.298],[1036.34,681.499],[993.108,572.939],[993.108,679.998]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,693.983],[1036.34,802.185],[993.108,692.351],[993.108,799.41]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,432.522],[1036.34,324.321],[1100.68,437.985],[1100.68,335.322]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,555.247],[1036.34,447.046],[1100.68,554.429],[1100.68,451.766]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,573.298],[1036.34,681.499],[1100.68,571.555],[1100.68,674.218]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1036.34,693.983],[1036.34,802.185],[1100.68,686.063],[1100.68,788.726]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1037.48,822.693],[1037.48,931.075],[1106.06,807.213],[1106.06,909.676]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1072.83,310.932],[1072.83,209.23],[1168.3,319.317],[1168.3,221.35]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1173.26,812.607],[1173.26,917.132],[1099.65,807.855],[1099.65,910.563]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,436.187],[1174.59,331.701],[1100.68,437.985],[1100.68,335.322]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,554.698],[1174.59,450.212],[1100.68,554.429],[1100.68,451.766]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,572.129],[1174.59,676.615],[1100.68,571.555],[1100.68,674.218]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,688.67],[1174.59,793.157],[1100.68,686.063],[1100.68,788.726]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1168.99,319.402],[1168.99,221.472],[1242.45,328.679],[1242.45,234.881]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1173.26,812.607],[1173.26,917.132],[1229.05,798.99],[1229.05,898.307]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,436.187],[1174.59,331.701],[1265.47,440.215],[1265.47,339.813]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,554.698],[1174.59,450.212],[1265.47,554.094],[1265.47,453.692]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,572.129],[1174.59,676.615],[1265.47,570.844],[1265.47,671.246]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1174.59,688.67],[1174.59,793.157],[1265.47,682.83],[1265.47,783.233]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1244.85,799.946],[1229.05,798.99],[1244.85,899.629],[1229.05,898.307]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1242.45,328.679],[1242.45,234.881],[1296.86,339.582],[1296.86,250.642]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1244.85,799.946],[1244.85,899.629],[1295.87,787.26],[1295.87,882.092]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1246.02,369.903],[1246.02,294.468],[1256.94,371.668],[1256.94,297.02]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1246.55,443.967],[1246.55,344.027],[1389.1,456.944],[1389.1,370.615]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1246.55,557.322],[1246.55,457.382],[1389.1,554.861],[1389.1,468.532]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1246.55,573.995],[1246.55,673.935],[1389.1,569.263],[1389.1,655.592]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1246.55,685.466],[1246.55,785.406],[1389.1,665.553],[1389.1,751.882]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1296.86,339.582],[1296.86,250.642],[1301.49,341.815],[1301.49,253.867]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1301.49,341.815],[1301.49,253.867],[1317.9,348.901],[1317.9,264.11]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1321.02,349.175],[1321.02,264.507],[1323.86,357.896],[1323.86,277.114]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1345.74,774.859],[1345.74,864.95],[1387.61,764.448],[1387.61,850.558]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1350.07,752.139],[1350.07,833.542],[1389.29,743.286],[1389.29,821.304]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1350.53,459.201],[1350.53,378.047],[1387.19,462.314],[1387.19,384.316]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1350.53,564.787],[1350.53,645.942],[1387.19,563.794],[1387.19,641.793]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1350.53,655.305],[1350.53,736.46],[1387.19,650.792],[1387.19,728.79]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1353.26,462.901],[1353.26,385.498],[1370.38,464.293],[1370.38,388.299]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1353.26,563.607],[1353.26,641.011],[1370.38,563.163],[1370.38,639.157]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1373.5,763.734],[1373.5,849.571],[1411.47,754.468],[1411.47,836.762]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1409.83,454.126],[1409.83,367.826],[1412.24,458.082],[1412.24,375.792]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1409.83,552.01],[1409.83,465.71],[1412.24,551.417],[1412.24,469.127]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1409.83,566.406],[1409.83,652.706],[1412.24,565.145],[1412.24,647.434]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:2,
                    verts:[[1409.83,662.663],[1409.83,748.963],[1412.24,656.929],[1412.24,739.218]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[484.283,785.898],[484.283,880.209],[447.921,783.9],[447.921,877.448]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[485.741,446.314],[485.741,352.094],[450.696,447.039],[450.696,353.554]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[485.741,568.898],[485.741,663.118],[450.696,568.667],[450.696,662.152]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[485.741,673.989],[485.741,768.209],[450.696,672.938],[450.696,766.422]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[524.551,451.325],[524.551,362.186],[467.161,452.439],[467.161,364.429]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[524.551,567.3],[524.551,656.439],[467.161,566.944],[467.161,654.954]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[524.551,666.724],[524.551,755.863],[467.161,665.109],[467.161,753.119]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[524.826,772.535],[524.826,861.737],[467.63,769.589],[467.63,857.665]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[686.579,436.454],[686.579,332.239],[471.281,441.172],[471.281,341.739]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[686.579,554.658],[686.579,450.443],[471.281,553.951],[471.281,454.518]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[686.579,572.043],[686.579,676.258],[471.281,570.539],[471.281,669.971]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[686.579,688.283],[686.579,792.498],[471.281,681.444],[471.281,780.876]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[686.579,811.797],[686.579,916.012],[471.281,799.29],[471.281,898.722]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[556.729,324.312],[556.729,228.57],[542.645,331.038],[542.645,238.291]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[604.762,322.049],[604.762,225.298],[556.729,324.312],[556.729,228.57]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[625.311,315.316],[625.311,215.566],[584.192,318.935],[584.192,220.798]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[656.827,312.779],[656.827,211.899],[625.311,315.316],[625.311,215.566]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[707.854,309.283],[707.854,206.846],[656.827,312.779],[656.827,211.899]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,431.229],[925.066,321.716],[687.877,436.426],[687.877,332.182]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,555.441],[925.066,445.929],[687.877,554.662],[687.877,450.418]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,573.71],[925.066,683.223],[687.877,572.053],[687.877,676.296]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,695.858],[925.066,805.371],[687.877,688.324],[687.877,792.568]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.989,825.705],[925.989,935.238],[688.713,811.921],[688.713,916.183]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[772.946,306.997],[772.946,203.542],[711.269,308.976],[711.269,206.403]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[816.177,305.945],[816.177,202.021],[772.946,306.997],[772.946,203.542]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[877.766,304.701],[877.766,200.223],[816.177,305.945],[816.177,202.021]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[877.766,304.701],[877.766,200.223],[895.232,308.227],[895.232,205.32]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[950.734,305.611],[950.734,201.538],[895.232,308.227],[895.232,205.32]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,431.229],[925.066,321.716],[1011.45,432.024],[1011.45,323.317]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,555.441],[925.066,445.929],[1011.45,555.322],[1011.45,446.615]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,573.71],[925.066,683.223],[1011.45,573.457],[1011.45,682.163]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.066,695.858],[925.066,805.371],[1011.45,694.706],[1011.45,803.412]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[925.989,825.705],[925.989,935.238],[1012.51,823.541],[1012.51,932.246]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[950.734,305.611],[950.734,201.538],[1031.36,308.53],[1031.36,205.758]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1011.45,432.024],[1011.45,323.317],[1038.73,434.869],[1038.73,329.047]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1011.45,555.322],[1011.45,446.615],[1038.73,554.896],[1038.73,449.074]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1011.45,573.457],[1011.45,682.163],[1038.73,572.549],[1038.73,678.371]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1011.45,694.706],[1011.45,803.412],[1038.73,690.581],[1038.73,796.403]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1012.51,823.541],[1012.51,932.246],[1038.5,816.347],[1038.5,922.302]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1031.36,308.53],[1031.36,205.758],[1104.75,314.073],[1104.75,213.77]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1085.2,818.913],[1085.2,925.848],[1038.5,816.347],[1038.5,922.302]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,433.939],[1083.68,327.174],[1038.73,434.869],[1038.73,329.047]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,555.035],[1083.68,448.27],[1038.73,554.896],[1038.73,449.074]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,572.846],[1083.68,679.611],[1038.73,572.549],[1038.73,678.371]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,691.929],[1083.68,798.694],[1038.73,690.581],[1038.73,796.403]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,433.939],[1083.68,327.174],[1134.09,439.493],[1134.09,338.358]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,555.035],[1083.68,448.27],[1134.09,554.203],[1134.09,453.068]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,572.846],[1083.68,679.611],[1134.09,571.074],[1134.09,672.209]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1083.68,691.929],[1083.68,798.695],[1134.09,683.878],[1134.09,785.012]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1085.2,818.913],[1085.2,925.848],[1138.89,803.179],[1138.89,904.099]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1104.75,314.073],[1104.75,213.77],[1189.41,322.994],[1189.41,226.665]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1208.82,807.76],[1208.82,910.431],[1133.19,803.865],[1133.19,905.047]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,438.019],[1210.02,335.39],[1134.09,439.493],[1134.09,338.358]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,554.423],[1210.02,451.795],[1134.09,554.203],[1134.09,453.068]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,571.544],[1210.02,674.173],[1134.09,571.074],[1134.09,672.209]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,686.014],[1210.02,788.643],[1134.09,683.878],[1134.09,785.012]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1189.99,323.082],[1189.99,226.791],[1252,332.647],[1252,240.617]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1208.82,807.76],[1208.82,910.431],[1251.28,794.037],[1251.28,891.461]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,438.019],[1210.02,335.39],[1288.82,442.246],[1288.82,343.902]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,554.423],[1210.02,451.795],[1288.82,553.79],[1288.82,455.446]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,571.544],[1210.02,674.173],[1288.82,570.196],[1288.82,668.54]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1210.02,686.014],[1210.02,788.643],[1288.82,679.887],[1288.82,778.231]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1214.69,372.719],[1214.69,298.539],[1223.53,374.504],[1223.53,301.119]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1267.35,794.816],[1251.28,794.037],[1267.35,892.538],[1251.28,891.461]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1252,332.647],[1252,240.617],[1293.79,343.61],[1293.79,256.463]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1267.35,794.816],[1267.35,892.538],[1305.83,782.081],[1305.83,874.934]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1269.55,445.851],[1269.55,347.886],[1376.7,458.847],[1376.7,374.514]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1269.55,556.965],[1269.55,459.001],[1376.7,554.501],[1376.7,470.167]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1269.55,573.308],[1269.55,671.272],[1376.7,568.569],[1376.7,652.903]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1269.55,682.576],[1269.55,780.54],[1376.7,662.633],[1376.7,746.966]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1293.79,343.61],[1293.79,256.463],[1296.06,345.805],[1296.06,259.634]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1296.06,345.805],[1296.06,259.634],[1304.91,352.783],[1304.91,269.721]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1322.68,464.483],[1322.68,388.683],[1336.05,465.878],[1336.05,391.492]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1322.68,563.103],[1322.68,638.903],[1336.05,562.658],[1336.05,637.044]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1322.68,647.648],[1322.68,723.448],[1336.05,645.626],[1336.05,720.012]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1323.46,737.472],[1323.46,813.267],[1336.19,733.948],[1336.19,808.396]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1328.31,460.89],[1328.31,381.447],[1356.61,464.007],[1356.61,387.724]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1328.31,564.249],[1328.31,643.691],[1356.61,563.255],[1356.61,639.537]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1328.31,652.857],[1328.31,732.3],[1356.61,648.338],[1356.61,724.621]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1328.41,747.645],[1328.41,827.33],[1358.66,738.782],[1358.66,815.078]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1343.35,769.663],[1343.35,857.767],[1374.79,759.26],[1374.79,843.387]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:3,
                    verts:[[1360.66,758.683],[1360.66,842.588],[1389.29,749.432],[1389.29,829.8]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[500.591,788.182],[500.591,883.367],[461.549,786.521],[461.549,881.072]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[501.865,445.457],[501.865,350.369],[464.245,446.06],[464.245,351.582]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[501.865,553.309],[501.865,458.221],[464.245,553.219],[464.245,458.741]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[501.865,569.172],[501.865,664.26],[464.245,568.979],[464.245,663.457]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[501.865,675.231],[501.865,770.319],[464.245,674.357],[464.245,768.835]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[499.382,440.28],[499.382,339.943],[468.764,443.081],[468.764,345.585]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[529.536,450.585],[529.536,360.695],[468.163,451.51],[468.163,362.558]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[499.382,554.085],[499.382,453.748],[468.764,553.665],[468.764,456.168]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[529.536,567.536],[529.536,657.426],[468.163,567.241],[468.163,656.193]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[499.382,570.823],[499.382,671.16],[468.764,569.93],[468.764,667.426]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[529.536,667.797],[529.536,757.687],[468.163,666.456],[468.163,755.408]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[499.382,682.736],[499.382,783.073],[468.764,678.675],[468.764,776.172]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[529.964,774.495],[529.964,864.446],[468.8,772.049],[468.8,861.066]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[499.382,801.654],[499.382,901.991],[469.04,794.185],[469.04,891.666]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[728.836,436.4],[728.836,332.129],[499.382,440.28],[499.382,339.943]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[728.836,554.666],[728.836,450.396],[499.382,554.085],[499.382,453.748]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[728.836,572.061],[728.836,676.331],[499.382,570.823],[499.382,671.16]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[728.836,688.362],[728.836,792.632],[499.382,682.736],[499.382,783.073]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[728.836,811.941],[728.836,916.211],[499.382,801.654],[499.382,901.991]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[577.828,322.94],[577.828,226.586],[556.467,329.52],[556.467,236.097]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[628.935,321.076],[628.935,223.892],[577.828,322.94],[577.828,226.586]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[656.716,314.567],[656.716,214.484],[611.323,317.819],[611.323,219.185]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[691.159,312.317],[691.159,211.231],[656.716,314.567],[656.716,214.484]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[746.106,309.289],[746.106,206.855],[691.159,312.317],[691.159,211.231]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,432.178],[978.5,323.627],[730.206,436.377],[730.206,332.083]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,555.299],[978.5,446.748],[730.206,554.67],[730.206,450.376]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,573.408],[978.5,681.958],[730.206,572.068],[730.206,676.362]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,694.482],[978.5,803.033],[730.206,688.395],[730.206,792.689]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[979.457,823.178],[979.457,931.745],[731.09,812.042],[731.09,916.351]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[813.649,307.585],[813.649,204.392],[749.85,309.015],[749.85,206.459]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[857.849,306.915],[813.649,307.585],[857.849,203.424],[813.649,204.392]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[920.309,306.216],[857.849,306.915],[920.309,202.413],[857.849,203.424]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[920.309,306.216],[920.309,202.413],[934.051,309.82],[934.051,207.623]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[991.543,307.723],[991.543,204.59],[934.051,309.82],[934.051,207.623]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,432.178],[978.5,323.627],[1061.68,433.288],[1061.68,325.862]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,555.299],[978.5,446.748],[1061.68,555.133],[1061.68,447.707]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,573.408],[978.5,681.958],[1061.68,573.054],[1061.68,680.479]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[978.5,694.482],[978.5,803.033],[1061.68,692.874],[1061.68,800.299]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[979.457,823.178],[979.457,931.745],[1062.72,820.18],[1062.72,927.6]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[991.543,307.723],[991.543,204.59],[1067.91,311.246],[1067.91,209.683]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1061.68,433.288],[1061.68,325.862],[1081.96,436.164],[1081.96,331.655]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1061.68,555.133],[1061.68,447.707],[1081.96,554.701],[1081.96,450.192]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1061.68,573.054],[1061.68,680.479],[1081.96,572.136],[1081.96,676.645]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1061.68,692.874],[1061.68,800.299],[1081.96,688.703],[1081.96,793.212]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1062.72,820.18],[1062.72,927.6],[1082.04,812.907],[1082.04,917.546]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1067.91,311.246],[1067.91,209.683],[1134.2,317.246],[1134.2,218.355]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,435.426],[1128.03,330.169],[1081.96,436.164],[1081.96,331.655]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,554.812],[1128.03,449.555],[1081.96,554.701],[1081.96,450.192]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,572.371],[1128.03,677.628],[1081.96,572.136],[1081.96,676.645]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,689.773],[1128.03,795.03],[1081.96,688.703],[1081.96,793.212]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1129.89,814.942],[1082.04,812.907],[1129.89,920.359],[1082.04,917.546]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,435.426],[1128.03,330.169],[1164.66,441.012],[1164.66,341.418]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,554.812],[1128.03,449.555],[1164.66,553.975],[1164.66,454.381]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,572.371],[1128.03,677.629],[1164.66,570.59],[1164.66,670.184]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1128.03,689.773],[1128.03,795.03],[1164.66,681.675],[1164.66,781.269]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1129.89,814.942],[1129.89,920.359],[1168.85,799.121],[1168.85,898.49]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1134.2,317.246],[1134.2,218.355],[1207.8,326.586],[1207.8,231.856]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1240.62,802.91],[1240.62,903.727],[1163.88,799.842],[1163.88,899.486]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,439.851],[1241.69,339.08],[1164.66,441.012],[1164.66,341.418]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,554.149],[1241.69,453.378],[1164.66,553.975],[1164.66,454.381]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,570.96],[1241.69,671.731],[1164.66,570.59],[1164.66,670.184]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,683.358],[1241.69,784.13],[1164.66,681.675],[1164.66,781.269]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1183.28,375.187],[1183.28,302.106],[1190.13,376.981],[1190.13,304.7]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1208.28,326.676],[1208.28,231.986],[1258.96,336.428],[1258.96,246.082]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1240.62,802.91],[1240.62,903.727],[1270.13,789.215],[1270.13,884.796]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,439.851],[1241.69,339.08],[1308.38,444.22],[1308.38,347.879]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,554.149],[1241.69,453.378],[1308.38,553.494],[1308.38,457.152]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,570.96],[1241.69,671.731],[1308.38,569.566],[1308.38,665.908]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1241.69,683.358],[1241.69,784.13],[1308.38,677.024],[1308.38,773.365]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1258.96,336.428],[1258.96,246.082],[1288.61,347.363],[1288.61,261.888]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1286.31,789.826],[1270.13,789.215],[1286.31,885.639],[1270.13,884.796]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1286.31,789.826],[1286.31,885.639],[1312.74,777.153],[1312.74,868.121]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1288.66,349.509],[1288.66,264.988],[1290.37,356.342],[1290.37,274.865]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1288.97,447.685],[1288.97,351.644],[1362.27,460.597],[1362.27,378.098]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1288.97,556.617],[1288.97,460.576],[1362.27,554.169],[1362.27,471.67]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1288.97,572.639],[1288.97,668.68],[1362.27,567.931],[1362.27,650.43]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1291.57,465.891],[1291.57,391.519],[1301.38,467.282],[1301.38,394.319]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1291.57,562.653],[1291.57,637.026],[1301.38,562.21],[1301.38,635.172]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1291.57,645.607],[1291.57,719.979],[1301.38,643.591],[1301.38,716.553]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1292.32,733.734],[1292.32,808.099],[1301.65,730.22],[1301.65,803.242]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1288.97,679.761],[1288.97,775.802],[1362.27,659.948],[1362.27,742.447]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1305.01,462.416],[1305.01,384.52],[1325.35,465.518],[1325.35,390.768]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1305.01,563.762],[1305.01,641.658],[1325.35,562.772],[1325.35,637.523]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1305.01,650.645],[1305.01,728.541],[1325.35,646.147],[1325.35,720.897]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1305.64,743.58],[1305.64,821.711],[1327.36,734.759],[1327.36,809.517]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1338.46,764.815],[1338.46,851.065],[1359.99,754.493],[1359.99,836.797]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:4,
                    verts:[[1345.94,754.043],[1345.94,836.174],[1365.71,744.866],[1365.71,823.488]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[537.479,449.816],[537.479,359.147],[472.503,450.541],[472.503,360.607]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[537.479,552.656],[537.479,461.987],[472.503,552.547],[472.503,462.613]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[537.479,567.781],[537.479,658.45],[472.503,567.55],[472.503,657.484]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[537.479,668.911],[537.479,759.58],[472.503,667.861],[472.503,757.795]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[538.06,776.529],[538.06,867.258],[473.308,774.612],[473.308,864.609]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[520.309,790.449],[520.309,886.501],[478.876,789.148],[478.876,884.702]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[521.383,444.606],[521.383,348.655],[481.467,445.078],[481.467,349.606]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[521.383,553.436],[521.383,457.485],[481.467,553.366],[481.467,457.893]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[521.383,569.443],[521.383,665.394],[481.467,569.293],[481.467,664.765]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[521.383,676.465],[521.383,772.416],[481.467,675.78],[481.467,771.253]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[531.122,439.434],[531.122,338.241],[493.179,442.119],[493.179,343.647]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[531.122,554.211],[531.122,453.018],[493.179,553.809],[493.179,455.337]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[531.122,571.093],[531.122,672.287],[493.179,570.236],[493.179,668.709]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[531.122,683.962],[531.122,785.156],[493.179,680.07],[493.179,778.542]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[531.122,803.896],[531.122,905.089],[493.424,796.734],[493.424,895.189]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[772.37,436.428],[772.37,332.187],[531.122,439.434],[531.122,338.241]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[772.37,554.662],[772.37,450.421],[531.122,554.211],[531.122,453.018]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[772.37,572.052],[772.37,676.293],[531.122,571.093],[531.122,672.287]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[772.37,688.32],[772.37,792.562],[531.122,683.962],[531.122,785.156]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[772.37,811.866],[772.37,916.107],[531.122,803.896],[531.122,905.089]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[573.169,327.997],[573.169,233.896],[567.701,335.511],[567.701,244.758]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[601.706,321.613],[601.706,224.668],[573.169,327.997],[573.169,233.896]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[655.434,320.166],[655.434,222.576],[601.706,321.613],[601.706,224.668]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[690.199,313.933],[690.199,213.568],[640.965,316.791],[640.965,217.698]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[727.214,311.986],[727.214,210.754],[690.199,313.933],[690.199,213.568]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[785.484,309.447],[785.484,207.083],[727.214,311.986],[727.214,210.754]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,433.217],[1030.12,325.719],[773.799,436.411],[773.799,332.151]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,555.143],[1030.12,447.646],[773.799,554.665],[773.799,450.405]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,573.076],[1030.12,680.573],[773.799,572.057],[773.799,676.317]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,692.976],[1030.12,800.474],[773.799,688.346],[773.799,792.605]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1031.1,820.413],[1031.1,927.923],[774.72,811.943],[774.72,916.214]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[854.729,308.328],[854.729,205.466],[789.514,309.208],[789.514,206.738]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[899.404,308.037],[854.729,308.328],[899.404,205.044],[854.729,205.466]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[962.041,307.869],[899.404,308.037],[962.041,204.802],[899.404,205.044]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[962.041,307.869],[962.041,204.802],[972.018,311.518],[972.018,210.076]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.83,309.933],[1030.83,207.785],[972.018,311.518],[972.018,210.076]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,433.217],[1030.12,325.719],[1109.25,434.614],[1109.25,328.532]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,555.143],[1030.12,447.646],[1109.25,554.934],[1109.25,448.853]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,573.076],[1030.12,680.573],[1109.25,572.631],[1109.25,678.712]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.12,692.976],[1030.12,800.474],[1109.25,690.951],[1109.25,797.033]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1030.83,309.933],[1030.83,207.785],[1102.32,313.998],[1102.32,213.661]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1031.1,820.413],[1031.1,927.923],[1110.26,816.654],[1110.26,922.726]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1102.32,313.998],[1102.32,213.661],[1161.18,320.376],[1161.18,222.88]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1109.25,434.614],[1109.25,328.532],[1122.62,437.494],[1122.62,334.333]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1109.25,554.934],[1109.25,448.853],[1122.62,554.502],[1122.62,451.341]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1109.25,572.631],[1109.25,678.712],[1122.62,571.712],[1122.62,674.873]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1109.25,690.951],[1109.25,797.033],[1122.62,686.776],[1122.62,789.937]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1110.26,816.654],[1110.26,922.726],[1122.98,809.372],[1122.98,912.66]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,436.942],[1169.24,333.222],[1122.62,437.494],[1122.62,334.333]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,554.585],[1169.24,450.865],[1122.62,554.502],[1122.62,451.341]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,571.888],[1169.24,675.608],[1122.62,571.712],[1122.62,674.873]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,687.575],[1122.62,686.776],[1169.24,791.295],[1122.62,789.937]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1171.41,810.893],[1122.98,809.372],[1171.41,914.763],[1122.98,912.66]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1151.92,377.304],[1151.92,305.167],[1156.83,379.1],[1156.83,307.763]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1161.18,320.376],[1161.18,222.88],[1223.6,330.033],[1223.6,236.839]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,436.942],[1169.24,333.222],[1192.4,442.51],[1192.4,344.434]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,554.585],[1169.24,450.865],[1192.4,553.75],[1192.4,455.675]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,571.888],[1169.24,675.608],[1192.4,570.112],[1192.4,668.187]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1169.24,687.575],[1169.24,791.295],[1192.4,679.503],[1192.4,777.579]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1171.41,810.893],[1171.41,914.763],[1195.98,795.127],[1195.98,892.968]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,441.647],[1269.73,342.697],[1192.4,442.51],[1192.4,344.434]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,553.88],[1269.73,454.929],[1192.4,553.75],[1192.4,455.675]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,570.387],[1269.73,669.337],[1192.4,570.112],[1192.4,668.187]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,680.754],[1269.73,779.704],[1192.4,679.503],[1192.4,777.579]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1268.79,798.154],[1191.75,795.874],[1268.79,897.152],[1191.75,894.001]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1223.98,330.124],[1223.98,236.971],[1263.58,339.978],[1263.58,251.214]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1260.12,467.128],[1260.12,394.009],[1266.52,468.508],[1266.52,396.788]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1260.12,562.259],[1260.12,635.378],[1266.52,561.819],[1266.52,633.538]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1260.12,643.814],[1260.12,716.933],[1266.52,641.813],[1266.52,713.533]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1260.82,730.451],[1260.82,803.562],[1266.91,726.964],[1266.91,798.74]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1263.58,339.978],[1263.58,251.214],[1281.59,350.816],[1281.59,266.879]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1268.79,798.154],[1268.79,897.152],[1285.86,784.596],[1285.86,878.409]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,441.647],[1269.73,342.697],[1324.44,446.111],[1324.44,351.686]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,553.88],[1269.73,454.929],[1324.44,553.211],[1324.44,458.786]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,570.387],[1269.73,669.337],[1324.44,568.963],[1324.44,663.388]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1269.73,680.754],[1269.73,779.704],[1324.44,674.283],[1324.44,768.708]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1280.85,463.777],[1280.85,387.261],[1293.64,466.851],[1293.64,393.452]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1280.85,563.328],[1280.85,639.844],[1293.64,562.347],[1293.64,635.747]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1280.85,648.672],[1280.85,725.187],[1293.64,644.215],[1293.64,717.615]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1281.98,739.951],[1281.98,816.693],[1295.6,731.212],[1295.6,804.613]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1301.99,785.047],[1285.86,784.596],[1301.99,879.034],[1285.86,878.409]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1301.99,785.047],[1301.99,879.034],[1316.91,772.526],[1316.91,861.725]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1305.06,449.442],[1305.06,355.243],[1346.17,462.187],[1346.17,381.357]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1305.06,556.284],[1305.06,462.086],[1346.17,553.867],[1346.17,473.037]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1305.06,571.999],[1305.06,666.197],[1346.17,567.351],[1346.17,648.182]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1305.06,677.065],[1305.06,771.264],[1346.17,657.508],[1346.17,738.338]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1329.63,749.83],[1329.63,830.35],[1341.04,740.772],[1341.04,817.829]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:5,
                    verts:[[1331.42,760.345],[1331.42,844.886],[1343.55,750.163],[1343.55,830.81]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[548.246,449.008],[548.246,357.519],[480.074,449.522],[480.074,358.554]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[548.246,552.777],[548.246,461.288],[480.074,552.7],[480.074,461.732]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[548.246,568.039],[548.246,659.528],[480.074,567.875],[480.074,658.843]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[548.246,670.084],[548.246,761.573],[480.074,669.338],[480.074,760.306]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[548.98,778.668],[548.98,870.215],[481.045,777.309],[481.045,868.336]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[543.222,792.732],[543.222,889.657],[499.712,791.81],[499.712,888.383]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[544.084,443.748],[544.084,346.928],[502.173,444.083],[502.173,347.602]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[544.084,553.565],[544.084,456.744],[502.173,553.515],[502.173,457.034]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[544.084,569.717],[544.084,666.537],[502.173,569.61],[502.173,666.091]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[544.084,677.708],[544.084,774.529],[502.173,677.223],[502.173,773.704]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[566.177,438.621],[566.177,336.603],[521.137,441.165],[521.137,341.727]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[566.177,554.333],[566.177,452.315],[521.137,553.952],[521.137,454.513]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[566.177,571.352],[566.177,673.37],[521.137,570.541],[521.137,669.98]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[566.177,685.141],[566.177,787.159],[521.137,681.453],[521.137,780.892]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[566.177,806.051],[566.177,908.07],[521.349,799.26],[521.349,898.681]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[816.776,436.517],[816.776,332.365],[566.177,438.621],[566.177,336.603]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[816.776,554.649],[816.776,450.497],[566.177,554.333],[566.177,452.315]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[816.776,572.023],[816.776,676.175],[566.177,571.352],[566.177,673.37]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[816.776,688.192],[816.776,792.343],[566.177,685.141],[566.177,787.159]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[816.776,811.631],[816.776,915.782],[566.177,806.051],[566.177,908.07]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[592.56,326.438],[592.56,231.643],[579.248,333.895],[579.248,242.421]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[628.116,320.298],[628.116,222.767],[592.56,326.438],[592.56,231.643]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[683.997,319.282],[683.997,221.299],[628.116,320.298],[628.116,222.767]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[725.434,313.373],[725.434,212.757],[672.823,315.813],[672.823,216.285]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[764.653,311.744],[764.653,210.403],[725.434,313.373],[725.434,212.757]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[825.635,309.707],[825.635,207.46],[764.653,311.744],[764.653,210.403]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,434.31],[1079.61,327.921],[818.247,436.505],[818.247,332.341]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,554.979],[1079.61,448.59],[818.247,554.65],[818.247,450.487]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,572.727],[1079.61,679.116],[818.247,572.027],[818.247,676.191]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,691.391],[1079.61,797.78],[818.247,688.21],[818.247,792.374]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1080.6,817.504],[1080.6,923.901],[819.195,811.684],[819.195,915.856]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[895.848,309.171],[829.907,309.504],[895.848,206.683],[829.907,207.166]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[940.53,309.249],[895.848,309.171],[940.53,206.797],[895.848,206.683]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[940.53,309.249],[1002.7,309.596],[940.53,206.797],[1002.7,207.298]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1002.7,309.596],[1002.7,207.298],[1008.91,313.259],[1008.91,212.592]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1068.42,312.176],[1008.91,313.259],[1068.42,211.028],[1008.91,212.593]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1068.42,312.176],[1068.42,211.028],[1134.51,316.722],[1134.51,217.599]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,434.31],[1079.61,327.921],[1153.98,435.966],[1153.98,331.256]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,554.979],[1079.61,448.59],[1153.98,554.731],[1153.98,450.021]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,572.727],[1079.61,679.116],[1153.98,572.199],[1153.98,676.909]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1079.61,691.391],[1079.61,797.78],[1153.98,688.99],[1153.98,793.7]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1080.6,817.504],[1080.6,923.901],[1154.95,813.059],[1154.95,917.756]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1120.64,379.074],[1120.64,307.725],[1123.68,380.865],[1123.68,310.313]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1134.51,316.722],[1134.51,217.599],[1185.72,323.408],[1185.72,227.263]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1153.98,435.966],[1153.98,331.256],[1160.59,438.826],[1160.59,337.016]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1153.98,554.731],[1153.98,450.021],[1160.59,554.303],[1160.59,452.492]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1153.98,572.199],[1153.98,676.909],[1160.59,571.287],[1160.59,673.097]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1153.98,688.99],[1153.98,793.7],[1160.59,684.844],[1160.59,786.654]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1154.95,813.059],[1154.95,917.756],[1161.22,805.829],[1161.22,907.762]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,438.453],[1160.59,438.826],[1207.27,336.265],[1160.59,337.016]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,554.358],[1207.27,452.17],[1160.59,554.302],[1160.59,452.492]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,571.406],[1207.27,673.594],[1160.59,571.287],[1160.59,673.097]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,685.384],[1160.59,684.844],[1207.27,787.573],[1160.59,786.654]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1209.7,806.856],[1161.22,805.829],[1209.7,909.182],[1161.22,907.762]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1185.72,323.408],[1185.72,227.263],[1237,333.293],[1237,241.551]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,438.453],[1207.27,336.265],[1217.39,443.961],[1217.39,347.356]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,554.358],[1207.27,452.17],[1217.39,553.533],[1217.39,456.928]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,571.406],[1207.27,673.594],[1217.39,569.649],[1217.39,666.254]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1207.27,685.384],[1207.27,787.573],[1217.39,677.4],[1217.39,774.005]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1209.7,806.856],[1209.7,909.182],[1220.36,791.264],[1220.36,887.628]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,443.381],[1217.39,443.961],[1294.3,346.188],[1217.39,347.356]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,553.62],[1294.3,456.427],[1217.39,553.533],[1217.39,456.928]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,569.834],[1294.3,667.027],[1217.39,569.649],[1217.39,666.254]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,678.241],[1217.39,677.4],[1294.3,775.434],[1217.39,774.005]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1293.5,793.563],[1216.87,792.03],[1293.5,890.806],[1216.87,888.687]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1228.43,468.195],[1228.43,396.158],[1231.58,469.56],[1231.58,398.907]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1228.43,561.919],[1228.43,633.956],[1231.58,561.483],[1231.58,632.136]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1228.43,642.267],[1228.43,714.304],[1231.58,640.288],[1231.58,710.94]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1229.09,727.618],[1229.09,799.645],[1232.09,724.168],[1232.09,794.875]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1237.28,333.384],[1237.28,241.683],[1266.09,343.269],[1266.09,255.97]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1256.02,464.974],[1256.02,389.672],[1261.6,468.008],[1261.6,395.783]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1256.02,562.946],[1256.02,638.248],[1261.6,561.978],[1261.6,634.204]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1256.02,646.936],[1256.02,722.238],[1261.6,642.537],[1261.6,714.763]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1257.61,736.755],[1257.61,812.275],[1263.5,728.13],[1263.5,800.353]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1266.09,343.269],[1266.09,255.97],[1272.98,353.952],[1272.98,271.412]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,443.381],[1294.3,346.188],[1337.27,447.898],[1337.27,355.285]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,553.62],[1294.3,456.427],[1337.27,552.943],[1337.27,460.329]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,569.834],[1294.3,667.027],[1337.27,568.393],[1337.27,661.007]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1294.3,678.241],[1294.3,775.434],[1337.27,671.692],[1337.27,764.305]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1293.5,793.563],[1293.5,890.806],[1298.69,780.23],[1298.69,872.374]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1314.66,780.532],[1298.69,780.23],[1314.66,872.793],[1298.69,872.374]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1312.01,746.049],[1312.01,825.124],[1315.47,737.146],[1315.47,812.816]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1314.66,780.532],[1314.66,872.793],[1318.63,768.235],[1318.63,855.793]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1318.08,451.103],[1318.08,358.647],[1328.65,463.617],[1328.65,384.287]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1318.08,555.969],[1318.08,463.513],[1328.65,553.596],[1328.65,474.266]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1318.08,674.516],[1318.08,766.972],[1328.65,655.314],[1328.65,734.644]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1322.49,756.272],[1322.49,839.256],[1325.72,746.272],[1325.72,825.432]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:6,
                    verts:[[1318.08,571.393],[1318.08,663.849],[1328.65,566.83],[1328.65,646.16]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[561.733,448.149],[561.733,355.789],[490.795,448.442],[490.795,356.379]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[561.733,552.905],[561.733,460.546],[490.795,552.861],[490.795,460.799]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[561.733,568.313],[561.733,660.673],[490.795,568.22],[490.795,660.282]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[561.733,671.329],[561.733,763.689],[490.795,670.904],[490.795,762.966]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[562.616,780.939],[562.616,873.354],[491.929,780.164],[491.929,872.283]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[569.154,795.06],[569.154,892.875],[523.9,794.535],[523.9,892.15]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[569.791,442.873],[569.791,345.166],[526.206,443.064],[526.206,345.549]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[569.791,553.696],[569.791,455.988],[526.206,553.667],[526.206,456.153]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[569.791,569.996],[569.791,667.703],[526.206,569.935],[526.206,667.45]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[569.791,678.977],[569.791,776.685],[526.206,678.701],[526.206,776.215]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[604.265,437.829],[604.265,335.007],[552.423,440.21],[552.423,339.802]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[604.265,554.452],[604.265,451.63],[552.423,554.095],[552.423,453.687]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[604.265,571.605],[604.265,674.427],[552.423,570.846],[552.423,671.253]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[604.265,686.29],[604.265,789.112],[552.423,682.838],[552.423,783.246]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[604.265,808.153],[604.265,910.974],[552.598,801.792],[552.598,902.181]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[593.297,332.17],[593.297,239.927],[583.562,342.359],[583.562,254.656]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[614.481,324.819],[614.481,229.302],[593.297,332.17],[593.297,239.927]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[861.716,436.646],[861.716,332.626],[604.265,437.829],[604.265,335.007]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[861.716,554.629],[861.716,450.609],[604.265,554.452],[604.265,451.63]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[861.716,571.982],[861.716,676.003],[604.265,571.605],[604.265,674.427]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[861.716,688.004],[861.716,792.025],[604.265,686.29],[604.265,789.112]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[861.716,811.288],[861.716,915.308],[604.265,808.153],[604.265,910.974]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[656.848,318.968],[656.848,220.845],[614.481,324.819],[614.481,229.302]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[714.401,318.395],[714.401,220.017],[656.848,318.968],[656.848,220.845]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[762.15,312.851],[762.15,212.003],[706.646,314.855],[706.646,214.901]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[803.191,311.551],[803.191,210.124],[762.15,312.851],[762.15,212.003]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[866.27,310.028],[866.27,207.923],[803.191,311.551],[803.191,210.124]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,435.429],[1126.77,330.174],[863.214,436.639],[863.214,332.612]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,554.812],[1126.77,449.557],[863.214,554.63],[863.214,450.603]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,572.37],[1126.77,677.625],[863.214,571.984],[863.214,676.012]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,689.769],[1126.77,795.024],[863.214,688.014],[863.214,792.042]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1127.76,814.527],[1127.76,919.786],[864.178,811.318],[864.178,915.35]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[870.739,309.861],[936.742,310.066],[870.739,207.682],[936.742,207.978]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[936.742,310.066],[980.988,310.504],[936.742,207.978],[980.988,208.611]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[980.988,310.504],[1042.08,311.345],[980.988,208.611],[1042.08,209.826]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1042.08,311.345],[1042.08,209.826],[1044.58,314.995],[1044.58,215.102]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1104.2,314.401],[1044.58,314.995],[1104.2,214.244],[1044.58,215.102]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1089.47,380.499],[1089.47,309.784],[1090.69,382.279],[1090.69,312.357]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1104.2,314.401],[1104.2,214.244],[1164.47,319.372],[1164.47,221.428]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,435.429],[1126.77,330.174],[1195.78,437.318],[1195.78,333.978]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,554.812],[1126.77,449.557],[1195.78,554.529],[1195.78,451.189]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,572.371],[1126.77,677.625],[1195.78,571.768],[1195.78,675.108]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1126.77,689.769],[1126.77,795.024],[1195.78,687.031],[1195.78,790.371]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1127.76,814.527],[1127.76,919.786],[1196.7,809.467],[1196.7,912.792]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1164.47,319.371],[1164.47,221.428],[1207.9,326.301],[1207.9,231.444]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1195.85,440.137],[1242.13,439.934],[1195.85,339.655],[1242.13,339.247]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1196.56,469.097],[1196.56,397.974],[1196.59,470.444],[1196.59,400.687]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1195.85,554.106],[1242.13,554.136],[1195.85,453.624],[1242.13,453.449]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1196.56,561.631],[1196.56,632.753],[1196.59,561.201],[1196.59,630.958]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1195.85,570.869],[1242.13,570.933],[1195.85,671.351],[1242.13,671.62]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1196.56,640.959],[1196.56,712.082],[1196.59,639.007],[1196.59,708.764]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1195.85,682.944],[1242.13,683.237],[1195.85,783.426],[1242.13,783.924]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1196.74,802.342],[1244.8,802.899],[1196.74,902.941],[1244.8,903.712]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1207.9,326.301],[1207.9,231.444],[1248.16,336.335],[1248.16,245.949]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1239.35,788.359],[1314.94,789.188],[1239.35,883.612],[1314.94,884.758]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1239.74,445.346],[1315.61,445.032],[1239.74,350.145],[1315.61,349.514]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1239.74,569.207],[1315.61,569.307],[1239.74,664.408],[1315.61,664.826]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1239.74,675.392],[1315.61,675.846],[1239.74,770.593],[1315.61,771.365]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1239.74,553.325],[1239.74,458.125],[1315.61,553.372],[1315.61,457.854]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1248.34,336.427],[1248.34,246.08],[1266.68,346.281],[1266.68,260.324]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1308.85,776.152],[1324.55,776.315],[1308.85,866.737],[1324.55,866.962]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1315.61,445.032],[1315.61,349.514],[1347.15,449.569],[1347.15,358.648]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1315.61,553.372],[1315.61,457.854],[1347.15,552.693],[1347.15,461.773]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1315.61,569.307],[1315.61,664.826],[1347.15,567.86],[1347.15,658.78]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:7,
                    verts:[[1315.61,675.846],[1315.61,771.365],[1347.15,669.27],[1347.15,760.19]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[504.621,447.293],[504.621,354.066],[493.288,451.81],[493.288,363.162]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[504.621,553.034],[504.621,459.807],[493.288,552.357],[493.288,463.709]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[504.621,568.586],[504.621,661.813],[493.288,567.145],[493.288,655.793]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[504.621,672.569],[504.621,765.796],[493.288,666.021],[493.288,754.669]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[505.916,783.2],[505.916,876.48],[494.241,770.525],[494.241,858.958]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[577.867,447.231],[577.867,353.941],[504.621,447.293],[504.621,354.066]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[577.867,553.043],[577.867,459.753],[504.621,553.034],[504.621,459.807]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[577.867,568.606],[577.867,661.896],[504.621,568.586],[504.621,661.813]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[577.867,672.659],[577.867,765.949],[504.621,672.569],[504.621,765.796]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[578.896,783.364],[578.896,876.707],[505.916,783.2],[505.916,876.48]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[597.962,797.456],[551.319,797.345],[597.962,896.187],[551.319,896.033]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[598.364,441.972],[598.364,343.351],[553.445,442.012],[553.445,343.432]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[598.364,553.831],[598.364,455.21],[553.445,553.825],[553.445,455.245]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[598.364,570.283],[598.364,668.905],[553.445,570.271],[553.445,668.851]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[598.364,680.283],[598.364,778.904],[553.445,680.225],[553.445,778.805]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[645.146,437.048],[645.146,333.434],[586.861,439.244],[586.861,337.857]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[645.146,554.569],[645.146,450.956],[586.861,554.24],[586.861,452.853]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[645.146,571.854],[645.146,675.468],[586.861,571.154],[586.861,672.541]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[645.146,687.423],[645.146,791.036],[586.861,684.239],[586.861,785.626]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[645.146,810.224],[645.146,913.838],[586.997,804.352],[586.997,905.72]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[609.765,330.316],[609.765,237.248],[589.434,340.456],[589.434,251.905]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[638.81,323.119],[638.81,226.845],[609.765,330.316],[609.765,237.248]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[687.732,317.601],[687.732,218.869],[638.81,323.119],[638.81,226.845]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[906.912,436.801],[906.912,332.938],[645.146,437.048],[645.146,333.434]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[906.912,554.606],[906.912,450.743],[645.146,554.569],[645.146,450.956]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[906.912,571.933],[906.912,675.796],[645.146,571.854],[645.146,675.468]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[906.912,687.78],[906.912,791.643],[645.146,687.423],[645.146,791.036]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[906.912,810.877],[906.912,914.74],[645.146,810.224],[645.146,913.838]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[746.465,317.481],[687.732,317.601],[746.465,218.696],[687.732,218.869]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[800.118,312.342],[800.118,211.267],[742.226,313.894],[742.226,213.51]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[842.592,311.379],[842.592,209.875],[800.118,312.342],[800.118,211.267]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[907.152,310.376],[907.152,208.425],[842.592,311.379],[842.592,209.875]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[908.42,436.8],[1171.46,436.552],[908.42,332.935],[1171.46,332.436]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[908.42,554.606],[908.42,450.742],[1171.46,554.643],[1171.46,450.528]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[908.42,571.933],[1171.46,572.012],[908.42,675.798],[1171.46,676.128]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[908.42,687.782],[1171.46,688.141],[908.42,791.647],[1171.46,792.256]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[909.392,810.883],[1172.43,811.54],[909.392,914.749],[1172.43,915.656]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[911.773,310.247],[977.2,310.979],[911.773,208.239],[977.2,209.297]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[977.2,310.979],[1020.59,311.764],[977.2,209.297],[1020.59,210.432]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1020.59,311.764],[1020.59,210.432],[1080.06,313.077],[1080.06,212.33]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1078.91,316.691],[1138.1,316.57],[1078.91,217.553],[1138.1,217.378]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1138.1,316.57],[1138.1,217.378],[1192.22,321.911],[1192.22,225.098]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1171.46,436.552],[1171.46,332.436],[1234.62,438.647],[1234.62,336.654]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1171.46,554.643],[1171.46,450.528],[1234.62,554.329],[1234.62,452.337]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1171.46,572.012],[1171.46,676.128],[1234.62,571.344],[1234.62,673.336]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1171.46,688.141],[1171.46,792.256],[1234.62,685.104],[1234.62,787.096]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1172.43,811.54],[1172.43,915.656],[1235.48,805.935],[1235.48,907.909]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1192.22,321.91],[1192.22,225.098],[1227.81,329.027],[1227.81,235.384]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1227.81,329.027],[1227.81,235.384],[1257.2,339.142],[1257.2,250.005]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1228.42,441.407],[1273.9,441.367],[1228.42,342.214],[1273.9,342.132]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1228.42,570.463],[1228.42,669.657],[1273.9,570.476],[1273.9,669.711]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1228.42,681.102],[1273.9,681.161],[1228.42,780.295],[1273.9,780.396]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1229.54,798.958],[1276.77,799.07],[1229.54,898.264],[1276.77,898.419]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1228.42,553.916],[1228.42,454.722],[1273.9,553.922],[1273.9,454.687]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1257.29,339.233],[1257.29,250.136],[1265.51,349.006],[1265.51,264.264]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1259.3,784.895],[1333.3,785.061],[1259.3,878.823],[1333.3,879.053]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1259.56,446.653],[1259.56,352.777],[1333.83,446.59],[1333.83,352.65]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1259.56,568.79],[1259.56,662.666],[1333.83,568.81],[1333.83,662.75]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1259.56,673.497],[1259.56,767.373],[1333.83,673.589],[1333.83,767.528]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1259.56,553.13],[1259.56,459.254],[1333.83,553.139],[1333.83,459.199]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1316.54,772.38],[1331.87,772.413],[1316.54,861.523],[1331.87,861.568]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1333.83,446.59],[1333.83,352.65],[1354.31,451.115],[1354.31,361.764]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1333.83,553.139],[1333.83,459.199],[1354.31,552.461],[1354.31,463.109]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1333.83,568.81],[1333.83,662.75],[1354.31,567.367],[1354.31,656.718]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:8,
                    verts:[[1333.83,673.589],[1333.83,767.528],[1354.31,667.028],[1354.31,756.379]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[521.552,446.07],[521.552,351.603],[499.373,450.584],[499.373,360.693]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[521.552,553.217],[521.552,458.75],[499.373,552.54],[499.373,462.65]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[521.552,568.976],[521.552,663.443],[499.373,567.536],[499.373,657.427]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[521.552,674.343],[521.552,768.81],[499.373,667.798],[499.373,757.689]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[523.002,786.433],[523.002,880.95],[499.857,773.763],[499.857,863.434]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[596.614,446.249],[596.614,351.964],[521.552,446.07],[521.552,351.603]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[596.614,553.19],[596.614,458.905],[521.552,553.217],[521.552,458.75]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[596.614,568.919],[596.614,663.204],[521.552,568.976],[521.552,663.443]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[596.614,674.083],[596.614,768.368],[521.552,674.343],[521.552,768.81]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[597.787,785.959],[523.002,786.433],[597.787,880.294],[523.002,880.95]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[629.546,799.931],[581.892,800.251],[629.546,899.609],[581.892,900.051]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[629.705,441.04],[583.815,440.924],[629.705,341.474],[583.815,341.241]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[629.705,553.971],[629.705,454.405],[583.815,553.988],[583.815,454.305]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[629.705,570.581],[629.705,670.147],[583.815,570.618],[583.815,670.301]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[629.705,681.635],[583.815,681.803],[629.705,781.201],[583.815,781.486]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[597.559,338.354],[597.559,248.866],[587.891,348.132],[587.891,262.999]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[628.613,328.322],[628.613,234.366],[597.559,338.354],[597.559,248.866]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,436.273],[688.622,331.874],[624.319,438.263],[624.319,335.881]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,554.685],[688.622,450.286],[624.319,554.387],[624.319,452.005]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,572.101],[688.622,676.501],[624.319,571.467],[624.319,673.848]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,688.546],[688.622,792.945],[624.319,685.661],[624.319,788.042]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,812.278],[688.622,916.677],[624.414,806.951],[624.414,909.313]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[665.462,321.326],[665.462,224.254],[628.613,328.322],[628.613,234.366]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[720.638,316.184],[720.638,216.821],[665.462,321.326],[665.462,224.254]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,436.273],[952.133,436.971],[688.622,331.874],[952.133,333.281]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,554.685],[952.133,554.58],[688.622,450.286],[952.133,450.89]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,572.101],[952.133,571.878],[688.622,676.501],[952.133,675.569]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,688.546],[952.133,687.533],[688.622,792.945],[952.133,791.224]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[688.622,812.278],[952.133,810.426],[688.622,916.677],[952.133,914.116]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[780.043,316.526],[720.638,316.184],[780.043,217.315],[720.638,216.821]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[839.153,311.828],[839.153,210.524],[779.392,312.913],[779.392,212.092]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[882.663,311.209],[839.153,311.828],[882.663,209.63],[839.153,210.524]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[948.086,310.729],[882.663,311.209],[948.086,208.937],[882.663,209.63]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[952.815,310.639],[952.815,208.805],[1017.05,311.885],[1017.05,210.607]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[953.637,436.975],[953.637,333.289],[1213.58,437.665],[1213.58,334.677]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[953.637,554.58],[953.637,450.893],[1213.58,554.477],[1213.58,451.489]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[953.637,571.877],[953.637,675.564],[1213.58,571.657],[1213.58,674.645]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[953.637,687.527],[953.637,791.214],[1213.58,686.528],[1213.58,789.516]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[954.606,810.408],[954.606,914.092],[1214.53,808.581],[1214.53,911.566]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1017.05,311.885],[1017.05,210.607],[1059.2,313.005],[1059.2,212.226]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1059.2,313.005],[1059.2,212.226],[1116.52,314.767],[1116.52,214.773]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1111.83,318.322],[1170.07,318.657],[1111.83,219.911],[1170.07,220.395]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1170.07,318.657],[1170.07,220.395],[1217.77,324.318],[1217.77,228.578]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1213.58,437.665],[1213.58,334.677],[1270.5,439.941],[1270.5,339.26]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1213.58,554.477],[1213.58,451.489],[1270.5,554.136],[1270.5,453.455]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1213.58,571.657],[1213.58,674.645],[1270.5,570.931],[1270.5,671.612]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1213.58,686.528],[1213.58,789.516],[1270.5,683.228],[1270.5,783.909]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1214.53,808.581],[1214.53,911.566],[1271.29,802.499],[1271.29,903.158]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1217.77,324.318],[1217.77,228.578],[1245.53,331.569],[1245.53,239.059]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1245.53,331.569],[1245.53,239.059],[1264.26,341.706],[1264.26,253.711]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1258.31,442.627],[1258.31,344.671],[1302.63,442.739],[1302.63,344.896]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1258.31,570.074],[1258.31,668.031],[1302.63,570.039],[1302.63,667.882]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1258.31,679.333],[1258.31,777.29],[1302.63,679.171],[1302.63,777.014]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1259.65,795.708],[1305.66,795.399],[1259.65,893.771],[1305.66,893.345]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1258.31,553.733],[1258.31,455.776],[1302.63,553.716],[1302.63,455.873]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1276.96,447.875],[1276.96,355.237],[1349.14,448.047],[1349.14,355.585]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1276.96,568.401],[1276.96,661.038],[1349.14,568.346],[1349.14,660.808]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1276.96,671.726],[1276.96,764.364],[1349.14,671.476],[1349.14,763.939]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1276.82,781.655],[1276.82,874.345],[1348.74,781.199],[1348.74,873.715]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1276.96,552.947],[1276.96,460.309],[1349.14,552.921],[1349.14,460.458]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1321.92,768.922],[1336.79,768.833],[1321.92,856.743],[1336.79,856.619]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1349.14,448.047],[1349.14,355.585],[1358.94,452.537],[1358.94,364.627]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1349.14,552.921],[1349.14,460.458],[1358.94,552.248],[1358.94,464.337]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1349.14,568.346],[1349.14,660.808],[1358.94,566.913],[1358.94,654.824]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:9,
                    verts:[[1349.14,671.476],[1349.14,763.939],[1358.94,664.967],[1358.94,752.877]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[541.626,444.769],[541.626,348.983],[508.334,449.254],[508.334,358.015]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[541.626,553.412],[541.626,457.626],[508.334,552.74],[508.334,461.501]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[541.626,569.391],[541.626,665.177],[508.334,567.961],[508.334,659.199]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[541.626,676.228],[541.626,772.014],[508.334,669.726],[508.334,760.965]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[543.226,789.87],[543.226,885.7],[508.328,777.278],[508.328,868.294]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.977,445.201],[541.626,444.769],[617.977,349.852],[541.626,348.983]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.977,553.347],[617.977,457.999],[541.626,553.412],[541.626,457.626]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.977,569.254],[541.626,569.391],[617.977,664.602],[541.626,665.177]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.977,675.603],[541.626,676.228],[617.977,770.951],[541.626,772.014]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[619.288,788.73],[543.226,789.87],[619.288,884.124],[543.226,885.7]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[607.965,336.045],[607.965,245.529],[588.119,345.826],[588.119,259.666]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[649.829,326.182],[649.829,231.272],[607.965,336.046],[607.965,245.529]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[615.574,803.255],[663.838,802.49],[615.574,904.204],[663.838,903.146]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.269,439.798],[663.743,440.076],[617.269,338.974],[663.743,339.533]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.269,554.157],[663.743,554.115],[617.269,453.332],[663.743,453.572]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.269,570.977],[663.743,570.888],[617.269,671.802],[663.743,671.432]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[617.269,683.435],[663.743,683.032],[617.269,784.259],[663.743,783.576]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[694.382,319.437],[694.382,221.522],[649.829,326.182],[649.829,231.272]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[654.001,468.97],[654.001,397.72],[653.547,470.316],[653.547,400.429]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[654.001,561.671],[654.001,632.922],[653.547,561.242],[653.547,631.129]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[654.001,641.143],[654.001,712.393],[653.547,639.192],[653.547,709.079]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[654.03,725.506],[654.03,796.725],[653.597,722.108],[653.597,792.028]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[664.691,437.267],[664.691,333.876],[663.743,440.076],[663.743,339.533]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[664.691,554.536],[664.691,451.145],[663.743,554.115],[663.743,453.572]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[664.691,571.784],[664.691,675.175],[663.743,570.888],[663.743,671.432]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[664.691,687.104],[664.691,790.496],[663.743,683.032],[663.743,783.576]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[664.742,809.59],[664.742,912.961],[663.838,802.49],[663.838,903.146]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,435.504],[734.522,330.325],[664.691,437.267],[664.691,333.876]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,554.8],[734.522,449.622],[664.691,554.536],[664.691,451.145]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,572.347],[734.522,677.525],[664.691,571.784],[664.691,675.175]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,689.661],[734.522,794.839],[664.691,687.104],[664.691,790.496]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,814.317],[734.522,919.495],[664.742,809.59],[664.742,912.961]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[755.46,314.714],[755.46,214.696],[694.382,319.437],[694.382,221.522]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,435.504],[734.522,330.325],[997.174,437.152],[997.174,333.645]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,554.8],[734.522,449.622],[997.174,554.553],[997.174,451.046]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,572.347],[734.522,677.525],[997.174,571.821],[997.174,675.328]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,689.661],[734.522,794.839],[997.174,687.27],[997.174,790.778]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[734.522,814.317],[734.522,919.495],[997.174,809.946],[997.174,913.453]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[755.46,314.714],[815.017,315.524],[755.46,214.696],[815.017,215.867]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[761.31,380.49],[761.31,309.772],[759.848,382.262],[759.848,312.333]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[818.003,311.908],[818.003,210.64],[815.017,315.524],[815.017,215.867]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[879.09,311.303],[818.003,311.908],[879.09,209.766],[818.003,210.64]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[923.233,311.034],[879.09,311.303],[923.233,209.378],[879.09,209.766]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[923.233,311.034],[988.903,311.079],[923.233,209.378],[988.903,209.443]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[993.694,311.027],[993.694,209.367],[1056.15,312.773],[1056.15,211.89]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[998.66,437.162],[998.66,333.664],[1253.05,438.759],[1253.05,336.88]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[998.66,554.552],[998.66,451.054],[1253.05,554.313],[1253.05,452.434]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[998.66,571.818],[998.66,675.316],[1253.05,571.308],[1253.05,673.187]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[998.66,687.257],[998.66,790.755],[1253.05,684.942],[1253.05,786.821]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[999.617,809.905],[999.617,913.397],[1253.98,805.672],[1253.98,907.545]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1056.15,312.773],[1056.15,211.89],[1096.68,314.213],[1096.68,213.972]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1096.68,314.213],[1096.68,213.972],[1151.38,316.402],[1151.38,217.135]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1143.26,319.877],[1143.26,222.159],[1200.08,320.65],[1200.08,223.277]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1200.08,320.65],[1200.08,223.277],[1241.16,326.585],[1241.16,231.855]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1241.16,326.585],[1241.16,231.855],[1261.12,333.923],[1261.12,242.462]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1253.05,438.759],[1253.05,336.88],[1303.41,441.192],[1303.41,341.779]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1253.05,554.313],[1253.05,452.434],[1303.41,553.948],[1303.41,454.536]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1253.05,571.308],[1253.05,673.187],[1303.41,570.532],[1303.41,669.945]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1253.05,684.942],[1253.05,786.821],[1303.41,681.415],[1303.41,780.827]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1253.98,805.672],[1253.98,907.545],[1304.14,799.176],[1304.14,898.565]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1261.12,333.923],[1261.12,242.462],[1269.43,344.027],[1269.43,257.066]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1285.57,443.791],[1285.57,347.014],[1328.39,444.047],[1328.39,347.529]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1285.57,569.703],[1285.57,666.48],[1328.39,569.621],[1328.39,666.139]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1285.57,677.646],[1285.57,774.423],[1328.39,677.275],[1328.39,773.793]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1287.11,792.606],[1287.11,889.483],[1331.56,791.901],[1331.56,888.508]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1292.01,449.009],[1292.01,357.522],[1361.67,449.403],[1361.67,358.315]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1292.01,568.039],[1292.01,659.526],[1361.67,567.913],[1361.67,659.001]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1292.01,670.082],[1292.01,761.569],[1361.67,669.511],[1361.67,760.599]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1291.98,778.646],[1291.98,870.185],[1361.4,777.606],[1361.4,868.747]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1285.57,553.558],[1285.57,456.781],[1328.39,553.52],[1328.39,457.003]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1325.11,765.774],[1339.46,765.57],[1325.11,852.391],[1339.46,852.109]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:10,
                    verts:[[1292.01,552.776],[1292.01,461.289],[1361.67,552.717],[1361.67,461.629]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[566.664,793.506],[566.664,890.727],[519.767,781.075],[519.767,873.543]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,443.393],[564.92,346.211],[520.287,447.819],[520.287,355.126]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,553.618],[564.92,456.437],[520.287,552.955],[520.287,460.261]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,569.83],[564.92,667.011],[520.287,568.418],[520.287,661.112]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,678.224],[564.92,775.405],[520.287,671.807],[520.287,764.5]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[537.591,451.037],[537.591,358.511],[523.228,463.486],[523.228,384.018]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[537.591,555.982],[537.591,463.456],[523.228,553.621],[523.228,474.153]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[537.591,571.417],[537.591,663.942],[523.228,566.878],[523.228,646.346]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[537.591,674.618],[537.591,767.143],[523.228,655.515],[523.228,734.983]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[537.591,781.226],[537.591,873.751],[523.228,747.078],[523.228,826.547]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,443.393],[641.987,444.087],[564.92,346.211],[641.987,347.61]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,553.618],[564.92,456.437],[641.987,553.514],[641.987,457.037]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,569.83],[564.92,667.011],[641.987,569.609],[641.987,666.086]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[564.92,678.224],[641.987,677.217],[564.92,775.405],[641.987,773.695]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[566.664,793.506],[643.429,791.671],[566.664,890.727],[643.429,888.191]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[590.449,343.26],[590.449,255.958],[582.081,353.867],[582.081,271.289]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[595.983,736.823],[595.983,812.37],[589.038,728.256],[589.038,800.527]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[620.712,333.529],[620.712,241.892],[590.449,343.26],[590.449,255.958]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[596.842,464.925],[596.842,389.573],[590.309,467.941],[590.309,395.646]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[596.842,562.962],[596.842,638.314],[590.309,562],[590.309,634.294]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[596.842,647.008],[596.842,722.359],[590.309,642.635],[590.309,714.93]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[673.429,323.898],[673.429,227.971],[620.712,333.529],[620.712,241.892]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[623.61,468.165],[623.61,396.097],[620.027,469.521],[620.027,398.828]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[623.61,561.928],[623.61,633.996],[620.027,561.496],[620.027,632.188]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[623.61,642.311],[623.61,714.379],[620.027,640.345],[620.027,711.037]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[623.568,727.642],[623.568,799.678],[620.155,724.217],[620.155,794.943]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[652.346,806.348],[652.346,908.479],[639.843,790.926],[639.843,887.16]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,438.639],[653.789,336.639],[641.987,444.087],[641.987,347.61]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,554.331],[653.789,452.33],[641.987,553.514],[641.987,457.037]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,571.347],[653.789,673.347],[641.987,569.609],[641.987,666.086]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,685.116],[653.789,787.116],[641.987,677.217],[641.987,773.695]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[652.346,806.348],[700.787,805.122],[652.346,908.479],[700.787,906.784]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,438.639],[700.433,439.084],[653.789,336.639],[700.433,337.534]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,554.331],[653.789,452.33],[700.433,554.264],[700.433,452.715]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,571.347],[653.789,673.347],[700.433,571.205],[700.433,672.754]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[653.789,685.116],[700.433,684.471],[653.789,787.116],[700.433,786.02]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[725.536,317.456],[725.536,218.659],[673.429,323.898],[673.429,227.971]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[707.89,436.261],[707.89,331.85],[700.433,439.084],[700.433,337.534]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[707.89,554.687],[707.89,450.276],[700.433,554.264],[700.433,452.715]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[707.89,572.105],[707.89,676.516],[700.433,571.205],[700.433,672.754]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[707.89,688.563],[707.89,792.974],[700.433,684.471],[700.433,786.02]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[707.897,812.256],[707.897,916.646],[700.787,805.122],[700.787,906.784]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,434.746],[782.685,328.798],[707.89,436.261],[707.89,331.85]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,554.914],[782.685,448.967],[707.89,554.687],[707.89,450.276]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,572.589],[782.685,678.536],[707.89,572.105],[707.89,676.516]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,690.76],[782.685,796.707],[707.89,688.563],[707.89,792.974]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,816.327],[782.685,922.275],[707.897,812.256],[707.897,916.646]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[792.108,313.196],[792.108,212.502],[725.536,317.456],[725.536,218.659]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[731.443,379.275],[731.443,308.015],[728.168,381.047],[728.168,310.577]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,434.746],[782.685,328.798],[1041.84,437.344],[1041.84,334.031]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,554.914],[782.685,448.967],[1041.84,554.525],[1041.84,451.212]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,572.589],[782.685,678.536],[1041.84,571.76],[1041.84,675.073]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,690.76],[782.685,796.707],[1041.84,686.993],[1041.84,790.306]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[782.685,816.327],[782.685,922.275],[1041.84,809.438],[1041.84,912.751]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[792.108,313.196],[851.279,314.481],[792.108,212.502],[851.279,214.359]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[857.923,310.886],[857.923,209.162],[851.279,314.481],[851.279,214.359]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[919.778,310.771],[857.923,310.886],[919.778,208.997],[857.923,209.162]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[919.778,310.771],[964.14,310.857],[919.778,208.997],[964.14,209.121]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[964.14,310.857],[1029.44,311.426],[964.14,209.121],[1029.44,209.944]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1034.25,311.412],[1034.25,209.923],[1094.36,313.641],[1094.36,213.145]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1043.29,437.359],[1043.29,334.06],[1289.8,439.83],[1289.8,339.038]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1043.29,554.522],[1043.29,451.224],[1289.8,554.152],[1289.8,453.36]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1043.29,571.755],[1043.29,675.053],[1289.8,570.966],[1289.8,671.759]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1043.29,686.972],[1043.29,790.27],[1289.8,683.388],[1289.8,784.18]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1044.23,809.374],[1044.23,912.663],[1290.69,802.822],[1290.69,903.606]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1094.36,313.641],[1094.36,213.145],[1132.92,315.387],[1132.92,215.669]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1132.92,315.387],[1132.92,215.669],[1184.55,317.978],[1184.55,219.414]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1173.13,321.355],[1173.13,224.295],[1228.08,322.548],[1228.08,226.02]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1228.08,322.548],[1228.08,226.02],[1262.37,328.711],[1262.37,234.928]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1262.37,328.711],[1262.37,234.928],[1274.61,336.092],[1274.61,245.597]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1289.8,439.83],[1289.8,339.038],[1333.36,442.398],[1333.36,344.208]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1289.8,554.152],[1289.8,453.36],[1333.36,553.767],[1333.36,455.578]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1289.8,570.966],[1289.8,671.759],[1333.36,570.148],[1333.36,668.337]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1289.8,683.388],[1289.8,784.181],[1333.36,679.666],[1333.36,777.856]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1290.69,802.822],[1290.69,903.606],[1334.01,795.973],[1334.01,894.137]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1304.76,450.058],[1304.76,359.634],[1371.52,450.659],[1371.52,360.845]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1304.76,567.704],[1304.76,658.128],[1371.52,567.512],[1371.52,657.326]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1304.76,668.561],[1304.76,758.985],[1371.52,667.689],[1371.52,757.503]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1304.86,775.864],[1304.86,866.339],[1371.37,774.274],[1371.37,864.141]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1310.19,444.898],[1310.19,349.243],[1351.22,445.289],[1351.22,350.031]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1310.19,569.35],[1310.19,665.005],[1351.22,569.225],[1351.22,664.483]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1310.19,676.041],[1310.19,771.696],[1351.22,675.474],[1351.22,770.732]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1311.9,789.654],[1311.9,885.402],[1354.49,788.576],[1354.49,883.912]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1310.19,553.393],[1310.19,457.738],[1351.22,553.334],[1351.22,458.076]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1326.19,762.925],[1339.96,762.613],[1326.19,848.452],[1339.96,848.021]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:11,
                    verts:[[1304.76,552.619],[1304.76,462.195],[1371.52,552.529],[1371.52,462.715]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[552.791,449.608],[552.791,355.585],[507.937,462.195],[507.937,381.373]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[552.791,556.253],[552.791,462.229],[507.937,553.866],[507.937,473.044]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[552.791,571.938],[552.791,665.962],[507.937,567.349],[507.937,648.17]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[552.791,676.81],[552.791,770.833],[507.937,657.495],[507.937,738.317]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[552.791,785.144],[552.791,879.168],[507.937,750.619],[507.937,831.441]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[593.423,797.326],[593.423,896.008],[534.335,785.148],[534.335,879.173]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,441.946],[591.544,343.299],[535.39,446.282],[535.39,352.029]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,553.835],[591.544,455.188],[535.39,553.185],[535.39,458.933]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,570.292],[591.544,668.939],[535.39,568.909],[535.39,663.161]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,680.321],[591.544,778.968],[535.39,674.036],[535.39,768.288]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[573.655,739.687],[573.655,816.329],[559.004,731.058],[559.004,804.401]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[574.087,463.85],[574.087,387.408],[560.362,466.887],[560.362,393.524]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[574.087,563.305],[574.087,639.747],[560.362,562.336],[560.362,635.699]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[574.087,648.566],[574.087,725.008],[560.362,644.163],[560.362,717.526]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[594.995,340.437],[594.995,251.877],[575.564,351.118],[575.564,267.316]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[593.956,467.199],[593.956,394.153],[587.133,468.563],[587.133,396.898]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[593.956,562.236],[593.956,635.283],[587.133,561.801],[587.133,633.466]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[593.956,643.711],[593.956,716.757],[587.133,641.734],[587.133,713.398]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[593.84,730.2],[593.84,803.215],[587.341,726.758],[587.341,798.456]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,441.946],[591.544,343.299],[668.696,442.914],[668.696,345.248]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,553.835],[591.544,455.188],[668.696,553.69],[668.696,456.024]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,570.292],[591.544,668.939],[668.696,569.983],[668.696,667.649]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[591.544,680.321],[591.544,778.968],[668.696,678.917],[668.696,776.584]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[593.423,797.326],[670.263,794.768],[593.423,896.008],[670.263,892.472]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[635.895,330.812],[635.895,237.965],[594.995,340.437],[594.995,251.877]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[699.451,321.485],[699.451,224.484],[635.895,330.812],[635.895,237.965]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[692.195,809.503],[692.195,912.841],[665.954,794.048],[665.954,891.476]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,437.455],[693.365,334.255],[668.696,442.914],[668.696,345.248]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,554.508],[693.365,451.308],[668.696,553.69],[668.696,456.024]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,571.724],[693.365,674.924],[668.696,569.983],[668.696,667.649]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,686.831],[693.365,790.031],[668.696,678.917],[668.696,776.584]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[692.195,809.503],[740.35,807.803],[692.195,912.841],[740.35,910.491]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,437.455],[693.365,334.255],[739.733,438.072],[739.733,335.497]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,554.508],[693.365,451.308],[739.733,554.416],[739.733,451.841]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,571.724],[693.365,674.924],[739.733,571.527],[739.733,674.102]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[693.365,686.831],[693.365,790.031],[739.733,685.937],[739.733,788.512]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[702.027,377.72],[702.027,305.767],[696.897,379.488],[696.897,308.323]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[758.898,315.4],[758.898,215.688],[699.451,321.485],[699.451,224.484]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[753.829,435.256],[753.829,329.825],[739.733,438.072],[739.733,335.497]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[753.829,554.838],[753.829,449.407],[739.733,554.416],[739.733,451.841]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[753.829,572.426],[753.829,677.856],[739.733,571.527],[739.733,674.102]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[753.829,690.021],[753.829,795.451],[739.733,685.937],[739.733,788.512]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[753.79,814.921],[753.79,920.331],[740.35,807.803],[740.35,910.491]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,434.008],[832.944,327.314],[753.829,435.256],[753.829,329.825]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,555.025],[832.944,448.33],[753.829,554.838],[753.829,449.407]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,572.824],[832.944,679.518],[753.829,572.426],[753.829,677.856]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,691.829],[832.944,798.523],[753.829,690.021],[753.829,795.451]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,818.281],[832.944,924.976],[753.79,814.921],[753.79,920.331]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[830.494,311.649],[830.494,210.266],[758.898,315.4],[758.898,215.688]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[830.494,311.649],[830.494,210.266],[888.719,313.412],[888.719,212.814]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,434.008],[832.944,327.314],[1085.92,437.552],[1085.92,334.449]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,555.025],[832.944,448.33],[1085.92,554.494],[1085.92,451.391]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,572.824],[832.944,679.518],[1085.92,571.693],[1085.92,674.796]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,691.829],[832.944,798.523],[1085.92,686.692],[1085.92,789.794]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[832.944,818.281],[832.944,924.976],[1085.92,808.888],[1085.92,911.99]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[899.019,309.862],[899.019,207.684],[888.719,313.412],[888.719,212.814]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[899.019,309.862],[961.057,310.248],[899.019,207.684],[961.057,208.24]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[961.057,310.248],[1005.21,310.69],[961.057,208.24],[1005.21,208.88]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1005.21,310.69],[1005.21,208.88],[1069.52,311.781],[1069.52,210.457]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1074.3,311.805],[1074.3,210.492],[1131.51,314.499],[1131.51,214.385]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1087.33,437.571],[1087.33,334.489],[1323.74,440.882],[1323.74,341.156]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1087.33,554.491],[1087.33,451.408],[1323.74,553.994],[1323.74,454.268]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1087.33,571.687],[1087.33,674.77],[1323.74,570.631],[1323.74,670.357]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1087.33,686.663],[1087.33,789.746],[1323.74,681.863],[1323.74,781.589]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1088.23,808.802],[1088.23,911.872],[1324.58,800.025],[1324.58,899.739]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1131.51,314.499],[1131.51,214.385],[1167.78,316.535],[1167.78,217.329]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1167.78,316.535],[1167.78,217.329],[1215.92,319.503],[1215.92,221.619]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1201.35,322.763],[1201.35,226.33],[1254.02,324.358],[1254.02,228.637]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1254.02,324.359],[1254.02,228.637],[1281.4,330.706],[1281.4,237.811]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1281.4,330.706],[1281.4,237.811],[1286.03,338.087],[1286.03,248.48]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1315.25,451.026],[1315.25,361.584],[1378.73,451.823],[1378.73,363.187]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1315.25,567.395],[1315.25,656.838],[1378.73,567.141],[1378.73,655.776]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1315.25,667.157],[1315.25,756.6],[1378.73,666.003],[1378.73,754.638]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1315.45,773.295],[1315.45,862.787],[1378.71,771.189],[1378.71,859.877]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1323.74,440.882],[1323.74,341.156],[1360.3,443.561],[1360.3,346.551]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1323.74,553.994],[1323.74,454.268],[1360.3,553.593],[1360.3,456.583]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1323.74,570.631],[1323.74,670.357],[1360.3,569.776],[1360.3,666.786]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1323.74,681.863],[1323.74,781.589],[1360.3,677.979],[1360.3,774.989]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1324.58,800.025],[1324.58,899.739],[1360.87,792.882],[1360.87,889.865]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1332.15,445.951],[1332.15,351.364],[1371.12,446.469],[1371.12,352.408]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1332.15,569.014],[1332.15,663.601],[1371.12,568.849],[1371.12,662.91]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1332.15,674.515],[1332.15,769.102],[1371.12,673.763],[1371.12,767.825]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1334.03,786.844],[1334.03,881.518],[1374.47,785.416],[1374.47,879.544]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1332.15,553.235],[1332.15,458.647],[1371.12,553.157],[1371.12,459.095]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:12,
                    verts:[[1315.25,552.474],[1315.25,463.032],[1378.73,552.355],[1378.73,463.72]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[571.205,448.091],[571.205,352.475],[494.504,460.752],[494.504,378.416]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[571.205,556.54],[571.205,460.925],[494.504,554.139],[494.504,471.804]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[571.205,572.491],[571.205,668.107],[494.504,567.875],[494.504,650.21]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[571.205,679.139],[571.205,774.754],[494.504,659.71],[494.504,742.045]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[571.205,789.307],[571.205,884.923],[494.504,754.577],[494.504,836.913]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[552.522,742.969],[552.522,820.865],[529.841,734.309],[529.841,808.894]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[552.505,462.616],[552.505,384.924],[531.284,465.664],[531.284,391.062]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[552.505,563.698],[552.505,641.391],[531.284,562.726],[531.284,637.328]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[552.505,650.355],[552.505,728.047],[531.284,645.936],[531.284,720.538]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[623.628,801.298],[623.628,901.499],[552.233,789.477],[552.233,885.158]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,440.442],[621.624,340.269],[553.843,444.649],[553.843,348.741]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,554.06],[621.624,453.888],[553.843,553.43],[553.843,457.522]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,570.772],[621.624,670.944],[553.843,569.43],[553.843,665.337]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,682.502],[621.624,782.675],[553.843,676.403],[553.843,772.311]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[565.077,466.07],[565.077,391.878],[554.883,467.436],[554.883,394.629]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[565.077,562.597],[565.077,636.788],[554.883,562.161],[554.883,634.967]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[565.077,645.348],[565.077,719.539],[554.883,643.368],[554.883,716.174]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[564.884,733.194],[564.884,807.353],[555.174,729.745],[555.174,802.585]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[570.711,350.186],[570.711,265.967],[568.213,356.931],[568.213,275.716]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[601.909,337.364],[601.909,247.436],[571.004,348.067],[571.004,262.906]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[653.63,327.911],[653.63,233.772],[601.909,337.364],[601.909,247.436]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,440.442],[621.624,340.269],[698.169,441.694],[698.169,342.79]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,554.06],[621.624,453.888],[698.169,553.873],[698.169,454.969]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,570.772],[621.624,670.944],[698.169,570.372],[698.169,669.276]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[621.624,682.502],[621.624,782.675],[698.169,680.687],[698.169,779.59]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[623.628,801.298],[623.628,901.499],[699.851,797.991],[699.851,896.927]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[727.937,318.967],[727.937,220.844],[653.63,327.911],[653.63,233.772]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[673.063,375.82],[673.063,303.021],[666.028,377.577],[666.028,305.561]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.103,812.679],[735.103,917.231],[694.829,797.302],[694.829,895.975]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,436.263],[735.976,331.854],[698.169,441.694],[698.169,342.79]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,554.687],[735.976,450.278],[698.169,553.873],[698.169,454.969]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,572.104],[735.976,676.513],[698.169,570.372],[698.169,669.276]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,688.56],[735.976,792.968],[698.169,680.687],[698.169,779.59]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[794.437,313.299],[794.437,212.651],[727.937,318.967],[727.937,220.844]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.103,812.679],[735.103,917.231],[782.474,810.494],[782.474,914.211]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,436.263],[735.976,331.854],[781.59,437.056],[781.59,333.451]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,554.687],[735.976,450.278],[781.59,554.568],[781.59,450.963]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,572.104],[735.976,676.513],[781.59,571.852],[781.59,675.457]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[735.976,688.56],[735.976,792.968],[781.59,687.411],[781.59,791.016]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[802.399,434.267],[802.399,327.835],[781.59,437.056],[781.59,333.451]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[802.399,554.986],[802.399,448.554],[781.59,554.568],[781.59,450.963]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[802.399,572.741],[802.399,679.173],[781.59,571.852],[781.59,675.457]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[802.399,691.453],[802.399,797.885],[781.59,687.411],[781.59,791.016]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[802.312,817.541],[802.312,923.953],[782.474,810.494],[782.474,914.211]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[870.514,310.102],[870.514,208.03],[794.437,313.299],[794.437,212.651]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,433.309],[885.099,325.905],[802.399,434.267],[802.399,327.835]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,555.129],[885.099,447.726],[802.399,554.986],[802.399,448.554]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,573.047],[885.099,680.451],[802.399,572.741],[802.399,679.173]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,692.843],[885.099,800.246],[802.399,691.453],[802.399,797.885]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,820.136],[885.099,927.54],[802.312,817.541],[802.312,923.953]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[870.514,310.102],[870.514,208.03],[927.212,312.345],[927.212,211.272]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,433.309],[885.099,325.905],[1129.19,437.785],[1129.19,334.918]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,555.129],[885.099,447.726],[1129.19,554.459],[1129.19,451.592]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,573.047],[885.099,680.451],[1129.19,571.619],[1129.19,674.486]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,692.843],[885.099,800.246],[1129.19,686.354],[1129.19,789.22]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[885.099,820.136],[885.099,927.54],[1129.19,808.27],[1129.19,911.136]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[941.133,308.867],[941.133,206.245],[927.212,312.345],[927.212,211.272]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[941.133,308.867],[1002.74,309.759],[941.133,206.245],[1002.74,207.534]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1002.74,309.759],[1046.26,310.56],[1002.74,207.534],[1046.26,208.692]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1046.26,310.56],[1046.26,208.692],[1108.95,312.166],[1108.95,211.014]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1113.65,312.229],[1113.65,211.104],[1167.44,315.366],[1167.44,215.639]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1130.53,437.809],[1130.53,334.968],[1354.73,441.92],[1354.73,343.246]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1130.53,554.455],[1130.53,451.614],[1354.73,553.839],[1354.73,455.165]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1130.53,571.611],[1130.53,674.453],[1354.73,570.3],[1354.73,668.974]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1130.53,686.318],[1130.53,789.16],[1354.73,680.359],[1354.73,779.032]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1131.4,808.163],[1131.4,910.988],[1355.52,797.267],[1355.52,895.926]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1167.44,315.366],[1167.44,215.639],[1201.09,317.675],[1201.09,218.976]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1201.09,317.675],[1201.09,218.976],[1245.37,320.994],[1245.37,223.774]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1227.82,324.118],[1227.82,228.289],[1277.79,326.096],[1277.79,231.149]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1277.79,326.096],[1277.79,231.149],[1298.2,332.584],[1298.2,240.526]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1322.2,758.051],[1334.61,757.543],[1322.2,841.715],[1334.61,841.013]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1323.45,451.921],[1323.45,363.385],[1383.33,452.9],[1383.33,365.358]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1323.45,567.11],[1323.45,655.645],[1383.33,566.797],[1383.33,654.34]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1323.45,665.86],[1323.45,754.396],[1383.33,664.44],[1383.33,751.983]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1323.76,770.919],[1323.76,859.504],[1383.43,768.331],[1383.43,855.925]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1351.41,446.957],[1351.41,353.39],[1388.08,447.594],[1388.08,354.673]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1351.41,568.693],[1351.41,662.26],[1388.08,568.49],[1388.08,661.411]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1351.41,673.056],[1351.41,766.623],[1388.08,672.132],[1388.08,765.054]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1353.43,784.158],[1353.43,877.804],[1391.47,782.403],[1391.47,875.379]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1354.73,441.92],[1354.73,343.246],[1384.16,444.689],[1384.16,348.822]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1354.73,553.839],[1354.73,455.165],[1384.16,553.424],[1384.16,457.557]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1354.73,570.3],[1354.73,668.974],[1384.16,569.417],[1384.16,665.284]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1354.73,680.359],[1354.73,779.032],[1384.16,676.344],[1384.16,772.211]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1355.52,797.267],[1355.52,895.926],[1384.66,789.889],[1384.66,885.727]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:13,
                    verts:[[1351.41,553.084],[1351.41,459.517],[1388.08,552.988],[1388.08,460.067]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[593.041,446.496],[593.041,349.209],[483.153,459.156],[483.153,375.147]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[593.041,556.843],[593.041,459.555],[483.153,554.442],[483.153,470.433]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[593.041,573.073],[593.041,670.36],[483.153,568.457],[483.153,652.466]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[593.041,681.585],[593.041,778.873],[483.153,662.159],[483.153,746.168]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[593.041,793.68],[593.041,890.968],[483.153,758.955],[483.153,842.964]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[532.728,746.673],[532.728,825.987],[501.654,738.02],[501.654,814.024]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[532.237,461.223],[532.237,382.117],[503.184,464.268],[503.184,388.25]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[532.237,564.143],[532.237,643.248],[503.184,563.171],[503.184,639.189]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[532.237,652.375],[532.237,731.481],[503.184,647.96],[503.184,723.978]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[537.064,464.773],[537.064,389.266],[523.353,466.136],[523.353,392.011]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[537.064,563.01],[537.064,638.517],[523.353,562.576],[523.353,636.7]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[537.064,647.228],[537.064,722.735],[523.353,645.252],[523.353,719.377]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[536.791,736.633],[536.791,812.107],[523.731,733.191],[523.731,807.349]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[566.112,346.875],[566.112,261.181],[556.577,353.721],[556.577,271.077]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[568.598,344.721],[568.598,258.07],[566.112,346.875],[566.112,261.181]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[611.378,334.061],[611.378,242.662],[568.598,344.721],[568.598,258.07]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[657.402,805.375],[657.402,907.134],[573.689,794.028],[573.689,891.449]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,438.897],[655.287,337.159],[575.872,442.934],[575.872,345.287]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,554.292],[655.287,452.554],[575.872,553.687],[575.872,456.041]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,571.264],[655.287,673.003],[575.872,569.977],[575.872,667.623]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,684.741],[655.287,786.479],[575.872,678.889],[575.872,776.536]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[674.051,324.856],[674.051,229.355],[611.378,334.061],[611.378,242.662]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[644.593,373.571],[644.593,299.771],[635.594,375.312],[635.594,302.286]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,438.897],[655.287,337.159],[730.459,440.442],[730.459,340.27]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,554.292],[655.287,452.554],[730.459,554.06],[730.459,453.888]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,571.264],[655.287,673.003],[730.459,570.771],[730.459,670.943]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[655.287,684.741],[655.287,786.479],[730.459,682.501],[730.459,782.673]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[657.402,805.375],[657.402,907.134],[732.246,801.294],[732.246,901.492]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[758.922,316.381],[758.922,217.106],[674.051,324.856],[674.051,229.355]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.013,815.816],[781.013,921.569],[726.528,800.643],[726.528,900.593]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,435.085],[781.567,329.481],[730.459,440.442],[730.459,340.27]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,554.863],[781.567,449.26],[730.459,554.06],[730.459,453.888]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,572.48],[781.567,678.084],[730.459,570.771],[730.459,670.943]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,690.268],[781.567,795.872],[730.459,682.501],[730.459,782.673]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[832.098,311.193],[832.098,209.607],[758.922,316.381],[758.922,217.106]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,435.085],[781.567,329.481],[825.914,436.056],[825.914,331.437]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,554.863],[781.567,449.26],[825.914,554.718],[825.914,450.099]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,572.48],[781.567,678.084],[825.914,572.171],[825.914,676.789]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.567,690.268],[781.567,795.872],[825.914,688.86],[825.914,793.479]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[781.013,815.816],[781.013,921.569],[827.064,813.139],[827.064,917.867]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[853.438,433.32],[853.438,325.926],[825.914,436.056],[825.914,331.437]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[853.438,555.128],[853.438,447.735],[825.914,554.718],[825.914,450.099]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[853.438,573.043],[853.438,680.436],[825.914,572.171],[825.914,676.789]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[853.438,692.827],[853.438,800.22],[825.914,688.86],[825.914,793.479]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[853.303,820.055],[853.303,927.427],[827.064,813.139],[827.064,917.867]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[912.026,308.598],[912.026,205.855],[832.098,311.193],[832.098,209.607]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,432.669],[938.895,324.617],[853.438,433.32],[853.438,325.926]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,555.225],[938.895,447.173],[853.438,555.128],[853.438,447.735]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,573.251],[938.895,681.303],[853.438,573.043],[853.438,680.436]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,693.77],[938.895,801.822],[853.438,692.827],[853.438,800.22]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,821.832],[938.895,929.884],[853.303,820.055],[853.303,927.427]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[912.026,308.598],[912.026,205.855],[966.596,311.319],[966.596,209.788]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,432.669],[938.895,324.617],[1171.37,438.057],[1171.37,335.467]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,555.225],[938.895,447.173],[1171.37,554.418],[1171.37,451.828]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,573.251],[938.895,681.303],[1171.37,571.532],[1171.37,674.122]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,693.77],[938.895,801.822],[1171.37,685.959],[1171.37,788.549]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[938.895,821.832],[938.895,929.884],[1171.37,807.548],[1171.37,910.138]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[984.065,307.94],[984.065,204.905],[966.596,311.319],[966.596,209.788]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[984.065,307.94],[984.065,204.905],[1044.62,309.342],[1044.62,206.932]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1044.62,309.342],[1044.62,206.932],[1087.05,310.5],[1087.05,208.605]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1087.05,310.5],[1087.05,208.605],[1147.49,312.613],[1147.49,211.659]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1152.07,312.713],[1152.07,211.804],[1201.92,316.27],[1201.92,216.945]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1172.63,438.086],[1172.63,335.526],[1382.62,442.953],[1382.62,345.326]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1172.63,554.413],[1172.63,451.853],[1382.62,553.684],[1382.62,456.057]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1172.63,571.523],[1172.63,674.083],[1382.62,569.971],[1382.62,667.597]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1172.63,685.917],[1172.63,788.477],[1382.62,678.861],[1382.62,776.489]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1173.45,807.42],[1173.45,909.961],[1383.36,794.522],[1383.36,892.132]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1201.92,316.27],[1201.92,216.945],[1232.66,318.833],[1232.66,220.649]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1232.66,318.832],[1232.66,220.649],[1272.72,322.474],[1272.72,225.913]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1252.38,325.444],[1252.38,230.206],[1299.28,327.784],[1299.28,233.588]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1299.28,327.784],[1299.28,233.588],[1312.67,334.368],[1312.67,243.105]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1317.12,755.98],[1328.77,755.382],[1317.12,838.852],[1328.77,838.025]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1329.33,452.752],[1329.33,365.058],[1385.3,453.902],[1385.3,367.375]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1329.33,566.845],[1329.33,654.538],[1385.3,566.478],[1385.3,653.005]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1329.33,664.656],[1329.33,752.349],[1385.3,662.988],[1385.3,749.515]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1329.75,768.713],[1329.75,856.453],[1385.51,765.672],[1385.51,852.25]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1367.89,447.926],[1367.89,355.34],[1402.01,448.673],[1402.01,356.845]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1367.89,568.384],[1367.89,660.97],[1402.01,568.146],[1402.01,659.974]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1367.89,671.652],[1367.89,764.238],[1402.01,670.569],[1402.01,762.396]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:14,
                    verts:[[1370.03,781.571],[1370.03,874.228],[1405.42,779.513],[1405.42,871.383]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[455.179,454.62],[455.179,368.821],[452,458.506],[452,376.646]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[455.179,551.936],[455.179,466.137],[452,551.353],[452,469.494]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[455.179,566.249],[455.179,652.048],[452,565.009],[452,646.869]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[455.179,661.947],[455.179,747.746],[452,656.314],[452,738.173]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[618.516,444.845],[618.516,345.824],[474.176,457.41],[474.176,371.569]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[618.516,557.156],[618.516,458.136],[474.176,554.773],[474.176,468.932]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[618.516,573.675],[618.516,672.695],[474.176,569.093],[474.176,654.934]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[618.516,684.12],[618.516,783.14],[474.176,664.838],[474.176,750.679]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[514.483,750.8],[514.483,831.692],[474.624,742.2],[474.624,819.803]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[618.516,798.211],[618.516,897.231],[474.176,763.744],[474.176,849.585]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[513.491,459.669],[513.491,378.988],[476.24,462.695],[476.24,385.083]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[513.491,564.638],[513.491,645.319],[476.24,563.673],[476.24,641.285]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[513.491,654.628],[513.491,735.309],[476.24,650.24],[476.24,727.852]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[510.073,463.305],[510.073,386.312],[492.681,464.659],[492.681,389.037]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[510.073,563.478],[510.073,640.472],[492.681,563.047],[492.681,638.668]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[543.47,350.439],[543.47,266.334],[539.938,359],[539.938,278.709]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[563.796,343.276],[563.796,255.979],[546.86,350.189],[546.86,265.972]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[568.589,341.099],[568.589,252.833],[563.796,343.276],[563.796,255.979]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[623.617,330.558],[623.617,237.598],[568.589,341.099],[568.589,252.833]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[694.844,809.488],[694.844,912.82],[598.943,798.749],[598.943,897.975]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,437.338],[692.635,334.02],[601.714,441.156],[601.714,341.708]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,554.525],[692.635,451.207],[601.714,553.953],[601.714,454.505]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,571.761],[692.635,675.08],[601.714,570.544],[601.714,669.992]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,687.001],[692.635,790.32],[601.714,681.466],[601.714,780.914]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[616.708,370.974],[616.708,296.016],[605.68,372.688],[605.68,298.494]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[697.292,321.687],[697.292,224.774],[623.617,330.558],[623.617,237.598]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,437.338],[692.635,334.02],[765.596,439.184],[765.596,337.736]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,554.525],[692.635,451.207],[765.596,554.249],[765.596,452.801]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,571.761],[692.635,675.08],[765.596,571.173],[765.596,672.621]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[692.635,687.001],[692.635,790.32],[765.596,684.326],[765.596,785.774]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[694.844,809.488],[694.844,912.82],[767.474,804.615],[767.474,906.083]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[792.413,313.778],[792.413,213.343],[697.292,321.687],[697.292,224.774]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[829.806,818.838],[829.806,925.746],[761.085,804.01],[761.085,905.248]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,433.949],[830.023,327.194],[765.596,439.184],[765.596,337.736]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,555.034],[830.023,448.278],[765.596,554.249],[765.596,452.801]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,572.843],[830.023,679.598],[765.596,571.173],[765.596,672.621]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,691.915],[830.023,798.67],[765.596,684.326],[765.596,785.774]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[871.779,309.137],[871.779,206.635],[792.413,313.778],[792.413,213.343]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[829.806,818.838],[829.806,925.746],[873.969,815.666],[873.969,921.361]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,433.949],[830.023,327.194],[872.555,435.099],[872.555,329.511]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,555.034],[830.023,448.278],[872.555,554.861],[872.555,449.272]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,572.843],[830.023,679.598],[872.555,572.476],[872.555,678.064]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[830.023,691.915],[830.023,798.67],[872.555,690.247],[872.555,795.836]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[954.835,307.189],[954.835,203.819],[871.779,309.137],[871.779,206.635]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[906.709,432.442],[906.709,324.159],[872.555,435.099],[872.555,329.511]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[906.709,555.259],[906.709,446.976],[872.555,554.861],[872.555,449.272]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[906.709,573.323],[906.709,681.606],[872.555,572.476],[872.555,678.064]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[906.709,694.1],[906.709,802.383],[872.555,690.247],[872.555,795.836]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[906.526,822.383],[906.526,930.645],[873.969,815.666],[873.969,921.361]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,432.118],[906.709,432.442],[993.991,323.506],[906.709,324.159]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,555.308],[993.991,446.697],[906.709,555.259],[906.709,446.976]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,573.427],[993.991,682.038],[906.709,573.323],[906.709,681.606]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,694.57],[906.709,694.1],[993.991,803.181],[906.709,802.383]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,823.294],[906.526,822.383],[993.991,931.906],[906.526,930.645]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[954.835,307.189],[954.835,203.819],[1006.66,310.381],[1006.66,208.433]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,432.118],[993.991,323.506],[1212.13,438.386],[1212.13,336.129]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,555.308],[993.991,446.697],[1212.13,554.368],[1212.13,452.112]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,573.427],[993.991,682.038],[1212.13,571.427],[1212.13,673.684]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,694.57],[993.991,803.181],[1212.13,685.482],[1212.13,787.739]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[993.991,823.294],[993.991,931.906],[1212.13,806.676],[1212.13,908.933]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1027.56,307.132],[1027.56,203.737],[1006.66,310.381],[1006.66,208.433]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1027.56,307.132],[1027.56,203.737],[1086.4,309.044],[1086.4,206.5]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1086.4,309.044],[1086.4,206.5],[1127.3,310.553],[1127.3,208.682]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1127.3,310.553],[1127.3,208.682],[1184.86,313.159],[1184.86,212.448]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1189.28,313.296],[1189.28,212.647],[1234.7,317.244],[1234.7,218.353]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1213.31,438.42],[1213.31,336.197],[1407.2,443.991],[1407.2,347.417]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1213.31,554.363],[1213.31,452.141],[1407.2,553.528],[1407.2,456.954]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1213.31,571.417],[1213.31,673.639],[1407.2,569.639],[1407.2,666.213]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1213.31,685.433],[1213.31,787.656],[1407.2,677.356],[1407.2,773.93]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1214.07,806.528],[1214.07,908.728],[1407.88,791.762],[1407.88,888.317]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1234.7,317.244],[1234.7,218.353],[1262.26,320.039],[1262.26,222.393]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1262.26,320.039],[1262.26,222.393],[1297.77,323.972],[1297.77,228.078]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1274.85,326.77],[1274.85,232.122],[1318.32,329.449],[1318.32,235.994]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1309.94,754.116],[1309.94,836.275],[1320.78,753.434],[1320.78,835.332]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1318.32,329.449],[1318.32,235.994],[1324.7,336.083],[1324.7,245.584]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1332.82,453.529],[1332.82,366.625],[1384.59,454.839],[1384.59,369.261]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1332.82,566.597],[1332.82,653.501],[1384.59,566.179],[1384.59,651.757]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1332.82,663.528],[1332.82,750.433],[1384.59,661.63],[1384.59,747.208]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1333.33,766.647],[1333.33,853.597],[1384.91,763.186],[1384.91,848.813]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1381.45,448.867],[1381.45,357.236],[1412.83,449.716],[1412.83,358.946]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1381.45,568.084],[1381.45,659.715],[1412.83,567.813],[1412.83,658.583]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1381.45,670.287],[1381.45,761.918],[1412.83,669.056],[1412.83,759.827]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:15,
                    verts:[[1383.69,779.055],[1383.69,870.75],[1416.23,776.717],[1416.23,867.519]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[448.113,452.605],[448.113,364.764],[435.527,456.579],[435.527,372.767]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[448.113,552.237],[448.113,464.396],[435.527,551.642],[435.527,467.829]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[448.113,566.891],[448.113,654.733],[435.527,565.624],[435.527,649.437]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[448.113,664.868],[448.113,752.709],[435.527,659.107],[435.527,742.919]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[498.064,755.342],[498.064,837.97],[449.008,746.853],[449.008,826.235]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[496.542,457.957],[496.542,375.542],[450.708,460.945],[450.708,381.558]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[496.542,551.435],[496.542,469.02],[450.708,550.988],[450.708,471.601]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[496.542,565.184],[496.542,647.6],[450.708,564.231],[450.708,643.618]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[496.542,657.109],[496.542,739.524],[450.708,652.778],[450.708,732.165]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[484.334,461.667],[484.334,383.013],[463.082,463.002],[463.082,385.701]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[484.334,564.001],[484.334,642.655],[463.082,563.575],[463.082,640.876]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[484.334,651.731],[484.334,730.385],[463.082,649.795],[463.082,727.096]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[483.888,744.868],[483.888,823.49],[463.647,741.497],[463.647,818.83]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[647.832,443.161],[647.832,342.376],[467.94,455.521],[467.94,367.699]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[647.832,557.475],[647.832,456.69],[467.94,555.131],[467.94,467.309]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[647.832,574.289],[647.832,675.074],[467.94,569.782],[467.94,657.604]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[647.832,686.703],[647.832,787.488],[467.94,667.737],[467.94,755.559]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[647.832,802.828],[647.832,903.614],[467.94,768.926],[467.94,856.748]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[535.583,346.583],[535.583,260.761],[522.974,355.307],[522.974,273.37]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[564.051,339.415],[564.051,250.398],[539.349,346.352],[539.349,260.426]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[571.264,337.227],[571.264,247.237],[564.051,339.415],[564.051,250.398]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[638.853,326.898],[638.853,232.308],[571.264,337.227],[571.264,247.237]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[589.554,368.028],[589.554,291.758],[576.428,369.705],[576.428,294.182]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[735.997,813.55],[735.997,918.435],[628.224,803.569],[628.224,904.637]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,435.798],[733.712,330.918],[631.591,439.345],[631.591,338.06]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,554.756],[733.712,449.876],[631.591,554.225],[631.591,452.94]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,572.253],[733.712,677.133],[631.591,571.122],[631.591,672.406]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,689.234],[733.712,794.114],[631.591,684.093],[631.591,785.378]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[723.469,318.459],[723.469,220.109],[638.853,326.898],[638.853,232.308]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[828.367,311.221],[828.367,209.647],[723.469,318.459],[723.469,220.109]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,435.798],[733.712,330.918],[803.552,437.947],[803.552,335.246]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,554.756],[733.712,449.876],[803.552,554.434],[803.552,451.733]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,572.253],[733.712,677.133],[803.552,571.567],[803.552,674.269]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[733.712,689.234],[733.712,794.114],[803.552,686.118],[803.552,788.82]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[735.997,813.55],[735.997,918.435],[805.505,807.875],[805.505,910.59]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.266,821.65],[881.266,929.632],[798.483,807.325],[798.483,909.83]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,432.891],[881.129,325.064],[803.552,437.947],[803.552,335.246]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,555.192],[881.129,447.365],[803.552,554.434],[803.552,451.733]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,573.18],[881.129,681.008],[803.552,571.567],[803.552,674.269]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,693.448],[881.129,801.276],[803.552,686.118],[803.552,788.82]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[913.308,307.198],[913.308,203.832],[828.367,311.221],[828.367,209.647]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,432.891],[881.129,325.064],[921.275,434.219],[921.275,327.739]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,555.192],[881.129,447.365],[921.275,554.993],[921.275,448.512]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,573.18],[881.129,681.008],[921.275,572.756],[921.275,679.237]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.129,693.448],[881.129,801.276],[921.275,691.523],[921.275,798.003]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[881.266,821.65],[881.266,929.632],[922.944,817.988],[922.944,924.57]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[998.667,305.941],[913.308,307.198],[998.667,202.015],[913.308,203.832]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,431.669],[961.867,322.604],[921.275,434.219],[921.275,327.739]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,555.375],[961.867,446.309],[921.275,554.993],[921.275,448.512]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,573.57],[961.867,682.636],[921.275,572.756],[921.275,679.237]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,695.219],[961.867,804.285],[921.275,691.523],[921.275,798.003]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.636,824.432],[961.636,933.478],[922.944,817.988],[922.944,924.57]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.636,824.432],[1049.94,824.438],[961.636,933.478],[1049.94,933.486]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,431.669],[1049.94,431.686],[961.867,322.604],[1049.94,322.638]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,555.375],[961.867,446.309],[1049.94,555.372],[1049.94,446.324]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,573.57],[1049.94,573.564],[961.867,682.636],[1049.94,682.613]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[961.867,695.219],[1049.94,695.195],[961.867,804.285],[1049.94,804.243]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[998.667,305.941],[998.667,202.015],[1047.11,309.591],[1047.11,207.29]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1071.28,306.503],[1071.28,202.828],[1047.11,309.591],[1047.11,207.29]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1049.94,431.686],[1049.94,322.638],[1251.09,438.791],[1251.09,336.944]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1049.94,555.373],[1049.94,446.324],[1251.09,554.308],[1251.09,452.461]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1049.94,573.564],[1049.94,682.613],[1251.09,571.298],[1251.09,673.145]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1049.94,695.195],[1049.94,804.243],[1251.09,684.896],[1251.09,786.742]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1049.94,824.438],[1049.94,933.486],[1251.09,805.603],[1251.09,907.449]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1071.28,306.503],[1071.28,202.828],[1127.73,308.917],[1127.73,206.317]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1127.73,308.917],[1127.73,206.317],[1166.65,310.77],[1166.65,208.995]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1166.65,310.77],[1166.65,208.995],[1220.72,313.849],[1220.72,213.446]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1224.93,314.022],[1224.93,213.696],[1265.48,318.327],[1265.48,219.919]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1252.17,438.829],[1252.17,337.021],[1428.26,445.048],[1428.26,349.545]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1252.17,554.302],[1252.17,452.494],[1428.26,553.37],[1428.26,457.867]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1252.17,571.286],[1252.17,673.094],[1428.26,569.302],[1428.26,664.805]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1252.17,684.84],[1252.17,786.648],[1428.26,675.824],[1428.26,771.327]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1252.86,805.437],[1252.86,907.22],[1428.87,788.956],[1428.87,884.437]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1265.48,318.327],[1265.48,219.919],[1289.61,321.33],[1289.61,224.259]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1289.61,321.33],[1289.61,224.259],[1320.29,325.521],[1320.29,230.317]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1295.03,328.127],[1295.03,234.084],[1334.74,331.12],[1334.74,238.41]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1300.62,752.431],[1300.62,833.946],[1310.6,751.67],[1310.6,832.894]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1333.83,454.265],[1333.83,368.107],[1381.14,455.721],[1381.14,371.039]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1333.83,566.362],[1333.83,652.52],[1381.14,565.898],[1381.14,650.58]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1333.83,662.461],[1333.83,748.62],[1381.14,660.351],[1381.14,745.033]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1334.43,764.69],[1334.43,850.892],[1381.56,760.842],[1381.56,845.573]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1391.96,449.794],[1391.96,359.102],[1420.42,450.735],[1420.42,360.998]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1391.96,567.788],[1391.96,658.48],[1420.42,567.488],[1420.42,657.225]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1391.96,668.944],[1391.96,759.636],[1420.42,667.579],[1420.42,757.316]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:16,
                    verts:[[1394.28,776.578],[1394.28,867.326],[1423.78,773.986],[1423.78,863.743]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[444.31,450.449],[444.31,360.421],[421.638,454.488],[421.638,368.556]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[444.31,552.561],[444.31,462.533],[421.638,551.955],[421.638,466.023]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[444.31,567.579],[444.31,657.607],[421.638,566.291],[421.638,652.223]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[444.31,667.994],[444.31,758.022],[421.638,662.138],[421.638,748.07]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[483.83,760.279],[483.83,844.794],[425.159,751.975],[425.159,833.316]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[481.749,456.096],[481.749,371.793],[426.94,459.018],[426.94,377.678]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[481.749,565.778],[481.749,650.081],[426.94,564.846],[426.94,646.186]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[481.749,659.808],[481.749,744.111],[426.94,655.571],[426.94,736.912]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[460.162,459.86],[460.162,379.374],[434.867,461.166],[434.867,382.003]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[460.162,564.577],[460.162,645.064],[434.867,564.161],[434.867,643.324]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[460.162,654.35],[460.162,734.837],[434.867,652.457],[434.867,731.62]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[481.749,551.714],[481.749,467.412],[426.94,551.277],[426.94,469.936]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[459.624,749.66],[459.624,830.115],[435.531,746.363],[435.531,825.557]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[681.151,441.48],[681.151,338.932],[464.88,453.501],[464.88,363.561]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[681.151,557.794],[681.151,455.245],[464.88,555.514],[464.88,465.574]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[681.151,574.901],[681.151,677.45],[464.88,570.518],[464.88,660.459]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[681.151,689.282],[681.151,791.83],[464.88,670.836],[464.88,760.777]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[681.151,807.439],[681.151,909.987],[464.88,774.466],[464.88,864.406]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[508,351.283],[508.001,267.555],[505.524,357.262],[505.524,276.196]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[530.249,342.446],[530.249,254.782],[508,351.283],[508.001,267.555]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[567.212,335.329],[567.212,244.491],[534.389,342.238],[534.389,254.479]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[563.352,364.741],[563.352,287.007],[548.055,366.368],[548.055,289.358]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[576.951,333.148],[576.951,241.341],[567.212,335.329],[567.212,244.491]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[657.315,323.139],[657.315,226.874],[576.951,333.148],[576.951,241.341]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[752.658,315.243],[752.658,215.461],[657.315,323.139],[657.315,226.874]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[780.814,817.452],[780.814,923.83],[661.722,808.392],[661.722,911.304]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,434.317],[778.478,327.936],[665.687,437.534],[665.687,334.413]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,554.978],[778.478,448.597],[665.687,554.496],[665.687,451.376]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,572.725],[778.478,679.107],[665.687,571.699],[665.687,674.82]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,691.381],[778.478,797.762],[665.687,686.717],[665.687,789.838]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[866.666,308.788],[866.666,206.13],[752.658,315.243],[752.658,215.461]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,434.317],[778.478,327.936],[844.22,436.769],[844.22,332.874]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,554.978],[778.478,448.597],[844.22,554.611],[844.22,450.715]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,572.725],[778.478,679.107],[844.22,571.943],[844.22,675.838]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[778.478,691.381],[778.478,797.762],[844.22,687.826],[844.22,791.721]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[780.814,817.452],[780.814,923.83],[846.231,810.978],[846.231,914.88]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[935.053,824.139],[935.053,933.074],[838.628,810.492],[838.628,914.208]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,431.953],[934.552,323.175],[844.22,436.769],[844.22,332.874]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,555.333],[934.552,446.554],[844.22,554.611],[844.22,450.715]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,573.479],[934.552,682.258],[844.22,571.943],[844.22,675.838]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,694.808],[934.552,803.586],[844.22,687.826],[844.22,791.721]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[956.423,305.453],[956.423,201.31],[866.666,308.788],[866.666,206.13]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,431.953],[934.552,323.175],[971.723,433.454],[971.723,326.197]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,555.333],[934.552,446.554],[971.723,555.108],[971.723,447.851]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,573.479],[934.552,682.258],[971.723,573.001],[971.723,680.257]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[934.552,694.808],[934.552,803.586],[971.723,692.632],[971.723,799.889]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[935.053,824.139],[935.053,933.074],[973.635,820.002],[973.635,927.354]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1043.16,304.926],[956.423,305.453],[1043.16,200.549],[956.423,201.31]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,431.043],[1018.44,321.342],[971.723,433.454],[971.723,326.197]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,555.469],[1018.44,445.768],[971.723,555.108],[971.723,447.851]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,573.77],[1018.44,683.471],[971.723,573],[971.723,680.257]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,696.128],[1018.44,805.829],[971.723,692.632],[971.723,799.889]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.16,826.095],[1018.16,935.777],[973.635,820.002],[973.635,927.354]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,431.043],[1018.44,321.342],[1106.18,431.412],[1106.18,322.085]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,555.469],[1018.44,445.768],[1106.18,555.414],[1106.18,446.087]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,573.77],[1018.44,683.471],[1106.18,573.652],[1106.18,682.979]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.44,696.128],[1018.44,805.829],[1106.18,695.593],[1106.18,804.92]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1018.16,826.095],[1106.18,825.165],[1018.16,935.777],[1106.18,934.492]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1043.16,304.926],[1043.16,200.549],[1087.6,309.012],[1087.6,206.455]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1114.82,306.119],[1114.82,202.272],[1087.6,309.012],[1087.6,206.455]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1106.18,431.412],[1106.18,322.085],[1287.81,439.292],[1287.81,337.953]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1106.18,555.414],[1106.18,446.087],[1287.81,554.233],[1287.81,452.894]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1106.18,573.652],[1106.18,682.979],[1287.81,571.138],[1287.81,672.477]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1106.18,695.593],[1106.18,804.92],[1287.81,684.169],[1287.81,785.508]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1106.18,825.165],[1106.18,934.492],[1287.81,804.274],[1287.81,905.613]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1114.82,306.119],[1114.82,202.272],[1168.21,309.021],[1168.21,206.467]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1168.21,309.021],[1168.21,206.467],[1204.69,311.204],[1204.69,209.623]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1204.69,311.204],[1204.69,209.623],[1254.68,314.73],[1254.68,214.719]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1258.63,314.937],[1258.63,215.019],[1293.92,319.561],[1293.92,221.702]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1288.78,439.334],[1288.78,338.038],[1445.54,446.135],[1445.54,351.734]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1288.78,554.227],[1288.78,452.931],[1445.54,553.207],[1445.54,458.806]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1288.78,571.125],[1288.78,672.421],[1445.54,568.956],[1445.54,663.357]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1288.78,684.108],[1288.78,785.404],[1445.54,674.248],[1445.54,768.65]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1289.09,750.895],[1289.09,831.823],[1298.17,750.061],[1298.17,830.67]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1289.4,804.091],[1289.4,905.36],[1446.08,786.069],[1446.08,880.446]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1293.92,319.561],[1293.92,221.702],[1314.4,322.744],[1314.4,226.303]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1312.68,329.552],[1312.68,236.143],[1348.31,332.83],[1348.31,240.882]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1314.4,322.744],[1314.4,226.303],[1340.02,327.154],[1340.02,232.677]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1332.26,454.972],[1332.26,369.53],[1374.86,456.561],[1374.86,372.73]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1332.26,566.137],[1332.26,651.579],[1374.86,565.63],[1374.86,649.461]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1332.26,661.437],[1332.26,746.879],[1374.86,659.133],[1374.86,742.964]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1332.95,762.811],[1332.95,848.294],[1375.38,758.611],[1375.38,842.489]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1399.27,450.717],[1399.27,360.962],[1424.63,451.742],[1424.63,363.025]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1399.27,567.494],[1399.27,657.249],[1424.63,567.167],[1424.63,655.884]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1399.27,667.605],[1399.27,757.36],[1424.63,666.12],[1424.63,754.837]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:17,
                    verts:[[1401.65,774.108],[1401.65,863.911],[1427.94,771.289],[1427.94,860.015]]
                },
                ],
                [
                {
                    num:"104",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[472.213,765.58],[472.213,852.123],[403.526,757.551],[403.526,841.024]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[469.542,454.095],[469.542,367.763],[405.384,456.92],[405.384,373.454]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[469.542,552.014],[469.542,465.683],[405.384,551.591],[405.384,468.124]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[469.542,566.416],[469.542,652.748],[405.384,565.515],[405.384,648.982]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[469.542,662.709],[469.542,749.04],[405.384,658.612],[405.384,742.079]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[437.965,457.89],[437.965,375.406],[408.44,459.153],[408.44,377.949]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[437.965,657.207],[437.965,739.691],[408.44,655.376],[408.44,736.579]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[437.33,754.886],[437.33,837.34],[409.209,751.697],[409.209,832.931]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[444.294,448.169],[444.294,355.831],[410.848,452.246],[410.848,364.04]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[444.294,552.902],[444.294,460.564],[410.848,552.291],[410.848,464.085]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[444.294,568.307],[444.294,660.645],[410.848,567.006],[410.848,655.212]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[444.294,671.299],[444.294,763.637],[410.848,665.389],[410.848,753.595]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[447.986,781.26],[447.986,873.799],[412.035,769.81],[412.035,857.97]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[437.965,565.206],[437.965,647.69],[408.44,564.803],[408.44,646.006]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[718.549,439.844],[718.549,335.578],[465.494,451.37],[465.494,359.194]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[718.549,558.104],[718.549,453.839],[465.494,555.919],[465.494,463.742]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[718.549,575.498],[718.549,679.764],[465.494,571.296],[465.494,663.472]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[718.549,691.794],[718.549,796.059],[465.494,674.107],[465.494,766.283]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[718.549,811.928],[718.549,916.194],[465.494,780.313],[465.494,872.489]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[495.417,346.956],[495.417,261.3],[486.485,353.066],[486.485,270.132]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[527.867,338.068],[527.867,248.453],[495.417,346.956],[495.417,261.3]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[538.39,361.125],[538.39,281.781],[520.85,362.685],[520.85,284.036]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[573.635,331.071],[573.635,238.337],[532.377,337.887],[532.377,248.189]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[585.993,328.918],[585.993,235.227],[573.635,331.071],[573.635,238.337]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[679.203,319.354],[679.203,221.403],[585.993,328.918],[585.993,235.227]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[784.866,312.124],[784.866,210.953],[679.203,319.354],[679.203,221.403]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[829.116,821.068],[829.116,928.828],[699.545,813.101],[699.545,917.815]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,432.944],[826.756,325.171],[704.097,435.769],[704.097,330.859]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,555.184],[826.756,447.41],[704.097,554.761],[704.097,449.851]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,573.163],[826.756,680.937],[704.097,572.262],[704.097,677.172]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,693.371],[826.756,801.145],[704.097,689.276],[704.097,794.186]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[907.091,306.568],[907.091,202.922],[784.866,312.125],[784.866,210.953]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,432.944],[826.756,325.171],[887.384,435.692],[887.384,330.704]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,555.184],[826.756,447.41],[887.384,554.772],[887.384,449.784]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,573.163],[826.756,680.937],[887.384,572.287],[887.384,677.275]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[826.756,693.371],[826.756,801.145],[887.384,689.388],[887.384,794.376]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[829.116,821.068],[829.116,928.828],[889.427,813.815],[889.427,918.801]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[990.67,826.184],[990.67,935.901],[881.311,813.401],[881.311,918.23]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,431.181],[989.799,321.62],[887.384,435.692],[887.384,330.704]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,555.448],[989.799,445.887],[887.384,554.772],[887.384,449.784]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,573.725],[989.799,683.286],[887.384,572.287],[887.384,677.275]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,695.927],[989.799,805.488],[887.384,689.388],[887.384,794.376]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1000.75,303.989],[1000.75,199.194],[907.091,306.568],[907.091,202.922]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,431.181],[989.799,321.62],[1023.41,432.845],[1023.41,324.972]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,555.448],[989.799,445.887],[1023.41,555.199],[1023.41,447.325]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,573.726],[989.799,683.286],[1023.41,573.195],[1023.41,681.068]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[989.799,695.927],[989.799,805.488],[1023.41,693.515],[1023.41,801.388]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[990.67,826.184],[990.67,935.901],[1025.55,821.598],[1025.55,929.56]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1000.75,303.989],[1087.84,304.224],[1000.75,199.194],[1087.84,199.534]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,430.605],[1075.78,320.46],[1023.41,432.845],[1023.41,324.972]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,555.535],[1075.78,445.389],[1023.41,555.199],[1023.41,447.325]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,573.909],[1075.78,684.055],[1023.41,573.195],[1023.41,681.068]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,696.763],[1075.78,806.908],[1023.41,693.515],[1023.41,801.388]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.47,827.259],[1075.47,937.387],[1025.55,821.598],[1025.55,929.56]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.47,827.259],[1075.47,937.387],[1162,825.379],[1162,934.788]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,430.605],[1075.78,320.46],[1162,431.331],[1162,321.923]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,555.535],[1075.78,445.389],[1162,555.426],[1162,446.017]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,573.909],[1075.78,684.055],[1162,573.678],[1162,683.086]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1075.78,696.763],[1075.78,806.908],[1162,695.71],[1162,805.118]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1087.84,304.224],[1087.84,199.534],[1127.68,308.716],[1127.68,206.026]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1157.66,306.049],[1157.66,202.171],[1127.68,308.716],[1127.68,206.026]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1157.66,306.049],[1157.66,202.171],[1207.33,309.417],[1207.33,207.04]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1162,431.331],[1162,321.923],[1321.8,439.909],[1321.8,339.197]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1162,555.426],[1162,446.017],[1321.8,554.14],[1321.8,453.428]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1162,573.678],[1162,683.086],[1321.8,570.941],[1321.8,671.654]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1162,695.71],[1162,805.118],[1321.8,683.274],[1321.8,783.986]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1162,825.379],[1162,934.788],[1321.8,802.636],[1321.8,903.349]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1207.33,309.417],[1207.33,207.04],[1240.95,311.911],[1240.95,210.644]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1240.95,311.911],[1240.95,210.644],[1286.3,315.849],[1286.3,216.337]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1275.32,749.48],[1275.32,829.867],[1283.44,748.58],[1283.44,828.622]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1289.95,316.089],[1289.95,216.684],[1319.63,320.985],[1319.63,223.761]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1319.63,320.985],[1319.63,223.761],[1336.3,324.318],[1336.3,228.578]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1322.65,439.955],[1322.65,339.288],[1458.8,447.263],[1458.8,354.006]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1322.65,554.133],[1322.65,453.467],[1458.8,553.038],[1458.8,459.781]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1322.65,570.927],[1322.65,671.593],[1458.8,568.596],[1458.8,661.853]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1322.65,683.208],[1322.65,783.874],[1458.8,672.613],[1458.8,765.87]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1323.19,802.439],[1323.19,903.075],[1459.26,783.073],[1459.26,876.305]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1327.53,331.077],[1327.53,238.348],[1358.83,334.609],[1358.83,243.453]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1328,455.661],[1328,370.917],[1365.7,457.369],[1365.7,374.357]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1328,565.917],[1328,650.661],[1365.7,565.372],[1365.7,648.384]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1328,660.438],[1328,745.182],[1365.7,657.962],[1365.7,740.974]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1328.77,760.978],[1328.77,845.761],[1366.31,756.464],[1366.31,839.52]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1336.3,324.318],[1336.3,228.578],[1356.66,328.905],[1356.66,235.208]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1403.19,451.65],[1403.19,362.84],[1425.34,452.746],[1425.34,365.048]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1403.19,567.196],[1403.19,656.006],[1425.34,566.846],[1425.34,654.545]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1403.19,666.253],[1403.19,755.063],[1425.34,664.663],[1425.34,752.361]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:18,
                    verts:[[1405.62,771.614],[1405.62,860.464],[1428.56,768.597],[1428.56,856.293]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[418.248,455.767],[418.248,371.131],[384.319,456.971],[384.319,373.555]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[418.248,551.764],[418.248,467.128],[384.319,551.583],[384.319,468.168]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[418.248,565.883],[418.248,650.519],[384.319,565.499],[384.319,648.915]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[418.248,660.284],[418.248,744.921],[384.319,658.539],[384.319,741.955]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[417.513,760.518],[417.513,845.125],[385.197,757.478],[385.197,840.922]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[463.72,771.199],[463.72,859.89],[384.665,763.552],[384.665,849.32]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[460.431,451.972],[460.431,363.489],[386.594,454.663],[386.594,368.908]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[460.431,552.332],[460.431,463.849],[386.594,551.929],[386.594,466.174]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[460.431,567.094],[460.431,655.577],[386.594,566.235],[386.594,651.99]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[460.431,665.786],[460.431,754.269],[386.594,661.885],[386.594,747.64]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[448.647,445.795],[448.647,351.049],[403.762,449.869],[403.762,359.255]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[448.647,553.258],[448.647,458.512],[403.762,552.648],[403.762,462.033]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[448.647,569.064],[448.647,663.81],[403.762,567.764],[403.762,658.379]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[448.647,674.741],[448.647,769.487],[403.762,668.834],[403.762,759.449]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[452.976,787.535],[452.976,882.473],[404.891,776.095],[404.891,866.658]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[485.694,342.364],[485.694,254.662],[469.853,348.565],[469.853,263.626]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[759.986,438.3],[759.986,332.416],[470.327,449.153],[470.327,354.652]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[759.986,558.397],[759.986,452.513],[470.327,556.339],[470.327,461.838]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[759.986,576.061],[759.986,681.945],[470.327,572.104],[470.327,666.605]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[759.986,694.162],[759.986,800.046],[470.327,677.508],[470.327,772.01]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[759.986,816.162],[759.986,922.047],[470.327,786.393],[470.327,880.894]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[528.882,333.504],[528.882,241.856],[485.694,342.364],[485.694,254.662]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[515.041,357.201],[515.041,276.108],[495.197,358.676],[495.197,278.24]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[583.692,326.709],[583.692,232.032],[533.75,333.354],[533.75,241.637]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[598.737,324.609],[598.737,228.999],[583.692,326.709],[583.692,232.032]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[704.666,315.633],[704.666,216.025],[598.737,324.609],[598.737,228.999]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[820.005,309.201],[820.005,206.727],[704.666,315.633],[704.666,216.025]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[880.56,824.255],[880.56,933.233],[741.677,817.56],[741.677,923.978]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,431.732],[878.208,322.73],[746.793,434.102],[746.793,327.503]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,555.366],[878.208,446.364],[746.793,555.01],[746.793,448.411]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,573.55],[878.208,682.552],[746.793,572.794],[746.793,679.393]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,695.128],[878.208,804.13],[746.793,691.693],[746.793,798.292]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[949.303,304.659],[949.303,200.163],[820.005,309.201],[820.005,206.727]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,431.732],[878.208,322.73],[932.69,434.761],[932.69,328.828]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,555.366],[878.208,446.364],[932.69,554.912],[932.69,448.98]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,573.55],[878.208,682.552],[932.69,572.584],[932.69,678.516]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[878.208,695.128],[878.208,804.13],[932.69,690.738],[932.69,796.67]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[880.56,824.255],[880.56,933.233],[934.742,816.262],[934.742,922.185]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1047.45,827.657],[1047.45,937.937],[926.198,815.93],[926.198,921.725]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,430.623],[1046.21,320.497],[932.69,434.761],[932.69,328.828]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,555.532],[1046.21,445.405],[932.69,554.912],[932.69,448.98]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,573.904],[1046.21,684.03],[932.69,572.584],[932.69,678.516]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,696.736],[1046.21,806.863],[932.69,690.738],[932.69,796.67]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1045.8,302.898],[1045.8,197.617],[949.303,304.659],[949.303,200.163]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1045.8,302.898],[1045.8,197.617],[1132.13,303.915],[1132.13,199.086]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,430.623],[1046.21,320.497],[1075.7,432.437],[1075.7,324.149]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,555.532],[1046.21,445.405],[1075.7,555.26],[1075.7,446.972]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,573.904],[1046.21,684.03],[1075.7,573.325],[1075.7,681.613]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1046.21,696.736],[1046.21,806.863],[1075.7,694.107],[1075.7,802.395]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1047.45,827.657],[1047.45,937.937],[1078.04,822.66],[1078.04,931.029]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,430.399],[1133.13,320.044],[1075.7,432.437],[1075.7,324.149]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,555.566],[1133.13,445.211],[1075.7,555.26],[1075.7,446.972]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,573.975],[1133.13,684.329],[1075.7,573.325],[1075.7,681.613]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,697.062],[1133.13,807.416],[1075.7,694.107],[1075.7,802.395]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1132.77,827.809],[1132.77,938.147],[1078.04,822.66],[1078.04,931.029]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1132.13,303.915],[1132.13,199.086],[1166.81,308.771],[1166.81,206.105]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,430.399],[1133.13,320.044],[1216.59,431.481],[1216.59,322.224]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,555.566],[1133.13,445.211],[1216.59,555.403],[1216.59,446.146]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,573.975],[1133.13,684.329],[1216.59,573.63],[1216.59,682.887]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1133.13,697.062],[1133.13,807.416],[1216.59,695.493],[1216.59,804.75]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1132.77,827.809],[1132.77,938.147],[1216.59,824.983],[1216.59,934.239]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1199.21,306.362],[1199.21,202.624],[1166.81,308.771],[1166.81,206.105]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1199.21,306.362],[1199.21,202.624],[1244.54,310.164],[1244.54,208.12]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1216.59,431.481],[1216.59,322.224],[1352.56,440.662],[1352.56,340.712]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1216.59,555.403],[1216.59,446.146],[1352.56,554.027],[1352.56,454.078]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1216.59,573.63],[1216.59,682.887],[1352.56,570.701],[1352.56,670.651]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1216.59,695.493],[1216.59,804.75],[1352.56,682.183],[1352.56,782.132]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1216.59,824.983],[1216.59,934.239],[1352.56,800.641],[1352.56,900.591]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1244.54,310.164],[1244.54,208.12],[1274.89,312.942],[1274.89,212.136]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1259.28,748.159],[1259.28,828.04],[1266.41,747.199],[1266.41,826.714]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1274.89,312.942],[1274.89,212.136],[1315.11,317.251],[1315.11,218.364]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1318.42,317.52],[1318.42,218.753],[1342.22,322.637],[1342.22,226.149]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1320.99,456.343],[1320.99,372.29],[1353.59,458.155],[1353.59,375.94]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1320.99,565.699],[1320.99,649.752],[1353.59,565.121],[1353.59,647.337]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1320.99,659.45],[1320.99,743.502],[1353.59,656.822],[1353.59,739.038]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1321.83,759.164],[1321.83,843.253],[1354.3,754.374],[1354.3,836.632]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1339.33,332.735],[1339.33,240.744],[1366.08,336.484],[1366.08,246.163]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1342.22,322.637],[1342.22,226.149],[1354.96,326.086],[1354.96,231.133]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1353.27,440.71],[1353.27,340.81],[1467.79,448.442],[1467.79,356.381]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1353.27,554.02],[1353.27,454.12],[1467.79,552.861],[1467.79,460.8]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1353.27,570.686],[1353.27,670.586],[1467.79,568.219],[1467.79,660.281]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1353.27,682.113],[1353.27,782.013],[1467.79,670.903],[1467.79,762.965]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1353.73,800.431],[1353.73,900.3],[1468.18,779.943],[1468.18,871.978]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1354.96,326.086],[1354.96,231.133],[1369.95,330.803],[1369.95,237.952]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1403.6,452.601],[1403.6,364.756],[1422.43,453.759],[1422.43,367.087]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1403.6,566.893],[1403.6,654.738],[1422.43,566.523],[1422.43,653.195]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1403.6,664.874],[1403.6,752.719],[1422.43,663.195],[1422.43,749.867]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:19,
                    verts:[[1406.04,769.07],[1406.04,856.947],[1425.53,765.885],[1425.53,852.545]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[401.612,453.508],[401.612,366.581],[363.13,454.633],[363.13,368.848]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[401.612,552.102],[401.612,465.176],[363.13,551.934],[363.13,466.148]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[401.612,566.604],[401.612,653.53],[363.13,566.245],[363.13,652.03]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[401.612,663.56],[401.612,750.486],[363.13,661.928],[363.13,747.714]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[400.773,766.512],[400.773,853.411],[364.12,763.67],[364.12,849.482]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[458.918,777.068],[458.918,868.003],[369.232,769.933],[369.232,858.14]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[454.987,449.752],[454.987,359.019],[371.223,452.264],[371.223,364.076]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[454.987,552.665],[454.987,461.931],[371.223,552.289],[371.223,464.101]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[454.987,567.802],[454.987,658.535],[371.223,567],[371.223,655.188]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[454.987,669.004],[454.987,759.737],[371.223,665.363],[371.223,753.551]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[457.97,443.362],[457.97,346.149],[401.051,447.387],[401.051,354.256]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[457.97,553.623],[457.97,456.41],[401.051,553.02],[401.051,459.888]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[457.97,569.84],[457.97,667.052],[401.051,568.556],[401.051,661.687]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[457.97,678.269],[457.97,775.481],[401.051,672.432],[401.051,765.564]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[462.948,793.957],[462.948,891.35],[402.106,782.661],[402.106,875.734]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[479.364,337.56],[479.364,247.719],[456.166,343.802],[456.167,256.741]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[493.762,352.998],[493.762,270.034],[471.563,354.365],[471.563,272.01]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[533.761,328.825],[533.761,235.093],[479.364,337.56],[479.364,247.719]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[805.256,436.905],[805.256,329.557],[479.939,446.887],[479.939,350.008]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[805.256,558.662],[805.256,451.314],[479.939,556.769],[479.939,459.891]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[805.256,576.57],[805.256,683.918],[479.939,572.93],[479.939,669.808]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[805.256,696.303],[805.256,803.651],[479.939,680.986],[479.939,777.864]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[805.256,819.99],[805.256,927.337],[479.939,792.609],[479.939,889.488]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[597.737,322.33],[597.737,225.703],[538.967,328.712],[538.967,234.927]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[615.5,320.312],[615.5,222.787],[597.737,322.33],[597.737,225.703]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[733.764,312.081],[733.764,210.89],[615.5,320.312],[615.5,222.787]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[857.863,306.58],[857.863,202.939],[733.764,312.081],[733.764,210.89]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[934.608,826.861],[934.608,936.836],[787.935,821.611],[787.935,929.578]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,430.739],[932.297,320.73],[793.575,432.593],[793.575,324.462]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,555.514],[932.297,445.505],[793.575,555.237],[793.575,447.107]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,573.867],[932.297,683.876],[793.575,573.275],[793.575,681.405]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,696.568],[932.297,806.577],[793.575,693.881],[793.575,802.011]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[992.827,303.163],[992.827,198],[857.863,306.58],[857.863,202.939]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,430.739],[932.297,320.73],[979.632,434.023],[979.632,327.344]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,555.514],[932.297,445.505],[979.632,555.022],[979.632,448.343]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,573.867],[932.297,683.876],[979.632,572.819],[979.632,679.498]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[932.297,696.568],[932.297,806.577],[979.632,691.807],[979.632,798.486]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[934.608,826.861],[934.608,936.836],[981.666,818.194],[981.666,924.855]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1104.55,828.433],[1104.55,939.009],[972.796,817.95],[972.796,924.518]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,430.326],[1102.95,319.899],[979.632,434.023],[979.632,327.344]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,555.576],[1102.95,445.149],[979.632,555.022],[979.632,448.343]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,573.998],[1102.95,684.426],[979.632,572.819],[979.632,679.498]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,697.167],[1102.95,807.594],[979.632,691.807],[979.632,798.486]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1090.95,302.271],[992.827,303.163],[1090.95,196.71],[992.827,198]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1090.95,302.271],[1090.95,196.71],[1175.37,304.073],[1175.37,199.315]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,430.326],[1102.95,319.899],[1127.81,432.27],[1127.81,323.813]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,555.576],[1102.95,445.149],[1127.81,555.285],[1127.81,446.828]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,573.998],[1102.95,684.426],[1127.81,573.378],[1127.81,681.835]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1102.95,697.167],[1102.95,807.594],[1127.81,694.349],[1127.81,802.806]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1104.55,828.433],[1104.55,939.009],[1130.32,823.077],[1130.32,931.605]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,430.465],[1189.54,320.178],[1127.81,432.27],[1127.81,323.813]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,555.556],[1189.54,445.268],[1127.81,555.285],[1127.81,446.828]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,573.954],[1189.54,684.241],[1127.81,573.378],[1127.81,681.835]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,696.966],[1189.54,807.253],[1127.81,694.349],[1127.81,802.806]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.15,827.638],[1189.15,937.91],[1130.32,823.077],[1130.32,931.605]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1175.37,304.073],[1175.37,199.315],[1204.39,309.241],[1204.39,206.786]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,430.465],[1189.54,320.178],[1269.01,431.892],[1269.01,323.053]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,555.556],[1189.54,445.268],[1269.01,555.342],[1269.01,446.502]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,573.954],[1189.54,684.241],[1269.01,573.499],[1269.01,682.338]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.54,696.966],[1189.54,807.253],[1269.01,694.896],[1269.01,803.736]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1189.15,827.638],[1189.15,937.91],[1269.01,823.892],[1269.01,932.731]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1238.81,307.122],[1238.81,203.722],[1204.39,309.241],[1204.39,206.786]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1238.81,307.122],[1238.81,203.722],[1279.22,311.314],[1279.22,209.782]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1240.96,746.906],[1240.96,826.309],[1247.08,745.895],[1247.08,824.91]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1269.01,431.892],[1269.01,323.053],[1379.55,441.564],[1379.55,342.528]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1269.01,555.342],[1269.01,446.502],[1379.55,553.892],[1379.55,454.857]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1269.01,573.499],[1269.01,682.339],[1379.55,570.414],[1379.55,669.449]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1269.01,694.896],[1269.01,803.736],[1379.55,680.875],[1379.55,779.911]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1269.01,823.892],[1269.01,932.731],[1379.55,798.251],[1379.55,897.286]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1279.22,311.314],[1279.22,209.782],[1305.95,314.344],[1305.95,214.161]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1305.95,314.344],[1305.95,214.161],[1340.62,318.972],[1340.62,220.851]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1311.15,457.027],[1311.15,373.668],[1338.53,458.927],[1338.53,377.494]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1311.15,565.481],[1311.15,648.84],[1338.53,564.875],[1338.53,646.308]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1311.15,658.458],[1311.15,741.817],[1338.53,655.703],[1338.53,737.136]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1312.06,757.342],[1312.06,840.734],[1339.31,752.321],[1339.31,833.794]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1343.56,319.268],[1343.56,221.278],[1361.3,324.548],[1361.3,228.911]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1347.83,334.552],[1347.83,243.37],[1369.86,338.478],[1369.86,249.046]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1361.3,324.548],[1361.3,228.911],[1370.04,328.075],[1370.04,234.008]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1370.04,328.075],[1370.04,234.008],[1379.6,332.874],[1379.6,240.946]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1380.13,441.614],[1380.13,342.63],[1472.31,449.679],[1472.31,358.871]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1380.13,553.885],[1380.13,454.901],[1472.31,552.676],[1472.31,461.868]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1380.13,570.398],[1380.13,669.382],[1472.31,567.825],[1472.31,658.633]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1380.13,680.802],[1380.13,779.786],[1472.31,669.11],[1472.31,759.918]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1380.5,798.03],[1380.5,896.981],[1472.62,776.662],[1472.62,867.443]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1400.37,453.58],[1400.37,366.726],[1415.81,454.787],[1415.81,369.157]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1400.37,566.581],[1400.37,653.434],[1415.81,566.196],[1415.81,651.826]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1400.37,663.455],[1400.37,750.309],[1415.81,661.706],[1415.81,747.335]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:20,
                    verts:[[1402.81,766.454],[1402.81,853.331],[1418.78,763.135],[1418.78,848.742]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[388.74,451.136],[388.74,361.805],[345.603,452.16],[345.603,363.867]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[388.74,552.458],[388.74,463.127],[345.603,552.304],[345.603,464.012]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[388.74,567.36],[388.74,656.691],[345.603,567.034],[345.603,655.326]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[388.74,666.998],[388.74,756.329],[345.603,665.513],[345.603,753.806]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[387.794,772.805],[387.794,862.111],[346.708,770.22],[346.708,858.537]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[458.409,783.1],[458.409,876.342],[357.973,776.624],[357.973,867.39]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[453.821,447.468],[453.821,354.419],[360.013,449.747],[360.013,359.009]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[453.821,553.007],[453.821,459.958],[360.013,552.666],[360.013,461.927]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[453.821,568.53],[453.821,661.58],[360.013,567.803],[360.013,658.542]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[453.821,672.315],[453.821,765.365],[360.013,669.011],[360.013,759.75]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[472.847,440.917],[472.847,341.227],[403.427,444.836],[403.427,349.119]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[472.847,553.989],[472.847,454.299],[403.427,553.402],[403.427,457.685]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[472.847,570.62],[472.847,670.31],[403.427,569.37],[403.427,665.087]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[472.847,681.812],[472.847,781.503],[403.427,676.131],[403.427,771.848]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[478.471,800.398],[478.471,900.255],[404.389,789.409],[404.389,885.063]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[446.025,338.833],[446.026,249.558],[441.026,344.82],[441.026,258.212]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[476.995,332.616],[476.995,240.572],[446.025,338.833],[446.026,249.558]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[475.08,348.559],[475.08,263.618],[450.501,349.793],[450.501,265.401]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[542.957,324.122],[542.957,228.294],[476.995,332.616],[476.995,240.572]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[853.955,435.716],[853.955,327.121],[494.87,444.615],[494.87,345.355]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[853.955,558.887],[853.955,450.293],[494.87,557.199],[494.87,457.939]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[853.955,577.003],[853.955,685.598],[494.87,573.758],[494.87,673.019]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[853.955,698.127],[853.955,806.722],[494.87,684.471],[494.87,783.732]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[853.955,823.25],[853.955,931.845],[494.87,798.839],[494.87,898.1]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[616.069,318.035],[616.069,219.495],[548.471,324.05],[548.471,228.189]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[636.531,316.132],[636.531,216.745],[616.069,318.035],[616.069,219.495]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[766.434,308.813],[766.434,206.166],[636.531,316.132],[636.531,216.745]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[898.077,304.375],[898.077,199.752],[766.434,308.813],[766.434,206.166]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[990.505,828.738],[990.505,939.431],[837.927,825.087],[837.927,934.385]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,430.021],[988.274,319.284],[844.034,431.303],[844.034,321.865]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,555.622],[988.274,444.885],[844.034,555.43],[844.034,445.993]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,574.096],[988.274,684.833],[844.034,573.687],[844.034,683.124]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,697.609],[988.274,808.347],[844.034,695.751],[844.034,805.188]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1037.05,302.178],[1037.05,196.576],[898.077,304.375],[898.077,199.752]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,430.021],[988.274,319.284],[1027.55,433.528],[1027.55,326.346]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,555.622],[988.274,444.885],[1027.55,555.097],[1027.55,447.915]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,574.096],[988.274,684.833],[1027.55,572.977],[1027.55,680.159]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[988.274,697.609],[988.274,808.347],[1027.55,692.525],[1027.55,799.707]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[990.505,828.738],[990.505,939.431],[1029.53,819.486],[1029.53,926.641]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1160.98,828.398],[1160.98,938.961],[1020.45,819.338],[1020.45,926.436]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,430.333],[1159.04,319.912],[1027.55,433.528],[1027.55,326.346]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,555.575],[1159.04,445.154],[1027.55,555.097],[1027.55,447.915]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,573.996],[1159.04,684.417],[1027.55,572.977],[1027.55,680.159]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,697.157],[1159.04,807.578],[1027.55,692.525],[1027.55,799.707]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1037.05,302.178],[1135.46,302.189],[1037.05,196.576],[1135.46,196.592]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1135.46,302.189],[1135.46,196.592],[1216.79,304.765],[1216.79,200.316]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,430.333],[1159.04,319.912],[1178.84,432.382],[1178.84,324.039]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,555.575],[1159.04,445.154],[1178.84,555.268],[1178.84,446.925]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,573.996],[1159.04,684.417],[1178.84,573.342],[1178.84,681.685]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1159.04,697.157],[1159.04,807.578],[1178.84,694.186],[1178.84,802.529]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1160.98,828.398],[1160.98,938.961],[1181.49,822.751],[1181.49,931.155]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,430.837],[1243.97,320.926],[1178.84,432.382],[1178.84,324.039]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,555.5],[1243.97,445.59],[1178.84,555.268],[1178.84,446.925]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,573.836],[1243.97,683.746],[1178.84,573.342],[1178.84,681.685]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,696.427],[1243.97,806.337],[1178.84,694.186],[1178.84,802.529]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.55,826.656],[1243.55,936.553],[1181.49,822.751],[1181.49,931.155]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1216.79,304.765],[1216.79,200.316],[1239.77,310.183],[1239.77,208.147]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1220.43,745.701],[1220.43,824.642],[1225.5,744.645],[1225.5,823.183]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1275.75,308.377],[1275.75,205.536],[1239.77,310.183],[1239.77,208.147]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,430.837],[1243.97,320.926],[1318.26,432.59],[1318.26,324.457]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,555.5],[1243.97,445.59],[1318.26,555.237],[1318.26,447.105]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,573.836],[1243.97,683.746],[1318.26,573.276],[1318.26,681.409]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.97,696.427],[1243.97,806.337],[1318.26,693.885],[1318.26,802.018]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1243.55,826.656],[1243.55,936.553],[1318.26,822.042],[1318.26,930.175]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1275.75,308.377],[1275.75,205.536],[1310.75,312.906],[1310.75,212.083]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1298.47,457.721],[1298.47,375.066],[1320.53,459.691],[1320.53,379.033]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1298.47,565.26],[1298.47,647.914],[1320.53,564.631],[1320.53,645.289]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1298.47,657.451],[1298.47,740.106],[1320.53,654.595],[1320.53,735.253]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1299.43,755.492],[1299.43,838.178],[1321.39,750.287],[1321.39,830.983]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1310.75,312.906],[1310.75,212.083],[1333.57,316.149],[1333.57,216.771]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1318.26,432.59],[1318.26,324.457],[1402.29,442.624],[1402.29,344.663]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1318.26,555.237],[1318.26,447.105],[1402.29,553.733],[1402.29,455.773]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1318.26,573.276],[1318.26,681.409],[1402.29,570.075],[1402.29,668.036]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1318.26,693.885],[1318.26,802.018],[1402.29,679.339],[1402.29,777.299]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1318.26,822.042],[1318.26,930.175],[1402.29,795.44],[1402.29,893.401]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1333.57,316.149],[1333.57,216.771],[1362.36,321.039],[1362.36,223.838]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1352.81,336.546],[1352.81,246.253],[1370.02,340.608],[1370.02,252.124]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1364.9,321.356],[1364.9,224.297],[1376.51,326.738],[1376.51,232.077]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1376.51,326.738],[1376.51,232.077],[1381.23,330.303],[1381.23,237.23]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1381.23,330.303],[1381.23,237.23],[1385.41,335.133],[1385.41,244.211]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1393.43,454.591],[1393.43,368.762],[1405.45,455.834],[1405.45,371.266]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1393.43,566.258],[1393.43,652.087],[1405.45,565.861],[1405.45,650.429]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1393.43,661.989],[1393.43,747.818],[1405.45,660.187],[1405.45,744.754]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1395.84,763.751],[1395.84,849.595],[1408.27,760.332],[1408.27,844.869]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1393.43,551.94],[1393.43,466.111],[1405.45,551.754],[1405.45,467.186]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1402.73,442.676],[1402.73,344.768],[1472.23,450.976],[1472.23,361.482]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1402.73,553.726],[1402.73,455.818],[1472.23,552.482],[1472.23,462.988]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1402.73,570.059],[1402.73,667.967],[1472.23,567.411],[1472.23,656.905]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1402.73,679.263],[1402.73,777.171],[1472.23,667.23],[1472.23,756.724]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:21,
                    verts:[[1403.01,795.213],[1403.01,893.086],[1472.46,773.222],[1472.46,862.688]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[380.377,448.684],[380.377,356.868],[332.552,449.581],[332.552,358.673]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[380.377,552.825],[380.377,461.009],[332.552,552.691],[332.552,461.783]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[380.377,568.142],[380.377,659.959],[332.552,567.856],[332.552,658.764]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[380.377,670.552],[380.377,762.369],[332.552,669.253],[332.552,760.161]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[379.324,779.314],[379.324,871.107],[333.773,777.05],[333.773,867.979]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[462.804,789.186],[462.804,884.755],[351.694,783.536],[351.694,876.944]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[457.55,445.16],[457.55,349.771],[353.767,447.149],[353.767,353.776]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[457.55,553.353],[457.55,457.964],[353.767,553.055],[353.767,459.682]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[457.55,569.266],[457.55,664.656],[353.767,568.632],[353.767,662.005]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[457.55,675.661],[457.55,771.051],[353.767,672.778],[353.767,766.151]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[493.787,438.519],[493.787,336.396],[411.6,442.264],[411.6,343.938]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[493.787,554.349],[493.787,452.226],[411.6,553.787],[411.6,455.462]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[493.787,571.385],[493.787,673.507],[411.6,570.19],[411.6,668.516]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[493.787,685.29],[493.787,787.412],[411.6,679.86],[411.6,778.186]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[500.04,806.708],[500.04,908.977],[412.449,796.215],[412.449,894.472]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[440.075,333.733],[440.076,242.186],[428.254,339.834],[428.254,251.006]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[459.593,343.94],[459.593,256.941],[432.641,345.012],[432.641,258.49]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[479.165,327.619],[479.165,233.349],[440.075,333.732],[440.076,242.186]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[556.879,319.5],[556.879,221.614],[479.165,327.619],[479.165,233.349]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[905.459,434.792],[905.459,325.228],[515.583,442.393],[515.583,340.802]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[905.459,559.062],[905.459,449.499],[515.583,557.621],[515.583,456.03]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[905.459,577.34],[905.459,686.904],[515.583,574.569],[515.583,676.16]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[905.459,699.545],[905.459,809.109],[515.583,687.881],[515.583,789.472]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[905.459,825.785],[905.459,935.349],[515.583,804.935],[515.583,906.526]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[638.894,313.943],[638.894,213.579],[562.66,319.475],[562.66,221.577]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[661.975,312.189],[661.975,211.046],[638.894,313.943],[638.894,213.579]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[802.464,305.952],[802.464,202.03],[661.975,312.189],[661.975,211.046]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[940.128,302.698],[940.128,197.328],[802.464,305.952],[802.464,202.03]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1047.3,829.749],[891.026,827.824],[1047.3,940.829],[891.026,938.167]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,429.63],[1045.18,318.496],[897.523,430.296],[897.523,319.838]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,555.681],[1045.18,444.547],[897.523,555.581],[897.523,445.123]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,574.22],[1045.18,685.354],[897.523,574.008],[897.523,684.466]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,698.177],[1045.18,809.31],[897.523,697.211],[897.523,807.669]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1081.22,301.793],[940.128,302.698],[1081.22,196.019],[940.128,197.328]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,429.63],[1045.18,318.496],[1075.62,433.315],[1075.62,325.918]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,555.681],[1045.18,444.547],[1075.62,555.128],[1075.62,447.731]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,574.22],[1045.18,685.354],[1075.62,573.045],[1075.62,680.442]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1045.18,698.177],[1045.18,809.31],[1075.62,692.833],[1075.62,800.23]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1047.3,829.749],[1047.3,940.829],[1077.52,820.026],[1077.52,927.388]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1215.61,827.466],[1215.61,937.672],[1068.37,819.979],[1068.37,927.322]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,430.676],[1213.36,320.602],[1075.62,433.315],[1075.62,325.918]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,555.524],[1213.36,445.451],[1075.62,555.128],[1075.62,447.731]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,573.887],[1213.36,683.96],[1075.62,573.045],[1075.62,680.442]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,696.66],[1213.36,806.734],[1075.62,692.833],[1075.62,800.23]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1081.22,301.793],[1081.22,196.019],[1178.52,302.722],[1178.52,197.363]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1178.52,302.722],[1178.52,197.363],[1255.61,306.039],[1255.61,202.157]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1197.77,744.524],[1197.77,823.016],[1201.77,743.434],[1201.77,821.509]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,430.676],[1213.36,320.602],[1227.8,432.803],[1227.8,324.886]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,555.524],[1213.36,445.451],[1227.8,555.205],[1227.8,447.288]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,573.887],[1213.36,683.96],[1227.8,573.208],[1227.8,681.125]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1213.36,696.66],[1213.36,806.734],[1227.8,693.577],[1227.8,801.493]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1215.61,827.466],[1215.61,937.672],[1230.55,821.607],[1230.55,929.573]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,431.537],[1295.32,322.337],[1227.8,432.803],[1227.8,324.886]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,555.395],[1295.32,446.195],[1227.8,555.205],[1227.8,447.288]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,573.612],[1295.32,682.812],[1227.8,573.208],[1227.8,681.125]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,695.411],[1295.32,804.611],[1227.8,693.577],[1227.8,801.493]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1294.88,824.803],[1294.88,933.992],[1230.55,821.607],[1230.55,929.573]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1255.61,306.039],[1255.61,202.157],[1272.28,311.635],[1272.28,210.246]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1309.32,310.162],[1272.28,311.635],[1309.32,208.117],[1272.28,210.246]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1282.99,458.431],[1282.99,376.496],[1299.68,460.453],[1299.68,380.567]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1282.99,565.033],[1282.99,646.968],[1299.68,564.388],[1299.68,644.274]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1282.99,656.422],[1282.99,738.357],[1299.68,653.491],[1299.68,733.377]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1284,753.601],[1284,835.563],[1300.61,748.261],[1300.61,828.181]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,431.537],[1295.32,322.337],[1363.38,433.588],[1363.38,326.466]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,555.395],[1295.32,446.195],[1363.38,555.088],[1363.38,447.966]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,573.612],[1295.32,682.812],[1363.38,572.958],[1363.38,680.079]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1295.32,695.411],[1295.32,804.611],[1363.38,692.439],[1363.38,799.56]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1294.88,824.803],[1294.88,933.992],[1363.38,819.398],[1363.38,926.519]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1309.32,310.162],[1309.32,208.117],[1338.54,314.965],[1338.54,215.059]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1338.54,314.965],[1338.54,215.059],[1357.24,318.377],[1357.24,219.991]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1354.13,338.73],[1354.13,249.409],[1366.47,342.881],[1366.47,255.41]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1357.24,318.377],[1357.24,219.991],[1379.93,323.462],[1379.93,227.341]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1363.38,433.588],[1363.38,326.466],[1420.35,443.845],[1420.35,347.122]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1363.38,555.088],[1363.38,447.966],[1420.35,553.55],[1420.35,456.828]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1363.38,572.958],[1363.38,680.079],[1420.35,569.686],[1420.35,666.409]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1363.38,692.439],[1363.38,799.56],[1420.35,677.568],[1420.35,774.291]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1363.38,819.398],[1363.38,926.519],[1420.35,792.203],[1420.35,888.925]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1382.05,323.797],[1382.05,227.826],[1387.55,329.217],[1387.55,235.659]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1382.78,455.637],[1382.78,370.869],[1391.38,456.904],[1391.38,373.42]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1382.78,565.924],[1382.78,650.693],[1391.38,565.52],[1391.38,649.004]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1382.78,660.473],[1382.78,745.241],[1391.38,658.636],[1391.38,742.119]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1385.15,760.957],[1385.15,845.732],[1394.03,757.474],[1394.03,840.917]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1420.65,443.898],[1420.65,347.229],[1467.49,452.331],[1467.49,364.212]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1420.65,553.542],[1420.65,456.874],[1467.49,552.279],[1467.49,464.159]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1420.65,569.669],[1420.65,666.338],[1467.49,566.979],[1467.49,655.098]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1420.65,677.491],[1420.65,774.16],[1467.49,665.265],[1467.49,753.385]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:22,
                    verts:[[1420.84,791.971],[1420.84,888.605],[1467.65,769.628],[1467.65,857.718]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[324.843,446.933],[324.843,353.34],[320.858,449.707],[320.858,358.928]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[324.843,553.088],[324.843,459.495],[320.858,552.672],[320.858,461.892]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[324.843,568.701],[324.843,662.293],[320.858,567.816],[320.858,658.595]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[324.843,673.092],[324.843,766.684],[320.858,669.069],[320.858,759.849]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[326.179,784.06],[326.179,877.669],[321.785,776.694],[321.785,867.486]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[377.291,446.193],[377.291,351.85],[324.843,446.933],[324.843,353.34]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[377.291,553.199],[377.291,458.856],[324.843,553.088],[324.843,459.495]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[377.291,568.937],[377.291,663.279],[324.843,568.701],[324.843,662.293]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[377.291,674.164],[377.291,768.507],[324.843,673.092],[324.843,766.684]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[376.132,785.928],[376.132,880.251],[326.179,784.06],[326.179,877.669]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[472.661,795.193],[472.661,893.059],[351.218,790.548],[351.218,886.638]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[466.75,442.878],[466.75,345.175],[353.304,444.513],[353.304,348.468]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[466.75,553.695],[466.75,455.992],[353.304,553.45],[353.304,457.405]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[466.75,569.994],[466.75,667.697],[353.304,569.473],[353.304,665.518]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[466.75,678.97],[466.75,776.673],[353.304,676.6],[353.304,772.645]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[447.933,339.21],[447.933,250.103],[418.66,340.088],[418.66,251.372]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[438.964,328.593],[438.964,234.757],[419.848,334.745],[419.848,243.65]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[521.16,436.232],[521.16,331.791],[426.217,439.727],[426.217,338.829]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[521.16,554.691],[521.16,450.251],[426.217,554.168],[426.217,453.27]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[521.16,572.115],[521.16,676.555],[426.217,571],[426.217,671.897]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[521.16,688.605],[521.16,793.046],[426.217,683.539],[426.217,784.436]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[528.002,812.71],[528.002,917.275],[426.932,802.928],[426.932,903.752]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[486.417,322.675],[486.418,226.203],[438.964,328.593],[438.964,234.757]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[575.838,315.081],[575.838,215.226],[486.417,322.675],[486.418,226.203]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[958.916,434.185],[958.916,323.985],[542.401,440.282],[542.401,336.476]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[958.916,559.177],[958.916,448.977],[542.401,558.021],[542.401,454.215]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[958.916,577.561],[958.916,687.761],[542.401,575.339],[542.401,679.144]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[958.916,700.476],[958.916,810.676],[542.401,691.121],[542.401,794.927]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[958.916,827.449],[958.916,937.649],[542.401,810.727],[542.401,914.533]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[666.278,310.178],[666.278,208.137],[581.831,315.108],[581.831,215.264]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[691.824,308.611],[691.824,205.875],[666.278,310.178],[666.278,208.137]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[841.46,303.618],[841.46,198.657],[691.824,308.611],[691.824,205.875]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[983.338,301.649],[983.338,195.811],[841.46,303.618],[841.46,198.657]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[946.363,829.665],[1103.86,829.783],[946.363,940.713],[1103.86,940.876]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[953.157,429.629],[1101.9,429.608],[953.157,318.495],[1101.9,318.452]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[953.157,555.681],[953.157,444.547],[1101.9,555.684],[1101.9,444.528]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[953.157,574.221],[1101.9,574.227],[953.157,685.355],[1101.9,685.383]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[953.157,698.177],[1101.9,698.209],[953.157,809.311],[1101.9,809.365]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[983.338,301.649],[1124.51,302.078],[983.338,195.811],[1124.51,196.431]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1101.9,429.608],[1101.9,318.452],[1122.92,433.42],[1122.92,326.129]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1101.9,555.684],[1101.9,444.528],[1122.92,555.113],[1122.92,447.822]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1101.9,574.227],[1101.9,685.383],[1122.92,573.011],[1122.92,680.302]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1101.9,698.209],[1101.9,809.365],[1122.92,692.681],[1122.92,799.973]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1103.86,829.783],[1103.86,940.876],[1124.71,819.728],[1124.71,926.975]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1267.29,825.583],[1267.29,935.069],[1115.62,819.782],[1115.62,927.051]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,431.375],[1264.77,322.012],[1122.92,433.42],[1122.92,326.129]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,555.419],[1264.77,446.055],[1122.92,555.113],[1122.92,447.822]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,573.664],[1264.77,683.027],[1122.92,573.011],[1122.92,680.302]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,695.646],[1264.77,805.01],[1122.92,692.681],[1122.92,799.973]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1124.51,302.078],[1124.51,196.431],[1219.27,303.916],[1219.27,199.089]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1173.13,743.364],[1173.13,821.412],[1176.05,742.248],[1176.05,819.869]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1219.27,303.916],[1219.27,199.089],[1291.05,307.92],[1291.05,204.876]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,431.375],[1264.77,322.012],[1273.66,433.548],[1273.66,326.386]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.81,459.16],[1264.81,377.964],[1276.13,461.214],[1276.13,382.099]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,555.419],[1264.77,446.055],[1273.66,555.094],[1273.66,447.932]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.81,564.801],[1264.81,645.997],[1276.13,564.146],[1276.13,643.26]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,573.664],[1264.77,683.028],[1273.66,572.971],[1273.66,680.132]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.81,655.365],[1264.81,736.562],[1276.13,652.388],[1276.13,731.503]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1264.77,695.646],[1264.77,805.01],[1273.66,692.496],[1273.66,799.658]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1265.86,751.66],[1265.86,832.88],[1277.11,746.235],[1277.11,825.38]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1267.29,825.583],[1267.29,935.069],[1276.46,819.6],[1276.46,926.799]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,432.577],[1342.5,324.431],[1273.66,433.548],[1273.66,326.386]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,555.239],[1342.5,447.093],[1273.66,555.094],[1273.66,447.932]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,573.28],[1342.5,681.426],[1273.66,572.971],[1273.66,680.132]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,693.904],[1342.5,802.05],[1273.66,692.496],[1273.66,799.658]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.04,822.053],[1276.46,819.6],[1342.04,930.189],[1276.46,926.799]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1291.05,307.92],[1291.05,204.876],[1301.27,313.617],[1301.27,213.11]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1338.87,312.489],[1301.27,313.617],[1338.87,211.48],[1301.27,213.11]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1338.87,312.489],[1338.87,211.48],[1362.05,317.496],[1362.05,218.717]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.04,822.053],[1342.04,930.189],[1403.42,815.955],[1403.42,921.76]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,432.577],[1342.5,324.431],[1403.42,434.886],[1403.42,329.081]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,555.239],[1342.5,447.093],[1403.42,554.893],[1403.42,449.088]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,573.28],[1342.5,681.426],[1403.42,572.544],[1403.42,678.349]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1342.5,693.904],[1342.5,802.05],[1403.42,690.557],[1403.42,796.362]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1351.71,341.102],[1351.71,252.838],[1359.21,345.296],[1359.21,258.9]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1362.05,317.496],[1362.05,218.717],[1376.5,321.028],[1376.5,223.823]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1368.5,456.717],[1368.5,373.043],[1373.73,457.994],[1373.73,375.616]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1368.5,565.58],[1368.5,649.253],[1373.73,565.172],[1373.73,647.55]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1368.5,658.907],[1368.5,742.58],[1373.73,657.055],[1373.73,739.433]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1370.8,758.073],[1370.8,841.745],[1376.19,754.562],[1376.19,836.891]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1376.5,321.028],[1376.5,223.823],[1392.99,326.239],[1392.99,231.355]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1403.42,434.886],[1403.42,329.081],[1433.42,445.222],[1433.42,349.896]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1403.42,554.893],[1403.42,449.088],[1433.42,553.344],[1433.42,458.018]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1403.42,572.544],[1403.42,678.349],[1433.42,569.247],[1433.42,664.573]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1403.42,690.557],[1403.42,796.362],[1433.42,675.571],[1433.42,770.898]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1403.42,815.955],[1403.42,921.76],[1433.42,788.551],[1433.42,883.877]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1433.57,445.276],[1433.57,350.004],[1458.14,453.74],[1458.14,367.049]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1433.57,553.336],[1433.57,458.064],[1458.14,552.068],[1458.14,465.377]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1433.57,569.23],[1433.57,664.501],[1458.14,566.53],[1458.14,653.22]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1433.57,675.494],[1433.57,770.766],[1458.14,663.223],[1458.14,749.914]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:23,
                    verts:[[1433.67,788.318],[1433.67,883.555],[1458.22,765.892],[1458.22,852.554]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[323.342,444.264],[323.342,347.966],[312.039,447.099],[312.039,353.675]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[323.342,553.488],[323.342,457.19],[312.039,553.063],[312.039,459.639]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[323.342,569.552],[323.342,665.85],[312.039,568.648],[312.039,662.072]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[323.342,676.961],[323.342,773.258],[312.039,672.851],[312.039,766.275]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[324.788,791.122],[324.788,887.432],[313.046,783.601],[313.046,877.034]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[380.224,443.711],[380.224,346.853],[323.342,444.264],[323.342,347.966]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[380.224,553.57],[380.224,456.712],[323.342,553.488],[323.342,457.19]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[380.224,569.729],[380.224,666.587],[323.342,569.552],[323.342,665.85]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[380.224,677.762],[380.224,774.62],[323.342,676.961],[323.342,773.258]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[378.963,792.518],[378.963,889.362],[324.788,791.122],[324.788,887.432]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[488.444,800.972],[488.444,901.047],[357.333,797.518],[357.333,896.274]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[481.901,440.678],[481.901,340.744],[359.406,441.894],[359.406,343.193]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[481.901,554.025],[481.901,454.092],[359.406,553.843],[359.406,455.142]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[481.901,570.696],[481.901,670.63],[359.406,570.308],[359.406,669.009]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[481.901,682.16],[481.901,782.093],[359.406,680.397],[359.406,779.098]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[440.745,334.451],[440.745,243.225],[409.26,335.103],[409.26,244.168]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[443.302,323.521],[443.302,227.427],[416.49,329.646],[416.49,236.28]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[499.211,317.904],[499.211,219.307],[443.302,323.521],[443.302,227.427]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[555.124,434.128],[555.124,327.554],[447.795,437.291],[447.795,333.924]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[555.124,555.007],[555.124,448.433],[447.795,554.533],[447.795,451.166]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[555.124,572.786],[555.124,679.359],[447.795,571.777],[447.795,675.144]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[555.124,691.656],[555.124,798.229],[447.795,687.07],[447.795,790.437]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[562.497,818.216],[562.497,924.886],[448.353,809.374],[448.353,912.663]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[600.003,310.995],[600.003,209.32],[499.211,317.904],[499.211,219.307]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1013.29,433.94],[1013.29,323.482],[575.45,438.347],[575.45,332.512]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1013.29,559.224],[1013.29,448.767],[575.45,558.388],[575.45,452.553]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1013.29,577.651],[1013.29,688.108],[575.45,576.044],[575.45,681.879]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1013.29,700.853],[1013.29,811.31],[575.45,694.09],[575.45,799.925]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1013.29,828.122],[1013.29,938.58],[575.45,816.033],[575.45,921.868]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[698.114,306.871],[698.114,203.357],[606.14,311.079],[606.14,209.439]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[725.889,305.528],[725.889,201.419],[698.114,306.871],[698.114,203.357]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[882.851,301.923],[882.851,196.207],[725.889,305.528],[725.889,201.419]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1026.9,301.309],[882.851,301.923],[1026.9,195.319],[882.851,196.207]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1002.86,830.486],[1002.86,941.848],[1158.96,828.769],[1158.96,939.473]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1009.84,429.349],[1009.84,317.932],[1157.18,429.982],[1157.18,319.206]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1009.84,555.723],[1009.84,444.305],[1157.18,555.628],[1157.18,444.852]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1009.84,574.31],[1009.84,685.728],[1157.18,574.108],[1157.18,684.884]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1009.84,698.583],[1009.84,810.001],[1157.18,697.666],[1157.18,808.442]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1026.9,301.309],[1026.9,195.319],[1166.02,303.078],[1166.02,197.877]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1146.73,742.211],[1146.73,819.817],[1148.56,741.079],[1148.56,818.254]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1157.18,429.982],[1157.18,319.206],[1168.45,433.863],[1168.45,327.02]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1157.18,555.628],[1157.18,444.852],[1168.45,555.046],[1168.45,448.204]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1157.18,574.108],[1157.18,684.884],[1168.45,572.87],[1168.45,679.712]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1157.18,697.666],[1157.18,808.442],[1168.45,692.04],[1168.45,798.882]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1158.96,828.769],[1158.96,939.473],[1170.12,818.535],[1170.12,925.326]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1314.88,822.737],[1161.22,818.69],[1314.88,931.136],[1161.22,925.542]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1166.02,303.078],[1166.02,197.877],[1256.85,305.789],[1256.85,201.796]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,432.437],[1312.14,324.148],[1168.45,433.863],[1168.45,327.02]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,555.26],[1312.14,446.972],[1168.45,555.046],[1168.45,448.204]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,573.325],[1312.14,681.613],[1168.45,572.87],[1168.45,679.712]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,694.107],[1312.14,802.396],[1168.45,692.04],[1168.45,798.882]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1244.1,459.908],[1244.1,379.469],[1250.1,461.974],[1250.1,383.63]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1244.1,564.562],[1244.1,645.001],[1250.1,563.903],[1250.1,642.247]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1244.1,654.282],[1244.1,734.72],[1250.1,651.286],[1250.1,729.63]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1245.18,749.669],[1245.18,830.128],[1251.13,744.21],[1251.13,822.582]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1256.85,305.789],[1256.85,201.796],[1322.4,310.409],[1322.4,208.473]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,432.437],[1312.14,324.148],[1315.46,434.62],[1315.46,328.546]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,555.26],[1312.14,446.972],[1315.46,554.933],[1315.46,448.859]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,573.325],[1312.14,681.613],[1315.46,572.628],[1315.46,678.703]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1312.14,694.107],[1312.14,802.396],[1315.46,690.941],[1315.46,797.016]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,433.949],[1315.46,434.62],[1384.52,327.194],[1315.46,328.546]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,555.033],[1384.52,448.279],[1315.46,554.933],[1315.46,448.859]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,572.843],[1315.46,572.628],[1384.52,679.597],[1315.46,678.703]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,691.915],[1315.46,690.941],[1384.52,798.669],[1315.46,797.016]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1314.88,822.737],[1314.88,931.136],[1318.27,816.724],[1318.27,922.823]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.05,818.42],[1318.27,816.724],[1384.05,925.167],[1318.27,922.823]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1322.4,310.409],[1322.4,208.473],[1326.2,316.124],[1326.2,216.734]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1363.82,315.345],[1326.2,316.124],[1363.82,215.608],[1326.2,216.734]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1345.55,343.652],[1345.55,256.524],[1348.32,347.843],[1348.32,262.582]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1350.74,457.826],[1350.74,375.278],[1352.68,459.102],[1352.68,377.846]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1350.74,565.226],[1350.74,647.774],[1352.68,564.819],[1352.68,646.075]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1350.74,657.298],[1350.74,739.847],[1352.68,655.45],[1352.68,736.705]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1352.97,755.111],[1352.97,837.651],[1354.94,751.607],[1354.94,832.807]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1363.82,315.345],[1363.82,215.608],[1380.86,320.481],[1380.86,223.032]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1380.86,320.481],[1380.86,223.032],[1391.02,324.083],[1391.02,228.238]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.05,818.42],[1384.05,925.167],[1437.6,811.749],[1437.6,915.946]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,433.949],[1384.52,327.194],[1437.6,436.472],[1437.6,332.276]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,555.033],[1384.52,448.279],[1437.6,554.655],[1437.6,450.459]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,572.843],[1384.52,679.597],[1437.6,572.038],[1437.6,676.234]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1384.52,691.915],[1384.52,798.669],[1437.6,688.256],[1437.6,792.453]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1391.02,324.083],[1391.02,228.238],[1401.34,329.349],[1401.34,235.85]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1437.6,436.472],[1437.6,332.276],[1441.29,446.744],[1441.29,352.96]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1437.6,554.655],[1437.6,450.459],[1441.29,553.116],[1441.29,459.332]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1437.6,572.038],[1437.6,676.234],[1441.29,568.761],[1441.29,662.545]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1437.6,688.256],[1437.6,792.453],[1441.29,673.365],[1441.29,767.149]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1437.6,811.749],[1437.6,915.946],[1441.29,784.516],[1441.29,878.3]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1441.31,446.797],[1441.31,353.067],[1444.33,455.193],[1444.33,369.975]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1441.31,553.108],[1441.31,459.378],[1444.33,551.85],[1444.33,466.632]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1441.31,568.744],[1441.31,662.474],[1444.33,566.066],[1444.33,651.284]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1441.31,673.288],[1441.31,767.018],[1444.33,661.117],[1444.33,746.335]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:24,
                    verts:[[1441.32,784.285],[1441.32,877.98],[1444.34,762.041],[1444.34,847.23]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[328.849,441.631],[328.849,342.664],[309.665,444.491],[309.665,348.424]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[328.849,553.882],[328.849,454.915],[309.665,553.454],[309.665,457.386]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[328.849,570.392],[328.849,669.359],[309.665,569.48],[309.665,665.547]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[328.849,680.777],[328.849,779.744],[309.665,676.631],[309.665,772.699]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[330.397,798.088],[330.397,897.061],[310.748,790.505],[310.748,886.578]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[389.821,441.296],[389.821,341.99],[328.849,441.631],[328.849,342.664]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[389.821,553.932],[389.821,454.626],[328.849,553.882],[328.849,454.915]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[389.821,570.499],[389.821,669.805],[328.849,570.392],[328.849,669.359]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[389.821,681.263],[389.821,780.57],[328.849,680.777],[328.849,779.744]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[388.467,798.934],[388.467,898.23],[330.397,798.088],[330.397,897.061]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[510.45,806.361],[510.45,908.497],[370.71,804.281],[370.71,905.622]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[503.319,438.62],[503.319,336.601],[372.739,439.353],[372.739,338.076]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[503.319,554.333],[503.319,452.314],[372.739,554.224],[372.739,452.947]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[503.319,571.353],[503.319,673.372],[372.739,571.119],[372.739,672.396]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[503.319,685.143],[503.319,787.162],[372.739,684.081],[372.739,785.358]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[438.63,329.761],[438.63,236.445],[405.109,330.154],[405.109,237.013]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[453.596,318.64],[453.597,220.37],[418.801,324.646],[418.801,229.052]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[517.858,313.435],[517.859,212.848],[453.596,318.64],[453.597,220.37]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[595.565,432.28],[595.565,323.834],[476.636,435.028],[476.636,329.367]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[595.565,555.284],[595.565,446.837],[476.636,554.872],[476.636,449.211]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[595.565,573.375],[595.565,681.822],[476.636,572.499],[476.636,678.16]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[595.565,694.334],[595.565,802.781],[476.636,690.351],[476.636,796.012]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[603.383,823.032],[603.383,931.543],[477.018,815.364],[477.018,920.942]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[629.349,307.374],[629.349,204.086],[517.858,313.435],[517.859,212.848]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1067.39,434.084],[1067.39,323.777],[614.592,436.657],[614.592,329.049]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1067.39,559.197],[1067.39,448.89],[614.592,558.709],[614.592,451.101]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1067.39,577.598],[1067.39,687.905],[614.592,576.66],[614.592,684.268]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1067.39,700.632],[1067.39,810.938],[614.592,696.683],[614.592,804.291]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1067.39,827.727],[1067.39,938.034],[614.592,820.669],[614.592,928.277]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[734.085,304.146],[734.085,199.418],[635.548,307.517],[635.548,204.291]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[763.769,303.06],[763.769,197.851],[734.085,304.146],[734.085,199.418]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[925.893,300.956],[925.893,194.81],[763.769,303.06],[763.769,197.851]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[925.893,300.956],[1069.92,301.73],[925.893,194.81],[1069.92,195.929]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1059.27,830.202],[1059.27,941.455],[1211.35,826.681],[1211.35,936.587]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1066.33,429.488],[1066.33,318.21],[1209.78,430.763],[1209.78,320.777]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1066.33,555.702],[1066.33,444.424],[1209.78,555.511],[1209.78,445.526]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1066.33,574.266],[1066.33,685.543],[1209.78,573.859],[1209.78,683.844]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1066.33,698.382],[1066.33,809.66],[1209.78,696.534],[1209.78,806.519]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1069.92,301.73],[1069.92,195.929],[1204.88,304.806],[1204.88,200.374]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1204.2,816.685],[1357.38,818.964],[1204.2,922.769],[1357.38,925.92]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1204.88,304.806],[1204.88,200.374],[1290.51,308.33],[1290.51,205.469]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1209.78,430.763],[1209.78,320.777],[1211.25,434.65],[1211.25,328.605]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1209.78,555.511],[1209.78,445.526],[1211.25,554.928],[1211.25,448.884]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1209.78,573.859],[1209.78,683.844],[1211.25,572.619],[1211.25,678.664]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1209.78,696.534],[1209.78,806.519],[1211.25,690.899],[1211.25,796.944]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1211.25,434.65],[1354.46,433.846],[1211.25,328.605],[1354.46,326.987]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1211.25,554.928],[1211.25,448.884],[1354.46,555.049],[1354.46,448.19]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1211.25,572.619],[1354.46,572.875],[1211.25,678.664],[1354.46,679.734]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1211.25,690.899],[1354.46,692.063],[1211.25,796.944],[1354.46,798.922]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1211.35,826.681],[1211.35,936.587],[1212.75,816.432],[1212.75,922.419]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1221.08,460.672],[1221.08,381.008],[1221.86,462.731],[1221.86,385.155]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1221.08,564.319],[1221.08,643.982],[1221.86,563.661],[1221.86,641.237]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1221.08,653.174],[1221.08,732.838],[1221.86,650.188],[1221.86,727.764]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1222.19,747.633],[1222.19,827.314],[1222.93,742.193],[1222.93,819.793]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1290.51,308.33],[1290.51,205.469],[1349.07,313.476],[1349.07,212.906]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1346.61,319.13],[1383.76,318.695],[1346.61,221.079],[1383.76,220.45]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1352.34,436.008],[1420.55,435.633],[1352.34,331.34],[1420.55,330.585]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1352.34,572.186],[1352.34,676.854],[1420.55,572.305],[1420.55,677.353]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1352.34,688.93],[1420.55,689.473],[1352.34,793.598],[1420.55,794.521]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1352.34,554.725],[1352.34,450.057],[1420.55,554.781],[1420.55,449.733]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1355.11,813.014],[1420.08,813.961],[1355.11,917.695],[1420.08,919.003]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1383.76,318.695],[1383.76,220.45],[1394.68,323.884],[1394.68,227.951]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1394.68,323.884],[1394.68,227.951],[1400.6,327.505],[1400.6,233.184]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1400.6,327.505],[1400.6,233.184],[1404.89,332.757],[1404.89,240.776]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1420.08,813.961],[1420.08,919.003],[1465.34,806.849],[1465.34,909.172]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1420.55,435.633],[1420.55,330.585],[1465.34,438.321],[1465.34,335.998]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1420.55,554.781],[1420.55,449.733],[1465.34,554.378],[1465.34,452.055]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1420.55,572.305],[1420.55,677.353],[1465.34,571.448],[1465.34,673.771]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:25,
                    verts:[[1420.55,689.473],[1420.55,794.521],[1465.34,685.577],[1465.34,787.9]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[342.02,439.097],[342.02,337.562],[314.499,441.94],[314.499,343.286]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[342.02,554.262],[342.02,452.726],[314.499,553.836],[314.499,455.182]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[342.02,571.2],[342.02,672.736],[314.499,570.294],[314.499,668.947]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[342.02,684.451],[342.02,785.987],[314.499,680.33],[314.499,778.983]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[343.655,804.789],[343.655,906.324],[315.65,797.257],[315.65,895.912]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[406.567,439.01],[406.567,337.385],[342.02,439.097],[342.02,337.562]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[406.567,554.275],[406.567,452.651],[342.02,554.262],[342.02,452.726]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[406.567,571.228],[406.567,672.853],[342.02,571.2],[342.02,672.736]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[406.567,684.578],[406.567,786.203],[342.02,684.451],[342.02,785.986]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[405.131,805.01],[405.131,906.63],[343.655,804.789],[343.655,906.324]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[538.755,811.197],[538.755,915.182],[391.826,810.656],[391.826,914.435]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[531.106,436.768],[531.106,332.87],[393.778,436.958],[393.778,333.254]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[531.106,554.611],[531.106,450.714],[393.778,554.582],[393.778,450.878]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[531.106,571.944],[531.106,675.841],[393.778,571.883],[393.778,675.587]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[531.106,687.828],[531.106,791.726],[393.778,687.552],[393.778,791.257]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[442.104,325.242],[406.799,325.345],[442.104,229.914],[406.799,230.062]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[470.2,314.075],[470.201,213.772],[427.286,319.861],[427.286,222.136]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[542.48,309.4],[542.481,207.015],[470.2,314.075],[470.201,213.772]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[642.05,430.758],[642.05,320.768],[512.766,433.011],[512.766,325.304]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[642.05,555.512],[642.05,445.522],[512.766,555.174],[512.766,447.468]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[642.05,573.861],[642.05,683.85],[512.766,573.142],[512.766,680.848]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[642.05,696.541],[642.05,806.531],[512.766,693.275],[512.766,800.981]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[650.205,826.977],[650.205,936.996],[512.952,820.704],[512.952,928.325]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[663.623,304.342],[663.623,199.704],[542.48,309.4],[542.481,207.015]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1119.98,434.627],[1119.98,324.891],[659.39,435.274],[659.39,326.216]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1119.98,559.094],[1119.98,449.357],[659.39,558.971],[659.39,449.913]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1119.98,577.4],[1119.98,687.136],[659.39,577.164],[659.39,686.222]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1119.98,699.798],[1119.98,809.534],[659.39,698.805],[659.39,807.863]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1119.98,826.236],[1119.98,935.973],[659.39,824.462],[659.39,933.52]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[773.662,302.109],[773.662,196.474],[669.795,304.547],[669.795,199.997]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[804.857,301.308],[773.662,302.109],[804.857,195.319],[773.662,196.474]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[969.714,300.78],[804.857,301.308],[969.714,194.555],[804.857,195.319]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[969.714,300.78],[969.714,194.555],[1111.48,302.932],[1111.48,197.666]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1111.48,302.932],[1111.48,197.666],[1240.29,307.241],[1240.29,203.894]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1114.3,828.78],[1114.3,939.49],[1259.84,823.549],[1259.84,932.258]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1121.3,430.055],[1121.3,319.353],[1258.51,431.938],[1258.51,323.145]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1121.3,555.617],[1121.3,444.915],[1258.51,555.335],[1258.51,446.542]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1121.3,574.085],[1121.3,684.787],[1258.51,573.484],[1258.51,682.277]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1121.3,697.559],[1121.3,808.261],[1258.51,694.83],[1258.51,803.623]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1240.29,307.241],[1240.29,203.894],[1319.63,311.494],[1319.63,210.042]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1243.63,813.79],[1243.63,918.767],[1393.97,814.343],[1393.97,919.531]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1250.4,435.77],[1250.4,330.862],[1390.94,435.575],[1390.94,330.469]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1250.4,572.262],[1250.4,677.17],[1390.94,572.324],[1390.94,677.43]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1250.4,689.274],[1250.4,794.183],[1390.94,689.557],[1390.94,794.663]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1250.4,554.76],[1250.4,449.852],[1390.94,554.79],[1390.94,449.684]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1319.63,311.494],[1319.63,210.042],[1370.64,317.066],[1370.64,218.096]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1362.22,322.584],[1398.44,322.479],[1362.22,226.071],[1398.44,225.92]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1383.63,437.682],[1383.63,334.712],[1450.01,437.592],[1450.01,334.531]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1383.63,571.652],[1383.63,674.622],[1450.01,571.681],[1450.01,674.742]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1383.63,686.502],[1383.63,789.472],[1450.01,686.633],[1450.01,789.695]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1386.33,808.544],[1449.56,808.772],[1386.33,911.515],[1449.56,911.83]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1383.63,554.474],[1383.63,451.504],[1450.01,554.487],[1450.01,451.426]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1398.44,322.479],[1398.44,225.92],[1403.38,327.649],[1403.38,233.392]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1403.38,327.649],[1403.38,233.392],[1405.21,331.239],[1405.21,238.583]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1450.01,437.592],[1450.01,334.531],[1486.32,440.393],[1486.32,340.17]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1450.01,554.487],[1450.01,451.426],[1486.32,554.068],[1486.32,453.845]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1450.01,571.681],[1450.01,674.742],[1486.32,570.787],[1486.32,671.009]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1450.01,686.633],[1450.01,789.695],[1486.32,682.573],[1486.32,782.795]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:26,
                    verts:[[1449.56,808.772],[1449.56,911.83],[1486.32,801.355],[1486.32,901.577]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[363.284,436.729],[363.284,332.793],[327.131,439.506],[327.131,338.386]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[363.284,554.617],[363.284,450.68],[327.131,554.201],[327.131,453.08]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[363.284,571.956],[363.284,675.892],[327.131,571.07],[327.131,672.191]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[363.284,687.884],[363.284,791.821],[327.131,683.858],[327.131,784.979]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[364.99,811.049],[364.99,914.978],[328.34,803.696],[328.34,904.814]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[430.709,436.915],[430.709,333.166],[363.284,436.729],[363.284,332.793]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[430.709,554.589],[430.709,450.841],[363.284,554.617],[363.284,450.68]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[430.709,571.897],[430.709,675.645],[363.284,571.956],[363.284,675.892]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[430.709,687.615],[430.709,791.364],[363.284,687.884],[363.284,791.82]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[429.207,810.581],[364.99,811.049],[429.207,914.331],[364.99,914.978]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[410.443,325.989],[410.443,230.993],[409.061,329.606],[409.061,236.222]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[414.784,320.787],[414.784,223.474],[410.443,325.989],[410.443,230.993]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[451.54,321.003],[414.784,320.787],[451.54,223.786],[414.784,223.474]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[573.173,815.326],[573.173,920.89],[420.889,816.459],[420.889,922.457]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[565.095,435.178],[565.095,329.669],[422.728,434.779],[422.728,328.865]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[565.095,554.849],[565.095,449.34],[422.728,554.909],[422.728,448.995]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[565.095,572.451],[565.095,677.959],[422.728,572.578],[422.728,678.492]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[565.095,690.133],[565.095,795.642],[422.728,690.712],[422.728,796.626]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[493.251,309.954],[493.251,207.816],[442.278,315.412],[442.278,215.705]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[572.956,305.922],[572.956,201.988],[493.251,309.954],[493.251,207.816]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[693.816,429.62],[693.816,318.476],[555.872,431.308],[555.872,321.875]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[693.816,555.682],[693.816,444.538],[555.872,555.429],[555.872,445.997]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[693.816,574.224],[693.816,685.368],[555.872,573.685],[555.872,683.118]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[693.816,698.191],[693.816,809.335],[555.872,695.744],[555.872,805.177]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[702.18,829.898],[702.18,941.034],[555.848,825.215],[555.848,934.561]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[702.34,302.007],[702.34,196.328],[572.956,305.922],[572.956,201.988]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[816.114,300.842],[816.114,194.643],[708.386,302.272],[708.386,196.709]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[709.104,434.252],[709.104,324.121],[1169.86,435.561],[1169.86,326.804]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[709.104,559.165],[709.104,449.034],[1169.86,558.916],[1169.86,450.16]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[709.104,577.537],[709.104,687.668],[1169.86,577.06],[1169.86,685.816]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[709.104,700.374],[709.104,810.505],[1169.86,698.365],[1169.86,807.121]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[709.104,827.267],[709.104,937.397],[1169.86,823.675],[1169.86,932.431]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[848.358,300.347],[816.114,300.842],[848.358,193.929],[816.114,194.643]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[848.358,300.347],[1013.37,301.418],[848.358,193.929],[1013.37,195.477]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1013.37,301.418],[1013.37,195.477],[1150.68,304.896],[1150.68,200.504]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1150.68,304.896],[1150.68,200.504],[1271.59,310.329],[1271.59,208.357]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1166.67,826.244],[1166.67,935.983],[1303.44,819.452],[1303.44,926.594]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1173.5,431.042],[1173.5,321.341],[1302.35,433.48],[1302.35,326.249]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1173.5,555.469],[1173.5,445.768],[1302.35,555.104],[1302.35,447.873]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1173.5,573.77],[1173.5,683.471],[1302.35,572.992],[1302.35,680.223]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1173.5,696.128],[1173.5,805.83],[1302.35,692.595],[1302.35,799.826]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1271.59,310.329],[1271.59,208.357],[1343.74,315.212],[1343.74,215.415]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1278.75,810.072],[1278.75,913.628],[1424.11,808.99],[1424.11,912.131]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1285.15,437.199],[1285.15,333.738],[1421.01,437.58],[1421.01,334.506]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1285.15,571.806],[1285.15,675.266],[1421.01,571.684],[1421.01,674.758]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1285.15,687.203],[1285.15,790.664],[1421.01,686.651],[1421.01,789.724]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1285.15,554.546],[1285.15,451.086],[1421.01,554.489],[1421.01,451.416]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1343.74,315.212],[1343.74,215.415],[1386.88,321.103],[1386.88,223.932]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1372.9,326.417],[1407.79,326.622],[1372.9,231.612],[1407.79,231.908]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1408.91,439.604],[1408.91,338.582],[1472.61,439.779],[1472.61,338.935]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1408.91,683.716],[1408.91,784.738],[1472.61,683.462],[1472.61,784.307]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1411.5,803.42],[1411.5,904.432],[1472.16,802.978],[1472.16,903.821]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1408.91,554.186],[1408.91,453.164],[1472.61,554.16],[1472.61,453.315]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1408.91,571.039],[1408.91,672.061],[1472.61,570.983],[1472.61,671.827]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1472.16,802.978],[1472.16,903.821],[1500.44,795.391],[1500.44,893.334]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1472.61,439.779],[1472.61,338.935],[1500.44,442.642],[1500.44,344.7]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1472.61,554.16],[1472.61,453.315],[1500.44,553.731],[1500.44,455.789]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1472.61,570.983],[1472.61,671.827],[1500.44,570.07],[1500.44,668.012]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:27,
                    verts:[[1472.61,683.462],[1472.61,784.307],[1500.44,679.312],[1500.44,777.254]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[392.777,434.592],[392.777,328.49],[347.908,437.252],[347.908,333.845]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[392.777,554.937],[392.777,448.834],[347.908,554.538],[347.908,451.132]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[392.777,572.637],[392.777,678.74],[347.908,571.789],[347.908,675.195]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[392.777,690.982],[392.777,797.085],[347.908,687.126],[347.908,790.533]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[394.532,816.694],[394.532,922.782],[349.161,809.66],[349.161,913.058]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[462.21,435.071],[392.777,434.592],[462.21,329.453],[392.777,328.49]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[462.21,554.865],[462.21,449.248],[392.777,554.937],[392.777,448.834]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[462.21,572.485],[462.21,678.103],[392.777,572.637],[392.777,678.74]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[462.21,690.289],[392.777,690.982],[462.21,795.906],[392.777,797.085]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[460.661,815.487],[394.532,816.694],[460.661,921.113],[394.532,922.782]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[413.364,325.461],[413.364,230.23],[409.687,330.767],[409.687,237.899]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[418.911,321.812],[418.911,224.956],[413.364,325.461],[413.364,230.23]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[429.325,316.59],[429.325,217.408],[418.911,321.812],[418.911,224.956]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[467.125,317.145],[429.325,316.59],[467.125,218.21],[429.325,217.408]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[613.235,818.617],[457.78,821.518],[613.235,925.44],[457.78,929.45]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[604.839,433.902],[459.469,432.88],[604.839,327.099],[459.469,325.04]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[604.839,555.041],[604.839,448.238],[459.469,555.194],[459.469,447.355]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[604.839,572.858],[459.469,573.184],[604.839,679.66],[459.469,681.023]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[604.839,691.983],[459.469,693.465],[604.839,798.786],[459.469,801.304]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[522.635,306.393],[522.635,202.669],[463.888,311.414],[463.888,209.926]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[608.907,303.108],[608.907,197.92],[522.635,306.393],[522.635,202.669]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[602.275,748.968],[602.275,829.158],[602.021,743.482],[602.021,821.576]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[605.296,429.977],[605.296,319.194],[604.839,433.902],[604.839,327.099]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[605.296,555.629],[605.296,444.847],[604.839,555.041],[604.839,448.238]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[605.296,574.11],[605.296,684.892],[604.839,572.858],[604.839,679.66]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[605.296,697.674],[605.296,808.456],[604.839,691.983],[604.839,798.786]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[605.053,828.744],[605.053,939.439],[604.607,818.395],[604.607,925.133]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[749.802,428.907],[749.802,317.041],[605.296,429.977],[605.296,319.194]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[749.802,555.789],[749.802,443.923],[605.296,555.629],[605.296,444.847]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[749.802,574.451],[749.802,686.317],[605.296,574.11],[605.296,684.892]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[749.802,699.224],[749.802,811.09],[605.296,697.674],[605.296,808.456]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[758.233,831.687],[758.233,943.507],[605.053,828.744],[605.053,939.439]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[744.786,300.445],[744.786,194.071],[608.907,303.108],[608.907,197.92]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[707.202,742.049],[707.202,819.594],[706.556,740.906],[706.556,818.014]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[860.556,300.392],[750.608,300.768],[860.556,193.992],[750.608,194.537]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[762.717,433.627],[762.717,322.841],[1215.97,436.857],[1215.97,329.459]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[762.717,559.283],[762.717,448.498],[1215.97,558.671],[1215.97,451.273]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[762.717,577.765],[762.717,688.551],[1215.97,576.587],[1215.97,683.985]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[762.717,701.333],[762.717,812.119],[1215.97,696.377],[1215.97,803.775]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[762.717,828.981],[762.717,939.766],[1215.97,820.121],[1215.97,927.519]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[893.345,300.212],[860.556,300.392],[893.345,193.735],[860.556,193.992]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[893.345,300.212],[893.345,193.735],[1055.9,302.857],[1055.9,197.558]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1055.9,302.857],[1055.9,197.558],[1186.76,307.567],[1186.76,204.366]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1186.76,307.567],[1186.76,204.366],[1298.29,313.987],[1298.29,213.646]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1215.24,822.673],[1215.24,931.047],[1341.38,814.514],[1341.38,919.769]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1221.79,432.418],[1221.79,324.111],[1340.55,435.34],[1340.55,329.995]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1221.79,555.263],[1221.79,446.956],[1340.55,554.825],[1340.55,449.48]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1221.79,573.331],[1221.79,681.638],[1340.55,572.399],[1340.55,677.744]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1221.79,694.135],[1221.79,802.442],[1340.55,689.898],[1340.55,795.243]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1298.29,313.987],[1298.29,213.646],[1362.62,319.388],[1362.62,221.452]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1309.01,805.635],[1309.01,907.494],[1447.54,803.05],[1447.54,903.921]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1314.95,438.896],[1314.95,337.156],[1444.41,439.806],[1444.41,338.989]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1314.95,571.265],[1314.95,673.005],[1444.41,570.974],[1444.41,671.791]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1314.95,684.743],[1314.95,786.483],[1444.41,683.423],[1444.41,784.24]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1314.95,554.292],[1314.95,452.552],[1444.41,554.156],[1444.41,453.339]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1362.62,319.388],[1362.62,221.452],[1397.77,325.494],[1397.77,230.277]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1378.73,330.546],[1378.73,237.581],[1411.95,331.034],[1411.95,238.286]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1427.99,441.724],[1427.99,342.851],[1488.3,442.139],[1488.3,343.687]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1427.99,570.363],[1427.99,669.236],[1488.3,570.23],[1488.3,668.682]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1427.99,680.643],[1427.99,779.516],[1488.3,680.041],[1488.3,778.493]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1430.44,797.775],[1430.44,896.628],[1487.88,796.726],[1487.88,895.178]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1427.99,553.868],[1427.99,454.995],[1488.3,553.806],[1488.3,455.354]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1488.3,442.139],[1488.3,343.687],[1507.9,445.017],[1507.9,349.483]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1488.3,553.806],[1488.3,455.354],[1507.9,553.375],[1507.9,457.84]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1488.3,570.23],[1488.3,668.682],[1507.9,569.312],[1507.9,664.846]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1488.3,680.041],[1488.3,778.493],[1507.9,675.869],[1507.9,771.404]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:28,
                    verts:[[1487.88,796.726],[1487.88,895.178],[1507.9,789.095],[1507.9,884.629]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[375.823,445.725],[375.823,350.908],[374.97,454.249],[374.97,368.073]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[375.823,553.269],[375.823,458.452],[374.97,551.991],[374.97,465.816]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[375.823,569.086],[375.823,663.903],[374.97,566.367],[374.97,652.543]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[375.823,674.843],[375.823,769.659],[374.97,662.485],[374.97,748.661]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[376.872,435.234],[376.872,329.783],[375.828,445.671],[375.828,350.799]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[376.872,554.841],[376.872,449.389],[375.828,553.277],[375.828,458.405]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[376.872,572.433],[376.872,677.884],[375.828,569.104],[375.828,663.975]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[376.872,690.051],[376.872,795.503],[375.828,674.921],[375.828,769.792]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,432.746],[430.293,324.772],[376.872,435.234],[376.872,329.783]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,555.214],[430.293,447.239],[376.872,554.841],[376.872,449.389]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,573.226],[430.293,681.201],[376.872,572.433],[376.872,677.884]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,693.659],[430.293,801.633],[376.872,690.051],[376.872,795.503]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[378.153,814.995],[378.153,920.432],[376.981,787.331],[376.981,882.192]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[432.072,821.569],[432.072,929.52],[378.153,814.995],[378.153,920.432]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[423.883,321.649],[423.883,224.721],[414.045,326.97],[414.045,232.411]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[433.768,318.02],[433.768,219.475],[423.883,321.649],[423.883,224.721]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,432.746],[500.717,433.529],[430.293,324.772],[500.717,326.349]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,555.214],[430.293,447.239],[500.717,555.096],[500.717,447.916]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,573.226],[500.717,572.977],[430.293,681.201],[500.717,680.157]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[430.293,693.659],[500.717,692.523],[430.293,801.633],[500.717,799.703]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[432.072,821.569],[499.143,819.591],[432.072,929.52],[499.143,926.786]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[450.459,312.853],[450.459,212.006],[433.768,318.02],[433.768,219.475]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[450.459,312.853],[488.825,313.762],[450.459,212.006],[488.825,213.32]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[470.312,757.194],[470.312,840.53],[468.623,753.649],[468.623,835.63]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[470.877,457.029],[470.877,373.671],[469.238,458.319],[469.238,376.27]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[470.877,565.481],[470.877,648.838],[469.238,565.069],[469.238,647.118]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[470.877,658.455],[470.877,741.812],[469.238,656.584],[469.238,738.633]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[473.676,341.68],[473.676,253.674],[471.374,345.923],[471.374,259.807]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[491.969,307.969],[491.969,204.946],[488.826,313.762],[488.826,213.32]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[557.969,303.489],[557.969,198.471],[491.969,307.969],[491.969,204.946]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[502.026,825.683],[502.026,935.208],[499.143,819.591],[499.143,926.786]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,431.316],[503.527,321.893],[500.717,433.529],[500.717,326.349]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,555.428],[503.527,446.004],[500.717,555.096],[500.717,447.916]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,573.682],[503.527,683.106],[500.717,572.977],[500.717,680.157]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,695.731],[503.527,805.155],[500.717,692.523],[500.717,799.703]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[502.026,825.683],[658.204,820.977],[502.026,935.208],[658.204,928.702]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,431.316],[503.527,321.893],[649.618,432.976],[649.618,325.234]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,555.428],[503.527,446.004],[649.618,555.179],[649.618,447.438]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,573.682],[503.527,683.106],[649.618,573.153],[649.618,680.895]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[503.527,695.731],[503.527,805.155],[649.618,693.326],[649.618,801.067]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[649.708,301.035],[649.708,194.924],[557.969,303.489],[557.969,198.471]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[579.601,459.256],[579.601,378.156],[574.047,461.34],[574.047,382.354]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[579.601,564.77],[579.601,645.87],[574.047,564.105],[574.047,643.091]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[579.601,655.227],[579.601,736.326],[574.047,652.205],[574.047,731.191]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[580.128,751.364],[580.128,832.471],[574.583,745.859],[574.583,824.861]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[790.073,299.7],[790.073,192.995],[649.708,301.035],[649.708,194.924]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[660.053,429.059],[660.053,317.347],[649.618,432.976],[649.618,325.234]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[660.053,555.766],[660.053,444.054],[649.618,555.179],[649.618,447.438]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[660.053,574.402],[660.053,686.115],[649.618,573.153],[649.618,680.895]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[660.053,699.004],[660.053,810.716],[649.618,693.326],[649.618,801.067]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[659.588,831.179],[659.588,942.806],[649.219,820.853],[649.219,928.531]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[817.069,832.29],[817.069,944.341],[659.588,831.179],[659.588,942.806]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[808.719,428.642],[808.719,316.508],[660.053,429.059],[660.053,317.347]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[808.719,555.829],[808.719,443.694],[660.053,555.766],[660.053,444.054]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[808.719,574.535],[808.719,686.67],[660.053,574.402],[660.053,686.115]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[808.719,699.608],[808.719,811.743],[660.053,699.004],[660.053,810.716]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[680.344,743.543],[680.344,821.659],[678.596,742.405],[678.596,820.086]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[795.573,300.078],[906.009,300.764],[795.573,193.538],[906.009,194.531]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[819.009,433.418],[819.009,322.413],[1257.47,438.469],[1257.47,332.761]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[819.009,559.323],[819.009,448.318],[1257.47,558.365],[1257.47,452.658]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[819.009,577.841],[819.009,688.846],[1257.47,576],[1257.47,681.707]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[819.009,701.654],[819.009,812.659],[1257.47,693.903],[1257.47,799.611]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[819.009,829.554],[819.009,940.559],[1257.47,815.7],[1257.47,921.407]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[906.009,300.764],[938.821,300.902],[906.009,194.531],[938.821,194.732]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[938.821,300.902],[938.821,194.732],[1096.43,305.045],[1096.43,200.72]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1096.43,305.045],[1096.43,200.72],[1219.1,310.862],[1219.1,209.128]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1219.1,310.862],[1219.1,209.128],[1320.14,318.113],[1320.14,219.61]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1259.09,818.195],[1259.09,924.856],[1373.2,808.892],[1373.2,911.996]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1265.27,434.133],[1265.27,327.564],[1372.62,437.46],[1372.62,334.265]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1265.27,555.006],[1265.27,448.437],[1372.62,554.507],[1372.62,451.312]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1265.27,572.784],[1265.27,679.353],[1372.62,571.723],[1372.62,674.918]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1265.27,691.648],[1265.27,798.217],[1372.62,686.825],[1372.62,790.02]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1320.14,318.113],[1320.14,219.61],[1376.24,323.916],[1376.24,227.997]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1334.06,800.609],[1334.06,900.546],[1464.28,796.685],[1464.28,895.121]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1339.49,440.811],[1339.49,341.013],[1461.18,442.193],[1461.18,343.797]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1339.49,570.654],[1339.49,670.452],[1461.18,570.213],[1461.18,668.61]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1339.49,681.966],[1339.49,781.764],[1461.18,679.963],[1461.18,778.359]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1339.49,554.005],[1339.49,454.207],[1461.18,553.798],[1461.18,455.401]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1376.24,323.916],[1376.24,227.997],[1403.46,330.134],[1403.46,236.985]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1379.92,334.882],[1379.92,243.848],[1411.2,335.623],[1411.2,244.919]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1440.95,443.987],[1440.95,347.407],[1497.34,444.614],[1497.34,348.67]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1440.95,569.641],[1440.95,666.22],[1497.34,569.441],[1497.34,665.384]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1440.95,677.363],[1440.95,773.942],[1497.34,676.454],[1497.34,772.397]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1443.24,791.753],[1443.24,888.304],[1496.94,790.17],[1496.94,886.115]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1440.95,553.529],[1440.95,456.95],[1497.34,553.435],[1497.34,457.492]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1496.94,790.17],[1496.94,886.115],[1509.1,782.606],[1509.1,875.659]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1497.34,444.614],[1497.34,348.67],[1509.1,447.464],[1509.1,354.411]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1497.34,553.435],[1497.34,457.492],[1509.1,553.008],[1509.1,459.955]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1497.34,569.441],[1497.34,665.384],[1509.1,568.531],[1509.1,661.584]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:29,
                    verts:[[1497.34,676.454],[1497.34,772.397],[1509.1,672.321],[1509.1,765.374]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[385.53,444.055],[385.53,347.545],[362.562,452.646],[362.562,364.847]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[385.53,553.519],[385.53,457.009],[362.562,552.231],[362.562,464.432]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[385.53,569.619],[385.53,666.129],[362.562,566.878],[362.562,654.678]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[385.53,677.264],[385.53,773.774],[362.562,664.808],[362.562,752.608]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[387.406,791.483],[387.406,887.931],[364.282,768.732],[364.282,856.481]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[413.737,433.504],[413.737,326.297],[385.676,444],[385.676,347.435]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[413.737,555.1],[413.737,447.894],[385.676,553.527],[385.676,456.962]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[413.737,572.985],[413.737,680.191],[385.676,569.636],[385.676,666.201]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[413.737,692.56],[413.737,799.767],[385.676,677.343],[385.676,773.908]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[415.026,819.568],[415.026,926.755],[386.841,791.749],[386.841,888.298]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,431.238],[475.273,321.736],[413.737,433.504],[413.737,326.297]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,555.44],[475.273,445.937],[413.737,555.1],[413.737,447.894]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,573.707],[475.273,683.21],[413.737,572.985],[413.737,680.191]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,695.844],[475.273,805.347],[413.737,692.56],[413.737,799.767]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[477.047,825.545],[477.047,935.017],[415.026,819.568],[415.026,926.755]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[440.633,318.247],[440.633,219.803],[424.442,323.509],[424.442,227.409]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[454.938,314.69],[454.938,214.662],[440.633,318.247],[440.633,219.803]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[454.013,760.51],[454.013,845.114],[448.828,756.958],[448.828,840.204]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[454.648,455.78],[454.648,371.156],[449.635,457.073],[449.635,373.76]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[454.648,565.879],[454.648,650.502],[449.635,565.466],[449.635,648.779]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[454.648,660.266],[454.648,744.889],[449.635,658.391],[449.635,741.704]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[477.971,309.659],[477.971,207.389],[454.938,314.69],[454.938,214.662]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[469.33,338.803],[469.33,249.515],[462.163,343.049],[462.163,255.653]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,431.238],[475.273,321.736],[545.563,432.329],[545.563,323.932]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,555.44],[475.273,445.937],[545.563,555.276],[545.563,446.879]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,573.707],[475.273,683.21],[545.563,573.359],[545.563,681.756]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[475.273,695.844],[475.273,805.347],[545.563,694.263],[545.563,802.66]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[477.047,825.545],[543.989,822.791],[477.047,935.017],[543.989,931.209]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[477.971,309.659],[516.376,310.926],[477.971,207.389],[516.377,209.222]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[526.117,305.155],[526.117,200.88],[516.377,310.926],[516.377,209.222]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[598.616,301.309],[598.616,195.321],[526.116,305.155],[526.116,200.88]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[552.808,828.845],[552.808,939.579],[543.989,822.791],[543.989,931.209]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,430.13],[554.089,319.504],[545.563,432.329],[545.563,323.932]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,555.606],[554.089,444.979],[545.563,555.276],[545.563,446.879]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,574.061],[554.089,684.687],[545.563,573.359],[545.563,681.756]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,697.451],[554.089,808.077],[545.563,694.263],[545.563,802.66]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[560.604,458.378],[560.604,376.389],[549.6,460.45],[549.6,380.561]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[560.604,565.05],[560.604,647.039],[549.6,564.389],[549.6,644.278]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[560.604,656.499],[560.604,738.488],[549.6,653.495],[549.6,733.384]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[561.162,753.686],[561.162,835.681],[550.188,748.215],[550.188,828.118]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[552.808,828.845],[552.808,939.58],[707.123,822.352],[707.123,930.603]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,430.13],[554.089,319.504],[698.483,432.42],[698.483,324.115]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,555.606],[554.089,444.979],[698.483,555.263],[698.483,446.958]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,574.061],[554.089,684.687],[698.483,573.33],[698.483,681.635]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[554.089,697.451],[554.089,808.077],[698.483,694.131],[698.483,802.436]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[694.517,299.749],[694.517,193.064],[598.616,301.309],[598.616,195.32]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[655.773,745.011],[655.773,823.688],[652.911,743.889],[652.911,822.137]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[837.191,299.775],[694.517,299.749],[837.191,193.103],[694.517,193.064]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[718.215,832.465],[718.215,944.584],[697.921,822.331],[697.921,930.575]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[718.897,428.577],[718.897,316.376],[698.483,432.42],[698.483,324.115]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[718.897,555.839],[718.897,443.637],[698.483,555.263],[698.483,446.958]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[718.897,574.556],[718.897,686.757],[698.483,573.33],[698.483,681.635]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[718.897,699.703],[718.897,811.904],[698.483,694.131],[698.483,802.436]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[869.152,428.823],[718.897,428.577],[869.152,316.872],[718.897,316.376]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[869.152,555.802],[869.152,443.85],[718.897,555.839],[718.897,443.637]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[869.152,574.478],[869.152,686.429],[718.897,574.556],[718.897,686.757]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[869.152,699.345],[718.897,699.703],[869.152,811.297],[718.897,811.904]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[877.275,831.715],[718.215,832.465],[877.275,943.547],[718.215,944.584]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[842.284,300.201],[842.284,193.717],[951.474,301.929],[951.474,196.213]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[876.645,433.622],[876.645,322.831],[1293.76,440.34],[1293.76,336.596]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[876.645,559.284],[876.645,448.493],[1293.76,558.01],[1293.76,454.266]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[876.645,577.767],[876.645,688.558],[1293.76,575.317],[1293.76,679.061]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[876.645,701.341],[876.645,812.132],[1293.76,691.031],[1293.76,794.775]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[876.645,828.994],[876.645,939.785],[1293.76,810.566],[1293.76,914.31]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[951.474,301.929],[983.798,302.374],[951.474,196.213],[983.798,196.859]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[983.798,302.374],[983.798,196.859],[1134.21,307.897],[1134.21,204.842]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1134.21,307.897],[1134.21,204.842],[1247.28,314.671],[1247.28,214.634]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1247.28,314.671],[1247.28,214.634],[1337.06,322.59],[1337.06,226.081]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1297.58,812.969],[1297.58,917.633],[1398.73,802.757],[1398.73,903.516]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1303.32,436.126],[1303.32,331.578],[1398.38,439.774],[1398.38,338.925]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1303.32,554.707],[1303.32,450.159],[1398.38,554.16],[1398.38,453.311]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1303.32,572.148],[1303.32,676.696],[1398.38,570.984],[1398.38,671.833]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1303.32,688.759],[1303.32,793.307],[1398.38,683.469],[1398.38,784.318]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1337.06,322.59],[1337.06,226.081],[1384.77,328.682],[1384.77,234.886]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1353.8,795.14],[1353.8,892.985],[1474.6,790.056],[1474.6,885.958]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1358.68,442.89],[1358.68,345.2],[1471.56,444.681],[1471.56,348.805]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1358.68,569.99],[1358.68,667.681],[1471.56,569.419],[1471.56,665.295]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1358.68,678.952],[1358.68,776.642],[1471.56,676.357],[1471.56,772.232]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1376.82,339.332],[1376.82,250.28],[1405.96,340.294],[1405.96,251.67]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1384.77,328.682],[1384.77,234.886],[1404.3,334.921],[1404.3,243.905]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1358.68,553.693],[1358.68,456.003],[1471.56,553.425],[1471.56,457.55]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1448.08,446.337],[1448.08,352.141],[1500.17,447.145],[1500.17,353.768]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1448.08,673.956],[1448.08,768.152],[1500.17,672.784],[1500.17,766.16]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1450.2,785.502],[1450.2,879.663],[1499.79,783.461],[1499.79,876.842]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1448.08,553.177],[1448.08,458.981],[1500.17,553.056],[1500.17,459.679]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1448.08,568.891],[1448.08,663.087],[1500.17,568.633],[1500.17,662.01]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1500.17,447.145],[1500.17,353.768],[1504.59,449.934],[1504.59,359.384]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1500.17,553.056],[1500.17,459.679],[1504.59,552.638],[1504.59,462.088]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1500.17,568.633],[1500.17,662.01],[1504.59,567.744],[1504.59,658.293]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1500.17,672.784],[1500.17,766.16],[1504.59,668.741],[1504.59,759.29]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:30,
                    verts:[[1499.79,783.461],[1499.79,876.842],[1504.59,776.059],[1504.59,866.609]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[401.68,442.554],[401.68,344.523],[355.709,451.107],[355.709,361.747]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[401.68,553.744],[401.68,455.713],[355.709,552.462],[355.709,463.102]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[401.68,570.098],[401.68,668.129],[355.709,567.369],[355.709,656.73]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[401.68,679.44],[401.68,777.471],[355.709,667.04],[355.709,756.4]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[403.461,795.442],[403.461,893.403],[357.362,772.796],[357.362,862.098]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[457.887,432.097],[457.887,323.464],[401.97,442.5],[401.97,344.414]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[457.887,555.311],[457.887,446.678],[401.97,553.752],[401.97,455.666]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[457.887,573.433],[457.887,682.066],[401.97,570.115],[401.97,668.201]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[457.887,694.6],[457.887,803.233],[401.97,679.518],[401.97,777.604]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[459.163,823.284],[459.163,931.891],[403.134,795.714],[403.134,893.779]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[442.18,763.701],[442.18,849.525],[433.392,760.18],[433.392,844.658]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[439.815,320.831],[439.815,223.538],[434.759,326.349],[434.759,231.514]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[442.883,454.578],[442.883,368.737],[434.393,455.86],[434.393,371.318]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[442.883,566.262],[442.883,652.103],[434.393,565.853],[434.393,650.395]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[442.883,662.007],[442.883,747.849],[434.393,660.149],[434.393,744.691]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[463.416,315.313],[463.416,215.561],[440.812,320.441],[440.812,222.974]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[469.801,336.152],[469.801,245.683],[457.645,340.352],[457.645,251.754]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,430.101],[526.834,319.446],[457.887,432.097],[457.887,323.464]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,555.61],[526.834,444.955],[457.887,555.311],[457.887,446.678]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,574.07],[526.834,684.725],[457.887,573.433],[457.887,682.066]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,697.493],[526.834,808.148],[457.887,694.6],[457.887,803.233]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[528.572,828.539],[528.572,939.156],[459.163,823.284],[459.163,931.891]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[482.124,311.883],[482.124,210.604],[463.416,315.313],[463.416,215.562]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[511.407,307.066],[511.407,203.641],[482.124,311.883],[482.124,210.604]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[511.407,307.066],[549.296,308.687],[511.407,203.641],[549.296,205.985]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,430.101],[526.834,319.446],[595.817,431.493],[595.817,322.248]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,555.61],[526.834,444.955],[595.817,555.401],[595.817,446.157]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,574.07],[526.834,684.725],[595.817,573.626],[595.817,682.871]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[526.834,697.493],[526.834,808.148],[595.817,695.475],[595.817,804.72]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[545.036,457.537],[545.036,374.694],[528.498,459.575],[528.498,378.798]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[545.036,565.319],[545.036,648.161],[528.498,564.668],[528.498,645.444]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[545.036,657.719],[545.036,740.561],[528.498,654.764],[528.498,735.54]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[528.572,828.539],[528.572,939.156],[594.27,825.025],[594.27,934.299]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[545.621,755.913],[545.621,838.759],[529.136,750.531],[529.136,831.319]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[565.687,303.024],[565.687,197.8],[549.296,308.687],[549.296,205.985]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[643.727,299.887],[643.727,193.264],[565.686,303.024],[565.686,197.8]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[609.024,830.944],[609.024,942.481],[594.27,825.025],[594.27,934.299]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,429.343],[610.058,317.919],[595.817,431.493],[595.817,322.248]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,555.724],[610.058,444.3],[595.817,555.401],[595.817,446.157]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,574.312],[610.058,685.736],[595.817,573.626],[595.817,682.871]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,698.592],[610.058,810.016],[595.817,695.475],[595.817,804.72]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[609.023,830.944],[609.023,942.481],[758.885,822.741],[758.885,931.141]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,429.343],[610.058,317.919],[750.33,432.237],[750.33,323.747]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,555.724],[610.058,444.3],[750.33,555.29],[750.33,446.8]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,574.312],[610.058,685.736],[750.33,573.389],[750.33,681.879]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[610.058,698.592],[610.058,810.016],[750.33,694.396],[750.33,802.886]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[633.752,746.444],[633.752,825.67],[629.777,745.349],[629.777,824.155]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[742.344,299.255],[742.344,192.351],[643.727,299.887],[643.727,193.264]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[742.344,299.255],[885.1,300.634],[742.344,192.351],[885.1,194.344]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,428.528],[780.426,316.278],[750.33,432.237],[750.33,323.747]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,555.846],[780.426,443.596],[750.33,555.29],[750.33,446.8]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,574.572],[780.426,686.822],[750.33,573.389],[750.33,681.879]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,699.773],[780.426,812.023],[750.33,694.396],[750.33,802.886]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[779.538,832.604],[779.538,944.775],[749.613,822.824],[749.613,931.256]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[779.538,832.604],[937.439,830.029],[779.538,944.775],[937.439,941.215]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,428.528],[780.426,316.278],[929.678,429.427],[929.678,318.087]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,555.846],[780.426,443.596],[929.678,555.711],[929.678,444.372]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,574.572],[780.426,686.822],[929.678,574.285],[929.678,685.625]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[780.426,699.773],[780.426,812.023],[929.678,698.471],[929.678,809.811]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[889.71,301.101],[889.71,195.017],[996.007,303.816],[996.007,198.941]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[934.292,434.216],[934.292,324.047],[1324.55,442.409],[1324.55,340.833]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[934.292,559.172],[934.292,449.003],[1324.55,557.618],[1324.55,456.043]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[934.292,577.55],[934.292,687.719],[1324.55,574.563],[1324.55,676.138]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[934.292,700.43],[934.292,810.598],[1324.55,687.858],[1324.55,789.433]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[934.292,827.366],[934.292,937.534],[1324.55,804.893],[1324.55,906.468]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[996.007,303.816],[1027.37,304.55],[996.007,198.941],[1027.37,200.005]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1027.37,304.55],[1027.37,200.005],[1168.66,311.304],[1168.66,209.767]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1168.66,311.304],[1168.66,209.767],[1271.08,318.874],[1271.08,220.709]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1271.08,318.874],[1271.08,220.709],[1349.18,327.298],[1349.18,232.886]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1330.37,807.178],[1330.37,909.627],[1418.05,796.29],[1418.05,894.575]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1335.61,438.329],[1335.61,336.014],[1417.93,442.216],[1417.93,343.842]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1335.61,554.377],[1335.61,452.063],[1417.93,553.795],[1417.93,455.421]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1335.61,571.445],[1335.61,673.76],[1417.93,570.206],[1417.93,668.58]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1335.61,685.565],[1335.61,787.88],[1417.93,679.93],[1417.93,778.304]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1349.18,327.298],[1349.18,232.886],[1388.53,333.574],[1388.53,241.956]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1368.34,789.378],[1368.34,885.021],[1478.97,783.322],[1478.97,876.648]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1369.86,343.809],[1369.86,256.75],[1396.74,344.959],[1396.74,258.413]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1372.65,445.076],[1372.65,349.602],[1476.03,447.209],[1476.03,353.897]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1372.65,569.293],[1372.65,664.767],[1476.03,568.613],[1476.03,661.925]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1372.65,675.783],[1372.65,771.257],[1476.03,672.691],[1476.03,766.003]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1388.53,333.574],[1388.53,241.956],[1400.73,339.755],[1400.73,250.891]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1372.65,553.366],[1372.65,457.892],[1476.03,553.046],[1476.03,459.734]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1449.84,448.721],[1449.84,356.943],[1497.4,449.681],[1497.4,358.875]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1449.84,568.13],[1449.84,659.909],[1497.4,567.824],[1497.4,658.631]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1449.84,670.499],[1449.84,762.277],[1497.4,669.108],[1497.4,759.914]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1451.77,779.164],[1451.77,870.9],[1497.05,776.742],[1497.05,867.553]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:31,
                    verts:[[1449.84,552.82],[1449.84,461.041],[1497.4,552.676],[1497.4,461.87]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[424.045,441.244],[424.045,341.884],[354.578,449.648],[354.578,358.808]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[424.045,553.94],[424.045,454.581],[354.578,552.681],[354.578,461.841]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[424.045,570.516],[424.045,669.875],[354.578,567.835],[354.578,658.675]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[424.045,681.339],[424.045,780.699],[354.578,669.155],[354.578,759.995]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[425.703,798.897],[425.703,898.18],[356.143,776.649],[356.143,867.424]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[434.978,766.738],[434.978,853.724],[422.522,763.287],[422.522,848.953]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[435.745,453.435],[435.745,366.435],[423.717,454.691],[423.717,368.964]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[435.745,552.113],[435.745,465.113],[423.717,551.925],[423.717,466.198]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[435.745,566.627],[435.745,653.627],[423.717,566.226],[423.717,651.953]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[435.745,663.665],[435.745,750.665],[423.717,661.844],[423.717,747.571]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[508.423,431.036],[508.423,321.327],[424.482,441.191],[424.482,341.778]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[508.423,555.47],[508.423,445.762],[424.482,553.948],[424.482,454.535]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[508.423,573.772],[508.423,683.48],[424.482,570.533],[424.482,669.946]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[508.423,696.138],[508.423,805.847],[424.482,681.416],[424.482,780.829]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[509.667,826.083],[509.667,935.76],[425.63,799.173],[425.63,898.561]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[445.539,327.291],[445.539,232.875],[441.696,332.219],[441.696,239.998]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[450.047,323.658],[450.047,227.624],[445.539,327.291],[445.539,232.875]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[461.433,318.184],[461.433,219.713],[450.047,323.658],[450.047,227.624]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[475.079,333.753],[475.079,242.216],[457.883,337.857],[457.883,248.147]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[491.831,312.884],[491.831,212.051],[462.894,317.803],[462.894,219.161]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[514.82,309.633],[514.82,207.351],[491.831,312.884],[491.831,212.051]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,429.349],[583.835,317.931],[508.423,431.036],[508.423,321.327]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,555.723],[583.835,444.305],[508.423,555.47],[508.423,445.762]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,574.31],[583.835,685.728],[508.423,573.772],[508.423,683.48]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,698.583],[583.835,810.001],[508.423,696.138],[508.423,805.847]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[585.507,830.514],[585.507,941.886],[509.667,826.083],[509.667,935.76]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[533.053,456.736],[533.053,373.082],[510.957,458.719],[510.957,377.076]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[533.053,565.574],[533.053,649.228],[510.957,564.941],[510.957,646.584]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[533.053,658.88],[533.053,742.534],[510.957,656.004],[510.957,737.647]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[533.662,758.031],[533.662,841.687],[511.642,752.793],[511.642,834.446]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[550.106,305.104],[550.106,200.806],[514.82,309.633],[514.82,207.351]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[550.106,305.104],[550.106,200.806],[586.916,307.065],[586.917,203.64]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,429.349],[583.835,317.931],[650.352,431.025],[650.352,321.306]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,555.723],[583.835,444.305],[650.352,555.472],[650.352,445.753]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,574.31],[583.835,685.728],[650.352,573.775],[650.352,683.494]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[583.835,698.583],[583.835,810.001],[650.352,696.153],[650.352,805.872]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[585.507,830.514],[585.507,941.886],[648.856,826.283],[648.856,936.037]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[609.845,301.594],[609.845,195.732],[586.917,307.065],[586.917,203.64]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[692.308,299.219],[692.308,192.299],[609.844,301.594],[609.844,195.732]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[614.476,747.841],[614.476,827.6],[609.395,746.781],[609.395,826.136]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[669.371,831.972],[669.371,943.902],[648.856,826.283],[648.856,936.037]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,428.959],[670.138,317.146],[650.352,431.025],[650.352,321.306]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,555.781],[670.138,443.968],[650.352,555.472],[650.352,445.753]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,574.434],[670.138,686.248],[650.352,573.775],[650.352,683.494]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,699.149],[670.138,810.962],[650.352,696.153],[650.352,805.872]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[669.37,831.972],[669.37,943.902],[812.324,822.187],[812.324,930.375]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,428.959],[670.138,317.146],[803.989,432.412],[803.989,324.099]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,555.781],[670.138,443.968],[803.989,555.264],[803.989,446.951]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,574.434],[670.138,686.248],[803.989,573.333],[803.989,681.646]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[670.138,699.149],[670.138,810.962],[803.989,694.143],[803.989,802.456]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[792.13,299.523],[692.308,299.219],[792.13,192.738],[692.308,192.299]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[792.13,299.523],[792.13,192.738],[932.798,302.206],[932.798,196.617]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,428.892],[843.194,317.011],[803.989,432.412],[803.989,324.099]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,555.791],[843.194,443.91],[803.989,555.264],[803.989,446.951]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,574.456],[843.194,686.337],[803.989,573.333],[803.989,681.646]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,699.246],[843.194,811.127],[803.989,694.143],[803.989,802.456]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[842.116,831.653],[842.116,943.461],[803.13,822.372],[803.13,930.63]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[842.116,831.653],[842.116,943.461],[996.256,827.346],[996.256,937.507]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,428.892],[843.194,317.011],[988.974,430.409],[988.974,320.066]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,555.791],[843.194,443.91],[988.974,555.564],[988.974,445.221]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,574.456],[843.194,686.337],[988.974,573.972],[988.974,684.315]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[843.194,699.246],[843.194,811.127],[988.974,697.046],[988.974,807.39]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[936.867,302.706],[936.867,197.337],[1038.79,306.33],[1038.79,202.576]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[990.717,435.158],[990.717,325.979],[1349.76,444.608],[1349.76,345.341]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[990.717,558.993],[990.717,449.814],[1349.76,557.201],[1349.76,457.933]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[990.717,577.206],[990.717,686.386],[1349.76,573.761],[1349.76,673.029]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[990.717,698.983],[990.717,808.162],[1349.76,684.482],[1349.76,783.75]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[990.717,824.78],[990.717,933.959],[1349.76,798.859],[1349.76,898.126]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1038.79,306.33],[1068.77,307.329],[1038.79,202.576],[1068.77,204.022]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1068.77,307.329],[1068.77,204.022],[1199.39,315.143],[1199.39,215.316]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1199.39,315.143],[1199.39,215.316],[1290.48,323.346],[1290.48,227.173]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1290.48,323.346],[1290.48,227.173],[1356.77,332.122],[1356.77,239.858]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1356.77,332.122],[1356.77,239.858],[1387.96,338.486],[1387.96,249.058]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1357.36,801.005],[1357.36,901.093],[1431.49,789.658],[1431.49,885.407]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1359.55,348.231],[1359.55,263.143],[1384.09,349.538],[1384.09,265.033]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1362.07,440.672],[1362.07,340.734],[1431.58,444.72],[1431.58,348.885]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1362.07,554.026],[1362.07,454.087],[1431.58,553.419],[1431.58,457.584]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1362.07,570.698],[1362.07,670.637],[1431.58,569.407],[1431.58,665.242]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1362.07,682.168],[1362.07,782.106],[1431.58,676.299],[1431.58,772.135]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1377.96,783.469],[1377.96,876.852],[1478.01,776.62],[1478.01,867.384]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1381.69,447.314],[1381.69,354.109],[1475.19,449.726],[1475.19,358.966]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1381.69,568.579],[1381.69,661.784],[1475.19,567.81],[1475.19,658.57]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1381.69,672.538],[1381.69,765.743],[1475.19,669.042],[1475.19,759.802]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1387.96,338.486],[1387.96,249.058],[1393.26,344.543],[1393.26,257.813]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1381.69,553.03],[1381.69,459.825],[1475.19,552.669],[1475.19,461.909]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1446.78,451.092],[1446.78,361.717],[1489.72,452.174],[1489.72,363.895]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1446.78,567.374],[1446.78,656.749],[1489.72,567.029],[1489.72,655.308]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1446.78,667.061],[1446.78,756.437],[1489.72,665.493],[1489.72,753.772]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1448.52,772.865],[1448.52,862.193],[1489.4,770.134],[1489.4,858.419]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:32,
                    verts:[[1446.78,552.464],[1446.78,463.089],[1489.72,552.302],[1489.72,464.024]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[452.21,440.135],[452.21,339.65],[359.184,448.28],[359.184,356.054]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[452.21,554.107],[452.21,453.622],[359.184,552.886],[359.184,460.66]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[452.21,570.87],[452.21,671.354],[359.184,568.271],[359.184,660.497]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[452.21,682.947],[452.21,783.431],[359.184,671.138],[359.184,763.364]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[453.72,801.822],[453.72,902.222],[360.641,780.26],[360.641,872.415]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[432.455,769.606],[432.455,857.689],[416.316,766.263],[416.316,853.068]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[433.281,452.356],[433.281,364.262],[417.699,453.572],[417.699,366.711]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[433.281,566.971],[433.281,655.065],[417.699,566.583],[417.699,653.444]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[433.281,665.229],[433.281,753.324],[417.699,663.466],[417.699,750.327]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[461.915,324.926],[461.915,229.458],[452.478,329.814],[452.478,236.523]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[564.237,430.325],[564.237,319.896],[452.793,440.084],[452.793,339.548]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[564.237,555.577],[564.237,445.148],[452.793,554.114],[452.793,453.578]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[564.237,573.999],[564.237,684.427],[452.793,570.886],[452.793,671.422]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[564.237,697.168],[564.237,807.597],[452.793,683.021],[452.793,783.557]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[565.426,827.953],[565.426,938.346],[453.909,802.097],[453.909,902.603]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[470.586,321.34],[470.586,224.273],[461.915,324.926],[461.915,229.458]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[485.024,331.618],[485.024,239.13],[462.819,335.576],[462.819,244.852]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[488.341,315.982],[488.341,216.528],[470.586,321.34],[470.586,224.273]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[525.31,310.973],[525.31,209.288],[490.261,315.615],[490.261,215.998]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[524.723,455.977],[524.723,371.553],[497.107,457.886],[497.107,375.398]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[524.723,565.816],[524.723,650.24],[497.107,565.207],[497.107,647.695]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[524.723,659.98],[524.723,744.404],[497.107,657.212],[497.107,739.7]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[525.35,760.038],[525.35,844.461],[497.833,754.996],[497.833,837.492]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[552.358,307.947],[552.358,204.915],[525.31,310.973],[525.31,209.289]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[593.251,303.774],[593.251,198.884],[552.358,307.947],[552.358,204.915]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,428.977],[644.973,317.182],[564.237,430.325],[564.237,319.896]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,555.779],[644.973,443.983],[564.237,555.576],[564.237,445.148]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,574.429],[644.973,686.224],[564.237,573.999],[564.237,684.427]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,699.123],[644.973,810.918],[564.237,697.168],[564.237,807.597]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[646.552,831.484],[646.552,943.227],[565.426,827.953],[565.426,938.346]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[598.066,749.204],[598.066,829.485],[591.899,748.191],[591.899,828.085]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[593.251,303.774],[593.251,198.884],[628.443,306.052],[628.443,202.176]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[657.635,300.848],[657.635,194.654],[628.443,306.052],[628.443,202.176]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,428.977],[644.973,317.182],[707.937,430.913],[707.937,321.08]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,555.779],[644.973,443.983],[707.937,555.488],[707.937,445.656]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,574.429],[644.973,686.224],[707.937,573.811],[707.937,683.644]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[644.973,699.123],[644.973,810.918],[707.937,696.316],[707.937,806.149]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[646.552,831.484],[646.552,943.227],[706.517,826.596],[706.517,936.469]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[743.298,299.268],[743.298,192.37],[657.634,300.848],[657.634,194.654]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.457,831.972],[732.457,943.902],[706.517,826.596],[706.517,936.469]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,428.961],[732.945,317.148],[707.937,430.913],[707.937,321.08]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,555.781],[732.945,443.969],[707.937,555.488],[707.937,445.656]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,574.434],[732.945,686.246],[707.937,573.811],[707.937,683.644]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,699.147],[732.945,810.959],[707.937,696.316],[707.937,806.149]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.456,831.972],[732.456,943.902],[866.304,820.775],[866.304,928.423]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,428.961],[732.945,317.148],[858.313,432.913],[858.313,325.108]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,555.781],[732.945,443.969],[858.313,555.189],[858.313,447.383]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,574.434],[732.945,686.246],[858.313,573.173],[858.313,680.978]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[732.945,699.147],[732.945,810.959],[858.313,693.417],[858.313,801.222]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[743.298,299.268],[842.82,300.488],[743.298,192.37],[842.82,194.134]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[842.82,300.488],[842.82,194.134],[979.391,304.394],[979.391,199.78]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[904.58,829.719],[904.58,940.787],[857.327,821.056],[857.327,928.811]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,429.628],[905.825,318.492],[858.313,432.913],[858.313,325.108]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,555.681],[905.825,444.546],[858.313,555.189],[858.313,447.383]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,574.221],[905.825,685.356],[858.313,573.173],[858.313,680.978]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,698.179],[905.825,809.315],[858.313,693.417],[858.313,801.222]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[904.58,829.719],[904.58,940.787],[1052.62,823.82],[1052.62,932.632]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,429.628],[905.825,318.492],[1045.91,431.714],[1045.91,322.694]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,555.681],[905.825,444.546],[1045.91,555.368],[1045.91,446.348]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,574.221],[905.825,685.356],[1045.91,573.555],[1045.91,682.576]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[905.825,698.179],[905.825,809.315],[1045.91,695.154],[1045.91,804.175]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[982.877,304.92],[982.877,200.537],[1079.15,309.357],[1079.15,206.951]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1044.87,436.397],[1044.87,328.517],[1369.58,446.878],[1369.58,349.991]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1044.87,558.758],[1044.87,450.878],[1369.58,556.77],[1369.58,459.883]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1044.87,576.755],[1044.87,684.635],[1369.58,572.933],[1369.58,669.82]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1044.87,697.082],[1044.87,804.962],[1369.58,680.999],[1369.58,777.886]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1044.87,821.382],[1044.87,929.262],[1369.58,792.632],[1369.58,889.519]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1079.15,309.357],[1079.15,206.951],[1107.4,310.59],[1107.4,208.736]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1107.4,310.59],[1107.4,208.736],[1226.21,319.287],[1226.21,221.305]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1226.21,319.287],[1226.21,221.305],[1305.61,327.965],[1305.61,233.849]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1305.61,327.965],[1305.61,233.849],[1360.22,336.955],[1360.22,246.844]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1346.4,352.53],[1346.4,269.357],[1368.58,353.965],[1368.58,271.432]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1360.22,336.955],[1360.22,246.844],[1383.56,343.328],[1383.56,256.056]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1378.73,794.626],[1378.73,892.275],[1439.51,783.014],[1439.51,876.224]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1382.89,443.09],[1382.89,345.602],[1439.79,447.229],[1439.79,353.938]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1382.89,553.664],[1382.89,456.176],[1439.79,553.043],[1439.79,459.752]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1382.89,569.927],[1382.89,667.415],[1439.79,568.606],[1439.79,661.898]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1382.89,678.663],[1382.89,776.151],[1439.79,672.661],[1439.79,765.953]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1383.06,777.544],[1383.06,868.661],[1472.39,770.07],[1472.39,858.33]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1386.22,449.555],[1386.22,358.622],[1469.7,452.187],[1469.7,363.922]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1386.22,567.864],[1386.22,658.798],[1469.7,567.025],[1469.7,655.29]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1386.22,669.289],[1386.22,760.223],[1469.7,665.474],[1469.7,753.74]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1439.55,453.408],[1439.55,366.381],[1477.85,454.586],[1477.85,368.753]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1386.22,552.695],[1386.22,461.761],[1469.7,552.3],[1469.7,464.035]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1439.55,566.635],[1439.55,653.663],[1477.85,566.26],[1477.85,652.093]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1439.55,663.704],[1439.55,750.731],[1477.85,661.996],[1477.85,747.83]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1441.1,766.714],[1441.1,853.691],[1477.56,763.742],[1477.56,849.581]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:33,
                    verts:[[1439.55,552.117],[1439.55,465.09],[1477.85,551.941],[1477.85,466.107]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[485.612,439.228],[485.612,337.825],[369.404,447.011],[369.404,353.497]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[485.612,554.242],[485.612,452.84],[369.404,553.076],[369.404,459.563]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[485.612,571.159],[485.612,672.561],[369.404,568.676],[369.404,662.189]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[485.612,684.261],[485.612,785.664],[369.404,672.979],[369.404,766.492]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[486.951,804.21],[486.951,905.524],[370.733,783.612],[370.733,877.049]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[434.552,772.3],[434.552,861.412],[414.762,769.103],[414.762,856.992]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[435.43,451.343],[435.43,362.221],[416.328,452.506],[416.328,364.564]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[435.43,567.294],[435.43,656.416],[416.328,566.923],[416.328,654.865]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[435.43,666.698],[435.43,755.819],[416.328,665.011],[416.328,752.953]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[483.122,322.893],[483.122,226.519],[468.055,327.686],[468.055,233.446]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[499.39,329.746],[499.39,236.424],[472.287,333.513],[472.287,241.869]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[495.952,319.396],[495.952,221.463],[483.122,322.893],[483.122,226.519]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[624.099,429.954],[624.099,319.149],[486.336,439.18],[486.336,337.728]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[520.029,455.258],[520.029,370.106],[486.991,457.074],[486.991,373.763]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[624.099,555.632],[624.099,444.827],[486.336,554.25],[486.336,452.798]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[520.029,566.045],[520.029,651.198],[486.991,565.466],[486.991,648.777]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[624.099,574.117],[624.099,684.922],[486.336,571.174],[486.336,672.626]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[520.029,661.022],[520.029,746.175],[486.991,658.39],[486.991,741.701]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[624.099,697.706],[624.099,808.511],[486.336,684.331],[486.336,785.783]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[520.67,761.938],[520.67,847.089],[487.754,757.143],[487.754,840.46]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[625.215,828.925],[625.215,939.69],[487.405,804.482],[487.405,905.901]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[519.993,314.22],[519.993,213.982],[495.952,319.396],[495.952,221.463]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[563.165,309.57],[563.165,207.261],[522.357,313.871],[522.357,213.478]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[593.959,306.811],[593.959,203.273],[563.165,309.57],[563.165,207.261]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[584.576,750.546],[584.576,831.34],[577.352,749.588],[577.352,830.015]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[639.935,303.049],[639.935,197.835],[593.959,306.811],[593.959,203.273]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,428.963],[708.889,317.153],[624.099,429.954],[624.099,319.149]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,555.781],[708.889,443.971],[624.099,555.632],[624.099,444.827]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,574.433],[708.889,686.243],[624.099,574.117],[624.099,684.922]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,699.144],[708.889,810.953],[624.099,697.706],[624.099,808.511]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[710.35,831.506],[710.35,943.258],[625.215,828.925],[625.215,939.69]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[639.936,303.049],[639.936,197.835],[673.012,305.614],[673.012,201.543]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.051,300.745],[708.051,194.504],[673.013,305.615],[673.013,201.543]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[795.649,299.968],[795.65,193.382],[708.051,300.745],[708.051,194.504]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,428.963],[708.889,317.153],[767.337,431.128],[767.337,321.514]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,555.781],[708.889,443.971],[767.337,555.456],[767.337,445.842]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,574.433],[708.889,686.243],[767.337,573.742],[767.337,683.357]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[708.889,699.144],[708.889,810.953],[767.337,696.004],[767.337,805.618]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[710.35,831.506],[710.35,943.258],[766.013,826.038],[766.013,935.699]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[796.908,831.033],[796.908,942.603],[766.013,826.038],[766.013,935.699]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,429.315],[797.113,317.862],[767.337,431.128],[767.337,321.514]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,555.728],[797.113,444.275],[767.337,555.456],[767.337,445.842]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,574.321],[797.113,685.774],[767.337,573.742],[767.337,683.357]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,698.633],[797.113,810.086],[767.337,696.004],[767.337,805.618]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[795.649,299.968],[795.65,193.382],[893.445,302.063],[893.445,196.409]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,429.315],[797.113,317.862],[912.253,433.697],[912.253,326.687]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,555.728],[797.113,444.275],[912.253,555.071],[912.253,448.061]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,574.321],[797.113,685.774],[912.253,572.923],[912.253,679.933]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[797.113,698.633],[797.113,810.086],[912.253,692.28],[912.253,799.29]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[796.908,831.033],[796.908,942.603],[919.793,818.62],[919.793,925.444]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[893.445,302.063],[893.445,196.409],[1024.14,307.086],[1024.14,203.67]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[965.719,826.942],[965.719,936.948],[911.158,818.989],[911.158,925.954]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,430.682],[967.106,320.615],[912.253,433.697],[912.253,326.687]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,555.523],[967.106,445.456],[912.253,555.071],[912.253,448.061]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,573.885],[967.106,683.952],[912.253,572.923],[912.253,679.933]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,696.651],[967.106,806.718],[912.253,692.28],[912.253,799.29]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[965.719,826.942],[965.719,936.948],[1105.67,819.622],[1105.67,926.829]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,430.682],[967.106,320.615],[1099.6,433.277],[1099.6,325.841]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,555.523],[967.106,445.456],[1099.6,555.134],[1099.6,447.698]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,573.885],[967.106,683.952],[1099.6,573.057],[1099.6,680.493]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[967.106,696.651],[967.106,806.718],[1099.6,692.889],[1099.6,800.325]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1027.02,307.628],[1027.02,204.451],[1116.62,312.772],[1116.62,211.887]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1095.92,437.872],[1095.92,331.538],[1384.33,449.163],[1384.33,354.673]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1095.92,558.478],[1095.92,452.145],[1384.33,556.337],[1384.33,461.847]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1095.92,576.217],[1095.92,682.551],[1384.33,572.1],[1384.33,666.591]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1095.92,817.337],[1095.92,923.67],[1384.33,786.365],[1384.33,880.856]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1095.92,694.819],[1095.92,801.153],[1384.33,677.493],[1384.33,771.983]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1116.62,312.772],[1116.62,211.887],[1142.87,314.209],[1142.87,213.966]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1142.87,314.209],[1142.87,213.966],[1249.1,323.611],[1249.1,227.557]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1249.1,323.611],[1249.1,227.557],[1316.72,332.621],[1316.72,240.58]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1316.72,332.621],[1316.72,240.58],[1359.97,341.706],[1359.97,253.712]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1330.9,356.648],[1330.9,275.309],[1350.72,358.185],[1350.72,277.531]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1359.97,341.706],[1359.97,253.712],[1375.86,348.021],[1375.86,262.839]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1384.11,771.718],[1384.11,860.608],[1462.79,763.77],[1462.79,849.621]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1386.72,451.757],[1386.72,363.055],[1460.25,454.555],[1460.25,368.69]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1386.72,552.365],[1386.72,463.663],[1460.25,551.945],[1460.25,466.081]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1386.72,567.162],[1386.72,655.864],[1460.25,566.27],[1460.25,652.134]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1386.72,666.099],[1386.72,754.8],[1460.25,662.041],[1460.25,747.906]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1394.8,788.199],[1394.8,883.391],[1442.69,776.489],[1442.69,867.203]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1398.4,445.522],[1398.4,350.5],[1443.15,449.695],[1443.15,358.903]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1398.4,553.299],[1398.4,458.277],[1443.15,552.674],[1443.15,461.882]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1398.4,569.151],[1398.4,664.173],[1443.15,567.82],[1443.15,658.612]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1398.4,675.136],[1398.4,770.158],[1443.15,669.087],[1443.15,759.879]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1428.76,455.636],[1428.76,370.866],[1462.52,456.886],[1462.52,373.385]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1428.76,660.475],[1428.76,745.244],[1462.52,658.661],[1462.52,742.163]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1430.12,760.801],[1430.12,845.517],[1462.26,757.645],[1462.26,841.153]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1428.76,565.925],[1428.76,650.694],[1462.52,565.526],[1462.52,649.027]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:34,
                    verts:[[1428.76,551.783],[1428.76,467.014],[1462.52,551.596],[1462.52,468.095]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[523.583,438.518],[523.583,336.395],[384.997,445.84],[384.997,351.139]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[523.583,554.349],[523.583,452.226],[384.997,553.251],[384.997,458.551]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[523.583,571.385],[523.583,673.508],[384.997,569.05],[384.997,663.75]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[523.583,685.291],[523.583,787.414],[384.997,674.676],[384.997,769.377]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[524.731,806.082],[524.731,908.112],[386.179,786.704],[386.179,881.324]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[441.114,774.825],[441.114,864.903],[417.756,771.809],[417.756,860.733]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[442.039,450.393],[442.039,360.309],[419.496,451.491],[419.496,362.519]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[442.039,567.597],[442.039,657.681],[419.496,567.247],[419.496,656.218]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[442.039,668.075],[442.039,758.159],[419.496,666.484],[419.496,755.455]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[518.883,454.573],[518.883,368.727],[480.579,456.279],[480.579,372.161]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[518.883,566.264],[518.883,652.11],[480.579,565.72],[480.579,649.837]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[518.883,662.015],[518.883,747.861],[480.579,659.542],[480.579,743.66]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[519.532,763.748],[519.532,849.59],[481.375,759.245],[481.375,843.366]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[517.842,328.122],[517.842,234.077],[486.027,331.656],[486.027,239.185]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[508.719,321.178],[508.719,224.04],[488.08,325.821],[488.08,230.751]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[525.629,317.81],[525.629,219.171],[508.719,321.178],[508.719,224.04]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[686.754,429.897],[686.754,319.034],[524.442,438.472],[524.442,336.303]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[686.754,555.641],[686.754,444.778],[524.442,554.356],[524.442,452.186]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[686.754,574.135],[686.754,684.998],[524.442,571.4],[524.442,673.569]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[686.754,697.789],[686.754,808.652],[524.442,685.357],[524.442,787.526]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[555.755,312.877],[555.755,212.041],[525.629,317.81],[525.629,219.171]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[687.781,829.066],[687.781,939.885],[525.449,806.348],[525.449,908.479]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[604.639,308.643],[604.639,205.921],[558.538,312.552],[558.538,211.571]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[573.999,751.883],[573.999,833.188],[565.755,750.987],[565.755,831.949]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[638.792,306.184],[638.792,202.367],[604.639,308.643],[604.639,205.921]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[689.23,302.877],[689.23,197.587],[638.792,306.184],[638.792,202.367]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,429.271],[774.265,317.773],[686.754,429.897],[686.754,319.034]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,555.735],[774.265,444.237],[686.754,555.641],[686.754,444.778]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,574.335],[774.265,685.833],[686.754,574.135],[686.754,684.998]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,698.697],[774.265,810.195],[686.754,697.789],[686.754,808.652]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[775.587,830.677],[775.587,942.111],[687.781,829.066],[687.781,939.885]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[689.23,302.877],[689.23,197.587],[719.755,305.696],[719.755,201.662]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[760.11,301.214],[760.11,195.183],[719.755,305.696],[719.756,201.662]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[848.393,301.231],[760.11,301.214],[848.393,195.207],[760.11,195.183]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,429.271],[774.265,317.773],[827.39,431.632],[827.39,322.527]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,555.735],[774.265,444.237],[827.39,555.381],[827.39,446.277]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,574.335],[774.265,685.833],[827.39,573.582],[827.39,682.686]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[774.265,698.697],[774.265,810.195],[827.39,695.274],[827.39,804.379]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[775.587,830.677],[775.587,942.111],[826.181,824.716],[826.181,933.871]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.46,829.274],[861.46,940.172],[826.181,824.716],[826.181,933.871]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,429.976],[861.385,319.194],[827.39,431.632],[827.39,322.527]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,555.629],[861.385,444.847],[827.39,555.381],[827.39,446.277]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,574.11],[861.385,684.892],[827.39,573.582],[827.39,682.686]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,697.674],[861.385,808.456],[827.39,695.274],[827.39,804.379]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[848.393,301.231],[848.393,195.207],[943.163,304.14],[943.163,199.412]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,429.976],[861.385,319.194],[964.917,434.715],[964.917,328.737]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,555.629],[861.385,444.847],[964.917,554.919],[964.917,448.94]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,574.11],[861.385,684.892],[964.917,572.598],[964.917,678.577]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.385,697.674],[861.385,808.456],[964.917,690.804],[964.917,796.782]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[861.459,829.274],[861.459,940.172],[971.916,815.856],[971.916,921.623]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[943.163,304.14],[943.163,199.412],[1066.48,310.159],[1066.48,208.112]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1024.54,823.484],[1024.54,932.168],[963.731,816.305],[963.731,922.244]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,431.993],[1026.04,323.256],[964.917,434.715],[964.917,328.737]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,555.326],[1026.04,446.589],[964.917,554.919],[964.917,448.94]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,573.466],[1026.04,682.204],[964.917,572.598],[964.917,678.577]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,694.75],[1026.04,803.487],[964.917,690.804],[964.917,796.782]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1024.54,823.484],[1024.54,932.168],[1154.8,814.932],[1154.8,920.346]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,431.993],[1026.04,323.256],[1149.43,435.03],[1149.43,329.37]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,555.326],[1026.04,446.589],[1149.43,554.872],[1149.43,449.212]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,573.466],[1026.04,682.204],[1149.43,572.498],[1149.43,678.157]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1026.04,694.75],[1026.04,803.487],[1149.43,690.348],[1149.43,796.007]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1068.75,310.711],[1068.75,208.907],[1150.89,316.453],[1150.89,217.208]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1143.3,439.52],[1143.3,334.914],[1394.45,451.415],[1394.45,359.287]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1143.3,558.166],[1143.3,453.561],[1394.45,555.91],[1394.45,463.782]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1143.3,575.616],[1143.3,680.221],[1394.45,571.279],[1394.45,663.407]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1143.3,692.291],[1143.3,796.896],[1394.45,674.037],[1394.45,766.165]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1143.3,812.817],[1143.3,917.422],[1394.45,780.187],[1394.45,872.316]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1150.89,316.453],[1150.89,217.208],[1174.93,318.06],[1174.93,219.533]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1174.93,318.06],[1174.93,219.533],[1268.17,328.004],[1268.17,233.907]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1268.17,328.004],[1268.17,233.907],[1324.14,337.219],[1324.14,247.226]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1313.51,360.537],[1313.51,280.93],[1331.01,362.153],[1331.01,283.266]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1324.14,337.219],[1324.14,247.226],[1356.5,346.299],[1356.5,260.35]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1356.5,346.299],[1356.5,260.35],[1365.37,352.502],[1365.37,269.316]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1381.63,766.085],[1381.63,852.821],[1449.89,757.794],[1449.89,841.359]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1383.7,453.883],[1383.7,367.336],[1447.49,456.802],[1447.49,373.216]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1383.7,566.484],[1383.7,653.031],[1447.49,565.553],[1447.49,649.139]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1383.7,663.016],[1383.7,749.563],[1447.49,658.783],[1447.49,742.37]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1383.7,552.046],[1383.7,465.5],[1447.49,551.609],[1447.49,468.022]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1406.03,781.859],[1406.03,874.626],[1441.64,770.187],[1441.64,858.492]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1409.08,447.919],[1409.08,355.327],[1442.24,452.076],[1442.24,363.698]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1409.08,552.94],[1409.08,460.348],[1442.24,552.317],[1442.24,463.939]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1409.08,568.386],[1409.08,660.978],[1442.24,567.06],[1442.24,655.438]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1409.08,671.661],[1409.08,764.253],[1442.24,665.635],[1442.24,754.013]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1415.03,457.748],[1415.03,375.12],[1444.36,459.052],[1444.36,377.746]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1415.03,565.251],[1415.03,647.879],[1444.36,564.835],[1444.36,646.141]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1415.03,657.412],[1415.03,740.04],[1444.36,655.522],[1444.36,736.828]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:35,
                    verts:[[1416.2,755.195],[1416.2,837.767],[1444.13,751.904],[1444.13,833.218]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[565.405,437.988],[565.405,335.328],[405.628,444.763],[405.628,348.971]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[565.405,554.428],[565.405,451.768],[405.628,553.413],[405.628,457.621]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[565.405,571.554],[565.405,674.215],[405.628,569.393],[405.628,665.185]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[565.405,686.059],[565.405,788.72],[405.628,676.237],[405.628,772.029]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[566.346,807.478],[566.346,910.041],[406.647,789.548],[406.647,885.256]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[451.919,777.201],[451.919,868.187],[425.12,774.397],[425.12,864.311]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[452.882,449.5],[452.882,358.511],[427.023,450.52],[427.023,360.565]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[452.882,567.882],[452.882,658.871],[427.023,567.557],[427.023,657.512]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[452.882,669.369],[452.882,760.358],[427.023,667.891],[427.023,757.846]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[521.14,453.915],[521.14,367.401],[477.78,455.494],[477.78,370.581]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[521.14,566.474],[521.14,652.987],[477.78,565.97],[477.78,650.883]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[521.14,662.969],[521.14,749.483],[477.78,660.68],[477.78,745.594]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[521.793,765.488],[521.793,851.995],[478.602,761.32],[478.602,846.234]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[539.995,326.722],[539.995,232.053],[503.721,329.985],[503.721,236.769]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[538.207,319.754],[538.207,221.982],[512.141,324.199],[512.141,228.407]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[559.053,316.551],[559.053,217.352],[538.207,319.754],[538.208,221.982]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[566.274,753.236],[566.274,835.059],[557.055,752.411],[557.055,833.918]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[594.955,311.916],[594.955,210.651],[559.053,316.551],[559.053,217.352]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[751.007,430.118],[751.007,319.479],[566.39,437.946],[566.39,335.243]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[751.007,555.608],[751.007,444.969],[566.39,554.434],[566.39,451.732]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[751.007,574.065],[751.007,684.704],[566.39,571.568],[566.39,674.27]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[751.007,697.469],[751.007,808.108],[566.39,686.12],[566.39,788.823]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[751.931,828.471],[751.931,939.063],[567.321,807.734],[567.321,910.395]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[648.964,308.144],[648.964,205.2],[598.125,311.617],[598.125,210.22]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[686.033,306.011],[686.033,202.116],[648.964,308.144],[648.964,205.2]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[740.244,303.19],[740.244,198.039],[686.033,306.011],[686.033,202.116]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[740.244,303.19],[740.244,198.039],[767.85,306.226],[767.85,202.427]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,429.855],[839.907,318.949],[751.007,430.118],[751.007,319.479]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,555.647],[839.907,444.742],[751.007,555.608],[751.007,444.969]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,574.149],[839.907,685.054],[751.007,574.065],[751.007,684.704]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,697.85],[839.907,808.756],[751.007,697.469],[751.007,808.108]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[841.074,829.117],[751.931,828.471],[841.074,939.955],[751.931,939.063]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[812.908,302.173],[812.908,196.569],[767.851,306.226],[767.851,202.427]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[812.908,302.173],[900.687,302.955],[812.908,196.569],[900.687,197.7]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,429.855],[839.907,318.949],[887.076,432.376],[887.076,324.025]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,555.647],[839.907,444.742],[887.076,555.269],[887.076,446.919]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,574.149],[839.907,685.054],[887.076,573.345],[887.076,681.695]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[839.907,697.85],[839.907,808.756],[887.076,694.196],[887.076,802.546]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[841.074,829.117],[841.074,939.955],[885.995,822.753],[885.995,931.157]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[925.026,826.838],[925.026,936.804],[885.995,822.753],[885.995,931.157]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,430.892],[924.682,321.039],[887.076,432.376],[887.076,324.025]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,555.492],[924.682,445.638],[887.076,555.269],[887.076,446.919]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,573.818],[924.682,683.671],[887.076,573.345],[887.076,681.695]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,696.346],[924.682,806.2],[887.076,694.196],[887.076,802.546]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[900.687,302.955],[900.687,197.7],[991.297,306.608],[991.297,202.98]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,430.892],[924.682,321.039],[1015.6,435.913],[1015.6,331.148]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,555.492],[924.682,445.638],[1015.6,554.739],[1015.6,449.975]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,573.818],[924.682,683.671],[1015.6,572.216],[1015.6,676.98]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[924.682,696.346],[924.682,806.2],[1015.6,689.068],[1015.6,793.832]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[925.026,826.838],[925.026,936.804],[1021.99,812.626],[1021.99,917.158]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[991.297,306.608],[991.297,202.98],[1106.03,313.495],[1106.03,212.934]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1080.3,819.512],[1080.3,926.678],[1014.34,813.145],[1014.34,917.875]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,433.499],[1081.89,326.288],[1015.6,435.913],[1015.6,331.148]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,555.101],[1081.89,447.89],[1015.6,554.739],[1015.6,449.975]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,572.986],[1081.89,680.197],[1015.6,572.216],[1015.6,676.98]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,692.567],[1081.89,799.778],[1015.6,689.068],[1015.6,793.832]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1080.3,819.512],[1080.3,926.678],[1199.66,809.922],[1199.66,913.42]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,433.499],[1081.89,326.288],[1195.01,436.907],[1195.01,333.152]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,555.101],[1081.89,447.89],[1195.01,554.59],[1195.01,450.834]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,572.986],[1081.89,680.197],[1195.01,571.899],[1195.01,675.655]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1081.89,692.567],[1081.89,799.778],[1195.01,687.626],[1195.01,791.381]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1107.69,314.049],[1107.69,213.733],[1181.82,320.283],[1181.82,222.744]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1181.82,320.283],[1181.82,222.744],[1203.51,322.03],[1203.51,225.271]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1186.67,441.28],[1186.67,338.522],[1400.43,453.596],[1400.43,363.756]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1186.67,557.832],[1186.67,455.074],[1400.43,555.496],[1400.43,465.656]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1186.67,574.974],[1186.67,677.733],[1400.43,570.484],[1400.43,660.324]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1186.67,807.987],[1186.67,910.745],[1400.43,774.205],[1400.43,864.045]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1186.67,689.589],[1186.67,792.347],[1400.43,670.69],[1400.43,760.531]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1203.51,322.03],[1203.51,225.271],[1283.63,332.367],[1283.63,240.212]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1283.63,332.367],[1283.63,240.212],[1328.26,341.678],[1328.26,253.671]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1294.64,364.162],[1294.64,286.17],[1309.87,365.837],[1309.87,288.592]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1328.26,341.678],[1328.26,253.671],[1350.25,350.672],[1350.25,266.671]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1350.25,350.672],[1350.25,266.671],[1352.56,356.723],[1352.56,275.417]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1376.11,760.72],[1376.11,845.404],[1434.27,752.194],[1434.27,833.619]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1377.67,455.906],[1377.67,371.41],[1432.04,458.908],[1432.04,377.456]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1377.67,565.839],[1377.67,650.334],[1432.04,564.881],[1432.04,646.333]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1377.67,660.083],[1377.67,744.578],[1432.04,655.731],[1432.04,737.182]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1398.89,459.726],[1398.89,379.104],[1423.97,461.067],[1423.97,381.803]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1398.89,564.62],[1398.89,645.242],[1423.97,564.192],[1423.97,643.456]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1377.67,551.743],[1377.67,467.248],[1432.04,551.293],[1432.04,469.841]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1398.89,654.544],[1398.89,735.167],[1423.97,652.601],[1423.97,731.864]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1399.89,749.947],[1399.89,830.511],[1423.77,746.564],[1423.77,825.835]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1415.43,450.24],[1415.43,360],[1437.69,454.343],[1437.69,368.263]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1415.43,552.592],[1415.43,462.353],[1437.69,551.977],[1437.69,465.897]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1415.43,567.646],[1415.43,657.886],[1437.69,566.337],[1437.69,652.417]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:36,
                    verts:[[1415.43,668.297],[1415.43,758.537],[1437.69,662.349],[1437.69,748.429]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[610.358,437.618],[610.358,334.582],[430.906,443.771],[430.906,346.973]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[610.358,554.484],[610.358,451.448],[430.906,553.561],[430.906,456.764]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[610.358,571.672],[610.358,674.708],[430.906,569.71],[430.906,666.507]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[610.358,686.596],[610.358,789.631],[430.906,677.675],[430.906,774.473]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[611.079,808.452],[611.079,911.389],[431.747,792.169],[431.747,888.879]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[466.696,779.452],[466.696,871.299],[436.624,776.891],[436.624,867.759]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[467.69,448.654],[467.69,356.807],[438.675,449.586],[438.675,358.684]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[467.69,568.152],[467.69,659.999],[438.675,567.855],[438.675,658.757]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[467.69,670.596],[467.69,762.442],[438.675,669.245],[438.675,760.147]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[526.621,453.272],[526.621,366.106],[478.458,454.71],[478.458,369.002]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[526.621,566.679],[526.621,653.844],[478.458,566.22],[478.458,651.928]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[526.621,663.901],[526.621,751.067],[478.458,661.817],[478.458,747.525]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[527.272,767.187],[527.272,854.344],[479.301,763.392],[479.301,849.098]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[565.436,325.51],[565.436,230.302],[525.012,328.47],[525.012,234.58]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[571.067,318.584],[571.067,220.29],[539.797,322.787],[539.797,226.366]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[561.307,754.634],[561.307,836.991],[551.164,753.885],[551.164,835.955]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[595.644,315.578],[595.644,215.946],[571.067,318.584],[571.067,220.29]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[636.927,311.286],[636.927,209.741],[595.644,315.578],[595.644,215.946]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[815.786,430.574],[815.786,320.398],[611.456,437.58],[611.456,334.506]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[815.786,555.539],[815.786,445.363],[611.456,554.489],[611.456,451.416]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[815.786,573.919],[815.786,684.096],[611.456,571.684],[611.456,674.758]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[815.786,696.808],[815.786,806.984],[611.456,686.65],[611.456,789.724]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[816.595,827.255],[816.595,937.381],[612.301,808.696],[612.301,911.726]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[695.403,308.013],[695.403,205.01],[640.448,311.018],[640.448,209.353]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[734.912,306.222],[734.912,202.422],[695.403,308.013],[695.403,205.01]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[792.167,303.908],[792.167,199.076],[734.912,306.222],[734.912,202.422]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[792.167,303.908],[792.167,199.076],[816.564,307.123],[816.564,203.723]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,430.665],[815.786,430.574],[904.797,320.581],[815.786,320.398]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,555.526],[904.797,445.441],[815.786,555.539],[815.786,445.363]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,573.89],[815.786,573.919],[904.797,683.974],[815.786,684.096]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,696.676],[815.786,696.808],[904.797,806.76],[815.786,806.984]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[865.66,303.528],[865.66,198.527],[816.564,307.123],[816.564,203.723]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[905.796,826.961],[816.595,827.255],[905.796,936.975],[816.595,937.381]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[865.659,303.528],[865.659,198.527],[951.843,305.036],[951.843,200.708]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,430.665],[904.797,320.581],[945.553,433.31],[945.553,325.907]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,555.526],[904.797,445.441],[945.553,555.129],[945.553,447.726]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,573.89],[904.797,683.974],[945.553,573.047],[945.553,680.449]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[904.797,696.676],[904.797,806.76],[945.553,692.841],[945.553,800.244]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[905.796,826.961],[905.796,936.975],[944.611,820.283],[944.611,927.743]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.732,823.872],[986.732,932.704],[944.611,820.283],[944.611,927.743]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,432.007],[986.133,323.283],[945.553,433.31],[945.553,325.907]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,555.325],[986.133,446.601],[945.553,555.129],[945.553,447.726]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,573.462],[986.133,682.186],[945.553,573.047],[945.553,680.449]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,694.73],[986.133,803.454],[945.553,692.841],[945.553,800.244]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[951.843,305.036],[951.843,200.708],[1037.34,309.355],[1037.34,206.951]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,432.007],[986.133,323.283],[1063.78,437.238],[1063.78,333.817]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,555.324],[986.133,446.601],[1063.78,554.541],[1063.78,451.12]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,573.462],[986.133,682.186],[1063.78,571.794],[1063.78,675.215]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.133,694.73],[986.133,803.454],[1063.78,687.147],[1063.78,790.568]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[986.732,823.872],[986.732,932.705],[1069.51,809.068],[1069.51,912.239]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1037.34,309.355],[1037.34,206.951],[1142.57,316.982],[1142.57,217.975]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,435.137],[1134.15,329.586],[1063.78,437.238],[1063.78,333.817]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,554.855],[1134.15,449.305],[1063.78,554.541],[1063.78,451.12]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,572.464],[1134.15,678.014],[1063.78,571.794],[1063.78,675.215]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,690.193],[1134.15,795.743],[1063.78,687.147],[1063.78,790.568]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1132.5,815.189],[1132.5,920.701],[1062.47,809.646],[1062.47,913.039]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1132.5,815.189],[1132.5,920.701],[1240.12,804.747],[1240.12,906.266]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,435.137],[1134.15,329.586],[1236.2,438.851],[1236.2,337.066]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,554.855],[1134.15,449.305],[1236.2,554.299],[1236.2,452.514]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,572.464],[1134.15,678.014],[1236.2,571.279],[1236.2,673.064]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1134.15,690.193],[1134.15,795.743],[1236.2,684.808],[1236.2,786.593]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1143.62,317.534],[1143.62,218.77],[1209.41,324.159],[1209.41,228.347]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1209.41,324.159],[1209.41,228.347],[1228.67,326.018],[1228.67,231.035]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1225.88,443.1],[1225.88,342.249],[1402.75,455.677],[1402.75,368.018]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1225.88,557.487],[1225.88,456.637],[1402.75,555.102],[1402.75,467.443]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1225.88,574.311],[1225.88,675.161],[1402.75,569.725],[1402.75,657.384]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1225.88,802.997],[1225.88,903.848],[1402.75,768.499],[1402.75,856.157]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1228.67,326.018],[1228.67,231.035],[1295.75,336.617],[1295.75,246.355]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1225.88,686.797],[1225.88,787.648],[1402.75,667.498],[1402.75,755.157]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1274.62,367.496],[1274.62,290.99],[1287.66,369.215],[1287.66,293.474]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1295.75,336.617],[1295.75,246.355],[1329.45,345.934],[1329.45,259.823]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1329.45,345.934],[1329.45,259.823],[1341.66,354.779],[1341.66,272.607]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1368.01,755.678],[1368.01,838.434],[1416.48,747.01],[1416.48,826.452]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1369.09,457.806],[1369.09,375.236],[1414.4,460.858],[1414.4,381.384]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1369.09,565.233],[1369.09,647.802],[1414.4,564.259],[1414.4,643.734]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1369.09,657.329],[1369.09,739.898],[1414.4,652.903],[1414.4,732.378]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1380.82,461.557],[1380.82,382.79],[1401.84,462.92],[1401.84,385.536]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1380.82,564.036],[1380.82,642.803],[1401.84,563.601],[1401.84,640.985]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1369.09,551.458],[1369.09,468.889],[1414.4,551.001],[1414.4,471.526]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1417.98,452.452],[1417.98,364.456],[1430.04,456.472],[1430.04,372.551]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1417.98,552.26],[1417.98,464.264],[1430.04,551.658],[1430.04,467.737]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1417.98,566.94],[1417.98,654.937],[1430.04,565.658],[1430.04,649.579]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:37,
                    verts:[[1417.98,665.09],[1417.98,753.086],[1430.04,659.262],[1430.04,743.183]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[485.153,781.613],[485.153,874.286],[452.011,779.32],[452.011,871.117]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[486.168,447.843],[486.168,355.173],[454.196,448.676],[454.196,356.852]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[486.168,568.411],[486.168,661.08],[454.196,568.145],[454.196,659.969]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[486.168,671.772],[486.168,764.442],[454.196,670.563],[454.196,762.388]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[657.757,437.383],[657.757,334.109],[460.414,442.851],[460.414,345.121]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[657.757,554.519],[657.757,451.245],[460.414,553.699],[460.414,455.969]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[657.757,571.747],[657.757,675.021],[460.414,570.003],[460.414,667.733]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[657.757,686.936],[657.757,790.21],[460.414,679.009],[460.414,776.739]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[658.251,809.071],[658.251,912.244],[461.064,794.601],[461.064,892.24]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[535.125,452.632],[535.125,364.817],[482.451,453.916],[482.451,367.403]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[535.125,566.883],[535.125,654.698],[482.451,566.474],[482.451,652.986]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[535.125,664.83],[535.125,752.644],[482.451,662.968],[482.451,749.481]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[535.768,768.879],[535.768,856.684],[483.309,765.49],[483.309,851.999]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[549.538,327.078],[549.538,232.568],[542.819,333.82],[542.819,242.312]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[558.978,756.106],[558.978,839.026],[547.967,755.438],[547.967,838.103]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[593.757,324.449],[593.757,228.767],[549.538,327.078],[549.538,232.568]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[606.791,317.623],[606.791,218.901],[570.606,321.547],[570.606,224.572]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[634.847,314.842],[634.847,214.882],[606.791,317.623],[606.791,218.901]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[681.047,310.932],[681.047,209.229],[634.847,314.842],[634.847,214.882]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,431.22],[880.181,321.698],[658.956,437.35],[658.956,334.042]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,555.442],[880.181,445.921],[658.956,554.524],[658.956,451.217]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,573.713],[880.181,683.235],[658.956,571.758],[658.956,675.065]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,695.871],[880.181,805.393],[658.956,686.984],[658.956,790.292]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.868,825.537],[880.868,935.006],[659.704,809.3],[659.704,912.56]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[743.288,308.181],[743.288,205.254],[684.878,310.695],[684.878,208.887]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[784.742,306.745],[784.742,203.177],[743.288,308.181],[743.288,205.254]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[844.304,304.945],[844.304,200.576],[784.742,306.745],[784.742,203.177]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[844.305,304.945],[844.305,200.576],[865.273,308.303],[865.273,205.43]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[917.722,305.184],[917.722,200.922],[865.274,308.303],[865.274,205.43]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,431.22],[880.181,321.698],[968.12,431.649],[968.12,322.563]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,555.442],[880.181,445.921],[968.12,555.378],[968.12,446.292]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,573.713],[880.181,683.235],[968.12,573.576],[968.12,682.663]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.181,695.871],[968.12,695.249],[880.181,805.393],[968.12,804.335]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[880.868,825.537],[968.944,824.346],[880.868,935.006],[968.944,933.36]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[917.721,305.184],[917.721,200.922],[1001.34,307.371],[1001.34,204.082]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[968.12,431.649],[968.12,322.563],[1002.17,434.385],[1002.17,328.071]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[968.12,555.378],[968.12,446.292],[1002.17,554.968],[1002.17,448.655]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[968.12,573.576],[968.12,682.663],[1002.17,572.704],[1002.17,679.017]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[968.12,695.249],[968.12,804.335],[1002.17,691.283],[1002.17,797.596]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[968.944,824.346],[968.944,933.36],[1001.37,817.439],[1001.37,923.812]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1001.34,307.371],[1001.34,204.082],[1080.94,312.277],[1080.94,211.173]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.92,820.522],[1045.92,928.074],[1001.37,817.439],[1001.37,923.812]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,433.265],[1045.09,325.817],[1002.17,434.385],[1002.17,328.071]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,555.136],[1045.09,447.688],[1002.17,554.968],[1002.17,448.655]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,573.061],[1045.09,680.509],[1002.17,572.704],[1002.17,679.017]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,692.906],[1045.09,800.354],[1002.17,691.283],[1002.17,797.596]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,433.265],[1045.09,325.817],[1109.12,438.641],[1109.12,336.643]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,555.136],[1045.09,447.688],[1109.12,554.33],[1109.12,452.332]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,573.061],[1045.09,680.509],[1109.12,571.346],[1109.12,673.344]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.09,692.906],[1045.09,800.354],[1109.12,685.113],[1109.12,787.111]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1045.92,820.522],[1045.92,928.074],[1114.15,805.311],[1114.15,907.045]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1080.94,312.277],[1080.94,211.173],[1176.01,320.522],[1176.01,223.091]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1180.84,810.662],[1180.84,914.443],[1107.78,805.94],[1107.78,907.915]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,436.852],[1182.53,333.039],[1109.12,438.641],[1109.12,336.643]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,554.598],[1182.53,450.786],[1109.12,554.33],[1109.12,452.332]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,571.917],[1182.53,675.729],[1109.12,571.346],[1109.12,673.344]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,687.707],[1182.53,791.519],[1109.12,685.113],[1109.12,787.111]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1176.48,321.066],[1176.48,223.875],[1233.74,327.994],[1233.74,233.889]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1180.84,810.662],[1180.84,914.443],[1276.2,799.541],[1276.2,899.07]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,436.852],[1182.53,333.039],[1273.01,440.81],[1273.01,341.01]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,554.598],[1182.53,450.786],[1273.01,554.005],[1273.01,454.206]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,571.917],[1182.53,675.729],[1273.01,570.654],[1273.01,670.454]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1182.53,687.707],[1182.53,791.519],[1273.01,681.969],[1273.01,781.768]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1233.74,327.994],[1233.74,233.889],[1250.55,329.938],[1250.55,236.701]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1250.55,329.938],[1250.55,236.701],[1304.83,340.688],[1304.83,252.239]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1253.73,370.522],[1253.73,295.363],[1264.65,372.27],[1264.65,297.89]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1260.95,444.93],[1260.95,345.999],[1401.91,457.634],[1401.91,372.028]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1260.95,557.14],[1260.95,458.209],[1401.91,554.731],[1401.91,469.125]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1260.95,573.644],[1260.95,672.575],[1401.91,569.012],[1401.91,654.617]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1260.95,797.977],[1260.95,896.908],[1401.91,763.129],[1401.91,848.735]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1260.95,683.989],[1260.95,782.92],[1401.91,664.494],[1401.91,750.1]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1304.83,340.688],[1304.83,252.239],[1328.09,349.94],[1328.09,265.613]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1328.09,349.94],[1328.09,265.613],[1331.1,358.586],[1331.1,278.111]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1358.37,459.567],[1358.37,378.784],[1395.03,462.645],[1395.03,384.981]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1358.37,564.671],[1358.37,645.454],[1395.03,563.689],[1395.03,641.353]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1358.37,654.775],[1358.37,735.558],[1395.03,650.313],[1395.03,727.977]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1357.75,751],[1357.75,831.967],[1396.94,742.261],[1396.94,819.888]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1361.23,463.231],[1361.23,386.162],[1378.36,464.607],[1378.36,388.933]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1361.23,563.502],[1361.23,640.571],[1378.36,563.063],[1378.36,638.738]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1417.23,454.534],[1417.23,368.648],[1419.8,458.449],[1419.8,376.532]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1417.23,551.948],[1417.23,466.062],[1419.8,551.362],[1419.8,469.445]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1417.23,566.276],[1417.23,652.162],[1419.8,565.027],[1419.8,646.945]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:38,
                    verts:[[1417.23,662.072],[1417.23,747.958],[1419.8,656.396],[1419.8,738.313]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[506.997,783.72],[506.997,877.2],[471.016,781.72],[471.016,874.434]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[508.024,447.051],[508.024,353.579],[473.32,447.779],[473.32,355.044]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[508.024,568.663],[508.024,662.135],[473.32,568.431],[473.32,661.166]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[508.024,672.92],[508.024,766.392],[473.32,671.865],[473.32,764.6]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[546.45,451.981],[546.45,363.506],[489.589,453.099],[489.589,365.759]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[546.45,567.091],[546.45,655.565],[489.589,566.734],[489.589,654.074]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[546.45,665.773],[546.45,754.248],[489.589,664.152],[489.589,751.492]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[547.082,770.6],[547.082,859.063],[490.455,767.648],[490.455,854.981]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[706.984,437.257],[706.984,333.855],[493.736,441.988],[493.736,343.384]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[706.984,554.538],[706.984,451.136],[493.736,553.829],[493.736,455.224]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[706.984,571.787],[706.984,675.189],[493.736,570.278],[493.736,668.883]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[706.984,687.119],[706.984,790.521],[493.736,680.26],[493.736,778.864]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[707.246,809.404],[707.246,912.704],[494.186,796.883],[494.186,895.395]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[559.161,757.683],[547.342,757.103],[559.161,841.206],[547.342,840.404]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[576.947,325.77],[576.947,230.677],[563.021,332.427],[563.021,240.299]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[624.573,323.494],[624.573,227.387],[576.947,325.77],[576.947,230.677]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[644.905,316.824],[644.906,217.746],[604.148,320.435],[604.148,222.965]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[676.151,314.291],[676.151,214.084],[644.905,316.824],[644.906,217.746]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[726.755,310.792],[726.755,209.028],[676.151,314.291],[676.151,214.084]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,432.01],[943.46,323.289],[708.269,437.228],[708.269,333.798]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,555.324],[943.46,446.603],[708.269,554.542],[708.269,451.112]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,573.461],[943.46,682.182],[708.269,571.797],[708.269,675.227]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,694.726],[943.46,803.447],[708.269,687.161],[708.269,790.591]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[944.02,823.438],[944.02,932.105],[708.914,809.616],[708.914,912.998]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[792.036,308.581],[792.036,205.832],[730.852,310.589],[730.852,208.734]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[834.94,307.503],[834.94,204.273],[792.036,308.581],[792.036,205.832]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[896.086,306.22],[896.086,202.418],[834.94,307.503],[834.94,204.273]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[896.086,306.22],[896.086,202.418],[913.476,309.686],[913.477,207.428]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[968.593,307.052],[968.593,203.621],[913.477,309.686],[913.477,207.429]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,432.01],[943.46,323.289],[1029.26,432.758],[1029.26,324.796]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,555.324],[943.46,446.603],[1029.26,555.212],[1029.26,447.25]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,573.461],[943.46,682.182],[1029.26,573.223],[1029.26,681.185]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[943.46,694.726],[943.46,803.447],[1029.26,693.641],[1029.26,801.604]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[944.02,823.438],[944.02,932.105],[1029.91,821.403],[1029.91,929.291]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[968.593,307.052],[968.593,203.621],[1048.79,309.864],[1048.79,207.686]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1029.26,432.758],[1029.26,324.796],[1056.45,435.553],[1056.45,330.425]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1029.26,555.212],[1029.26,447.25],[1056.45,554.793],[1056.45,449.665]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1029.26,573.223],[1029.26,681.185],[1056.45,572.331],[1056.45,677.459]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1029.26,693.641],[1029.26,801.604],[1056.45,689.589],[1056.45,794.717]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1029.91,821.403],[1029.91,929.291],[1055.8,814.345],[1055.8,919.534]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1048.79,309.864],[1048.79,207.686],[1121.9,315.278],[1121.9,215.512]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,434.617],[1101.1,328.54],[1056.45,435.553],[1056.45,330.425]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,554.933],[1101.1,448.856],[1056.45,554.793],[1056.45,449.665]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,572.63],[1101.1,678.707],[1056.45,572.331],[1056.45,677.459]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,690.946],[1101.1,797.023],[1056.45,689.589],[1056.45,794.717]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1102.15,816.923],[1102.15,923.098],[1055.8,814.345],[1055.8,919.534]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,434.617],[1101.1,328.54],[1151.43,440.079],[1151.43,339.539]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,554.933],[1101.1,448.856],[1151.43,554.115],[1151.43,453.575]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,572.629],[1101.1,678.707],[1151.43,570.887],[1151.43,671.427]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1101.1,690.946],[1101.1,797.023],[1151.43,683.027],[1151.43,783.567]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1102.15,816.923],[1102.15,923.098],[1155.75,801.469],[1155.75,901.735]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1121.9,315.278],[1121.9,215.512],[1206.36,324.03],[1206.36,228.161]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1225.21,806.059],[1225.21,908.08],[1150.07,802.14],[1150.07,902.662]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,438.594],[1226.93,336.549],[1151.43,440.079],[1151.43,339.539]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,554.337],[1226.93,452.292],[1151.43,554.115],[1151.43,453.575]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,571.361],[1226.93,673.406],[1151.43,570.887],[1151.43,671.427]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,685.18],[1226.93,787.226],[1151.43,683.027],[1151.43,783.567]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1206.28,324.562],[1206.28,228.929],[1254.98,331.713],[1254.98,239.266]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1225.21,806.059],[1225.21,908.08],[1308.06,794.416],[1308.06,891.985]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,438.594],[1226.93,336.549],[1305.58,442.74],[1305.58,344.898]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,554.337],[1226.93,452.292],[1305.58,553.716],[1305.58,455.874]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,571.361],[1226.93,673.406],[1305.58,570.038],[1305.58,667.88]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1226.93,685.18],[1226.93,787.226],[1305.58,679.169],[1305.58,777.012]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1232.2,373.227],[1232.2,299.273],[1241.06,374.994],[1241.06,301.827]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1254.98,331.713],[1254.98,239.266],[1269.33,333.721],[1269.33,242.17]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1269.33,333.721],[1269.33,242.17],[1311.18,344.53],[1311.18,257.793]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1292.01,446.731],[1292.01,349.691],[1398.34,459.453],[1398.34,375.756]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1292.01,556.798],[1292.01,459.757],[1398.34,554.386],[1398.34,470.688]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1292.01,572.987],[1292.01,670.028],[1398.34,568.348],[1398.34,652.046]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1292.01,793.035],[1292.01,890.076],[1398.34,758.139],[1398.34,841.836]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1292.01,681.224],[1292.01,778.265],[1398.34,661.702],[1398.34,745.4]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1311.18,344.53],[1311.18,257.793],[1324.52,353.66],[1324.52,270.99]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1340.44,464.745],[1340.44,389.211],[1353.85,466.124],[1353.85,391.988]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1340.44,563.019],[1340.44,638.554],[1353.85,562.579],[1353.85,636.715]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1340.44,647.269],[1340.44,722.803],[1353.85,645.269],[1353.85,719.405]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1340.95,736.637],[1340.95,812.113],[1353.72,733.157],[1353.72,807.302]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1345.88,461.181],[1345.88,382.034],[1374.27,464.263],[1374.27,388.24]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1345.88,564.156],[1345.88,643.303],[1374.27,563.173],[1374.27,639.196]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1345.88,652.435],[1345.88,731.582],[1374.27,647.967],[1374.27,723.99]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:39,
                    verts:[[1345.68,746.711],[1345.68,826.038],[1376.03,737.961],[1376.03,813.943]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[531.953,785.814],[531.953,880.094],[493.392,784.127],[493.392,877.761]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[532.986,446.265],[532.986,351.995],[495.796,446.878],[495.796,353.231]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[532.986,553.188],[532.986,458.918],[495.796,553.096],[495.796,459.448]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[532.986,568.914],[532.986,663.184],[495.796,568.718],[495.796,662.366]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[532.986,674.06],[532.986,768.33],[495.796,673.171],[495.796,766.818]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[560.41,451.305],[560.41,362.146],[499.708,452.248],[499.708,364.044]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[560.41,567.306],[560.41,656.466],[499.708,567.005],[499.708,655.209]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[560.41,666.753],[560.41,755.912],[499.708,665.386],[499.708,753.59]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[530.482,441.167],[530.482,341.729],[500.242,443.942],[500.242,347.318]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[530.482,553.952],[530.482,454.514],[500.242,553.536],[500.242,456.912]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[530.482,570.54],[530.482,669.978],[500.242,569.655],[500.242,666.279]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[530.482,681.451],[530.482,780.889],[500.242,677.427],[500.242,774.051]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[561.024,772.386],[561.024,861.531],[500.578,769.898],[500.578,858.092]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[530.724,799.058],[530.724,898.403],[500.777,791.673],[500.777,888.193]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[757.503,437.213],[757.503,333.768],[530.482,441.167],[530.482,341.729]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[757.503,554.544],[757.503,451.099],[530.482,553.952],[530.482,454.514]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[757.503,571.801],[757.503,675.247],[530.482,570.54],[530.482,669.978]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[757.503,687.182],[757.503,790.628],[530.482,681.451],[530.482,780.889]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[757.532,809.52],[757.532,912.864],[530.724,799.058],[530.724,898.403]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[561.731,759.399],[549.167,758.911],[561.731,843.578],[549.167,842.903]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[606.922,324.507],[606.922,228.852],[585.837,331.033],[585.837,238.284]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[657.541,322.603],[657.541,226.1],[606.922,324.507],[606.922,228.852]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[684.993,316.139],[684.993,216.756],[640.045,319.409],[640.045,221.482]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[719.112,313.872],[719.112,213.479],[684.993,316.139],[684.993,216.756]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[773.571,310.81],[773.571,209.053],[719.112,313.872],[719.112,213.479]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,432.902],[1005.07,325.086],[758.861,437.19],[758.861,333.72]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,555.19],[1005.07,447.374],[758.861,554.548],[758.861,451.078]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,573.177],[1005.07,680.993],[758.861,571.809],[758.861,675.279]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,693.432],[1005.07,801.248],[758.861,687.217],[758.861,790.686]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.5,821.07],[1005.5,928.831],[759.395,809.714],[759.395,913.133]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[841.167,309.147],[841.167,206.649],[777.888,310.642],[777.888,208.81]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[885.036,308.427],[841.167,309.147],[885.036,205.609],[841.167,206.649]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[947.067,307.654],[885.036,308.427],[947.067,204.491],[885.036,205.609]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[947.068,307.654],[947.068,204.491],[960.788,311.196],[960.788,209.612]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1017.91,309.048],[1017.91,206.506],[960.789,311.197],[960.789,209.612]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,432.902],[1005.07,325.086],[1087.79,433.947],[1087.79,327.189]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,555.19],[1005.07,447.374],[1087.79,555.034],[1087.79,448.277]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,573.177],[1005.07,680.993],[1087.79,572.843],[1087.79,679.601]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.07,693.432],[1005.07,801.248],[1087.79,691.918],[1087.79,798.675]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1005.5,821.07],[1005.5,928.831],[1088.26,818.249],[1088.26,924.932]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1017.91,309.048],[1017.91,206.506],[1093.97,312.431],[1093.97,211.397]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1087.79,433.947],[1087.79,327.189],[1108.1,436.774],[1108.1,332.884]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1087.79,555.034],[1087.79,448.277],[1108.1,554.61],[1108.1,450.72]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1087.79,572.843],[1087.79,679.601],[1108.1,571.941],[1108.1,675.832]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1087.79,691.918],[1087.79,798.675],[1108.1,687.819],[1108.1,791.709]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1088.26,818.249],[1088.26,924.932],[1107.6,811.11],[1107.6,915.062]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1093.97,312.431],[1093.97,211.397],[1160.12,318.281],[1160.12,219.853]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1155.14,813.191],[1107.6,811.11],[1155.14,917.94],[1107.6,915.062]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,436.019],[1153.9,331.362],[1108.1,436.774],[1108.1,332.884]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,554.723],[1153.9,450.067],[1108.1,554.61],[1108.1,450.72]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,572.182],[1153.9,676.839],[1108.1,571.941],[1108.1,675.832]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,688.914],[1153.9,793.571],[1108.1,687.819],[1108.1,791.709]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,436.019],[1153.9,331.362],[1190.66,441.517],[1190.66,342.434]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,554.723],[1153.9,450.067],[1190.66,553.899],[1190.66,454.816]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,572.182],[1153.9,676.839],[1190.66,570.429],[1190.66,669.512]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1153.9,688.914],[1153.9,793.571],[1190.66,680.944],[1190.66,780.027]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1155.14,813.191],[1155.14,917.94],[1194.26,797.639],[1194.26,896.44]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1160.12,318.281],[1160.12,219.853],[1233.72,327.438],[1233.72,233.088]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1265.64,801.487],[1265.64,901.76],[1189.29,798.343],[1189.29,897.414]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,440.325],[1267.36,340.035],[1190.66,441.517],[1190.66,342.434]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,554.078],[1267.36,453.787],[1190.66,553.899],[1190.66,454.816]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,570.809],[1267.36,671.099],[1190.66,570.429],[1190.66,669.512]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,682.671],[1267.36,782.961],[1190.66,680.944],[1190.66,780.027]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1210.17,375.605],[1210.17,302.711],[1217.05,377.382],[1217.05,305.279]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1233.12,327.956],[1233.12,233.834],[1273.32,335.262],[1273.32,244.395]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1265.64,801.487],[1265.64,901.76],[1335.93,789.458],[1335.93,885.131]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,440.325],[1267.36,340.035],[1334.14,444.611],[1334.14,348.664]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,554.078],[1267.36,453.787],[1334.14,553.436],[1334.14,457.489]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,570.809],[1267.36,671.099],[1334.14,569.442],[1334.14,665.388]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1267.36,682.671],[1267.36,782.961],[1334.14,676.458],[1334.14,772.404]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1273.32,335.262],[1273.32,244.395],[1285.23,337.315],[1285.23,247.364]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1285.23,337.315],[1285.23,247.364],[1315.1,348.106],[1315.1,262.962]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1315.1,348.106],[1315.1,262.962],[1319.02,357.07],[1319.02,275.919]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1319.28,448.474],[1319.28,353.261],[1392.41,461.125],[1392.41,379.182]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1318.68,466.096],[1318.68,391.932],[1328.56,467.472],[1328.56,394.703]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1319.28,556.468],[1319.28,461.255],[1392.41,554.068],[1392.41,472.125]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1318.68,562.588],[1318.68,636.753],[1328.56,562.149],[1328.56,634.919]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1318.68,645.31],[1318.68,719.474],[1328.56,643.315],[1328.56,716.084]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1319.05,733.055],[1319.05,807.161],[1328.45,729.583],[1328.45,802.361]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1319.28,788.254],[1319.28,883.467],[1392.41,753.553],[1392.41,835.497]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1319.28,572.351],[1319.28,667.564],[1392.41,567.739],[1392.41,649.682]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1319.28,678.55],[1319.28,773.763],[1392.41,659.137],[1392.41,741.081]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1331.89,462.642],[1331.89,384.975],[1352.41,465.712],[1352.41,391.158]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1331.89,563.69],[1331.89,641.356],[1352.41,562.711],[1352.41,637.265]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1331.89,650.317],[1331.89,727.984],[1352.41,645.867],[1352.41,720.421]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:40,
                    verts:[[1332.1,742.827],[1332.1,820.669],[1354.02,734.111],[1354.02,808.62]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[576.839,450.592],[576.839,360.709],[512.668,451.349],[512.668,362.233]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[576.839,552.539],[576.839,462.656],[512.668,552.426],[512.668,463.311]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[576.839,567.534],[576.839,657.417],[512.668,567.292],[512.668,656.408]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[576.839,667.787],[576.839,757.67],[512.668,666.69],[512.668,755.805]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[577.432,774.273],[577.432,864.14],[513.534,772.275],[513.534,861.378]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[559.783,787.933],[559.783,883.023],[518.917,786.578],[518.917,881.149]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[560.81,445.469],[560.81,350.392],[521.404,445.962],[521.404,351.385]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[560.81,553.307],[560.81,458.231],[521.404,553.233],[521.404,458.657]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[560.81,569.168],[560.81,664.244],[521.404,569.011],[521.404,663.587]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[560.81,675.214],[560.81,770.29],[521.404,674.499],[521.404,769.076]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[570.305,440.37],[570.305,340.124],[532.904,443.04],[532.904,345.501]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[570.305,554.071],[570.305,453.826],[532.904,553.671],[532.904,456.133]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[570.305,570.794],[570.305,671.04],[532.904,569.943],[532.904,667.481]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[570.305,682.606],[570.305,782.852],[532.904,678.735],[532.904,776.274]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[570.333,801.17],[570.333,901.321],[533.207,794.06],[533.207,891.493]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[808.869,437.228],[808.869,333.797],[570.305,440.37],[570.305,340.124]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[808.869,554.542],[808.869,451.111],[570.305,554.071],[570.305,453.826]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[808.869,571.797],[808.869,675.228],[570.305,570.794],[570.305,671.04]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[808.869,687.161],[808.869,790.593],[570.305,682.606],[570.305,782.852]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[808.666,809.484],[808.666,912.815],[570.333,801.17],[570.333,901.321]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[611.046,329.603],[611.046,236.217],[605.757,337.034],[605.757,246.958]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[639.184,323.253],[639.184,227.039],[611.046,329.603],[611.046,236.217]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[692.366,321.737],[692.366,224.847],[639.184,323.253],[639.184,227.039]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[726.695,315.523],[726.696,215.866],[677.972,318.427],[677.972,220.064]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[763.351,313.538],[763.351,212.996],[726.695,315.523],[726.696,215.866]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[821.1,310.93],[821.1,209.226],[763.351,313.538],[763.351,212.996]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,433.86],[1064.6,327.014],[810.284,437.209],[810.284,333.759]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,555.047],[1064.6,448.201],[810.284,554.545],[810.284,451.095]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,572.871],[1064.6,679.717],[810.284,571.803],[810.284,675.253]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,692.044],[1064.6,798.89],[810.284,687.189],[810.284,790.638]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.9,818.531],[1064.9,925.32],[810.703,809.659],[810.703,913.057]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[890.294,309.817],[890.294,207.618],[825.592,310.798],[825.592,209.035]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[934.661,309.452],[890.294,309.817],[934.661,207.091],[890.294,207.618]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[996.918,309.179],[934.66,309.452],[996.918,206.696],[934.66,207.091]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[996.918,309.179],[996.918,206.696],[1006.93,312.769],[1006.93,211.885]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1065.42,311.102],[1065.42,209.475],[1006.93,312.769],[1006.93,211.885]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,433.86],[1064.6,327.014],[1143.43,435.177],[1143.43,329.667]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,555.047],[1064.6,448.201],[1143.43,554.849],[1143.43,449.34]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,572.871],[1064.6,679.717],[1143.43,572.451],[1143.43,677.961]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.6,692.044],[1064.6,798.89],[1143.43,690.134],[1143.43,795.644]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1065.42,311.102],[1065.42,209.475],[1136.73,315.003],[1136.73,215.114]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1064.9,818.531],[1064.9,925.32],[1143.72,814.987],[1143.72,920.422]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1136.73,315.003],[1136.73,215.114],[1195.61,321.221],[1195.61,224.102]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1143.43,435.177],[1143.43,329.667],[1156.92,438.013],[1156.92,335.379]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1143.43,554.849],[1143.43,449.34],[1156.92,554.424],[1156.92,451.79]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1143.43,572.451],[1143.43,677.961],[1156.92,571.546],[1156.92,674.181]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1143.43,690.134],[1143.43,795.644],[1156.92,686.023],[1156.92,788.657]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1143.72,814.987],[1143.72,920.422],[1156.57,807.826],[1156.57,910.523]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1204.76,809.425],[1156.57,807.826],[1204.76,912.734],[1156.57,910.523]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,437.433],[1203.35,334.209],[1156.92,438.013],[1156.92,335.379]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,554.511],[1203.35,451.288],[1156.92,554.424],[1156.92,451.79]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,571.731],[1203.35,674.955],[1156.92,571.546],[1156.92,674.181]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,686.864],[1203.35,790.088],[1156.92,686.023],[1156.92,788.657]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1187.76,377.654],[1187.76,305.671],[1192.72,379.433],[1192.72,308.243]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1195.61,321.221],[1195.61,224.102],[1258.21,330.693],[1258.21,237.793]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,437.433],[1203.35,334.209],[1226.81,442.923],[1226.81,345.265]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,554.511],[1203.35,451.288],[1226.81,553.689],[1226.81,456.031]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,571.731],[1203.35,674.955],[1226.81,569.98],[1226.81,667.637]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1203.35,686.864],[1203.35,790.088],[1226.81,678.905],[1226.81,776.563]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1204.76,809.426],[1204.76,912.734],[1229.69,793.897],[1229.69,891.268]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1302.23,797.029],[1225.45,794.627],[1302.23,895.598],[1225.45,892.277]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,442.013],[1303.93,343.433],[1226.81,442.923],[1226.81,345.265]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,553.825],[1303.93,455.245],[1226.81,553.689],[1226.81,456.031]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,570.27],[1303.93,668.85],[1226.81,569.98],[1226.81,667.637]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,680.224],[1303.93,778.804],[1226.81,678.905],[1226.81,776.563]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1257.13,331.194],[1257.13,238.516],[1288.96,338.598],[1288.96,249.217]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1288.96,338.598],[1288.96,249.217],[1298.49,340.679],[1298.49,252.228]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1296.14,467.286],[1296.14,394.327],[1302.64,468.654],[1302.64,397.082]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1296.14,562.209],[1296.14,635.167],[1302.64,561.772],[1302.64,633.344]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1296.14,643.585],[1296.14,716.543],[1302.64,641.602],[1302.64,713.174]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1296.37,729.902],[1296.37,802.803],[1302.56,726.451],[1302.56,798.032]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1298.49,340.679],[1298.49,252.228],[1316.83,351.392],[1316.83,267.713]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1302.23,797.029],[1302.23,895.598],[1360.06,784.731],[1360.06,878.597]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,442.013],[1303.93,343.433],[1358.93,446.395],[1358.93,352.258]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,553.825],[1303.93,455.245],[1358.93,553.168],[1358.93,459.031]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,570.27],[1303.93,668.85],[1358.93,568.872],[1358.93,663.009]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1303.93,680.224],[1303.93,778.804],[1358.93,673.871],[1358.93,768.008]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1316.64,463.947],[1316.64,387.604],[1329.65,466.993],[1329.65,393.738]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1316.64,563.274],[1316.64,639.617],[1329.65,562.302],[1329.65,635.557]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1316.64,648.425],[1316.64,724.769],[1329.65,644.01],[1329.65,717.265]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1317.23,739.354],[1317.23,815.868],[1331.11,730.707],[1331.11,803.915]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1342.98,450.135],[1342.98,356.664],[1384.45,462.645],[1384.45,382.295]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1342.98,556.153],[1342.98,462.682],[1384.45,553.78],[1384.45,473.43]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1342.98,783.699],[1342.98,877.17],[1384.45,749.385],[1384.45,829.735]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1342.98,676.001],[1342.98,769.472],[1384.45,656.805],[1384.45,737.155]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:41,
                    verts:[[1342.98,571.746],[1342.98,665.217],[1384.45,567.185],[1384.45,647.535]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[595.607,449.827],[595.607,359.169],[528.354,450.389],[528.354,360.301]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[595.607,552.654],[595.607,461.996],[528.354,552.57],[528.354,462.482]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[595.607,567.778],[595.607,658.436],[528.354,567.598],[528.354,657.687]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[595.607,668.896],[595.607,759.554],[528.354,668.081],[528.354,758.169]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[596.173,776.295],[596.173,866.935],[529.211,774.812],[529.211,864.885]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[590.285,790.113],[590.285,886.036],[547.411,789.107],[547.411,884.646]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[591.3,444.65],[591.3,348.743],[549.962,445.015],[549.962,349.48]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[591.3,553.43],[591.3,457.523],[549.962,553.375],[549.962,457.839]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[591.3,569.429],[591.3,665.336],[549.962,569.313],[549.962,664.848]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[591.3,676.401],[591.3,772.307],[549.962,675.871],[549.962,771.407]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[573.626,763.374],[559.77,763.083],[573.626,849.074],[559.77,848.672]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[612.909,439.583],[612.909,338.539],[568.563,442.127],[568.563,343.663]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[612.909,554.189],[612.909,453.146],[568.563,553.808],[568.563,455.344]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[612.909,571.046],[612.909,672.089],[568.563,570.234],[568.563,668.698]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[612.909,683.747],[612.909,784.791],[568.563,680.058],[568.563,778.522]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[612.72,803.256],[612.72,904.205],[568.627,796.477],[568.627,894.835]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[860.719,437.278],[860.719,333.899],[612.909,439.583],[612.909,338.539]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[860.719,554.535],[860.719,451.155],[612.909,554.189],[612.909,453.146]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[860.719,571.781],[860.719,675.16],[612.909,571.046],[612.909,672.089]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[860.719,687.088],[860.719,790.468],[612.909,683.747],[612.909,784.791]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[860.288,809.354],[860.288,912.635],[612.72,803.256],[612.72,904.205]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[638.466,328.106],[638.466,234.054],[625.461,335.496],[625.461,244.735]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[673.505,321.973],[673.505,225.189],[638.466,328.106],[638.466,234.054]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[728.805,320.858],[728.805,223.578],[673.505,321.973],[673.505,225.189]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[769.719,314.935],[769.72,215.016],[717.658,317.454],[717.658,218.657]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[808.563,313.245],[808.563,212.573],[769.72,314.935],[769.72,215.016]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[869.024,311.105],[869.024,209.48],[808.563,313.245],[808.563,212.573]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,434.851],[1121.78,329.01],[862.176,437.265],[862.176,333.871]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,554.898],[1121.78,449.058],[862.176,554.536],[862.176,451.143]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,572.555],[1121.78,678.396],[862.176,571.785],[862.176,675.178]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,690.607],[1121.78,796.448],[862.176,687.108],[862.176,790.501]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.96,815.902],[1121.96,921.687],[862.476,809.509],[862.476,912.849]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[939.118,310.541],[873.646,311.009],[939.118,208.665],[873.646,209.341]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[983.536,310.525],[939.118,310.541],[983.536,208.642],[939.118,208.665]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[983.536,310.525],[1045.4,310.738],[983.536,208.642],[1045.4,208.949]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1045.4,310.738],[1045.4,208.949],[1051.7,314.35],[1051.7,214.17]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1110.96,313.155],[1051.7,314.35],[1110.96,212.443],[1051.7,214.17]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1110.96,313.155],[1110.96,212.443],[1177.02,317.523],[1177.02,218.756]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,434.851],[1121.78,329.01],[1196.04,436.418],[1196.04,332.166]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,554.898],[1121.78,449.058],[1196.04,554.663],[1196.04,450.412]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,572.555],[1121.78,678.396],[1196.04,572.055],[1196.04,676.307]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.78,690.607],[1121.78,796.448],[1196.04,688.335],[1196.04,792.587]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1121.96,815.902],[1121.96,921.687],[1196.16,811.699],[1196.16,915.876]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1165.03,379.371],[1165.03,308.154],[1168.13,381.148],[1168.13,310.722]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1177.02,317.523],[1177.02,218.756],[1228.39,324.048],[1228.39,228.188]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1196.04,436.418],[1196.04,332.166],[1202.84,439.242],[1202.84,337.852]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1196.04,554.663],[1196.04,450.412],[1202.84,554.24],[1202.84,452.851]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1196.04,572.055],[1196.04,676.307],[1202.84,571.154],[1202.84,672.544]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1196.04,688.335],[1196.04,792.587],[1202.84,684.242],[1202.84,785.631]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1196.16,811.699],[1196.16,915.876],[1202.64,804.569],[1202.64,906.021]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,438.83],[1202.84,439.242],[1249.41,337.023],[1202.84,337.852]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,554.302],[1249.41,452.495],[1202.84,554.24],[1202.84,452.851]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,571.286],[1249.41,673.093],[1202.84,571.154],[1202.84,672.544]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,684.839],[1202.84,684.242],[1249.41,786.646],[1202.84,785.631]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1250.98,805.703],[1202.64,804.569],[1250.98,907.588],[1202.64,906.021]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1228.39,324.048],[1228.39,228.188],[1280.01,333.757],[1280.01,242.222]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,438.83],[1249.41,337.023],[1259.96,444.276],[1259.96,347.989]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,554.302],[1249.41,452.495],[1259.96,553.486],[1259.96,457.2]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,571.286],[1249.41,673.092],[1259.96,569.549],[1259.96,665.835]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1249.41,684.839],[1249.41,786.646],[1259.96,676.944],[1259.96,773.23]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1250.98,805.703],[1250.98,907.588],[1262.13,790.303],[1262.13,886.299]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1335.15,792.748],[1258.63,791.053],[1335.15,889.68],[1258.63,887.336]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,443.633],[1259.96,444.276],[1336.82,346.696],[1259.96,347.989]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,553.582],[1336.82,456.645],[1259.96,553.486],[1259.96,457.2]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,569.753],[1336.82,666.691],[1259.96,569.549],[1259.96,665.835]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,677.875],[1259.96,676.944],[1336.82,774.812],[1259.96,773.23]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1272.93,468.316],[1272.93,396.401],[1276.2,469.671],[1276.2,399.13]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1272.93,561.88],[1272.93,633.794],[1276.2,561.448],[1276.2,631.988]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1272.93,642.092],[1272.93,714.006],[1276.2,640.127],[1276.2,710.668]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1273.03,727.174],[1273.03,799.03],[1276.14,723.754],[1276.14,794.303]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1278.47,334.24],[1278.47,242.918],[1302.12,341.692],[1302.12,253.689]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1300.29,465.097],[1300.29,389.919],[1306.13,468.109],[1306.13,395.985]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1300.29,562.907],[1300.29,638.085],[1306.13,561.946],[1306.13,634.07]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1300.29,646.759],[1300.29,721.937],[1306.13,642.392],[1306.13,714.516]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1301.25,736.292],[1301.25,811.636],[1307.44,727.742],[1307.44,799.816]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1302.12,341.692],[1302.12,253.689],[1309.31,343.789],[1309.31,256.722]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1309.31,343.789],[1309.31,256.722],[1316.6,354.374],[1316.6,272.023]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1335.15,792.748],[1335.15,889.68],[1380.72,780.282],[1380.72,872.446]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,443.633],[1336.82,346.696],[1380.23,448.077],[1380.23,355.645]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,553.582],[1336.82,456.645],[1380.23,552.916],[1380.23,460.484]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,569.753],[1336.82,666.691],[1380.23,568.336],[1380.23,660.768]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1336.82,677.875],[1336.82,774.812],[1380.23,671.433],[1380.23,763.865]]
                },{
                    num:"503",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1363.37,451.698],[1363.37,359.865],[1374.7,464.011],[1374.7,385.093]]
                },{
                    num:"403",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1363.37,555.856],[1363.37,464.024],[1374.7,553.521],[1374.7,474.604]]
                },{
                    num:"203",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1363.37,673.604],[1363.37,765.436],[1374.7,654.71],[1374.7,733.627]]
                },{
                    num:"103",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1363.37,779.413],[1363.37,871.245],[1374.7,745.639],[1374.7,824.557]]
                },{
                    num:"303",
                    tipo:"TorreA",
                    frame:42,
                    verts:[[1363.37,571.176],[1363.37,663.008],[1374.7,566.687],[1374.7,645.604]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[616.62,449.001],[616.62,357.505],[546.695,449.358],[546.695,358.225]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[616.62,552.778],[616.62,461.282],[546.695,552.724],[546.695,461.591]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[616.62,568.041],[616.62,659.537],[546.695,567.927],[546.695,659.061]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[616.62,670.093],[616.62,761.589],[546.695,669.575],[546.695,760.709]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[617.155,778.481],[617.155,869.957],[547.536,777.538],[547.536,868.653]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[582.811,765.693],[568.413,765.508],[582.811,852.278],[568.413,852.023]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[623.307,792.385],[623.307,889.177],[578.736,791.746],[578.736,888.294]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[624.3,443.796],[624.3,347.025],[581.332,444.029],[581.332,347.492]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[624.3,553.558],[624.3,456.786],[581.332,553.523],[581.332,456.987]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[624.3,569.701],[624.3,666.473],[581.332,569.627],[581.332,666.164]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[624.3,677.638],[624.3,774.41],[581.332,677.302],[581.332,773.838]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[657.644,805.351],[657.644,907.101],[606.856,798.955],[606.856,898.259]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[658.052,438.793],[658.052,336.949],[607.035,441.192],[607.035,341.78]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[658.052,554.307],[658.052,452.464],[607.035,553.948],[607.035,454.536]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[658.052,571.297],[658.052,673.141],[607.035,570.532],[607.035,669.944]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[658.052,684.892],[658.052,786.736],[607.035,681.414],[607.035,780.826]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[647.212,333.824],[647.212,242.318],[637.855,343.911],[637.855,256.898]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[667.96,326.517],[667.96,231.756],[647.212,333.824],[647.212,242.318]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[912.114,809.176],[912.114,912.388],[657.644,805.351],[657.644,907.101]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[912.766,437.348],[912.766,334.039],[658.052,438.793],[658.052,336.949]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[912.766,554.524],[912.766,451.215],[658.052,554.307],[658.052,452.464]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[912.766,571.758],[912.766,675.068],[658.052,571.297],[658.052,673.141]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[912.766,686.987],[912.766,790.297],[658.052,684.892],[658.052,786.736]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[709.705,320.639],[709.705,223.261],[667.96,326.517],[667.96,231.756]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[766.668,319.938],[766.668,222.247],[709.705,320.639],[709.705,223.261]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[813.83,314.343],[813.831,214.16],[758.887,316.458],[758.887,217.217]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[854.502,312.958],[854.502,212.158],[813.83,314.343],[813.831,214.16]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[917.095,311.297],[917.095,209.757],[854.502,312.958],[854.502,212.158]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,435.851],[1176.44,331.025],[914.251,437.339],[914.251,334.022]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,554.748],[1176.44,449.922],[914.251,554.525],[914.251,451.208]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,572.236],[1176.44,677.062],[914.251,571.761],[914.251,675.079]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,689.157],[1176.44,793.983],[914.251,687],[914.251,790.317]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.49,813.25],[1176.49,918.021],[914.43,809.309],[914.43,912.573]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[921.801,311.237],[987.414,311.278],[921.801,209.671],[987.414,209.729]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[987.414,311.278],[1031.46,311.603],[987.414,209.729],[1031.46,210.199]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1031.46,311.603],[1092.36,312.285],[1031.46,210.199],[1092.36,211.185]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1092.36,312.285],[1092.36,211.185],[1094.98,315.895],[1094.98,216.404]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1154.44,315.163],[1094.98,315.895],[1154.44,215.345],[1094.98,216.404]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1142,380.761],[1142,310.163],[1143.29,382.53],[1143.29,312.72]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1154.44,315.163],[1154.44,215.345],[1214.84,319.948],[1214.84,222.262]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,435.851],[1176.44,331.025],[1245.53,437.645],[1245.53,334.638]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,554.748],[1176.44,449.922],[1245.53,554.479],[1245.53,451.472]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,572.236],[1176.44,677.062],[1245.53,571.664],[1245.53,674.671]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.44,689.157],[1176.44,793.983],[1245.53,686.556],[1245.53,789.564]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1176.49,813.25],[1176.49,918.021],[1245.48,808.447],[1245.48,911.382]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1214.84,319.948],[1214.84,222.262],[1258.55,326.725],[1258.55,232.058]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1245.48,808.447],[1245.48,911.382],[1245.79,801.394],[1245.79,901.632]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1245.85,440.439],[1292.12,440.189],[1245.85,340.263],[1292.12,339.759]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1245.85,554.061],[1292.12,554.098],[1245.85,453.885],[1292.12,453.669]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1245.85,570.773],[1292.12,570.852],[1245.85,670.948],[1292.12,671.281]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1245.85,682.506],[1292.12,682.869],[1245.85,782.682],[1292.12,783.298]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1245.79,801.394],[1293.82,802.083],[1245.79,901.632],[1293.82,902.583]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1258.55,326.725],[1258.55,232.058],[1299.26,336.604],[1299.26,246.337]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1288.92,787.662],[1364.57,788.687],[1288.92,882.649],[1364.57,884.065]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1290.23,445.559],[1366.2,445.17],[1290.23,350.573],[1366.2,349.792]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1290.23,569.139],[1366.2,569.263],[1290.23,664.125],[1366.2,664.642]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1290.23,675.084],[1366.2,675.647],[1290.23,770.069],[1366.2,771.025]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1290.23,553.294],[1290.23,458.308],[1366.2,553.352],[1366.2,457.973]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1297.3,337.066],[1297.3,247.003],[1312.96,344.526],[1312.96,257.785]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1312.96,344.526],[1312.96,257.785],[1317.89,346.626],[1317.89,260.824]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1364.57,788.687],[1364.57,884.065],[1398.18,776.137],[1398.18,866.717]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1366.2,445.17],[1366.2,349.792],[1398.29,449.645],[1398.29,358.802]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1366.2,553.352],[1366.2,457.973],[1398.29,552.681],[1398.29,461.839]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1366.2,569.263],[1366.2,664.642],[1398.29,567.836],[1398.29,658.678]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:43,
                    verts:[[1366.2,675.647],[1366.2,771.025],[1398.29,669.16],[1398.29,760.002]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[567.658,448.247],[567.658,355.986],[556.769,452.706],[556.769,364.967]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[567.658,552.891],[567.658,460.631],[556.769,552.222],[556.769,464.483]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[567.658,568.282],[567.658,660.542],[556.769,566.859],[556.769,654.598]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[567.658,671.187],[567.658,763.447],[556.769,664.721],[556.769,752.46]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[639.823,448.104],[639.823,355.699],[567.658,448.247],[567.658,355.986]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[639.823,552.912],[639.823,460.507],[567.658,552.891],[567.658,460.631]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[639.823,568.327],[639.823,660.732],[567.658,568.282],[567.658,660.542]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[639.823,671.394],[639.823,763.799],[567.658,671.187],[567.658,763.447]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[640.323,780.855],[640.323,873.238],[568.476,780.478],[568.476,872.717]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[594.116,768.265],[579.25,768.191],[594.116,855.835],[579.25,855.733]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[658.74,794.772],[612.802,794.517],[658.74,892.477],[612.802,892.125]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[659.703,442.899],[659.703,345.218],[615.422,442.992],[615.422,345.405]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[659.703,553.692],[659.703,456.011],[615.422,553.678],[615.422,456.091]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[659.703,569.988],[659.703,667.669],[615.422,569.958],[615.422,667.545]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[659.703,678.939],[659.703,776.62],[615.422,678.805],[615.422,776.392]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[704.915,807.478],[704.915,910.042],[647.755,801.516],[647.755,901.801]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[705.542,437.992],[705.542,335.336],[648.183,440.226],[648.183,339.835]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[705.542,554.428],[705.542,451.771],[648.183,554.093],[648.183,453.702]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[705.542,571.553],[705.542,674.209],[648.183,570.84],[648.183,671.231]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[705.542,686.053],[705.542,788.71],[648.183,682.814],[648.183,783.206]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[670.948,331.998],[670.948,239.678],[651.171,342.065],[651.171,254.23]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[699.431,324.813],[699.431,229.293],[670.948,331.998],[670.948,239.678]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[747.647,319.23],[747.647,221.224],[699.431,324.813],[699.431,229.293]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[963.914,808.985],[963.914,912.125],[704.915,807.478],[704.915,910.042]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[964.781,437.423],[964.781,334.189],[705.542,437.992],[705.542,335.336]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[964.781,554.513],[964.781,451.28],[705.542,554.428],[705.542,451.771]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[964.781,571.735],[964.781,674.968],[705.542,571.553],[705.542,674.209]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[964.781,686.879],[964.781,790.112],[705.542,686.053],[705.542,788.71]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[805.809,318.953],[747.647,319.23],[805.809,220.823],[747.647,221.224]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[858.842,313.722],[858.842,213.262],[801.489,315.416],[801.489,215.711]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[900.976,312.651],[900.976,211.714],[858.842,313.722],[858.842,213.262]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[965.117,311.477],[965.117,210.017],[900.976,312.651],[900.976,211.714]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[966.279,437.419],[1228.47,436.844],[966.279,334.183],[1228.47,333.023]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[966.279,554.513],[966.279,451.277],[1228.47,554.6],[1228.47,450.779]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[966.279,571.736],[1228.47,571.919],[966.279,674.972],[1228.47,675.74]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[966.279,686.884],[1228.47,687.718],[966.279,790.12],[1228.47,791.539]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[966.337,809.097],[1228.39,810.622],[966.337,912.279],[1228.39,914.387]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[969.862,311.453],[1035.01,311.995],[969.862,209.983],[1035.01,210.766]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1035.01,311.995],[1078.28,312.652],[1035.01,210.766],[1078.28,211.716]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1078.28,312.652],[1078.28,211.716],[1137.67,313.788],[1137.67,213.357]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1136.67,317.375],[1195.82,317.093],[1136.67,218.543],[1195.82,218.135]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1195.82,317.093],[1195.82,218.135],[1250.21,322.251],[1250.21,225.59]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1228.47,436.844],[1228.47,333.023],[1291.9,438.842],[1291.9,337.048]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1228.47,554.6],[1228.47,450.779],[1291.9,554.3],[1291.9,452.506]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1228.47,571.919],[1228.47,675.74],[1291.9,571.282],[1291.9,673.076]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1228.47,687.718],[1228.47,791.539],[1291.9,684.821],[1291.9,786.616]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1228.39,810.622],[1228.39,914.387],[1291.69,805.278],[1291.69,907.001]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1250.21,322.251],[1250.21,225.59],[1286.18,329.23],[1286.18,235.678]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1286.18,329.23],[1286.18,235.678],[1316.11,339.218],[1316.11,250.115]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1285.96,441.589],[1331.54,441.494],[1285.96,342.58],[1331.54,342.388]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1285.96,570.406],[1285.96,669.415],[1331.54,570.436],[1331.54,669.542]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1285.96,680.838],[1331.54,680.976],[1285.96,779.847],[1331.54,780.082]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1286.03,798.341],[1333.34,798.604],[1286.03,897.411],[1333.34,897.774]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1285.96,553.888],[1285.96,454.879],[1331.54,553.903],[1331.54,454.797]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1313.75,339.659],[1313.75,250.751],[1321.66,347.09],[1321.66,261.493]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1316.44,784.483],[1390.67,784.873],[1316.44,878.254],[1390.67,878.792]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1317.71,446.762],[1317.71,352.996],[1392.25,446.614],[1392.25,352.699]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1317.71,568.755],[1317.71,662.521],[1392.25,568.803],[1392.25,662.718]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1317.71,673.339],[1317.71,767.105],[1392.25,673.553],[1392.25,767.469]]
                },{
                    num:"603",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1321.66,347.09],[1321.66,261.493],[1324.39,349.186],[1324.39,264.523]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1317.71,553.113],[1317.71,459.348],[1392.25,553.135],[1392.25,459.22]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1390.67,784.873],[1390.67,878.792],[1412.65,772.312],[1412.65,861.429]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1392.25,446.614],[1392.25,352.699],[1413.33,451.093],[1413.33,361.719]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1392.25,553.135],[1392.25,459.22],[1413.33,552.464],[1413.33,463.09]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1392.25,568.803],[1392.25,662.718],[1413.33,567.374],[1413.33,656.748]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:44,
                    verts:[[1392.25,673.553],[1392.25,767.469],[1413.33,667.06],[1413.33,756.434]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[591.253,447.047],[591.253,353.571],[569.755,451.52],[569.755,362.577]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[591.253,553.07],[591.253,459.595],[569.755,552.4],[569.755,463.458]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[591.253,568.664],[591.253,662.14],[569.755,567.238],[569.755,656.18]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[591.253,672.926],[591.253,766.401],[569.755,666.442],[569.755,755.384]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[665.201,447.129],[665.201,353.736],[591.253,447.047],[591.253,353.571]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[665.201,553.058],[665.201,459.665],[591.253,553.07],[591.253,459.595]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[665.201,568.638],[665.201,662.031],[591.253,568.664],[591.253,662.14]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[665.201,672.807],[665.201,766.2],[591.253,672.926],[591.253,766.401]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[607.56,771.112],[592.305,771.155],[607.56,859.77],[592.305,859.829]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[665.661,783.434],[592.042,783.65],[665.661,876.803],[592.042,877.102]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[696.516,797.291],[649.561,797.436],[696.516,895.959],[649.561,896.16]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[697.438,441.953],[652.183,441.9],[697.438,343.312],[652.183,343.205]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[697.438,553.834],[697.438,455.193],[652.183,553.842],[652.183,455.147]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[697.438,570.289],[697.438,668.93],[652.183,570.306],[652.183,669.001]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[697.438,680.311],[652.183,680.388],[697.438,778.952],[652.183,779.083]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[660.062,347.847],[660.062,262.586],[657.232,349.937],[657.232,265.609]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[668.355,340.436],[668.355,251.874],[660.062,347.847],[660.062,262.586]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[696.645,330.002],[696.645,236.794],[666.323,340.002],[666.323,251.248]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[755.229,437.173],[755.229,333.687],[691.91,439.224],[691.91,337.816]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[755.229,554.55],[755.229,451.064],[691.91,554.243],[691.91,452.835]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[755.229,571.814],[755.229,675.3],[691.91,571.16],[691.91,672.568]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[755.229,687.24],[755.229,790.726],[691.91,684.268],[691.91,785.675]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[754.383,809.653],[754.383,913.048],[691.231,804.176],[691.231,905.478]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[732.819,322.981],[732.819,226.646],[696.645,330.002],[696.645,236.794]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[787.23,317.732],[787.23,219.058],[732.819,322.981],[732.819,226.646]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1015.5,808.803],[754.383,809.653],[1015.5,911.873],[754.383,913.048]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1016.57,437.495],[755.229,437.173],[1016.57,334.334],[755.229,333.687]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1016.57,554.502],[755.229,554.55],[1016.57,451.342],[755.229,451.064]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1016.57,571.712],[755.229,571.814],[1016.57,674.872],[755.229,675.3]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1016.57,686.775],[755.229,687.24],[1016.57,789.935],[755.229,790.726]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[846.113,317.889],[787.23,317.732],[846.113,219.285],[787.23,219.058]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[904.604,313.055],[904.604,212.299],[845.332,314.315],[845.332,214.119]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[947.826,312.307],[904.604,313.055],[947.826,211.217],[904.604,212.299]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1012.93,311.626],[947.826,312.307],[1012.93,210.233],[947.826,211.217]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1017.67,311.639],[1017.67,210.252],[1081.76,312.674],[1081.76,211.747]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1018.07,437.496],[1018.07,334.338],[1277.77,437.815],[1277.77,334.98]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1018.07,554.502],[1018.07,451.343],[1277.77,554.454],[1277.77,451.619]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1018.07,571.711],[1018.07,674.87],[1277.77,571.609],[1277.77,674.444]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1018.07,686.772],[1018.07,789.93],[1277.77,686.309],[1277.77,789.144]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1018.01,808.892],[1018.01,911.997],[1277.57,808.047],[1277.57,910.829]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1081.76,312.674],[1081.76,211.747],[1123.88,313.654],[1123.88,213.163]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1123.88,313.653],[1123.88,213.163],[1181.26,315.225],[1181.26,215.435]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1176.72,318.771],[1235.05,318.926],[1176.72,220.56],[1235.05,220.785]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1235.05,318.926],[1235.05,220.785],[1283.15,324.413],[1283.15,228.716]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1277.77,437.815],[1277.77,334.98],[1335.13,439.998],[1335.13,339.375]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1277.77,554.454],[1277.77,451.619],[1335.13,554.127],[1335.13,453.504]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1277.77,571.609],[1277.77,674.444],[1335.13,570.913],[1335.13,671.536]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1277.77,686.309],[1277.77,789.144],[1335.13,683.146],[1335.13,783.769]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1277.57,808.047],[1277.57,910.829],[1334.77,802.219],[1334.77,902.772]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1283.15,324.413],[1283.15,228.716],[1311.36,331.55],[1311.36,239.031]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1311.36,331.55],[1311.36,239.031],[1330.66,341.594],[1330.66,253.549]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1323.2,442.685],[1323.2,344.787],[1367.73,442.737],[1367.73,344.892]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1323.2,570.056],[1323.2,667.954],[1367.73,570.039],[1367.73,667.885]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1323.2,679.25],[1323.2,777.148],[1367.73,679.174],[1367.73,777.019]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1323.41,795.433],[1369.62,795.29],[1323.41,893.391],[1369.62,893.193]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1323.2,553.724],[1323.2,455.826],[1367.73,553.716],[1367.73,455.871]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1341.29,781.529],[1341.29,874.171],[1413.62,781.317],[1413.62,873.877]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1342.52,447.88],[1342.52,355.247],[1415.14,447.96],[1415.14,355.409]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1342.52,568.399],[1342.52,661.031],[1415.14,568.373],[1415.14,660.924]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1342.52,671.719],[1342.52,764.351],[1415.14,671.602],[1415.14,764.153]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1342.52,552.946],[1342.52,460.314],[1415.14,552.934],[1415.14,460.383]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1413.62,781.317],[1413.62,873.877],[1424.31,768.809],[1424.31,856.586]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1415.14,447.96],[1415.14,355.409],[1425.53,452.421],[1425.53,364.394]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1415.14,552.934],[1415.14,460.383],[1425.53,552.265],[1425.53,464.237]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1415.14,568.373],[1415.14,660.924],[1425.53,566.95],[1425.53,654.978]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:45,
                    verts:[[1415.14,671.602],[1415.14,764.153],[1425.53,665.135],[1425.53,753.162]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[617.534,445.756],[617.534,350.972],[585.167,450.219],[585.167,359.959]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[617.534,553.264],[617.534,458.479],[585.167,552.595],[585.167,462.335]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[617.534,569.076],[617.534,663.861],[585.167,567.653],[585.167,657.913]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[617.534,674.797],[617.534,769.582],[585.167,668.327],[585.167,758.588]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[623.2,774.247],[607.64,774.413],[623.2,864.104],[607.64,864.333]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[692.772,446.074],[617.534,445.756],[692.772,351.612],[617.534,350.972]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[692.772,553.216],[692.772,458.754],[617.534,553.264],[617.534,458.479]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[692.772,568.975],[617.534,569.076],[692.772,663.438],[617.534,663.861]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[692.772,674.336],[617.534,674.797],[692.772,768.799],[617.534,769.582]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[693.187,786.227],[618.287,787.065],[693.187,880.664],[618.287,881.823]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[669.015,345.594],[669.015,259.329],[664.007,347.687],[664.007,262.357]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[684.979,338.164],[684.979,248.59],[669.015,345.594],[669.015,259.329]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[724.31,327.831],[724.31,233.656],[683.347,337.711],[683.347,247.938]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[736.597,799.945],[688.999,800.508],[736.597,899.628],[688.999,900.407]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[691.601,440.75],[737.471,440.955],[691.601,340.89],[737.471,341.302]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[691.601,554.014],[737.471,553.984],[691.601,454.154],[737.471,454.331]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[691.601,570.673],[737.471,570.608],[691.601,670.533],[737.471,670.26]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[691.601,682.055],[737.471,681.758],[691.601,781.915],[737.471,781.41]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[768.095,321.016],[768.095,223.806],[724.31,327.831],[724.31,233.656]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[737.223,806.938],[737.223,909.295],[736.597,799.945],[736.597,899.628]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[738.154,438.184],[738.154,335.722],[737.471,440.955],[737.471,341.302]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[738.154,554.399],[738.154,451.937],[737.471,553.984],[737.471,454.331]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[738.154,571.492],[738.154,673.954],[737.471,570.608],[737.471,670.26]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[738.154,685.776],[738.154,788.237],[737.471,681.758],[737.471,781.411]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[805.928,811.877],[805.928,916.122],[737.223,806.938],[737.223,909.295]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,436.337],[806.989,332.003],[738.154,438.184],[738.154,335.722]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,554.676],[806.989,450.342],[738.154,554.399],[738.154,451.937]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,572.081],[806.989,676.415],[738.154,571.492],[738.154,673.954]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,688.453],[806.989,792.787],[738.154,685.776],[738.154,788.237]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[828.383,316.14],[828.383,216.757],[768.095,321.016],[768.095,223.806]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[805.928,811.877],[805.928,916.122],[1066.71,808.639],[1066.71,911.646]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,436.337],[806.989,332.003],[1067.98,437.56],[1067.98,334.467]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,554.676],[806.989,450.342],[1067.98,554.492],[1067.98,451.399]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,572.081],[806.989,676.415],[1067.98,571.691],[1067.98,674.784]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[806.989,688.453],[806.989,792.787],[1067.98,686.679],[1067.98,789.773]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[828.383,316.14],[887.494,316.741],[828.383,216.757],[887.494,217.626]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[836.897,381.362],[836.897,311.031],[835.518,383.122],[835.518,313.576]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[890.306,313.149],[890.306,212.434],[887.494,316.741],[887.494,217.626]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[950.989,312.339],[890.306,313.149],[950.99,211.264],[890.306,212.434]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[994.916,311.921],[950.989,312.339],[994.916,210.659],[950.99,211.264]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[994.916,311.921],[1060.39,311.739],[994.916,210.659],[1060.39,210.396]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1065.09,311.788],[1065.09,210.467],[1127.54,313.306],[1127.54,212.661]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1069.46,437.567],[1069.46,334.481],[1324.28,438.762],[1324.28,336.886]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1069.46,554.491],[1069.46,451.405],[1324.28,554.312],[1324.28,452.436]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1069.46,571.688],[1069.46,674.775],[1324.28,571.307],[1324.28,673.183]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1069.46,686.669],[1069.46,789.756],[1324.28,684.937],[1324.28,786.813]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1069.27,808.705],[1069.27,911.738],[1323.97,805.542],[1323.97,907.365]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1127.54,313.306],[1127.54,212.661],[1168.15,314.598],[1168.15,214.529]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1168.15,314.598],[1168.15,214.529],[1223.04,316.588],[1223.04,217.406]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1215.07,320.073],[1215.07,222.442],[1272.11,320.653],[1272.11,223.281]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1272.11,320.653],[1272.11,223.281],[1313.69,326.43],[1313.69,231.631]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1313.69,326.43],[1313.69,231.631],[1334.14,333.681],[1334.14,242.112]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1324.28,438.762],[1324.28,336.886],[1375.23,441.107],[1375.23,341.609]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1324.28,554.312],[1324.28,452.436],[1375.23,553.961],[1375.23,454.463]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1324.28,571.307],[1324.28,673.183],[1375.23,570.559],[1375.23,670.057]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1324.28,684.937],[1324.28,786.813],[1375.23,681.537],[1375.23,781.035]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1323.97,805.542],[1323.97,907.365],[1374.72,799.283],[1374.72,898.713]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1334.14,333.681],[1334.14,242.112],[1343.02,343.733],[1343.02,256.641]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1357.59,443.722],[1357.59,346.876],[1400.74,443.915],[1400.74,347.264]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1357.59,569.725],[1357.59,666.572],[1400.74,569.664],[1400.74,666.315]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1357.59,677.746],[1357.59,774.592],[1400.74,677.467],[1400.74,774.118]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1357.93,792.679],[1357.93,889.584],[1402.7,792.149],[1402.7,888.852]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1363.55,778.804],[1363.55,870.403],[1433.52,778.021],[1433.52,869.32]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1364.71,448.911],[1364.71,357.325],[1434.97,449.208],[1434.97,357.922]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1364.71,568.07],[1364.71,659.656],[1434.97,567.975],[1434.97,659.261]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1364.71,670.224],[1364.71,761.81],[1434.97,669.794],[1434.97,761.079]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1357.59,553.569],[1357.59,456.722],[1400.74,553.54],[1400.74,456.888]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:46,
                    verts:[[1364.71,552.791],[1364.71,461.205],[1434.97,552.747],[1434.97,461.461]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,444.374],[646.588,348.187],[603.117,448.802],[603.117,357.105]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,553.471],[646.588,457.285],[603.117,552.807],[603.117,461.111]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,569.517],[646.588,665.704],[603.117,568.105],[603.117,659.801]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,676.802],[646.588,772.988],[603.117,670.381],[603.117,762.078]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[621.637,452.391],[621.637,361.286],[608.565,464.569],[608.565,386.238]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[621.637,570.923],[621.637,662.028],[608.565,566.483],[608.565,644.815]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[621.637,672.54],[621.637,763.645],[608.565,653.852],[608.565,732.184]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[621.637,555.725],[621.637,464.62],[608.565,553.415],[608.565,475.084]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[615.699,754.194],[615.699,836.383],[611.712,744.378],[611.712,822.814]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[625.356,777.971],[625.356,869.252],[620.463,765.925],[620.463,852.599]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[625.282,744.161],[625.282,822.513],[621.146,735.414],[621.146,810.422]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[625.356,777.971],[641.128,777.677],[625.356,869.252],[641.128,868.845]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[647.297,790.724],[647.297,886.881],[641.128,777.677],[641.128,868.845]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,444.374],[722.58,444.939],[646.588,348.187],[722.58,349.325]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,553.471],[646.588,457.285],[722.58,553.386],[722.58,457.773]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,569.517],[646.588,665.704],[722.58,569.337],[722.58,664.951]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[646.588,676.802],[722.58,675.983],[646.588,772.988],[722.58,771.596]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[647.297,790.724],[722.944,789.233],[647.297,886.881],[722.944,884.82]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[672.47,345.163],[672.47,258.708],[664.687,355.648],[664.687,273.863]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[678.471,735.035],[678.471,809.898],[671.972,726.555],[671.972,798.175]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[679.706,343.075],[679.706,255.689],[672.47,345.163],[672.47,258.708]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[680.098,465.573],[680.098,390.877],[673.948,468.56],[673.948,396.893]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[680.098,562.755],[680.098,637.45],[673.948,561.802],[673.948,633.469]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[680.098,646.069],[680.098,720.764],[673.948,641.738],[673.948,713.405]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[703.513,335.66],[703.513,244.97],[679.706,343.075],[679.706,255.689]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[753.97,325.484],[753.97,230.264],[702.307,335.19],[702.307,244.293]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[706.048,726.054],[706.048,797.483],[702.82,722.66],[702.82,792.791]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[706.82,468.742],[706.82,397.26],[703.417,470.087],[703.417,399.969]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[706.82,561.744],[706.82,633.226],[703.417,561.315],[703.417,631.434]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[706.82,641.473],[706.82,712.955],[703.417,639.524],[703.417,709.642]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[731.124,803.726],[731.124,904.855],[719.441,788.484],[719.441,883.784]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,439.546],[733.683,338.465],[722.58,444.939],[722.58,349.325]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,554.195],[733.683,453.114],[722.58,553.386],[722.58,457.773]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,571.057],[733.683,672.138],[722.58,569.337],[722.58,664.951]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,683.801],[733.683,784.882],[722.58,675.983],[722.58,771.596]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[731.124,803.726],[778.964,802.728],[731.124,904.855],[778.964,903.475]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,439.546],[779.781,439.908],[733.683,338.465],[779.781,339.195]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,554.195],[733.683,453.114],[779.781,554.14],[779.781,453.427]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,571.057],[733.683,672.138],[779.781,570.942],[779.781,671.655]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[733.683,683.801],[779.781,683.275],[733.683,784.882],[779.781,783.988]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[805.243,318.923],[805.243,220.78],[753.97,325.484],[753.97,230.264]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[786.861,437.11],[786.861,333.56],[779.781,439.908],[779.781,339.195]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[786.861,554.56],[786.861,451.01],[779.781,554.14],[779.781,453.427]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[786.861,571.834],[786.861,675.385],[779.781,570.942],[779.781,671.655]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[786.861,687.332],[786.861,790.882],[779.781,683.275],[779.781,783.988]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[785.679,809.79],[785.679,913.237],[778.964,802.728],[778.964,903.475]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[859.434,814.138],[859.434,919.248],[785.679,809.79],[785.679,913.237]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,435.487],[860.704,330.291],[786.861,437.11],[786.861,333.56]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,554.803],[860.704,449.607],[786.861,554.56],[786.861,451.01]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,572.352],[860.704,677.548],[786.861,571.834],[786.861,675.385]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,689.685],[860.704,794.881],[786.861,687.332],[786.861,790.882]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[871.039,314.461],[871.039,214.33],[805.243,318.923],[805.243,220.78]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[813.762,380.22],[813.762,309.381],[810.594,381.986],[810.594,311.933]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[859.434,814.138],[859.434,919.248],[1117.37,808.487],[1117.37,911.437]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,435.487],[860.704,330.291],[1118.82,437.622],[1118.82,334.59]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,554.803],[860.704,449.607],[1118.82,554.483],[1118.82,451.452]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,572.352],[860.704,677.548],[1118.82,571.671],[1118.82,674.703]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[860.704,689.685],[860.704,794.88],[1118.82,686.59],[1118.82,789.622]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[871.039,314.461],[929.865,315.516],[871.039,214.33],[929.865,215.855]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[936.308,311.925],[936.308,210.665],[929.865,315.516],[929.865,215.855]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[997.869,311.579],[936.308,311.925],[997.869,210.165],[936.308,210.665]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[997.869,311.579],[1042.11,311.498],[997.869,210.165],[1042.11,210.048]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1042.11,311.498],[1107.36,311.818],[1042.11,210.048],[1107.36,210.511]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1111.97,311.903],[1111.97,210.634],[1172.23,313.895],[1172.23,213.512]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1120.27,437.634],[1120.27,334.614],[1367.92,439.682],[1367.92,338.739]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1120.27,554.481],[1120.27,451.462],[1367.92,554.174],[1367.92,453.231]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1120.27,571.667],[1120.27,674.687],[1367.92,571.014],[1367.92,671.957]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1120.27,686.573],[1120.27,789.592],[1367.92,683.603],[1367.92,784.546]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1119.97,808.531],[1119.97,911.497],[1367.49,803.106],[1367.49,903.998]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1172.23,313.895],[1172.23,213.512],[1210.97,315.489],[1210.97,215.817]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1210.97,315.489],[1210.97,215.817],[1262.94,317.879],[1262.94,219.271]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1251.63,321.285],[1251.63,224.195],[1306.95,322.277],[1306.95,225.628]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1306.95,322.277],[1306.95,225.628],[1341.81,328.304],[1341.81,234.34]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1341.81,328.304],[1341.81,234.34],[1354.54,335.631],[1354.54,244.93]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1367.92,439.682],[1367.92,338.739],[1412.17,442.171],[1412.17,343.752]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1367.92,554.174],[1367.92,453.231],[1412.17,553.801],[1412.17,455.382]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1367.92,571.014],[1367.92,671.957],[1412.17,570.22],[1412.17,668.639]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1367.92,683.603],[1367.92,784.546],[1412.17,679.995],[1412.17,778.414]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1367.49,803.106],[1367.49,903.998],[1411.53,796.468],[1411.53,894.822]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1383.23,776.299],[1383.23,866.941],[1450.45,774.974],[1450.45,865.109]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1384.34,449.859],[1384.34,359.234],[1451.82,450.361],[1451.82,360.244]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1384.34,567.768],[1384.34,658.393],[1451.82,567.607],[1451.82,657.724]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1384.34,668.849],[1384.34,759.474],[1451.82,668.122],[1451.82,758.238]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1389.13,444.702],[1389.13,348.849],[1430.59,445.029],[1430.59,349.506]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1389.13,569.412],[1389.13,665.266],[1430.59,569.308],[1430.59,664.831]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1389.13,676.325],[1389.13,772.178],[1430.59,675.852],[1430.59,771.375]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1389.58,790.077],[1389.58,885.987],[1432.61,789.179],[1432.61,884.745]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1389.13,553.422],[1389.13,457.569],[1430.59,553.373],[1430.59,457.851]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:47,
                    verts:[[1384.34,552.649],[1384.34,462.024],[1451.82,552.574],[1451.82,462.457]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[641.382,450.976],[641.382,358.387],[598.762,463.335],[598.762,383.709]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[641.382,555.993],[641.382,463.404],[598.762,553.649],[598.762,474.023]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[641.382,571.439],[641.382,664.028],[598.762,566.933],[598.762,646.559]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[641.382,674.711],[641.382,767.299],[598.762,655.746],[598.762,735.372]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[614.901,757.706],[614.901,841.238],[602.228,747.746],[602.228,827.469]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[615.948,747.427],[615.948,827.029],[604.062,738.558],[604.062,814.768]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,442.903],[678.531,345.226],[623.757,447.27],[623.757,354.019]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,553.691],[678.531,456.014],[623.757,553.037],[623.757,459.787]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,569.986],[678.531,667.664],[623.757,568.593],[623.757,661.844]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,678.933],[678.531,776.611],[623.757,672.603],[623.757,765.854]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[645.592,781.828],[645.592,874.584],[630.044,769.608],[630.044,857.692]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[645.592,781.828],[661.474,781.397],[645.592,874.584],[661.474,873.988]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[662.381,737.781],[662.381,813.694],[648.339,729.214],[648.339,801.851]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[663.659,464.544],[663.659,388.805],[650.464,467.561],[650.464,394.881]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[663.659,563.083],[663.659,638.822],[650.464,562.121],[650.464,634.8]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[663.659,647.56],[663.659,723.299],[650.464,643.186],[650.464,715.866]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[679.188,794.615],[679.188,892.26],[661.474,781.397],[661.474,873.988]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[682.725,342.362],[682.725,254.659],[664.109,352.963],[664.109,269.982]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[682.679,728.484],[682.679,800.841],[676.427,725.062],[676.427,796.111]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[683.587,467.827],[683.587,395.417],[677.008,469.183],[677.008,398.147]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[683.587,562.036],[683.587,634.446],[677.008,561.604],[677.008,632.639]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[683.587,642.8],[683.587,715.21],[677.008,640.835],[677.008,711.87]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,442.903],[678.531,345.226],[754.686,443.728],[754.686,346.886]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,553.691],[678.531,456.014],[754.686,553.568],[754.686,456.727]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,569.986],[678.531,667.664],[754.686,569.723],[754.686,666.565]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[678.531,678.933],[678.531,776.611],[754.686,677.738],[754.686,774.579]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[679.188,794.615],[754.996,792.439],[679.188,892.26],[754.996,889.252]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[692.238,340.291],[692.238,251.664],[682.726,342.362],[682.726,254.659]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[724.046,332.927],[724.046,241.02],[692.238,340.291],[692.238,251.664]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[785.671,322.974],[785.671,226.636],[723.291,332.442],[723.291,240.321]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[775.955,807.068],[775.955,909.475],[750.78,791.71],[750.78,888.244]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,438.295],[778.444,335.946],[754.686,443.728],[754.686,346.886]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,554.382],[778.444,452.033],[754.686,553.568],[754.686,456.727]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,571.456],[778.444,673.805],[754.686,569.723],[754.686,666.565]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,685.614],[778.444,787.963],[754.686,677.738],[754.686,774.579]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[775.955,807.068],[823.601,805.618],[775.955,909.475],[823.601,907.471]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,438.295],[778.444,335.946],[824.35,438.821],[824.35,337.006]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,554.382],[778.444,452.033],[824.35,554.303],[824.35,452.488]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,571.456],[778.444,673.805],[824.35,571.288],[824.35,673.103]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[778.444,685.614],[778.444,787.963],[824.35,684.851],[824.35,786.666]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[844.254,316.716],[844.254,217.59],[785.671,322.974],[785.671,226.636]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[790.735,378.747],[790.735,307.251],[785.74,380.513],[785.74,309.805]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[836.551,812.707],[836.551,917.269],[823.601,805.618],[823.601,907.471]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[837.981,436.013],[837.981,331.35],[824.35,438.822],[824.35,337.006]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[837.981,554.724],[837.981,450.062],[824.35,554.303],[824.35,452.488]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[837.981,572.184],[837.981,676.847],[824.35,571.288],[824.35,673.104]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[837.981,688.923],[837.981,793.586],[824.35,684.851],[824.35,786.666]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[914.775,816.409],[914.775,922.388],[836.551,812.707],[836.551,917.269]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,434.634],[916.247,328.574],[837.981,436.013],[837.981,331.35]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,554.931],[916.247,448.87],[837.981,554.724],[837.981,450.062]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,572.624],[916.247,678.684],[837.981,572.184],[837.981,676.847]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,690.922],[916.247,796.982],[837.981,688.923],[837.981,793.585]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[915.132,312.712],[915.132,211.802],[844.254,316.716],[844.254,217.59]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[914.775,816.409],[914.775,922.388],[1167.28,808.331],[1167.28,911.221]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[915.132,312.712],[915.132,211.802],[973.137,314.229],[973.137,213.995]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,434.634],[916.247,328.574],[1168.9,437.686],[1168.9,334.719]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,554.931],[916.247,448.87],[1168.9,554.474],[1168.9,451.507]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,572.624],[916.247,678.684],[1168.9,571.651],[1168.9,674.617]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[916.247,690.922],[916.247,796.982],[1168.9,686.497],[1168.9,789.464]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[983.221,310.662],[983.221,208.839],[973.137,314.229],[973.137,213.995]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[983.221,310.662],[1045.1,310.793],[983.221,208.839],[1045.1,209.028]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1045.1,310.793],[1089.24,311.054],[1045.1,209.029],[1089.24,209.406]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1089.24,311.054],[1089.24,209.406],[1153.67,311.88],[1153.67,210.599]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1158.14,312],[1158.14,210.774],[1215.67,314.453],[1215.67,214.319]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1170.31,437.703],[1170.31,334.753],[1408.56,440.581],[1408.56,340.549]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1170.31,554.471],[1170.31,451.522],[1408.56,554.04],[1408.56,454.008]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1170.31,571.645],[1170.31,674.595],[1408.56,570.727],[1408.56,670.759]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1170.31,686.473],[1170.31,789.422],[1408.56,682.301],[1408.56,782.333]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1169.89,808.351],[1169.89,911.248],[1408.03,800.728],[1408.03,900.711]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1215.67,314.453],[1215.67,214.319],[1252.21,316.338],[1252.21,217.044]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1252.21,316.338],[1252.21,217.044],[1300.82,319.109],[1300.82,221.049]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1286.32,322.419],[1286.32,225.834],[1339.48,323.809],[1339.48,227.843]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1339.48,323.809],[1339.48,227.843],[1367.47,330.048],[1367.47,236.861]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1367.47,330.048],[1367.47,236.861],[1372.56,337.411],[1372.56,247.504]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1400.36,774],[1400.36,863.762],[1464.44,772.16],[1464.44,861.219]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1401.4,450.73],[1401.4,360.987],[1465.73,451.426],[1465.73,362.389]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1401.4,567.49],[1401.4,657.233],[1465.73,567.268],[1465.73,656.305]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1401.4,667.587],[1401.4,757.33],[1465.73,666.578],[1465.73,755.614]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1408.03,800.728],[1408.03,900.711],[1445.12,793.763],[1445.12,891.083]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1408.56,440.581],[1408.56,340.549],[1445.9,443.194],[1445.9,345.811]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1408.56,554.04],[1408.56,454.008],[1445.9,553.648],[1445.9,456.266]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1408.56,570.727],[1408.56,670.759],[1445.9,569.894],[1445.9,667.276]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1408.56,682.301],[1408.56,782.333],[1445.9,678.512],[1445.9,775.894]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1417.77,445.63],[1417.77,350.718],[1457.26,446.083],[1457.26,351.63]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1417.77,569.117],[1417.77,664.029],[1457.26,568.972],[1457.26,663.425]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1417.77,674.98],[1417.77,769.893],[1457.26,674.323],[1457.26,768.776]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1418.34,787.612],[1418.34,882.579],[1459.32,786.365],[1459.32,880.855]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1417.77,553.283],[1417.77,458.37],[1457.26,553.215],[1457.26,458.762]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:48,
                    verts:[[1401.4,552.519],[1401.4,462.776],[1465.73,552.414],[1465.73,463.377]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[607.942,751.11],[607.942,832.12],[587.954,742.146],[587.954,819.728]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[663.816,449.456],[663.816,355.274],[590.342,461.946],[590.342,380.862]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[663.816,556.281],[663.816,462.099],[590.342,553.913],[590.342,472.83]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[663.816,571.993],[663.816,666.176],[590.342,567.44],[590.342,648.523]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[663.816,677.043],[663.816,771.226],[590.342,657.878],[590.342,738.961]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[615.883,761.607],[615.883,846.631],[594.128,751.537],[594.128,832.709]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[647.087,740.943],[647.087,818.065],[625.201,732.314],[625.201,806.137]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[647.995,463.357],[647.995,386.416],[627.476,466.396],[627.476,392.536]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[647.995,563.462],[647.995,640.403],[627.476,562.492],[627.476,636.353]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[647.995,649.28],[647.995,726.221],[627.476,644.874],[627.476,718.735]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[668.511,785.97],[668.511,880.309],[641.861,773.633],[641.861,863.255]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,441.355],[713.487,342.108],[647.272,445.627],[647.272,350.711]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,553.924],[713.487,454.677],[647.272,553.283],[647.272,458.367]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,570.48],[713.487,669.727],[647.272,569.118],[647.272,664.034]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,681.178],[713.487,780.425],[647.272,674.985],[647.272,769.901]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[660.757,466.751],[660.757,393.25],[650.882,468.114],[650.882,395.995]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[660.757,562.379],[660.757,635.88],[650.882,561.945],[650.882,634.064]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[660.757,644.361],[660.757,717.862],[650.882,642.385],[650.882,714.504]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[659.709,731.341],[659.709,804.791],[650.321,727.9],[650.321,800.035]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[665.049,349.963],[665.049,265.647],[660.862,358.793],[660.862,278.409]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[694.904,339.291],[694.904,250.22],[665.049,349.963],[665.049,265.647]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[668.511,785.97],[684.387,785.394],[668.511,880.309],[684.387,879.513]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[714.084,798.713],[714.084,897.925],[684.387,785.394],[684.387,879.513]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[706.737,337.248],[706.737,247.266],[694.904,339.291],[694.904,250.22]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[746.685,329.981],[746.685,236.762],[706.737,337.248],[706.737,247.266]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,441.355],[713.487,342.108],[789.154,442.451],[789.154,344.315]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,553.924],[713.487,454.677],[789.154,553.759],[789.154,455.624]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,570.48],[713.487,669.727],[789.154,570.131],[789.154,668.266]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[713.487,681.178],[713.487,780.425],[789.154,679.589],[789.154,777.725]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[714.084,798.713],[714.084,897.925],[789.405,795.82],[789.405,893.926]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[819.453,320.322],[819.453,222.802],[746.407,329.482],[746.407,236.042]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[767.792,376.936],[767.792,304.634],[760.925,378.699],[760.925,307.182]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[823.488,810.496],[823.488,914.213],[784.481,795.116],[784.481,892.952]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,437.012],[825.882,333.362],[789.154,442.451],[789.154,344.315]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,554.574],[825.882,450.924],[789.154,553.759],[789.154,455.624]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,571.866],[825.882,675.516],[789.154,570.131],[789.154,668.266]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,687.475],[825.882,791.125],[789.154,679.589],[789.154,777.725]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[885.102,314.423],[885.102,214.275],[819.453,320.322],[819.453,222.802]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[823.488,810.496],[870.469,808.579],[823.488,914.213],[870.469,911.563]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,437.012],[825.882,333.362],[871.142,437.708],[871.142,334.764]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,554.574],[825.882,450.924],[871.142,554.47],[871.142,451.526]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,571.866],[825.882,675.516],[871.142,571.643],[871.142,674.587]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[825.882,687.475],[825.882,791.125],[871.142,686.465],[871.142,789.409]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[889.755,815.646],[889.755,921.333],[870.469,808.579],[870.469,911.563]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[891.427,434.908],[891.427,329.125],[871.142,437.708],[871.142,334.764]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[891.427,554.89],[891.427,449.107],[871.142,554.47],[871.142,451.526]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[891.427,572.537],[891.427,678.32],[871.142,571.643],[871.142,674.588]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[891.427,690.525],[891.427,796.307],[871.142,686.465],[871.142,789.409]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[960.565,310.923],[960.565,209.216],[885.102,314.423],[885.102,214.275]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[971.779,818.647],[971.779,925.481],[889.755,815.646],[889.755,921.333]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,433.795],[973.444,326.883],[891.427,434.908],[891.427,329.125]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,555.057],[973.444,448.145],[891.427,554.89],[891.427,449.107]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,572.892],[973.444,679.803],[891.427,572.537],[891.427,678.32]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,692.138],[973.444,799.05],[891.427,690.525],[891.427,796.307]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[960.565,310.923],[960.565,209.216],[1017.18,312.909],[1017.18,212.087]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[971.779,818.647],[971.779,925.481],[1216.21,808.137],[1216.21,910.953]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,433.795],[973.444,326.883],[1217.98,437.764],[1217.98,334.877]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,555.057],[973.444,448.145],[1217.98,554.462],[1217.98,451.575]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,572.892],[973.444,679.803],[1217.98,571.626],[1217.98,674.513]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[973.444,692.138],[973.444,799.05],[1217.98,686.384],[1217.98,789.271]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1030.89,309.389],[1030.89,206.999],[1017.18,312.909],[1017.18,212.087]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1030.89,309.389],[1092.51,310.009],[1030.89,206.999],[1092.51,207.895]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1092.51,310.009],[1136.13,310.618],[1092.51,207.895],[1136.13,208.776]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1136.13,310.618],[1136.13,208.776],[1199.11,311.949],[1199.11,210.7]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1203.41,312.105],[1203.41,210.925],[1257.66,315.005],[1257.66,215.116]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1219.34,437.786],[1219.34,334.921],[1446.04,441.466],[1446.04,342.332]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1219.34,554.458],[1219.34,451.594],[1446.04,553.907],[1446.04,454.773]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1219.34,571.619],[1219.34,674.484],[1446.04,570.445],[1446.04,669.579]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1219.34,686.352],[1219.34,789.217],[1446.04,681.017],[1446.04,780.151]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1218.8,808.133],[1218.8,910.948],[1445.42,798.387],[1445.42,897.474]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1257.66,315.005],[1257.66,215.116],[1291.67,317.168],[1291.67,218.243]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1291.67,317.168],[1291.67,218.243],[1336.52,320.299],[1336.52,222.769]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1319,323.495],[1319,227.389],[1369.58,325.269],[1369.58,229.953]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1369.58,325.269],[1369.58,229.953],[1390.59,331.681],[1390.59,239.221]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1414.86,771.883],[1414.86,860.836],[1475.46,769.555],[1475.46,857.618]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1415.83,451.531],[1415.83,362.6],[1476.66,452.412],[1476.66,364.375]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1415.83,567.234],[1415.83,656.165],[1476.66,566.953],[1476.66,654.99]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1415.83,666.426],[1415.83,755.356],[1476.66,665.148],[1476.66,753.185]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1443.42,446.514],[1443.42,352.497],[1480.68,447.087],[1480.68,353.652]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1443.42,568.835],[1443.42,662.851],[1480.68,568.652],[1480.68,662.087]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1443.42,673.699],[1443.42,767.715],[1480.68,672.867],[1480.68,766.303]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1444.1,785.263],[1444.1,879.332],[1482.75,783.685],[1482.75,877.151]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1446.04,441.466],[1446.04,342.332],[1476.28,444.184],[1476.28,347.805]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1446.04,553.907],[1446.04,454.773],[1476.28,553.5],[1476.28,457.121]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1446.04,570.445],[1446.04,669.579],[1476.28,569.578],[1476.28,665.957]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1446.04,681.017],[1446.04,780.151],[1476.28,677.077],[1476.28,773.455]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1445.42,798.387],[1445.42,897.474],[1475.39,791.146],[1475.39,887.465]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:49,
                    verts:[[1443.42,553.15],[1443.42,459.134],[1480.68,553.065],[1480.68,459.629]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[601.429,755.214],[601.429,837.793],[572.956,746.189],[572.956,825.317]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[689.132,447.841],[689.132,351.964],[583.482,460.399],[583.482,377.694]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[689.132,556.588],[689.132,460.711],[583.482,554.206],[583.482,471.501]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[689.132,572.582],[689.132,668.459],[583.482,568.003],[583.482,650.709]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[689.132,679.521],[689.132,775.398],[583.482,660.251],[583.482,742.957]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[618.842,765.893],[618.842,852.555],[587.587,755.755],[587.587,838.542]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[632.694,744.53],[632.694,823.024],[602.627,735.869],[602.627,811.051]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[633.208,462.011],[633.208,383.704],[605.051,465.061],[605.051,389.846]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[633.208,563.891],[633.208,642.198],[605.051,562.918],[605.051,638.133]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[633.208,651.233],[633.208,729.539],[605.051,646.811],[605.051,722.025]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[638.381,465.509],[638.381,390.749],[625.076,466.875],[625.076,393.5]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[638.381,562.775],[638.381,637.535],[625.076,562.34],[625.076,635.715]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[637.19,734.637],[637.19,809.348],[624.536,731.19],[624.536,804.582]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[638.381,646.161],[638.381,720.921],[625.076,644.181],[625.076,717.556]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[667.669,346.655],[667.669,260.865],[654.325,355.645],[654.325,273.859]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[694.3,790.368],[694.3,886.389],[656.115,777.983],[656.115,869.268]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[709.165,335.964],[709.165,245.412],[667.669,346.655],[667.669,260.865]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,439.744],[751.58,338.865],[673.867,443.884],[673.867,347.201]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,554.165],[751.58,453.285],[673.867,553.545],[673.867,456.862]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,570.994],[751.58,671.874],[673.867,569.674],[673.867,666.356]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,683.513],[751.58,784.392],[673.867,677.512],[673.867,774.194]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[694.3,790.368],[710.038,789.64],[694.3,886.389],[710.038,885.382]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[723.354,333.964],[723.354,242.519],[709.165,335.964],[709.165,245.412]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[752.109,802.975],[752.109,903.816],[710.038,789.64],[710.038,885.382]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[771.543,326.845],[771.543,232.229],[723.354,333.964],[723.354,242.519]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[744.943,374.783],[744.943,301.523],[736.151,376.537],[736.151,304.057]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,439.744],[751.58,338.865],[826.036,441.124],[826.036,341.644]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,554.165],[751.58,453.285],[826.036,553.958],[826.036,454.478]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,570.994],[751.58,671.874],[826.036,570.554],[826.036,670.034]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[751.58,683.513],[751.58,784.392],[826.036,681.512],[826.036,780.993]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[752.109,802.975],[752.109,903.816],[826.221,799.334],[826.221,898.783]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[855.344,317.563],[855.344,218.814],[771.767,326.334],[771.767,231.493]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[873.688,813.953],[873.688,918.993],[820.603,798.661],[820.603,897.853]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,435.717],[875.955,330.755],[826.036,441.124],[826.036,341.644]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,554.768],[875.955,449.806],[826.036,553.958],[826.036,454.478]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,572.279],[875.955,677.241],[826.036,570.554],[826.036,670.034]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,689.351],[875.955,794.313],[826.036,681.512],[826.036,780.993]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[927.732,312.084],[927.732,210.894],[855.344,317.563],[855.344,218.814]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[873.688,813.953],[873.688,918.993],[919.492,811.555],[919.492,915.678]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,435.717],[875.955,330.755],[920.078,436.588],[920.078,332.509]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,554.768],[875.955,449.806],[920.078,554.638],[920.078,450.559]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,572.278],[875.955,677.24],[920.078,572.001],[920.078,676.08]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[875.955,689.351],[875.955,794.313],[920.078,688.088],[920.078,792.167]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[945.154,818.547],[945.154,925.343],[919.492,811.555],[919.492,915.678]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[947.06,433.818],[947.06,326.931],[920.078,436.589],[920.078,332.509]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[947.06,555.053],[947.06,448.166],[920.078,554.638],[920.078,450.559]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[947.06,572.884],[947.06,679.772],[920.078,572.001],[920.078,676.08]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[947.06,692.104],[947.06,798.992],[920.078,688.088],[920.078,792.167]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1007.2,309.137],[1007.2,206.635],[927.732,312.084],[927.732,210.894]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1030.21,820.788],[1030.21,928.441],[945.154,818.547],[945.154,925.343]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,432.992],[1032.06,325.267],[947.06,433.818],[947.06,326.931]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,555.177],[1032.06,447.452],[947.06,555.053],[947.06,448.166]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,573.148],[1032.06,680.873],[947.06,572.884],[947.06,679.772]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,693.302],[1032.06,801.027],[947.06,692.104],[947.06,798.992]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1007.2,309.137],[1007.2,206.635],[1061.84,311.596],[1061.84,210.19]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1030.21,820.788],[1030.21,928.441],[1263.87,807.864],[1263.87,910.576]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,432.992],[1032.06,325.267],[1265.78,437.873],[1265.78,335.096]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,555.177],[1032.06,447.452],[1265.78,554.445],[1265.78,451.669]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,573.148],[1032.06,680.873],[1265.78,571.591],[1265.78,674.368]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1032.06,693.302],[1032.06,801.027],[1265.78,686.226],[1265.78,789.002]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1079.13,308.15],[1079.13,205.208],[1061.84,311.596],[1061.84,210.19]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1079.13,308.15],[1079.13,205.208],[1139.86,309.267],[1139.86,206.824]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1139.86,309.268],[1139.86,206.824],[1182.52,310.228],[1182.52,208.211]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1182.52,310.228],[1182.52,208.211],[1243.42,312.062],[1243.42,210.863]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1247.51,312.252],[1247.51,211.137],[1297.95,315.582],[1297.95,215.95]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1266.42,807.836],[1266.42,910.537],[1479.43,796.049],[1479.43,894.243]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1267.06,437.9],[1267.06,335.15],[1480.14,442.35],[1480.14,344.111]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1267.06,554.441],[1267.06,451.692],[1480.14,553.774],[1480.14,455.536]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1267.06,571.582],[1267.06,674.332],[1480.14,570.163],[1480.14,668.401]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1267.06,686.187],[1267.06,788.937],[1480.14,679.736],[1480.14,777.974]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1297.95,315.582],[1297.95,215.951],[1329.14,318.008],[1329.14,219.458]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1329.14,318.008],[1329.14,219.457],[1369.85,321.477],[1369.85,224.472]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1349.46,324.541],[1349.46,228.9],[1397.07,326.683],[1397.07,231.997]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1397.07,326.683],[1397.07,231.997],[1411.04,333.228],[1411.04,241.457]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1426.67,769.922],[1426.67,858.124],[1483.44,767.131],[1483.44,854.267]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1427.56,452.274],[1427.56,364.096],[1484.54,453.33],[1484.54,366.223]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1427.56,566.997],[1427.56,655.175],[1484.54,566.66],[1484.54,653.767]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1427.56,665.349],[1427.56,753.526],[1484.54,663.818],[1484.54,750.924]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1465.94,447.365],[1465.94,354.211],[1500.73,448.052],[1500.73,355.594]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1465.94,568.563],[1465.94,661.717],[1500.73,568.344],[1500.73,660.802]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1465.94,672.465],[1465.94,765.619],[1500.73,671.469],[1500.73,763.927]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:50,
                    verts:[[1466.71,783.001],[1466.71,876.204],[1502.8,781.11],[1502.8,873.592]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[561.658,455.621],[561.658,370.836],[559.038,459.457],[559.038,378.561]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[561.658,551.786],[561.658,467.001],[559.038,551.211],[559.038,470.315]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[561.658,565.93],[561.658,650.714],[559.038,564.706],[559.038,645.601]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[561.658,660.496],[561.658,745.28],[559.038,654.935],[559.038,735.83]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[596.623,759.736],[596.623,844.044],[559.258,750.694],[559.258,831.545]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[717.518,446.147],[717.518,348.493],[578.41,458.696],[578.41,374.204]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[717.518,556.909],[717.518,459.255],[578.41,554.529],[578.41,470.037]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[717.518,573.2],[717.518,670.854],[578.41,568.624],[578.41,653.116]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[717.518,682.121],[717.518,779.775],[578.41,662.865],[578.41,747.357]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[619.35,748.545],[619.35,828.574],[580.733,739.891],[580.733,816.611]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[624.015,770.55],[624.015,858.992],[582.832,760.401],[582.832,844.963]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[619.446,460.502],[619.446,380.667],[583.307,463.549],[583.307,386.803]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[619.446,564.372],[619.446,644.208],[583.307,563.401],[583.307,640.147]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[619.446,653.419],[619.446,733.255],[583.307,649.002],[583.307,725.748]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[616.559,464.098],[616.559,387.908],[599.672,465.461],[599.672,390.653]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[616.559,563.225],[616.559,639.415],[599.672,562.791],[599.672,637.599]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[649.013,352.239],[649.013,268.936],[646.003,360.716],[646.003,281.189]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[672.159,343.05],[672.159,255.653],[649.196,352.162],[649.196,268.825]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[725.679,332.408],[725.679,240.271],[672.159,343.05],[672.159,255.653]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[723.143,794.978],[723.143,892.762],[673.033,782.629],[673.033,875.691]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,438.096],[792.902,335.544],[703.75,442.059],[703.75,343.526]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,554.412],[792.902,451.861],[703.75,553.818],[703.75,455.285]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,571.52],[792.902,674.071],[703.75,570.256],[703.75,668.789]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,685.903],[792.902,788.454],[703.75,680.158],[703.75,778.691]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[722.226,372.286],[722.226,297.913],[711.448,374.022],[711.448,300.422]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[723.143,794.978],[738.595,794.089],[723.143,892.762],[738.595,891.533]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[742.247,330.467],[742.247,237.464],[725.679,332.408],[725.679,240.271]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[793.352,807.339],[793.352,909.849],[738.595,794.089],[738.595,891.533]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[798.725,323.557],[798.725,227.476],[742.247,330.467],[742.247,237.464]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,438.096],[792.902,335.544],[865.343,439.77],[865.343,338.916]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,554.412],[792.902,451.861],[865.343,554.161],[865.343,453.307]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,571.52],[792.902,674.071],[865.343,570.986],[865.343,671.84]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[792.902,685.903],[792.902,788.454],[865.343,683.476],[865.343,784.33]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[793.352,807.339],[793.352,909.849],[865.458,802.922],[865.458,903.743]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[893.331,314.746],[893.331,214.742],[799.475,323.037],[799.475,226.727]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[926.44,817.365],[926.44,923.709],[859.166,802.288],[859.166,902.867]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,434.441],[928.551,328.184],[865.343,439.77],[865.343,338.916]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,554.96],[928.551,448.703],[865.343,554.161],[865.343,453.307]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,572.686],[928.551,678.942],[865.343,570.986],[865.343,671.84]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,691.202],[928.551,797.459],[865.343,683.476],[865.343,784.33]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[972.025,309.753],[972.025,207.525],[893.331,314.746],[893.331,214.742]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[926.44,817.365],[926.44,923.709],[970.517,814.476],[970.517,919.715]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,434.44],[928.551,328.184],[971.006,435.49],[971.006,330.297]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,554.96],[928.551,448.703],[971.006,554.802],[971.006,449.61]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,572.686],[928.551,678.942],[971.006,572.351],[971.006,677.544]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[928.551,691.202],[928.551,797.459],[971.006,689.681],[971.006,794.874]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1002.52,821.33],[1002.52,929.19],[970.517,814.476],[970.517,919.715]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1004.65,432.774],[1004.65,324.828],[971.006,435.49],[971.006,330.297]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1004.65,555.209],[1004.65,447.264],[971.006,554.802],[971.006,449.61]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1004.65,573.217],[1004.65,681.163],[971.006,572.351],[971.006,677.544]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1004.65,693.618],[1004.65,801.564],[971.006,689.681],[971.006,794.874]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1054.82,307.409],[1054.82,204.138],[972.025,309.753],[972.025,207.525]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1089.74,822.755],[1002.52,821.33],[1089.74,931.161],[1002.52,929.19]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,432.256],[1091.75,323.785],[1004.65,432.774],[1004.65,324.828]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,555.287],[1091.75,446.816],[1004.65,555.209],[1004.65,447.264]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,573.383],[1091.75,681.854],[1004.65,573.217],[1004.65,681.163]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,694.369],[1004.65,693.618],[1091.75,802.84],[1004.65,801.564]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1054.82,307.409],[1054.82,204.138],[1106.87,310.342],[1106.87,208.377]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1089.74,822.755],[1089.74,931.161],[1309.88,807.458],[1309.88,910.014]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,432.256],[1091.75,323.785],[1311.91,438.033],[1311.91,335.418]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,555.287],[1091.75,446.816],[1311.91,554.422],[1311.91,451.807]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,573.383],[1091.75,681.854],[1311.91,571.54],[1311.91,674.155]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1091.75,694.369],[1091.75,802.84],[1311.91,685.994],[1311.91,788.609]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1127.64,306.997],[1127.64,203.542],[1106.87,310.342],[1106.87,208.377]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1127.64,306.997],[1127.64,203.542],[1186.83,308.62],[1186.83,205.887]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1186.83,308.62],[1186.83,205.888],[1228.08,309.931],[1228.08,207.783]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1228.08,309.931],[1228.08,207.783],[1286.28,312.263],[1286.28,211.153]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1290.1,312.486],[1290.1,211.476],[1336.25,316.225],[1336.25,216.88]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1312.36,807.406],[1312.36,909.942],[1509.79,793.68],[1509.79,890.968]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1313.1,438.064],[1313.1,335.481],[1510.59,443.246],[1510.59,345.916]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1313.1,554.417],[1313.1,451.834],[1510.59,553.64],[1510.59,456.31]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1313.1,571.53],[1313.1,674.113],[1510.59,569.877],[1510.59,667.207]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1313.1,685.949],[1313.1,788.532],[1510.59,678.437],[1510.59,775.767]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1336.25,316.225],[1336.25,216.88],[1364.31,318.897],[1364.31,220.742]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1364.31,318.897],[1364.31,220.742],[1400.54,322.679],[1400.54,226.209]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1377.48,325.59],[1377.48,230.417],[1421.74,328.083],[1421.74,234.021]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1421.74,328.083],[1421.74,234.021],[1428.63,334.718],[1428.63,243.611]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1435.63,768.083],[1435.63,855.582],[1488.28,764.857],[1488.28,851.123]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1436.44,452.97],[1436.44,365.498],[1489.27,454.191],[1489.27,367.957]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1436.44,566.775],[1436.44,654.247],[1489.27,566.386],[1489.27,652.62]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1436.44,664.34],[1436.44,751.812],[1489.27,662.569],[1489.27,748.803]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1485.14,448.196],[1485.14,355.885],[1517.22,448.989],[1517.22,357.482]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1485.14,568.298],[1485.14,660.609],[1517.22,568.045],[1517.22,659.553]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1485.14,671.26],[1485.14,763.571],[1517.22,670.11],[1517.22,761.618]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:51,
                    verts:[[1486.01,780.79],[1486.01,873.149],[1519.28,778.608],[1519.28,870.132]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[558.773,453.64],[558.773,366.848],[546.995,457.581],[546.995,374.784]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[558.773,552.082],[558.773,465.29],[546.995,551.492],[546.995,468.695]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[558.773,566.561],[558.773,653.353],[546.995,565.304],[546.995,648.101]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[558.773,663.367],[558.773,750.159],[546.995,657.654],[546.995,740.452]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[593.797,764.663],[593.797,850.855],[547.119,755.662],[547.119,838.413]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[607.265,752.984],[607.265,834.711],[559.704,744.387],[559.704,822.827]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[606.912,458.833],[606.912,377.306],[562.425,461.86],[562.425,383.401]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[606.912,551.304],[606.912,469.777],[562.425,550.851],[562.425,472.391]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[606.912,564.905],[606.912,646.432],[562.425,563.939],[562.425,642.399]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[606.912,655.839],[606.912,737.366],[562.425,651.451],[562.425,729.91]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[595.446,462.517],[595.446,384.723],[574.811,463.869],[574.811,387.447]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[595.446,563.73],[595.446,641.523],[574.811,563.299],[574.811,639.721]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[595.446,650.499],[595.446,728.293],[574.811,648.538],[574.811,724.96]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[593.959,742.583],[593.959,820.333],[574.325,739.169],[574.325,815.612]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[749.153,444.396],[749.153,344.906],[575.415,456.84],[575.415,370.402]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[749.153,557.241],[749.153,457.751],[575.415,554.881],[575.415,468.443]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[749.153,573.838],[749.153,673.329],[575.415,569.301],[575.415,655.74]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[749.153,684.808],[749.153,784.298],[575.415,665.713],[575.415,752.151]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[631.683,775.55],[631.682,865.905],[580.148,765.46],[580.148,851.957]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[645.427,348.435],[645.427,263.438],[633.534,357.111],[633.534,275.978]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[678.746,339.171],[678.746,250.047],[645.694,348.358],[645.694,263.326]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[744.627,328.659],[744.627,234.853],[678.746,339.171],[678.746,250.047]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[699.723,369.443],[699.723,293.804],[686.895,371.152],[686.895,296.273]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[755.208,799.736],[755.208,899.339],[692.857,787.528],[692.857,882.463]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,436.44],[837.483,332.21],[737.113,440.176],[737.113,339.734]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,554.66],[837.483,450.43],[737.113,554.1],[737.113,453.658]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,572.048],[837.483,676.278],[737.113,570.856],[737.113,671.298]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,688.304],[837.483,792.534],[737.113,682.887],[737.113,783.329]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[763.575,326.798],[763.575,232.161],[744.627,328.659],[744.627,234.853]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[755.208,799.736],[770.207,798.68],[755.208,899.339],[770.207,897.879]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[828.311,320.168],[828.311,222.577],[763.575,326.798],[763.575,232.161]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.846,811.722],[837.846,915.909],[770.207,798.68],[770.207,897.879]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[933.342,311.933],[933.342,210.677],[829.609,319.642],[829.609,221.82]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,436.44],[837.483,332.21],[907.027,438.416],[907.027,336.191]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,554.66],[837.483,450.43],[907.027,554.364],[907.027,452.138]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,572.048],[837.483,676.278],[907.027,571.418],[907.027,673.643]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.483,688.304],[837.483,792.534],[907.027,685.438],[907.027,787.664]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[837.846,811.722],[837.846,915.909],[907.069,806.507],[907.069,908.699]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[981.531,820.634],[981.531,928.228],[900.134,805.921],[900.134,907.889]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,433.217],[983.454,325.72],[907.027,438.416],[907.027,336.191]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,555.143],[983.454,447.646],[907.027,554.364],[907.027,452.138]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,573.076],[983.454,680.573],[907.027,571.418],[907.027,673.643]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,692.976],[983.454,800.472],[907.027,685.438],[907.027,787.664]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1017.79,307.499],[1017.79,204.267],[933.342,311.933],[933.342,210.677]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[981.531,820.634],[981.531,928.228],[1023.29,817.25],[1023.29,923.55]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,433.217],[983.454,325.72],[1023.68,434.446],[1023.68,328.195]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,555.143],[983.454,447.646],[1023.68,554.959],[1023.68,448.708]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,573.076],[983.454,680.573],[1023.68,572.684],[1023.68,678.935]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[983.454,692.976],[983.454,800.472],[1023.68,691.194],[1023.68,797.445]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1103.12,305.809],[1103.12,201.824],[1017.79,307.499],[1017.79,204.267]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,431.813],[1063.84,322.892],[1023.68,434.446],[1023.68,328.195]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,555.354],[1063.84,446.433],[1023.68,554.959],[1023.68,448.708]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,573.524],[1063.84,682.445],[1023.68,572.684],[1023.68,678.935]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,695.012],[1063.84,803.932],[1023.68,691.194],[1023.68,797.445]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1061.51,823.897],[1061.51,932.739],[1023.29,817.25],[1023.29,923.55]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1061.51,823.897],[1149.91,824.455],[1061.51,932.739],[1149.91,933.51]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,431.813],[1152.06,431.622],[1063.84,322.892],[1152.06,322.508]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,555.354],[1152.06,555.382],[1063.84,446.433],[1152.06,446.268]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,573.524],[1152.06,573.585],[1063.84,682.444],[1152.06,682.699]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1063.84,695.012],[1152.06,695.288],[1063.84,803.932],[1152.06,804.402]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1103.12,305.808],[1103.12,201.824],[1151.95,309.21],[1151.95,206.74]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1149.91,824.455],[1149.91,933.51],[1353.8,806.858],[1353.8,909.184]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1176.06,305.998],[1176.06,202.098],[1151.95,309.21],[1151.95,206.74]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1152.06,431.622],[1152.06,322.508],[1355.92,438.266],[1355.92,335.888]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1152.06,555.382],[1152.06,446.268],[1355.92,554.386],[1355.92,452.008]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1152.06,573.585],[1152.06,682.699],[1355.92,571.466],[1355.92,673.844]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1152.06,695.288],[1152.06,804.402],[1355.92,685.656],[1355.92,788.034]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1176.06,305.998],[1176.06,202.098],[1233.05,308.126],[1233.05,205.174]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1233.05,308.126],[1233.05,205.174],[1272.42,309.786],[1272.42,207.573]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1272.42,309.786],[1272.42,207.573],[1327.28,312.603],[1327.28,211.645]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1330.8,312.858],[1330.8,212.014],[1372.16,316.979],[1372.16,217.97]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1356.19,806.782],[1356.19,909.079],[1536.19,791.239],[1536.19,887.593]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1357.02,438.302],[1357.02,335.96],[1537.05,444.17],[1537.05,347.776]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1357.02,554.381],[1357.02,452.039],[1537.05,553.502],[1537.05,457.108]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1357.02,571.454],[1357.02,673.796],[1537.05,569.582],[1537.05,665.976]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1357.02,685.604],[1357.02,787.946],[1537.05,677.098],[1537.05,773.491]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1372.16,316.979],[1372.16,217.97],[1396.83,319.877],[1396.83,222.159]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1396.83,319.877],[1396.83,222.159],[1428.26,323.942],[1428.26,228.034]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1402.77,326.681],[1402.77,231.994],[1443.31,329.505],[1443.31,236.076]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1442.32,453.632],[1442.32,366.832],[1490.7,455.008],[1490.7,369.602]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1442.32,566.564],[1442.32,653.364],[1490.7,566.125],[1490.7,651.531]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1442.32,663.379],[1442.32,750.179],[1490.7,661.385],[1490.7,746.791]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1441.6,766.333],[1441.6,853.163],[1489.81,762.698],[1489.81,848.139]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1500.79,449.021],[1500.79,357.547],[1529.96,449.913],[1529.96,359.341]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1500.79,568.035],[1500.79,659.51],[1529.96,567.75],[1529.96,658.322]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1500.79,670.064],[1500.79,761.539],[1529.96,668.772],[1529.96,759.343]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:52,
                    verts:[[1501.74,778.595],[1501.74,870.114],[1531.99,776.142],[1531.99,866.724]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[558.443,451.507],[558.443,362.552],[536.85,455.534],[536.85,370.663]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[558.443,552.402],[558.443,463.447],[536.85,551.799],[536.85,466.927]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[558.443,567.242],[558.443,656.197],[536.85,565.957],[536.85,650.829]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[558.443,666.46],[558.443,755.415],[536.85,660.621],[536.85,745.493]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[593.277,769.971],[593.277,858.193],[536.869,761.084],[536.869,845.907]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[596.704,757.835],[596.704,841.417],[539.796,749.36],[539.796,829.701]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[595.873,457.008],[595.873,373.631],[542.662,459.992],[542.662,379.638]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[595.873,565.487],[595.873,648.865],[542.662,564.535],[542.662,644.889]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[595.873,658.485],[595.873,741.862],[542.662,654.16],[542.662,734.513]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[575.267,460.764],[575.267,381.193],[550.709,462.097],[550.709,383.877]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[575.267,653.04],[575.267,732.611],[550.709,651.108],[550.709,729.327]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[575.267,564.289],[575.267,643.859],[550.709,563.864],[550.709,642.083]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[595.873,551.578],[595.873,468.2],[542.662,551.131],[542.662,470.777]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[573.626,747.238],[573.626,826.768],[550.256,743.874],[550.256,822.116]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[784.166,442.62],[784.166,341.267],[574.846,454.841],[574.846,366.305]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[784.166,557.578],[784.166,456.225],[574.846,555.26],[574.846,466.725]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[784.166,574.486],[784.166,675.839],[574.846,570.03],[574.846,658.566]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[784.166,687.533],[784.166,788.886],[574.846,668.781],[574.846,757.317]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[642.156,780.852],[642.156,873.235],[579.88,770.909],[579.88,859.49]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[622.407,353.166],[622.407,270.275],[620.326,359.087],[620.326,278.835]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[643.728,344.331],[643.728,257.506],[622.407,353.166],[622.407,270.275]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[687.681,335.055],[687.681,244.098],[644.085,344.253],[644.085,257.393]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[677.566,366.258],[677.566,289.2],[662.621,367.928],[662.621,291.613]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[766.178,324.772],[766.178,229.234],[687.681,335.055],[687.681,244.098]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[790.615,804.556],[790.615,906.002],[715.822,792.614],[715.822,889.494]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[787.482,323.014],[787.482,226.691],[766.178,324.772],[766.178,229.234]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,434.817],[885.259,328.942],[774.099,438.269],[774.099,335.894]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,554.903],[885.259,449.028],[774.099,554.386],[774.099,452.011]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,572.566],[885.259,678.441],[774.099,571.464],[774.099,673.84]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,690.657],[885.259,796.532],[774.099,685.651],[774.099,788.027]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[860.333,316.745],[860.333,217.63],[787.482,323.014],[787.482,226.691]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[790.615,804.556],[804.973,803.327],[790.615,906.002],[804.973,904.303]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.525,816.018],[885.525,921.848],[804.973,803.327],[804.973,904.303]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[975.218,309.204],[975.218,206.732],[862.196,316.218],[862.196,216.87]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,434.817],[885.259,328.942],[950.95,437.1],[950.95,333.54]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,554.903],[885.259,449.028],[950.95,554.561],[950.95,451.001]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,572.566],[885.259,678.441],[950.95,571.837],[950.95,675.397]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.259,690.657],[885.259,796.532],[950.95,687.346],[950.95,790.906]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[885.525,816.018],[885.525,921.848],[950.913,809.994],[950.913,913.52]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1038.6,823.645],[1038.6,932.391],[943.382,809.464],[943.382,912.787]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,432.091],[1040.31,323.452],[950.95,437.1],[950.95,333.54]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,555.312],[1040.31,446.673],[950.95,554.561],[950.95,451.001]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,573.435],[1040.31,682.074],[950.95,571.837],[950.95,675.397]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,694.609],[1040.31,803.248],[950.95,687.346],[950.95,790.906]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1064.71,305.403],[1064.71,201.238],[975.218,309.204],[975.218,206.732]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1038.6,823.645],[1038.6,932.391],[1077.44,819.771],[1077.44,927.036]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,432.09],[1040.31,323.452],[1077.71,433.497],[1077.71,326.284]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,555.312],[1040.31,446.673],[1077.71,555.101],[1077.71,447.888]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,573.435],[1040.31,682.074],[1077.71,572.987],[1077.71,680.2]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1040.31,694.609],[1040.31,803.248],[1077.71,692.57],[1077.71,799.782]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1151.69,304.414],[1064.71,305.403],[1151.69,199.808],[1064.71,201.238]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1121.63,826.134],[1121.63,935.831],[1077.44,819.771],[1077.44,927.036]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,430.977],[1124.14,321.21],[1077.71,433.497],[1077.71,326.284]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,555.479],[1124.14,445.711],[1077.71,555.101],[1077.71,447.888]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,573.791],[1124.14,683.558],[1077.71,572.987],[1077.71,680.2]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,696.223],[1124.14,805.991],[1077.71,692.57],[1077.71,799.783]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1121.63,826.134],[1210.1,825.779],[1121.63,935.831],[1210.1,935.341]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,430.977],[1124.14,321.21],[1212.38,431.13],[1212.38,321.517]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,555.479],[1124.14,445.711],[1212.38,555.456],[1212.38,445.843]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,573.791],[1124.14,683.558],[1212.38,573.742],[1212.38,683.354]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1124.14,696.223],[1124.14,805.991],[1212.38,696.001],[1212.38,805.614]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1151.69,304.414],[1151.69,199.808],[1196.65,308.271],[1196.65,205.383]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1223.91,305.226],[1223.91,200.981],[1196.65,308.271],[1196.65,205.383]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1210.1,825.779],[1210.1,935.341],[1395.09,805.997],[1395.09,907.994]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1212.38,431.13],[1212.38,321.517],[1397.29,438.598],[1397.29,336.557]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1212.38,555.456],[1212.38,445.843],[1397.29,554.337],[1397.29,452.295]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1212.38,573.742],[1212.38,683.354],[1397.29,571.36],[1397.29,673.401]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1212.38,696.001],[1212.38,805.614],[1397.29,685.174],[1397.29,787.216]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1223.91,305.226],[1223.91,200.981],[1278,307.854],[1278,204.781]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1278,307.854],[1278,204.781],[1315.04,309.855],[1315.04,207.673]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1315.04,309.855],[1315.04,207.673],[1365.93,313.14],[1365.93,212.42]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1369.12,313.425],[1369.12,212.832],[1405.25,317.894],[1405.25,219.292]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1397.36,805.898],[1397.36,907.857],[1558.25,788.683],[1558.25,884.06]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1398.28,438.638],[1398.28,336.637],[1559.18,445.137],[1559.18,349.723]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1398.28,554.331],[1398.28,452.33],[1559.18,553.357],[1559.18,457.944]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1398.28,571.347],[1398.28,673.348],[1559.18,569.274],[1559.18,664.687]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1398.28,685.116],[1398.28,787.117],[1559.18,675.696],[1559.18,771.109]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1405.25,317.894],[1405.25,219.292],[1426.29,320.994],[1426.29,223.774]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1424.97,327.856],[1424.97,233.692],[1461.47,330.986],[1461.47,238.216]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1426.29,320.994],[1426.29,223.774],[1452.65,325.308],[1452.65,230.009]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1444.36,764.635],[1444.36,850.816],[1487.88,760.623],[1487.88,845.271]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1444.99,454.275],[1444.99,368.126],[1488.66,455.793],[1488.66,371.183]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1444.99,566.359],[1444.99,652.508],[1488.66,565.875],[1488.66,650.485]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1444.99,662.448],[1444.99,748.596],[1488.66,660.247],[1488.66,744.857]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1512.62,449.855],[1512.62,359.226],[1538.7,450.836],[1538.7,361.201]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1512.62,567.769],[1512.62,658.398],[1538.7,567.456],[1538.7,657.091]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1512.62,668.855],[1512.62,759.484],[1538.7,667.433],[1538.7,757.068]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:53,
                    verts:[[1513.64,776.376],[1513.64,867.046],[1540.69,773.676],[1540.69,863.315]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[587.997,763.075],[587.997,848.66],[521.347,754.802],[521.347,837.224]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[586.656,455.036],[586.656,369.658],[524.354,457.947],[524.354,375.522]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[586.656,551.873],[586.656,466.496],[524.354,551.437],[524.354,469.011]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[586.656,566.116],[586.656,651.494],[524.354,565.188],[524.354,647.613]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[586.656,661.345],[586.656,746.722],[524.354,657.123],[524.354,739.549]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[556.32,458.843],[556.32,377.326],[527.661,460.144],[527.661,379.945]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[556.32,564.902],[556.32,646.419],[527.661,564.487],[527.661,644.686]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[556.32,655.825],[556.32,737.342],[527.661,653.939],[527.661,734.138]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[554.522,752.34],[554.522,833.82],[527.245,749.056],[527.245,829.28]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[561.094,449.236],[561.094,357.978],[529.012,453.326],[529.012,366.214]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[561.094,552.742],[561.094,461.485],[529.012,552.13],[529.012,465.018]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[561.094,567.966],[561.094,659.224],[529.012,566.662],[529.012,653.773]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[561.094,669.753],[561.094,761.01],[529.012,663.824],[529.012,750.935]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[595.44,775.62],[595.44,866.001],[528.916,766.936],[528.916,853.997]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[822.611,440.859],[822.611,337.658],[577.104,452.712],[577.104,361.944]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[822.611,557.912],[822.611,454.711],[577.104,555.664],[577.104,464.896]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[822.611,575.128],[822.611,678.329],[577.104,570.806],[577.104,661.575]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[822.611,690.236],[822.611,793.437],[577.104,672.047],[577.104,762.816]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[655.766,786.394],[655.766,880.896],[582.424,776.707],[582.424,867.504]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[612.92,348.899],[612.92,264.109],[604.531,354.981],[604.531,272.899]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[644.224,339.96],[644.224,251.187],[612.92,348.899],[612.92,264.109]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[655.948,362.739],[655.948,284.114],[638.817,364.355],[638.817,286.449]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[699.229,330.751],[699.229,237.877],[644.674,339.882],[644.674,251.075]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[790.47,320.815],[790.47,223.514],[699.229,330.751],[699.229,237.877]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[829.406,809.329],[829.406,912.601],[742.137,797.802],[742.137,896.666]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[814.066,319.186],[814.066,221.158],[790.47,320.815],[790.47,223.514]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[894.748,313.372],[894.748,212.754],[814.066,319.186],[814.066,221.158]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,433.276],[936.028,325.838],[814.767,436.381],[814.767,332.092]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,555.134],[936.028,447.697],[814.767,554.669],[814.767,450.38]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,573.057],[936.028,680.495],[814.767,572.067],[814.767,676.356]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,692.891],[936.028,800.329],[814.767,688.389],[814.767,792.678]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[829.406,809.329],[842.917,807.924],[829.406,912.601],[842.917,910.658]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.189,820.099],[936.189,927.489],[842.917,807.924],[842.917,910.658]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1018.69,306.651],[1018.69,203.042],[897.19,312.848],[897.19,211.999]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,433.276],[936.028,325.838],[996.851,435.865],[996.851,331.052]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,555.134],[936.028,447.697],[996.851,554.746],[996.851,449.934]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,573.057],[936.028,680.495],[996.851,572.232],[996.851,677.044]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.028,692.891],[936.028,800.329],[996.851,689.137],[996.851,793.95]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[936.189,820.099],[936.189,927.489],[996.732,813.269],[996.732,918.047]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1097.13,826.267],[1097.13,936.016],[988.666,812.805],[988.666,917.405]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,431.11],[1098.58,321.477],[996.851,435.865],[996.851,331.052]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,555.459],[1098.58,445.826],[996.851,554.746],[996.851,449.934]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,573.748],[1098.58,683.381],[996.851,572.232],[996.851,677.044]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,696.03],[1098.58,805.663],[996.851,689.137],[996.851,793.95]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1112.36,303.559],[1112.36,198.573],[1018.69,306.651],[1018.69,203.042]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1097.13,826.267],[1097.13,936.016],[1132.41,821.918],[1132.41,930.003]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,431.11],[1098.58,321.477],[1132.56,432.689],[1132.56,324.657]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,555.459],[1098.58,445.826],[1132.56,555.222],[1132.56,447.19]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,573.748],[1098.58,683.381],[1132.56,573.244],[1132.56,681.276]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1098.58,696.03],[1098.58,805.663],[1132.56,693.741],[1132.56,801.773]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1112.36,303.559],[1199.99,303.314],[1112.36,198.573],[1199.99,198.218]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,430.316],[1184.86,319.877],[1132.56,432.689],[1132.56,324.657]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,555.578],[1184.86,445.14],[1132.56,555.222],[1132.56,447.19]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,574.002],[1184.86,684.44],[1132.56,573.245],[1132.56,681.276]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,697.182],[1184.86,807.621],[1132.56,693.741],[1132.56,801.773]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1182.2,827.912],[1182.2,938.289],[1132.41,821.918],[1132.41,930.003]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1182.2,827.912],[1182.2,938.289],[1269.56,826.613],[1269.56,936.494]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,430.316],[1184.86,319.877],[1271.93,430.824],[1271.93,320.901]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,555.578],[1184.86,445.14],[1271.93,555.502],[1271.93,445.579]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,574.002],[1184.86,684.44],[1271.93,573.839],[1271.93,683.762]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1184.86,697.182],[1184.86,807.621],[1271.93,696.445],[1271.93,806.368]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1199.99,303.314],[1199.99,198.218],[1240.45,307.604],[1240.45,204.419]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1270.59,304.761],[1270.59,200.309],[1240.45,307.604],[1240.45,204.419]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1269.56,826.613],[1269.56,936.494],[1433.16,804.808],[1433.16,906.351]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1270.59,304.761],[1270.59,200.309],[1321.09,307.876],[1321.09,204.812]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1271.93,430.824],[1271.93,320.901],[1435.41,439.055],[1435.41,337.476]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1271.93,555.502],[1271.93,445.579],[1435.41,554.268],[1435.41,452.689]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1271.93,573.839],[1271.93,683.762],[1435.41,571.214],[1435.41,672.793]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1271.93,696.445],[1271.93,806.368],[1435.41,684.513],[1435.41,786.092]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1321.09,307.876],[1321.09,204.812],[1355.34,310.204],[1355.34,208.177]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1355.34,310.204],[1355.34,208.177],[1401.69,313.929],[1401.69,213.562]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1404.49,314.242],[1404.49,214.013],[1435.02,319.019],[1435.02,220.919]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1435.02,319.02],[1435.02,220.919],[1452.23,322.294],[1452.23,225.653]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1435.28,804.687],[1435.28,906.183],[1575.59,785.974],[1575.59,880.315]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1436.27,439.098],[1436.27,337.564],[1576.56,446.162],[1576.56,351.787]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1436.27,554.262],[1436.27,452.727],[1576.56,553.203],[1576.56,458.829]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1436.27,571.2],[1436.27,672.735],[1576.56,568.947],[1576.56,663.321]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1436.27,684.45],[1436.27,785.984],[1576.56,674.21],[1576.56,768.584]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1443.73,329.154],[1443.73,235.568],[1475.88,332.563],[1475.88,240.495]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1444.25,454.91],[1444.25,369.406],[1482.97,456.559],[1482.97,372.725]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1444.25,566.156],[1444.25,651.661],[1482.97,565.63],[1482.97,649.464]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1444.25,661.526],[1444.25,747.031],[1482.97,659.137],[1482.97,742.97]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1443.72,762.955],[1443.72,848.494],[1482.3,758.599],[1482.3,842.473]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1452.23,322.294],[1452.23,225.653],[1473.3,326.818],[1473.3,232.191]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1520.35,450.711],[1520.35,360.95],[1543.19,451.773],[1543.19,363.087]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1520.35,567.496],[1520.35,657.257],[1543.19,567.157],[1543.19,655.842]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1520.35,667.613],[1520.35,757.375],[1543.19,666.075],[1543.19,754.76]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:54,
                    verts:[[1521.44,774.096],[1521.44,863.895],[1545.11,771.176],[1545.11,859.859]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[581.542,768.665],[581.542,856.387],[504.79,760.695],[504.79,845.37]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[538.988,456.762],[538.988,373.134],[506.056,458.016],[506.056,375.659]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[538.988,551.615],[538.988,467.987],[506.056,551.427],[506.056,469.07]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[538.988,565.566],[538.988,649.193],[506.056,565.166],[506.056,647.522]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[538.988,658.842],[538.988,742.47],[506.056,657.024],[506.056,739.381]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[537.033,757.87],[537.033,841.465],[505.685,754.705],[505.685,837.089]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[579.659,452.929],[579.659,365.416],[507.93,455.734],[507.93,371.065]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[579.659,552.189],[579.659,464.676],[507.93,551.769],[507.93,467.099]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[579.659,566.788],[579.659,654.301],[507.93,565.893],[507.93,650.563]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[579.659,664.398],[579.659,751.911],[507.93,660.332],[507.93,745.001]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[567.203,446.85],[567.203,353.174],[523.963,450.969],[523.963,361.469]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[567.203,553.1],[567.203,459.424],[523.963,552.483],[523.963,462.983]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[567.203,568.727],[567.203,662.403],[523.963,567.414],[523.963,656.914]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[567.203,673.212],[567.203,766.888],[523.963,667.24],[523.963,756.74]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[600.704,781.547],[600.704,874.196],[523.744,773.18],[523.744,862.628]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[864.424,439.159],[864.424,334.176],[582.637,450.476],[582.637,357.363]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[864.424,558.234],[864.424,453.251],[582.637,556.088],[582.637,462.975]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[864.424,575.748],[864.424,680.731],[582.637,571.621],[582.637,664.734]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[864.424,692.844],[864.424,797.827],[582.637,675.478],[582.637,768.591]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[672.841,792.091],[672.841,888.772],[588.219,782.792],[588.219,875.915]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[605.431,344.344],[605.431,257.524],[590.292,350.551],[590.292,266.497]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[647.256,335.369],[647.256,244.552],[605.431,344.344],[605.431,257.524]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[635.127,358.902],[635.127,278.567],[615.75,360.446],[615.75,280.799]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[713.652,326.327],[713.652,231.481],[647.803,335.293],[647.803,244.441]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[817.585,316.875],[817.585,217.82],[713.652,326.327],[713.652,231.481]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[871.503,813.925],[871.503,918.953],[771.952,802.984],[771.952,903.829]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[843.361,315.405],[843.361,215.693],[817.585,316.875],[817.585,217.82]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[931.416,310.146],[931.416,208.091],[843.361,315.405],[843.361,215.693]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,431.872],[989.414,323.011],[859.048,434.564],[859.048,328.433]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,555.345],[989.414,446.484],[859.048,554.941],[859.048,448.81]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,573.505],[989.414,682.366],[859.048,572.646],[859.048,678.778]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,694.926],[989.414,803.786],[859.048,691.023],[859.048,797.154]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[871.503,813.925],[883.944,812.343],[871.503,918.953],[883.944,916.767]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.462,823.816],[989.462,932.626],[883.944,812.343],[883.944,916.767]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1063.35,304.378],[1063.35,199.756],[934.437,309.633],[934.437,207.351]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,431.872],[989.414,323.011],[1044.32,434.758],[1044.32,328.824]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,555.345],[989.414,446.484],[1044.32,554.912],[1044.32,448.978]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,573.505],[989.414,682.366],[1044.32,572.585],[1044.32,678.519]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.414,694.926],[989.414,803.786],[1044.32,690.742],[1044.32,796.676]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[989.462,823.816],[989.462,932.626],[1044.12,816.202],[1044.12,922.101]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1156.39,828.357],[1156.39,938.904],[1035.6,815.814],[1035.6,921.565]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,430.33],[1157.56,319.906],[1044.32,434.758],[1044.32,328.824]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,555.576],[1157.56,445.152],[1044.32,554.912],[1044.32,448.978]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,573.997],[1157.56,684.421],[1044.32,572.585],[1044.32,678.519]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,697.161],[1157.56,807.585],[1044.32,690.742],[1044.32,796.676]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1160.17,302.069],[1160.17,196.418],[1063.35,304.378],[1063.35,199.756]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1156.39,828.357],[1156.39,938.904],[1187.52,823.561],[1187.52,932.274]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,430.33],[1157.56,319.906],[1187.53,432.071],[1187.53,323.412]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,555.576],[1157.56,445.152],[1187.53,555.315],[1187.53,446.656]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,573.997],[1157.56,684.421],[1187.53,573.442],[1187.53,682.1]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1157.56,697.161],[1157.56,807.585],[1187.53,694.637],[1187.53,803.296]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1160.17,302.069],[1160.17,196.419],[1247.33,302.6],[1247.33,197.186]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,429.878],[1245.14,318.996],[1187.53,432.071],[1187.53,323.412]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,555.644],[1245.14,444.761],[1187.53,555.315],[1187.53,446.656]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,574.141],[1245.14,685.023],[1187.53,573.442],[1187.53,682.1]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,697.817],[1245.14,808.699],[1187.53,694.637],[1187.53,803.296]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1242.36,829.1],[1242.36,939.931],[1187.52,823.561],[1187.52,932.274]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1242.36,829.1],[1242.36,939.931],[1327.36,826.841],[1327.36,936.808]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,429.878],[1245.14,318.996],[1329.78,430.747],[1329.78,320.747]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,555.644],[1245.14,444.761],[1329.78,555.513],[1329.78,445.513]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,574.141],[1245.14,685.023],[1329.78,573.864],[1329.78,683.864]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1245.14,697.817],[1245.14,808.699],[1329.78,696.556],[1329.78,806.557]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1247.33,302.6],[1247.33,197.186],[1282.71,307.29],[1282.71,203.965]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1315.4,304.684],[1315.4,200.199],[1282.71,307.29],[1282.71,203.965]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1315.4,304.684],[1315.4,200.199],[1361.65,308.262],[1361.65,205.37]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1327.36,826.841],[1327.36,936.808],[1467.34,803.229],[1467.34,904.168]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1329.78,430.747],[1329.78,320.747],[1469.61,439.658],[1469.61,338.692]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1329.78,555.513],[1329.78,445.513],[1469.61,554.178],[1469.61,453.211]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1329.78,573.864],[1329.78,683.864],[1469.61,571.021],[1469.61,671.988]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1329.78,696.556],[1329.78,806.557],[1469.61,683.637],[1469.61,784.604]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1361.65,308.262],[1361.65,205.37],[1392.68,310.897],[1392.68,209.178]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1392.68,310.897],[1392.68,209.178],[1433.92,315.027],[1433.92,215.149]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1436.33,315.364],[1436.33,215.636],[1460.94,320.403],[1460.94,222.919]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1439.92,455.551],[1439.92,370.697],[1473.48,457.315],[1473.48,374.249]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1439.92,565.952],[1439.92,650.807],[1473.48,565.389],[1473.48,648.455]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1439.92,660.597],[1439.92,745.452],[1473.48,658.039],[1473.48,741.106]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1439.48,761.26],[1439.48,846.15],[1472.92,756.598],[1472.92,839.706]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1458.64,330.615],[1458.64,237.68],[1486.2,334.269],[1486.2,242.962]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1460.94,320.403],[1460.94,222.919],[1474.17,323.82],[1474.17,227.858]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1469.28,803.087],[1469.28,903.971],[1587.82,783.079],[1587.82,876.313]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1470.34,439.705],[1470.34,338.786],[1588.84,447.257],[1588.84,353.993]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1470.34,554.171],[1470.34,453.252],[1588.84,553.039],[1588.84,459.776]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1470.34,571.006],[1470.34,671.925],[1588.84,568.598],[1588.84,661.861]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1470.34,683.569],[1470.34,784.488],[1588.84,672.622],[1588.84,765.885]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1474.17,323.819],[1474.17,227.858],[1489.79,328.509],[1489.79,234.636]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1523.71,451.603],[1523.71,362.745],[1543.18,452.734],[1543.18,365.023]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1523.71,567.211],[1523.71,656.069],[1543.18,566.851],[1543.18,654.562]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1523.71,666.321],[1523.71,755.179],[1543.18,664.682],[1543.18,752.393]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:55,
                    verts:[[1524.85,771.724],[1524.85,860.615],[1545.02,768.612],[1545.02,856.315]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[521.63,763.795],[521.63,849.656],[486.066,760.795],[486.066,845.508]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[523.744,454.532],[523.744,368.644],[486.387,455.721],[486.387,371.038]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[523.744,551.949],[523.744,466.061],[486.387,551.771],[486.387,467.088]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[523.744,566.277],[523.744,652.165],[486.387,565.898],[486.387,650.581]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[523.744,662.074],[523.744,747.962],[486.387,660.351],[486.387,745.034]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[577.791,774.549],[577.791,864.522],[490.651,767.004],[490.651,854.091]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[575.334,450.71],[575.334,360.947],[493.911,453.366],[493.911,366.295]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[575.334,552.522],[575.334,462.759],[493.911,552.124],[493.911,465.053]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[575.334,567.496],[575.334,657.259],[493.911,566.649],[493.911,653.72]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[575.334,667.616],[575.334,757.378],[493.911,663.766],[493.911,750.836]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[609.511,787.672],[609.511,882.663],[521.906,779.756],[521.906,871.719]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[577.273,444.382],[577.273,348.205],[522.258,448.488],[522.258,356.472]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[577.273,553.47],[577.273,457.292],[522.258,552.855],[522.258,460.839]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[577.273,569.515],[577.273,665.692],[522.258,568.205],[522.258,660.221]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[577.273,676.789],[577.273,772.967],[522.258,670.837],[522.258,762.853]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[600.355,339.545],[600.355,250.588],[578.023,345.833],[578.023,259.677]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[909.386,437.578],[909.386,330.936],[591.919,448.165],[591.919,352.627]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[909.386,558.534],[909.386,451.892],[591.919,556.526],[591.919,460.989]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[909.386,576.324],[909.386,682.966],[591.919,572.464],[591.919,668.002]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[909.386,695.271],[909.386,801.912],[591.919,679.025],[591.919,774.563]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[615.435,354.769],[615.435,272.593],[593.762,356.22],[593.762,274.691]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[693.678,797.836],[693.678,896.713],[597.73,789.079],[597.73,884.607]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[653.189,330.625],[653.189,237.694],[600.355,339.545],[600.355,250.588]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[731.186,321.866],[731.186,225.033],[653.835,330.55],[653.835,237.586]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[847.521,313.056],[847.521,212.3],[731.186,321.866],[731.186,225.033]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[916.67,818.189],[916.67,924.848],[805.321,808.026],[805.321,910.799]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[875.305,311.776],[875.305,210.448],[847.521,313.056],[847.521,212.3]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[970.065,307.181],[970.065,203.806],[875.305,311.776],[875.305,210.448]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,430.668],[1044.84,320.587],[906.705,432.878],[906.705,325.038]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,555.525],[1044.84,445.444],[906.705,555.194],[906.705,447.354]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,573.889],[1044.84,683.97],[906.705,573.184],[906.705,681.024]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,696.671],[1044.84,806.753],[906.705,693.467],[906.705,801.307]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[916.67,818.189],[927.811,816.436],[916.67,924.848],[927.811,922.425]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.76,827.005],[1044.76,937.035],[927.811,816.436],[927.811,922.425]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1108.64,302.496],[1108.64,197.036],[973.659,306.684],[973.659,203.089]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,430.668],[1044.84,320.587],[1092.79,433.833],[1092.79,326.961]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,555.525],[1044.84,445.444],[1092.79,555.051],[1092.79,448.179]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,573.889],[1044.84,683.97],[1092.79,572.88],[1092.79,679.752]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.84,696.671],[1044.84,806.752],[1092.79,692.082],[1092.79,798.955]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1044.76,827.005],[1044.76,937.035],[1092.51,818.654],[1092.51,925.492]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1215.47,829.768],[1215.47,940.855],[1083.63,818.351],[1083.63,925.072]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,429.804],[1216.33,318.847],[1092.79,433.833],[1092.79,326.961]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,555.655],[1216.33,444.698],[1092.79,555.051],[1092.79,448.179]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,574.165],[1216.33,685.122],[1092.79,572.879],[1092.79,679.752]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,697.923],[1216.33,808.88],[1092.79,692.082],[1092.79,798.954]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1207.42,301.036],[1108.64,302.496],[1207.42,194.925],[1108.64,197.036]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1207.42,301.036],[1207.42,194.925],[1292.93,302.364],[1292.93,196.844]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1215.47,829.768],[1215.47,940.855],[1241.86,824.568],[1241.86,933.667]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,429.804],[1216.33,318.847],[1241.75,431.692],[1241.75,322.649]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,555.655],[1216.33,444.698],[1241.75,555.372],[1241.75,446.329]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,574.165],[1216.33,685.121],[1241.75,573.563],[1241.75,682.606]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1216.33,697.923],[1216.33,808.88],[1241.75,695.187],[1241.75,804.23]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,429.713],[1303.94,318.664],[1241.75,431.692],[1241.75,322.649]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,555.668],[1303.94,444.619],[1241.75,555.372],[1241.75,446.329]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,574.194],[1303.94,685.243],[1241.75,573.563],[1241.75,682.606]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,698.055],[1303.94,809.104],[1241.75,695.187],[1241.75,804.23]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1301.08,829.565],[1301.08,940.574],[1241.86,824.568],[1241.86,933.667]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1292.93,302.363],[1292.93,196.844],[1322.68,307.408],[1322.68,204.136]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1301.08,829.565],[1301.08,940.574],[1382.42,826.352],[1382.42,936.133]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,429.713],[1303.94,318.664],[1384.88,430.942],[1384.88,321.138]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,555.668],[1303.94,444.619],[1384.88,555.484],[1384.88,445.68]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,574.194],[1303.94,685.242],[1384.88,573.802],[1384.88,683.606]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1303.94,698.055],[1303.94,809.104],[1384.88,696.275],[1384.88,806.079]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1357.53,305.074],[1357.53,200.763],[1322.68,307.408],[1322.68,204.136]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1357.53,305.074],[1357.53,200.763],[1398.91,309.079],[1398.91,206.551]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1382.42,826.352],[1382.42,936.133],[1496.95,801.206],[1496.95,901.371]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1384.88,430.941],[1384.88,321.138],[1499.21,440.43],[1499.21,340.246]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1384.88,555.484],[1384.88,445.68],[1499.21,554.062],[1499.21,453.878]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1384.88,573.802],[1384.88,683.606],[1499.21,570.775],[1499.21,670.96]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1384.88,696.275],[1384.88,806.079],[1499.21,682.519],[1499.21,782.703]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1398.91,309.079],[1398.91,206.551],[1426.34,311.992],[1426.34,210.762]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1426.34,311.992],[1426.34,210.762],[1462.02,316.483],[1462.02,217.253]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1431.8,456.208],[1431.8,372.02],[1460.04,458.073],[1460.04,375.774]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1431.8,565.742],[1431.8,649.931],[1460.04,565.148],[1460.04,647.446]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1431.8,659.644],[1431.8,743.833],[1460.04,656.942],[1460.04,739.24]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1431.46,759.521],[1431.46,843.747],[1459.61,754.594],[1459.61,836.937]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1463.99,316.84],[1463.99,217.769],[1482.46,322.085],[1482.46,225.351]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1469.32,332.272],[1469.32,240.076],[1492.1,336.134],[1492.1,245.657]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1482.46,322.085],[1482.46,225.351],[1491.62,325.607],[1491.62,230.441]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1491.62,325.607],[1491.62,230.441],[1501.72,330.414],[1501.72,237.39]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1498.71,801.044],[1498.71,901.147],[1594.59,779.972],[1594.59,872.018]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1499.81,440.48],[1499.81,340.346],[1595.64,448.432],[1595.64,356.361]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1499.81,554.055],[1499.81,453.921],[1595.64,552.863],[1595.64,460.791]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1499.81,570.759],[1499.81,670.893],[1595.64,568.223],[1595.64,660.294]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1499.81,682.446],[1499.81,782.58],[1595.64,670.918],[1595.64,762.989]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1522.45,452.539],[1522.45,364.631],[1538.46,453.728],[1538.46,367.025]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1522.45,566.913],[1522.45,654.821],[1538.46,566.533],[1538.46,653.236]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1522.45,664.964],[1522.45,752.872],[1538.46,663.24],[1538.46,749.943]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:56,
                    verts:[[1523.62,769.231],[1523.62,857.169],[1540.21,765.96],[1540.21,852.648]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[508.872,770.065],[508.872,858.323],[468.981,767.285],[468.981,854.479]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[511.141,452.174],[511.141,363.895],[469.244,453.275],[469.244,366.112]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[511.141,552.302],[511.141,464.024],[469.244,552.137],[469.244,464.975]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[511.141,567.029],[511.141,655.308],[469.244,566.678],[469.244,653.84]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[511.141,665.493],[511.141,753.772],[469.244,663.897],[469.244,751.06]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[577.241,780.651],[577.241,872.957],[479.544,773.673],[479.544,863.311]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[574.183,448.406],[574.183,356.308],[482.908,450.862],[482.908,361.253]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[574.183,552.867],[574.183,460.769],[482.908,552.499],[482.908,462.89]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[574.183,568.231],[574.183,660.329],[482.908,567.448],[482.908,657.056]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[574.183,670.955],[574.183,763.053],[482.908,667.395],[482.908,757.004]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[622.294,793.887],[622.294,891.253],[524.003,786.579],[524.003,881.151]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[591.797,441.876],[591.797,343.157],[524.498,445.914],[524.498,351.288]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[591.797,553.845],[591.797,455.127],[524.498,553.24],[524.498,458.615]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[591.797,570.314],[591.797,669.033],[524.498,569.026],[524.498,663.651]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[591.797,680.423],[591.797,779.141],[524.498,674.569],[524.498,769.194]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[568.205,340.875],[568.205,252.51],[563.69,346.827],[563.69,261.113]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[598.151,334.565],[598.151,243.39],[568.205,340.875],[568.205,252.51]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[597.28,350.376],[597.28,266.243],[573.279,351.709],[573.279,268.17]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[662.384,325.809],[662.384,230.733],[598.151,334.565],[598.151,243.39]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[957.082,436.176],[957.082,328.064],[605.419,445.817],[605.419,347.817]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[957.082,558.8],[957.082,450.688],[605.419,556.972],[605.419,458.971]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[957.082,576.836],[957.082,684.948],[605.419,573.32],[605.419,671.32]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[957.082,697.422],[957.082,805.534],[605.419,682.627],[605.419,780.628]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[718.505,803.495],[718.505,904.536],[611.412,795.458],[611.412,893.426]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[752.009,317.471],[752.009,218.681],[663.13,325.738],[663.13,230.63]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[880.154,309.476],[880.154,207.125],[752.009,317.471],[752.009,218.681]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[964.477,821.954],[964.477,930.053],[842.16,812.775],[842.16,917.364]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[909.71,308.419],[880.155,309.476],[909.71,205.595],[880.155,207.125]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1010.28,304.597],[1010.28,200.07],[909.71,308.419],[909.71,205.595]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,429.727],[1101.48,318.692],[957.285,431.391],[957.285,322.043]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,555.666],[1101.48,444.631],[957.285,555.417],[957.285,446.069]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,574.189],[1101.48,685.224],[957.285,573.659],[957.285,683.007]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,698.035],[1101.48,809.07],[957.285,695.623],[957.285,804.971]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[964.477,821.954],[964.477,930.053],[974.087,820.041],[974.087,927.409]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.28,829.498],[1101.28,940.481],[974.087,820.041],[974.087,927.409]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1153.85,301.119],[1153.85,195.046],[1014.42,304.124],[1014.42,199.388]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,429.727],[1101.48,318.692],[1141.51,433.144],[1141.51,325.572]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,555.666],[1101.48,444.631],[1141.51,555.154],[1141.51,447.583]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,574.189],[1101.48,685.224],[1141.51,573.099],[1141.51,680.671]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.48,698.035],[1101.48,809.07],[1141.51,693.082],[1141.51,800.653]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1101.28,829.498],[1101.28,940.481],[1141.14,820.485],[1141.14,928.022]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.25,830.362],[1273.25,941.676],[1132.02,820.274],[1132.02,927.731]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,429.585],[1273.79,318.406],[1141.51,433.144],[1141.51,325.572]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,555.687],[1273.79,444.509],[1141.51,555.154],[1141.51,447.583]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,574.235],[1273.79,685.413],[1141.51,573.099],[1141.51,680.671]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,698.241],[1273.79,809.42],[1141.51,693.082],[1141.51,800.653]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1153.85,301.119],[1253.25,300.559],[1153.85,195.046],[1253.25,194.236]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1253.25,300.559],[1253.25,194.236],[1335.9,302.686],[1335.9,197.311]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.25,830.362],[1273.25,941.676],[1294.42,824.818],[1294.42,934.012]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,429.585],[1273.79,318.406],[1294.18,431.598],[1294.18,322.459]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,555.687],[1273.79,444.509],[1294.18,555.386],[1294.18,446.247]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,574.235],[1273.79,685.413],[1294.18,573.593],[1294.18,682.731]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1273.79,698.241],[1273.79,809.42],[1294.18,695.323],[1294.18,804.462]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,429.866],[1360.08,318.972],[1294.18,431.598],[1294.18,322.459]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,555.645],[1360.08,444.751],[1294.18,555.386],[1294.18,446.247]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,574.145],[1360.08,685.039],[1294.18,573.593],[1294.18,682.731]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,697.834],[1360.08,808.728],[1294.18,695.323],[1294.18,804.462]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1357.18,829.191],[1357.18,940.058],[1294.42,824.818],[1294.42,934.012]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1335.9,302.686],[1335.9,197.311],[1359.59,308.028],[1359.59,205.031]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1357.18,829.191],[1357.18,940.058],[1433.61,825.057],[1433.61,934.343]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1396.13,305.997],[1396.13,202.097],[1359.59,308.028],[1359.59,205.031]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,429.866],[1360.08,318.972],[1436.05,431.44],[1436.05,322.142]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,555.645],[1360.08,444.751],[1436.05,555.409],[1436.05,446.111]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,574.145],[1360.08,685.039],[1436.05,573.643],[1436.05,682.941]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1360.08,697.834],[1360.08,808.728],[1436.05,695.552],[1436.05,804.85]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1396.13,305.997],[1396.13,202.097],[1432.1,310.382],[1432.1,208.434]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1419.77,456.89],[1419.77,373.393],[1442.59,458.837],[1442.59,377.314]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1419.77,565.525],[1419.77,649.022],[1442.59,564.904],[1442.59,646.427]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1419.77,658.656],[1419.77,742.154],[1442.59,655.833],[1442.59,737.357]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1419.53,757.716],[1419.53,841.252],[1442.27,752.57],[1442.27,834.139]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1432.1,310.382],[1432.1,208.434],[1455.6,313.538],[1455.6,212.996]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1433.61,825.057],[1433.61,934.343],[1521.34,798.698],[1521.34,897.905]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1436.05,431.44],[1436.05,322.142],[1523.57,441.384],[1523.57,342.168]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1436.05,555.409],[1436.05,446.111],[1523.57,553.919],[1523.57,454.702]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1436.05,573.643],[1436.05,682.941],[1523.57,570.471],[1523.57,669.688]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1436.05,695.552],[1436.05,804.85],[1523.57,681.135],[1523.57,780.352]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1455.6,313.538],[1455.6,212.996],[1485.33,318.333],[1485.33,219.927]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1475.42,334.151],[1475.42,242.792],[1493.28,338.178],[1493.28,248.613]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1486.85,318.707],[1486.85,220.467],[1499.07,324.096],[1499.07,228.258]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1499.07,324.096],[1499.07,228.258],[1504.13,327.683],[1504.13,233.443]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1504.13,327.683],[1504.13,233.443],[1508.71,332.556],[1508.71,240.485]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1516.36,453.527],[1516.36,366.621],[1528.87,454.762],[1528.87,369.107]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1516.36,566.597],[1516.36,653.504],[1528.87,566.204],[1528.87,651.858]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1516.36,663.531],[1516.36,750.438],[1528.87,661.741],[1528.87,747.396]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1517.57,766.6],[1517.57,853.533],[1530.52,763.204],[1530.52,848.839]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1522.88,798.52],[1522.88,897.658],[1595.62,776.641],[1595.62,867.413]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1524.03,441.436],[1524.03,342.272],[1596.69,449.693],[1596.69,358.898]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1524.03,553.911],[1524.03,454.747],[1596.69,552.674],[1596.69,461.88]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1524.03,570.454],[1524.03,669.619],[1596.69,567.821],[1596.69,658.615]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:57,
                    verts:[[1524.03,681.06],[1524.03,780.224],[1596.69,669.091],[1596.69,759.885]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[499.394,776.607],[499.394,867.366],[455.122,774.112],[455.122,863.917]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[501.81,449.714],[501.81,358.942],[455.318,450.702],[455.318,360.931]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[501.81,552.671],[501.81,461.898],[455.318,552.523],[455.318,462.752]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[501.81,567.814],[501.81,658.586],[455.318,567.499],[455.318,657.27]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[501.81,669.059],[501.81,759.832],[455.318,667.627],[455.318,757.398]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[580.411,786.871],[580.411,881.554],[472.163,780.627],[472.163,872.923]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[576.732,446.056],[576.732,351.574],[475.608,448.253],[475.608,355.999]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[576.732,553.219],[576.732,458.738],[475.608,552.89],[475.608,460.636]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[576.732,568.981],[576.732,663.462],[475.608,568.28],[475.608,660.534]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[576.732,674.363],[576.732,768.845],[475.608,671.178],[475.608,763.432]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[639.447,800.057],[639.447,899.782],[530.658,793.537],[530.658,890.77]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[611.228,439.384],[611.228,338.14],[531.304,443.289],[531.304,346.003]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[611.228,554.219],[611.228,452.974],[531.304,553.634],[531.304,456.348]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[611.228,571.109],[611.228,672.353],[531.304,569.863],[531.304,667.149]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[611.228,684.035],[611.228,785.279],[531.304,678.374],[531.304,775.66]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[561.375,335.741],[561.375,245.09],[550.189,341.845],[550.189,253.913]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[581.141,345.769],[581.141,259.585],[554.81,346.956],[554.81,261.3]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[599.301,329.485],[599.301,236.046],[561.375,335.741],[561.375,245.09]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[675.173,321.023],[675.173,223.816],[599.301,329.485],[599.301,236.046]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1006.88,435.018],[1006.88,325.69],[623.56,443.484],[623.56,343.036]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1006.88,559.02],[1006.88,449.693],[623.56,557.414],[623.56,456.967]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1006.88,577.258],[1006.88,686.585],[623.56,574.171],[623.56,674.618]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1006.88,699.199],[1006.88,808.526],[623.56,686.208],[623.56,786.655]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[747.439,808.913],[747.439,912.025],[629.678,801.792],[629.678,902.182]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[776.213,313.262],[776.213,212.598],[676.019,320.957],[676.019,223.72]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[915.224,306.264],[915.224,202.482],[776.213,313.262],[776.213,212.598]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1014.28,825.046],[1014.28,934.327],[882.211,817.061],[882.211,923.289]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[946.239,305.462],[915.224,306.264],[946.239,201.321],[915.224,202.482]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1051.47,302.517],[1051.47,197.064],[946.239,305.462],[946.239,201.321]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,429.111],[1158.31,317.452],[1010.11,430.171],[1010.11,319.587]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,555.758],[1158.31,444.099],[1010.11,555.599],[1010.11,445.015]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,574.386],[1158.31,686.045],[1010.11,574.048],[1010.11,684.632]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,698.928],[1158.31,810.588],[1010.11,697.391],[1010.11,807.976]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1014.28,825.046],[1014.28,934.327],[1022.14,822.99],[1022.14,931.485]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1157.99,831.132],[1157.99,942.74],[1022.14,822.99],[1022.14,931.485]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1198.13,300.352],[1056.13,302.076],[1198.13,193.937],[1056.13,196.428]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,429.111],[1158.31,317.452],[1189.57,432.74],[1189.57,324.759]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,555.758],[1158.31,444.099],[1189.57,555.215],[1189.57,447.234]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,574.386],[1158.31,686.045],[1189.57,573.228],[1189.57,681.209]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1158.31,698.928],[1158.31,810.588],[1189.57,693.668],[1189.57,801.649]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1157.99,831.132],[1157.99,942.74],[1189.12,821.559],[1189.12,929.507]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.49,830.02],[1328.49,941.204],[1179.89,821.448],[1179.89,929.354]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,429.717],[1328.69,318.672],[1189.57,432.74],[1189.57,324.759]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,555.668],[1328.69,444.623],[1189.57,555.215],[1189.57,447.234]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,574.193],[1328.69,685.238],[1189.57,573.228],[1189.57,681.209]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,698.05],[1328.69,809.095],[1189.57,693.668],[1189.57,801.649]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1198.13,300.352],[1198.13,193.937],[1296.72,300.726],[1296.72,194.477]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1296.72,300.726],[1296.72,194.477],[1375.3,303.634],[1375.3,198.681]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,429.717],[1328.69,318.672],[1343.69,431.827],[1343.69,322.922]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,555.668],[1328.69,444.623],[1343.69,555.351],[1343.69,446.446]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,574.192],[1328.69,685.238],[1343.69,573.519],[1343.69,682.425]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.69,698.05],[1328.69,809.095],[1343.69,694.99],[1343.69,803.896]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1328.49,830.02],[1328.49,941.204],[1344.06,824.207],[1344.06,933.167]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,430.37],[1412.27,319.987],[1343.69,431.827],[1343.69,322.922]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,555.57],[1412.27,445.187],[1343.69,555.351],[1343.69,446.446]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,573.984],[1412.27,684.367],[1343.69,573.519],[1343.69,682.425]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,697.103],[1412.27,807.486],[1343.69,694.99],[1343.69,803.896]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1409.38,827.888],[1409.38,938.255],[1344.06,824.207],[1344.06,933.167]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1375.3,303.634],[1375.3,198.681],[1392.6,309.203],[1392.6,206.731]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1430.32,307.503],[1392.6,309.203],[1430.32,204.273],[1392.6,206.73]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1403.78,457.602],[1403.78,374.826],[1421.1,459.613],[1421.1,378.877]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1403.78,565.298],[1403.78,648.073],[1421.1,564.656],[1421.1,645.393]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1403.78,657.624],[1403.78,740.4],[1421.1,654.708],[1421.1,735.445]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1403.64,755.83],[1403.64,838.645],[1420.91,750.515],[1420.91,831.297]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1409.38,827.888],[1409.38,938.255],[1479.74,822.891],[1479.74,931.348]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,430.37],[1412.27,319.987],[1482.13,432.267],[1482.13,323.808]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,555.57],[1412.27,445.187],[1482.13,555.285],[1482.13,446.826]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,573.984],[1412.27,684.367],[1482.13,573.379],[1482.13,681.839]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1412.27,697.103],[1412.27,807.486],[1482.13,694.353],[1482.13,802.812]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1430.33,307.503],[1430.33,204.273],[1460.46,312.207],[1460.46,211.073]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1460.46,312.207],[1460.46,211.073],[1479.78,315.564],[1479.78,215.925]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1476.67,336.267],[1476.67,245.849],[1489.55,340.413],[1489.55,251.843]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1479.78,315.564],[1479.78,215.925],[1503.3,320.6],[1503.3,223.204]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1479.74,822.891],[1479.74,931.348],[1539.92,795.688],[1539.92,893.743]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1482.13,432.267],[1482.13,323.808],[1542.09,442.528],[1542.09,344.471]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1482.13,555.285],[1482.13,446.826],[1542.09,553.748],[1542.09,455.691]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1482.13,573.379],[1482.13,681.839],[1542.09,570.106],[1542.09,668.163]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1482.13,694.352],[1482.13,802.812],[1542.09,679.477],[1542.09,777.534]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1504.36,320.985],[1504.36,223.76],[1510.32,326.453],[1510.32,231.663]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1505.34,454.571],[1505.34,368.722],[1514.34,455.838],[1514.34,371.273]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1505.34,566.265],[1505.34,652.113],[1514.34,565.861],[1514.34,650.425]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1505.34,662.019],[1505.34,747.868],[1514.34,660.182],[1514.34,744.747]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1506.57,763.823],[1506.57,849.694],[1515.88,760.339],[1515.88,844.878]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1510.32,326.453],[1510.32,231.664],[1511.32,330.063],[1511.32,236.881]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1541.24,795.495],[1541.24,893.476],[1590.73,773.085],[1590.73,862.498]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1542.4,442.582],[1542.4,344.578],[1591.81,451.038],[1591.81,361.607]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1542.4,553.74],[1542.4,455.737],[1591.81,552.472],[1591.81,463.042]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1542.4,570.089],[1542.4,668.092],[1591.81,567.392],[1591.81,656.822]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:58,
                    verts:[[1542.4,679.4],[1542.4,777.403],[1591.81,667.141],[1591.81,756.571]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[445.37,448.034],[445.37,355.558],[441.926,450.788],[441.926,361.104]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[445.37,552.923],[445.37,460.447],[441.926,552.51],[441.926,462.826]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[445.37,568.35],[445.37,660.825],[441.926,567.471],[441.926,657.155]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[445.37,671.495],[445.37,763.971],[441.926,667.503],[441.926,757.187]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[445.249,781.19],[445.249,873.702],[441.449,773.874],[441.449,863.589]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[496.428,447.189],[496.428,353.856],[445.37,448.034],[445.37,355.558]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[496.428,553.049],[496.428,459.717],[445.37,552.923],[445.37,460.447]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[496.428,568.619],[496.428,661.952],[445.37,568.35],[445.37,660.825]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[496.428,672.721],[496.428,766.053],[445.37,671.495],[445.37,763.971]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[493.875,783.326],[493.875,876.654],[445.249,781.19],[445.249,873.702]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[587.801,793.084],[587.801,890.144],[469.247,787.759],[469.247,882.783]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[583.489,443.704],[583.489,346.838],[472.743,445.577],[472.743,350.611]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[583.489,553.572],[583.489,456.706],[472.743,553.291],[472.743,458.325]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[583.489,569.731],[583.489,666.597],[472.743,569.133],[472.743,664.1]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[583.489,677.773],[583.489,774.639],[472.743,675.057],[472.743,770.023]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[567.553,341.01],[567.553,252.706],[538.933,342.018],[538.933,254.162]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[558.096,330.516],[558.096,237.537],[539.759,336.713],[539.759,246.494]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[661.266,806.024],[661.266,908.032],[542.463,800.488],[542.463,900.379]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[635.902,436.972],[635.902,333.282],[543.266,440.668],[543.266,340.725]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[635.902,554.58],[635.902,450.89],[543.266,554.026],[543.266,454.084]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[635.902,571.878],[635.902,675.568],[543.266,570.699],[543.266,670.642]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[635.902,687.532],[635.902,791.222],[543.266,682.173],[543.266,782.116]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[604.278,324.402],[604.278,228.7],[558.096,330.516],[558.096,237.537]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[691.817,316.386],[691.817,217.114],[604.278,324.402],[604.278,228.7]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1057.92,434.165],[1057.92,323.943],[646.665,441.224],[646.665,338.408]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1057.92,559.181],[1057.92,448.96],[646.665,557.843],[646.665,455.026]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1057.92,577.569],[1057.92,687.791],[646.665,574.995],[646.665,677.812]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1057.92,700.508],[1057.92,810.73],[646.665,689.675],[646.665,792.492]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[780.433,813.914],[780.433,918.939],[652.833,807.917],[652.833,910.649]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[803.756,309.371],[803.756,206.973],[692.759,316.326],[692.759,217.026]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[952.296,303.551],[952.296,198.561],[803.756,309.371],[803.756,206.973]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1065.2,827.298],[1065.2,937.44],[925.008,820.709],[925.008,928.332]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[984.388,303.033],[952.296,303.551],[984.388,197.81],[952.296,198.561]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1092.91,301.059],[1092.91,194.956],[984.388,303.033],[984.388,197.81]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1064.23,429.286],[1214.11,428.873],[1064.23,317.803],[1214.11,316.972]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1064.23,555.732],[1064.23,444.25],[1214.11,555.794],[1214.11,443.893]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1064.23,574.33],[1214.11,574.462],[1064.23,685.813],[1214.11,686.363]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1064.23,698.675],[1214.11,699.274],[1064.23,810.158],[1214.11,811.174]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1065.2,827.298],[1065.2,937.44],[1071.12,825.123],[1071.12,934.434]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1213.67,831.766],[1213.67,943.616],[1071.12,825.123],[1071.12,934.434]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1098.03,300.657],[1240.54,300.284],[1098.03,194.377],[1240.54,193.838]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1214.11,428.873],[1214.11,316.972],[1235.94,432.664],[1235.94,324.606]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1214.11,555.794],[1214.11,443.893],[1235.94,555.226],[1235.94,447.168]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1214.11,574.462],[1214.11,686.363],[1235.94,573.253],[1235.94,681.31]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1214.11,699.274],[1214.11,811.174],[1235.94,693.778],[1235.94,801.835]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1213.67,831.766],[1213.67,943.616],[1235.42,821.764],[1235.42,929.791]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.87,828.66],[1379.87,939.323],[1226.21,821.758],[1226.21,929.782]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,430.231],[1379.72,319.707],[1235.94,432.664],[1235.94,324.606]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,555.591],[1379.72,445.067],[1235.94,555.226],[1235.94,447.168]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,574.029],[1379.72,684.552],[1235.94,573.253],[1235.94,681.31]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,697.305],[1379.72,807.828],[1235.94,693.778],[1235.94,801.835]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1240.54,300.284],[1240.54,193.838],[1336.83,301.601],[1336.83,195.742]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1336.83,301.601],[1336.83,195.742],[1410.19,305.25],[1410.19,201.017]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,430.231],[1379.72,319.707],[1389.1,432.408],[1389.1,324.09]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,555.591],[1379.72,445.067],[1389.1,555.264],[1389.1,446.947]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,574.029],[1379.72,684.552],[1389.1,573.334],[1389.1,681.652]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.72,697.304],[1379.72,807.828],[1389.1,694.149],[1389.1,802.467]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1379.87,828.66],[1379.87,939.323],[1389.61,822.664],[1389.61,931.035]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1383.83,458.347],[1383.83,376.326],[1395.67,460.402],[1395.67,380.466]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1383.83,565.06],[1383.83,647.081],[1395.67,564.404],[1395.67,644.341]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1383.83,656.544],[1383.83,738.565],[1395.67,653.564],[1395.67,733.501]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1383.79,753.857],[1383.79,835.917],[1395.59,748.424],[1395.59,828.407]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,431.246],[1459.27,321.75],[1389.1,432.408],[1389.1,324.09]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,555.439],[1459.27,445.943],[1389.1,555.264],[1389.1,446.947]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,573.705],[1459.27,683.2],[1389.1,573.334],[1389.1,681.652]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,695.834],[1459.27,805.329],[1389.1,694.149],[1389.1,802.467]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1456.43,825.599],[1389.61,822.664],[1456.43,935.092],[1389.61,931.035]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1410.19,305.25],[1410.19,201.017],[1420.93,310.968],[1420.93,209.281]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.3,309.617],[1420.93,310.968],[1459.3,207.328],[1420.93,209.281]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1456.43,825.599],[1456.43,935.092],[1519.69,819.828],[1519.69,927.114]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.3,309.617],[1459.3,207.328],[1483.3,314.572],[1483.3,214.49]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,431.246],[1459.27,321.75],[1522,433.433],[1522,326.155]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,555.439],[1459.27,445.943],[1522,555.111],[1522,447.833]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,573.705],[1459.27,683.2],[1522,573.007],[1522,680.285]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1459.27,695.834],[1459.27,805.329],[1522,692.663],[1522,799.941]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1472.87,338.621],[1472.87,249.252],[1480.79,342.838],[1480.79,255.348]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1483.3,314.572],[1483.3,214.49],[1498.28,318.081],[1498.28,219.562]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1489.38,455.668],[1489.38,370.931],[1494.92,456.953],[1494.92,373.519]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1489.38,565.915],[1489.38,650.652],[1494.92,565.505],[1494.92,648.939]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1489.38,660.429],[1489.38,745.165],[1494.92,658.565],[1494.92,741.999]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1490.61,760.904],[1490.61,845.658],[1496.34,757.37],[1496.34,840.773]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1498.28,318.081],[1498.28,219.562],[1515.46,323.286],[1515.46,227.087]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1519.69,819.828],[1519.69,927.114],[1552.21,792.179],[1552.21,888.892]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1522,433.433],[1522,326.155],[1554.3,443.86],[1554.3,347.153]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1522,555.111],[1522,447.833],[1554.3,553.548],[1554.3,456.841]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1522,573.007],[1522,680.285],[1554.3,569.681],[1554.3,666.388]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1522,692.663],[1522,799.941],[1554.3,677.546],[1554.3,774.253]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1553.3,791.974],[1553.3,888.609],[1579.87,769.32],[1579.87,857.293]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1554.46,443.914],[1554.46,347.262],[1580.93,452.462],[1580.93,364.475]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1554.46,553.54],[1554.46,456.888],[1580.93,552.259],[1580.93,464.272]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1554.46,569.664],[1554.46,666.316],[1580.93,566.937],[1580.93,654.924]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:59,
                    verts:[[1554.46,677.468],[1554.46,774.12],[1580.93,665.076],[1580.93,753.063]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[440.208,445.315],[440.208,350.082],[429.63,448.147],[429.63,355.786]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[440.208,553.33],[440.208,458.098],[429.63,552.906],[429.63,460.545]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[440.208,569.217],[440.208,664.45],[429.63,568.314],[429.63,660.674]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[440.208,675.438],[440.208,770.67],[429.63,671.331],[429.63,763.692]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[440.172,788.405],[440.172,883.675],[429.206,780.883],[429.206,873.277]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[495.69,444.643],[495.69,348.73],[440.208,445.315],[440.208,350.082]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[495.69,553.431],[495.69,457.518],[440.208,553.33],[440.208,458.098]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[495.69,569.431],[495.69,665.344],[440.208,569.217],[440.208,664.45]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[495.69,676.411],[495.69,772.324],[440.208,675.438],[440.208,770.67]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[493.017,790.1],[493.017,886.019],[440.172,788.405],[440.172,883.675]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[599.857,799.146],[599.857,898.523],[471.542,794.938],[471.542,892.706]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[594.913,441.405],[594.913,342.209],[475.051,442.886],[475.051,345.191]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[594.913,553.916],[594.913,454.72],[475.051,553.694],[475.051,455.999]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[594.913,570.464],[594.913,669.66],[475.051,569.992],[475.051,667.687]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[594.913,681.105],[594.913,780.302],[475.051,678.959],[475.051,776.654]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[557.099,336.174],[557.099,245.716],[526.277,336.969],[526.277,246.864]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[558.93,325.3],[558.93,229.998],[533.022,331.516],[533.022,238.982]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[613.509,319.435],[613.509,221.52],[558.93,325.3],[558.93,229.998]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[687.906,811.613],[687.906,915.758],[559.931,807.263],[559.931,909.745]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[665.997,434.712],[665.997,328.732],[560.894,438.115],[560.894,335.583]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[665.997,554.919],[665.997,448.938],[560.894,554.409],[560.894,451.878]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[665.997,572.599],[665.997,678.58],[560.894,571.514],[560.894,674.045]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[665.997,690.808],[665.997,796.789],[560.894,685.875],[560.894,788.407]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[712.471,312.031],[712.471,210.818],[613.509,319.435],[613.509,221.52]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1109.14,433.671],[1109.14,322.932],[674.904,439.107],[674.904,334.069]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1109.14,559.275],[1109.14,448.536],[674.904,558.244],[674.904,453.206]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1109.14,577.749],[1109.14,688.488],[674.904,575.767],[674.904,680.805]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1109.14,701.265],[1109.14,812.004],[674.904,692.924],[674.904,797.962]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[817.245,818.318],[817.244,925.026],[681.036,813.65],[681.036,918.573]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[834.443,305.935],[834.443,202.006],[713.504,311.978],[713.504,210.741]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[990.773,301.465],[990.773,195.545],[834.443,305.935],[834.443,202.006]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1116.18,828.563],[1116.18,939.189],[969.875,823.549],[969.875,932.257]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1023.5,301.254],[990.773,301.465],[1023.5,195.238],[990.773,195.545]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1133.75,300.321],[1023.5,301.254],[1133.75,193.89],[1023.5,195.238]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1116.18,828.563],[1116.18,939.189],[1120.01,826.3],[1120.01,936.06]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1118.52,428.793],[1118.52,316.811],[1267.54,429.052],[1267.54,317.333]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1118.52,555.806],[1118.52,443.824],[1267.54,555.767],[1267.54,444.048]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1118.52,574.487],[1118.52,686.469],[1267.54,574.405],[1267.54,686.123]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1118.52,699.39],[1118.52,811.372],[1267.54,699.013],[1267.54,810.732]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1266.98,831.295],[1266.98,942.966],[1120.01,826.3],[1120.01,936.06]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1139.25,299.966],[1139.25,193.379],[1280.08,300.978],[1280.08,194.842]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1266.98,831.295],[1266.98,942.966],[1278.93,821.019],[1278.93,928.76]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1267.54,429.052],[1267.54,317.333],[1279.52,432.947],[1279.52,325.177]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1267.54,555.767],[1267.54,444.048],[1279.52,555.184],[1279.52,447.413]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1267.54,574.405],[1267.54,686.123],[1279.52,573.162],[1279.52,680.932]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1267.54,699.013],[1267.54,810.732],[1279.52,693.367],[1279.52,801.137]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1426.1,826.24],[1426.1,935.978],[1269.9,821.118],[1269.9,928.897]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1280.08,300.978],[1280.08,194.842],[1372.6,303.22],[1372.6,198.083]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,431.143],[1425.62,321.542],[1279.52,432.947],[1279.52,325.177]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,555.454],[1425.62,445.854],[1279.52,555.184],[1279.52,447.413]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,573.738],[1425.62,683.338],[1279.52,573.162],[1279.52,680.932]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,695.983],[1425.62,805.583],[1279.52,693.367],[1279.52,801.137]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1360.06,459.123],[1360.06,377.89],[1366.46,461.203],[1366.46,382.077]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1360.06,564.812],[1360.06,646.046],[1366.46,564.149],[1366.46,643.275]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1360.06,655.419],[1360.06,736.652],[1366.46,652.404],[1366.46,731.53]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1360.12,751.798],[1360.12,833.07],[1366.49,746.302],[1366.49,825.473]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1372.6,303.22],[1372.6,198.083],[1439.73,307.547],[1439.73,204.337]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,431.142],[1425.62,321.542],[1429.31,433.35],[1429.31,325.987]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,555.454],[1425.62,445.854],[1429.31,555.123],[1429.31,447.761]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,573.738],[1425.62,683.338],[1429.31,573.034],[1429.31,680.396]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1425.62,695.983],[1425.62,805.583],[1429.31,692.783],[1429.31,800.146]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1426.1,826.24],[1426.1,935.978],[1429.92,820.16],[1429.92,927.573]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,432.496],[1429.31,433.35],[1499.89,324.268],[1429.31,325.987]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,555.251],[1499.89,447.023],[1429.31,555.123],[1429.31,447.761]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,573.306],[1429.31,573.034],[1499.89,681.534],[1429.31,680.396]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,694.021],[1429.31,692.783],[1499.89,802.249],[1429.31,800.146]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1497.16,822.317],[1429.92,820.16],[1497.16,930.555],[1429.92,927.573]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1439.73,307.547],[1439.73,204.337],[1443.9,313.328],[1443.9,212.693]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1482.36,312.337],[1443.9,313.328],[1482.36,211.26],[1443.9,212.693]]
                },{
                    num:"604",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1463.97,341.203],[1463.97,252.984],[1467.03,345.441],[1467.03,259.111]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1468.59,456.812],[1468.59,373.236],[1470.75,458.102],[1470.75,375.833]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1468.59,565.55],[1468.59,649.126],[1470.75,565.138],[1470.75,647.407]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1468.59,658.769],[1468.59,742.345],[1470.75,656.899],[1470.75,739.168]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1469.82,757.857],[1469.82,841.447],[1472.04,754.311],[1472.04,836.545]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1482.36,312.337],[1482.36,211.26],[1500.07,317.466],[1500.07,218.674]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1497.16,822.317],[1497.16,930.555],[1552.52,815.884],[1552.52,921.662]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1500.07,317.466],[1500.07,218.674],[1510.66,321.074],[1510.66,223.889]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,432.496],[1499.89,324.268],[1554.71,434.93],[1554.71,329.17]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,555.251],[1499.89,447.023],[1554.71,554.886],[1554.71,449.126]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,573.306],[1499.89,681.534],[1554.71,572.53],[1554.71,678.29]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1499.89,694.021],[1499.89,802.249],[1554.71,690.493],[1554.71,796.253]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1510.66,321.074],[1510.66,223.889],[1521.5,326.375],[1521.5,231.551]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1552.52,815.884],[1552.52,921.662],[1557.93,788.199],[1557.93,883.39]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1554.71,434.93],[1554.71,329.17],[1559.9,445.369],[1559.9,350.192]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1554.71,554.886],[1554.71,449.126],[1559.9,553.322],[1559.9,458.145]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1554.71,572.53],[1554.71,678.29],[1559.9,569.2],[1559.9,664.377]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1554.71,690.492],[1554.71,796.253],[1559.9,675.358],[1559.9,770.536]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1558.77,787.986],[1558.77,883.096],[1563.12,765.374],[1563.12,851.838]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1559.93,445.423],[1559.93,350.301],[1564.17,453.954],[1564.17,367.48]]
                },{
                    num:"404",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1559.93,553.314],[1559.93,458.191],[1564.17,552.035],[1564.17,465.561]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1559.93,569.183],[1559.93,664.305],[1564.17,566.461],[1564.17,652.936]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:60,
                    verts:[[1559.93,675.28],[1559.93,770.403],[1564.17,662.913],[1564.17,749.387]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[440.682,795.616],[440.682,893.643],[421.968,787.975],[421.968,883.081]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[440.625,442.596],[440.625,344.607],[422.328,445.475],[422.328,350.405]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[440.625,553.738],[440.625,455.749],[422.328,553.306],[422.328,458.236]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[440.625,570.084],[440.625,668.073],[422.328,569.166],[422.328,664.236]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[440.625,679.379],[440.625,777.367],[422.328,675.205],[422.328,770.275]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[500.244,442.133],[500.244,343.674],[440.625,442.596],[440.625,344.607]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[500.244,553.807],[500.244,455.349],[440.625,553.738],[440.625,455.749]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[500.244,570.232],[500.244,668.69],[440.625,570.084],[440.625,668.073]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[500.244,680.05],[500.244,778.509],[440.625,679.379],[440.625,777.367]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[497.476,796.786],[497.476,895.262],[440.682,795.616],[440.682,893.643]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[616.903,804.892],[616.903,906.466],[479.736,802.003],[479.736,902.473]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[611.347,439.221],[611.347,337.811],[483.211,440.238],[483.211,339.858]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[611.347,554.243],[611.347,452.833],[483.211,554.091],[483.211,453.712]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[611.347,571.161],[611.347,672.571],[483.211,570.837],[483.211,671.216]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[611.347,684.272],[611.347,785.682],[483.211,682.797],[483.211,783.177]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[550.359,331.352],[550.359,238.745],[517.489,331.897],[517.489,239.533]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[564.39,320.212],[564.39,222.644],[530.584,326.356],[530.584,231.524]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[627.326,314.711],[627.326,214.692],[564.39,320.212],[564.39,222.644]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[719.32,816.635],[719.32,922.701],[583.414,813.671],[583.414,918.602]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[701.453,432.682],[701.453,324.643],[584.536,435.701],[584.536,330.722]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[701.453,555.223],[701.453,447.184],[584.536,554.771],[584.536,449.792]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[701.453,573.247],[701.453,681.286],[584.536,572.284],[584.536,677.262]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[701.453,693.751],[701.453,801.791],[584.536,689.375],[584.536,794.353]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[737.135,308.095],[737.135,205.128],[627.326,314.711],[627.326,214.692]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1159.34,433.579],[1159.34,322.742],[708.23,437.202],[708.23,330.167]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1159.34,559.292],[1159.34,448.456],[708.23,558.605],[708.23,451.57]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1159.34,577.783],[1159.34,688.619],[708.23,576.461],[708.23,683.497]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1159.34,701.407],[1159.34,812.243],[708.23,695.846],[708.23,802.882]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[857.4,821.944],[857.4,930.039],[714.228,818.795],[714.228,925.686]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[867.898,303.087],[867.898,197.891],[738.249,308.051],[738.249,205.065]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1029.9,300.113],[1029.9,193.591],[867.898,303.087],[867.898,197.891]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1166.01,828.732],[1166.01,939.422],[1015.92,825.431],[1015.92,934.859]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1029.9,300.113],[1062.76,300.225],[1029.9,193.591],[1062.76,193.751]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1062.76,300.225],[1173.03,300.377],[1062.76,193.751],[1173.03,193.971]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1166.01,828.732],[1166.01,939.422],[1167.67,826.416],[1167.67,936.221]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1316.57,829.665],[1167.67,826.416],[1316.57,940.712],[1167.67,936.221]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1171.66,428.736],[1171.66,316.695],[1317.23,429.67],[1317.23,318.577]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1171.66,555.815],[1171.66,443.775],[1317.23,555.675],[1317.23,444.582]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1171.66,574.506],[1171.66,686.546],[1317.23,574.208],[1317.23,685.3]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1171.66,699.473],[1171.66,811.513],[1317.23,698.118],[1317.23,809.211]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1178.84,300.076],[1178.84,193.538],[1315.78,302.465],[1315.78,196.991]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1309.88,819.487],[1466.02,822.775],[1309.88,926.642],[1466.02,931.189]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1315.78,302.465],[1315.78,196.991],[1403.17,305.585],[1403.17,201.5]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1317.23,429.67],[1317.23,318.577],[1319.24,433.604],[1319.24,326.5]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1317.23,555.675],[1317.23,444.582],[1319.24,555.085],[1319.24,447.981]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1317.23,574.208],[1317.23,685.3],[1319.24,572.953],[1319.24,680.057]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1317.23,698.118],[1317.23,809.211],[1319.24,692.414],[1319.24,799.519]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1316.57,829.665],[1316.57,940.712],[1318.59,819.284],[1318.59,926.362]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1319.24,433.604],[1465.22,432.446],[1319.24,326.5],[1465.22,324.167]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1319.24,555.085],[1465.22,555.259],[1319.24,447.981],[1465.22,446.98]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1319.24,572.953],[1465.22,573.322],[1319.24,680.057],[1465.22,681.601]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1319.24,692.414],[1465.22,694.094],[1319.24,799.519],[1465.22,802.372]]
                },{
                    num:"504",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1332.69,459.927],[1332.69,379.509],[1333.76,462.01],[1333.76,383.702]]
                },{
                    num:"304",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1332.69,564.556],[1332.69,644.974],[1333.76,563.892],[1333.76,642.199]]
                },{
                    num:"204",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1332.69,654.253],[1332.69,734.671],[1333.76,651.234],[1333.76,729.541]]
                },{
                    num:"104",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1332.84,749.664],[1332.84,830.121],[1333.9,744.161],[1333.9,822.514]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1403.17,305.585],[1403.17,201.5],[1463.24,310.505],[1463.24,208.612]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1460.98,316.262],[1499,315.632],[1460.98,216.934],[1499,216.023]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1463.32,434.648],[1533.18,434.105],[1463.32,328.601],[1533.18,327.508]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1463.32,572.62],[1533.18,572.793],[1463.32,678.666],[1533.18,679.39]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1463.32,690.902],[1533.18,691.689],[1463.32,796.949],[1533.18,798.286]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1464.04,816.711],[1530.59,818.083],[1464.04,922.805],[1530.59,924.701]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1463.32,554.929],[1463.32,448.882],[1533.18,555.01],[1533.18,448.413]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1499,315.632],[1499,216.023],[1510.41,320.855],[1510.41,223.573]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1510.41,320.855],[1510.41,223.573],[1516.65,324.508],[1516.65,228.853]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1516.65,324.508],[1516.65,228.853],[1521.28,329.829],[1521.28,236.544]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1530.59,818.083],[1530.59,924.701],[1577.49,811.12],[1577.49,915.076]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1533.18,434.105],[1533.18,327.508],[1579.55,436.736],[1579.55,332.806]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1533.18,555.01],[1533.18,448.413],[1579.55,554.616],[1579.55,450.686]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1533.18,572.793],[1533.18,679.39],[1579.55,571.954],[1579.55,675.883]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:61,
                    verts:[[1533.18,691.689],[1533.18,798.286],[1579.55,687.874],[1579.55,791.804]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[447.339,439.941],[447.339,339.26],[420.827,442.824],[420.827,345.067]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[447.339,554.135],[447.339,453.455],[420.827,553.703],[420.827,455.946]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[447.339,570.931],[447.339,671.612],[420.827,570.011],[420.827,667.769]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[447.339,683.228],[447.339,783.909],[420.827,679.048],[420.827,776.805]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[447.497,802.658],[447.497,903.379],[420.541,795.009],[420.541,892.804]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[510.643,439.718],[510.643,338.812],[447.339,439.941],[447.339,339.26]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[510.643,554.169],[510.643,453.263],[447.339,554.136],[447.339,453.455]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[510.643,571.002],[510.643,671.908],[447.339,570.931],[447.339,671.612]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[510.643,683.551],[510.643,784.457],[447.339,683.228],[447.339,783.909]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[507.808,803.22],[507.808,904.155],[447.497,802.658],[447.497,903.379]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[639.101,810.151],[639.101,913.736],[494.39,808.774],[494.39,911.833]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[632.971,437.217],[632.971,333.775],[497.778,437.701],[497.778,334.751]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[632.971,554.544],[632.971,451.102],[497.778,554.471],[497.778,451.52]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[632.971,571.8],[632.971,675.242],[497.778,571.646],[497.778,674.596]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[632.971,687.177],[632.971,790.619],[497.778,686.475],[497.778,789.425]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[547.883,326.645],[513.19,326.905],[547.883,231.941],[513.19,232.317]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[574.885,315.381],[574.885,215.66],[532.997,321.349],[532.997,224.287]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[645.914,310.369],[645.914,208.416],[574.885,315.381],[574.885,215.66]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[755.222,820.908],[755.222,928.607],[613.042,819.507],[613.042,926.67]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[741.935,430.958],[741.935,321.17],[614.318,433.504],[614.318,326.297]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[741.935,555.482],[741.935,445.694],[614.318,555.1],[614.318,447.894]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[741.935,573.797],[741.935,683.584],[614.318,572.985],[614.318,680.191]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[741.935,696.251],[741.935,806.039],[614.318,692.56],[614.318,799.766]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[765.625,304.715],[765.625,200.243],[645.914,310.369],[645.914,208.416]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1207.26,433.909],[1207.26,323.419],[746.34,435.581],[746.34,326.846]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1207.26,559.23],[1207.26,448.74],[746.34,558.913],[746.34,450.177]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1207.26,577.662],[1207.26,688.152],[746.34,577.052],[746.34,685.788]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1207.26,700.9],[1207.26,811.39],[746.34,698.334],[746.34,807.07]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[900.197,824.635],[900.197,933.758],[752.096,823.163],[752.096,931.725]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[903.564,300.948],[903.564,194.799],[766.809,304.681],[766.809,200.194]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1068.82,299.578],[903.564,300.948],[1068.82,192.817],[903.564,194.799]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1213.45,827.747],[1062.11,826.243],[1213.45,938.061],[1062.11,935.982]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1068.82,299.578],[1101.28,300.018],[1068.82,192.817],[1101.28,193.452]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1101.28,300.018],[1101.28,193.452],[1209.82,301.264],[1209.82,195.253]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1212.91,825.418],[1361.16,826.879],[1212.91,934.842],[1361.16,936.861]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1215.84,301.022],[1215.84,194.904],[1346.79,304.735],[1346.79,200.272]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1222.31,429.137],[1222.31,317.503],[1361.91,430.724],[1361.91,320.7]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1222.31,555.755],[1222.31,444.121],[1361.91,555.517],[1361.91,445.492]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1222.31,574.378],[1222.31,686.011],[1361.91,573.871],[1361.91,683.896]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1222.31,698.891],[1222.31,810.525],[1361.91,696.59],[1361.91,806.615]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1345.17,816.87],[1345.17,923.026],[1498.73,818.332],[1498.73,925.046]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1346.79,304.735],[1346.79,200.272],[1427.86,308.657],[1427.86,205.941]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1354.12,434.631],[1354.12,328.568],[1497.64,434.117],[1497.64,327.532]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1354.12,572.625],[1354.12,678.688],[1497.64,572.789],[1497.64,679.374]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1354.12,690.926],[1354.12,796.989],[1497.64,691.672],[1497.64,798.257]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1354.12,554.931],[1354.12,448.868],[1497.64,555.008],[1497.64,448.423]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1427.86,308.657],[1427.86,205.942],[1480.24,314.071],[1480.24,213.767]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1471.84,319.721],[1508.92,319.443],[1471.84,221.934],[1508.92,221.532]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1490.4,436.277],[1490.4,331.882],[1558.47,436.038],[1558.47,331.4]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1490.4,572.1],[1490.4,676.495],[1558.47,572.176],[1558.47,676.814]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1490.4,688.54],[1490.4,792.935],[1558.47,688.887],[1558.47,793.524]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1491.2,812.382],[1556.05,812.986],[1491.2,916.82],[1556.05,917.655]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1490.4,554.685],[1490.4,450.29],[1558.47,554.72],[1558.47,450.083]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1508.92,319.443],[1508.92,221.532],[1514.19,324.68],[1514.19,229.101]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1514.19,324.68],[1514.19,229.101],[1516.21,328.324],[1516.21,234.369]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1556.05,812.986],[1556.05,917.655],[1594.22,805.636],[1594.22,907.495]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1558.47,436.038],[1558.47,331.4],[1596.1,438.812],[1596.1,336.988]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1558.47,554.72],[1558.47,450.083],[1596.1,554.305],[1596.1,452.48]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1558.47,572.176],[1558.47,676.814],[1596.1,571.291],[1596.1,673.116]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:62,
                    verts:[[1558.47,688.887],[1558.47,793.524],[1596.1,684.864],[1596.1,786.689]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[460.911,437.417],[460.911,334.177],[425.827,440.257],[425.827,339.897]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[460.911,554.514],[460.911,451.274],[425.827,554.088],[425.827,453.728]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[460.911,571.736],[460.911,674.976],[425.827,570.831],[425.827,671.191]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[460.911,686.887],[460.911,790.127],[425.827,682.77],[425.827,783.13]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[461.177,809.35],[461.177,912.63],[425.627,801.822],[425.627,902.223]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[527.264,437.466],[527.264,334.277],[460.911,437.417],[460.911,334.177]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[527.264,554.506],[527.264,451.317],[460.911,554.514],[460.911,451.274]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[527.264,571.721],[527.264,674.91],[460.911,571.736],[460.911,674.976]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[527.264,686.816],[527.264,790.005],[460.911,686.887],[460.911,790.127]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[524.4,809.226],[461.177,809.35],[524.4,912.457],[461.177,912.63]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[509.948,327.311],[509.948,232.904],[508.794,330.925],[508.794,238.127]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[513.925,322.104],[513.925,225.378],[509.948,327.311],[509.948,232.904]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[550.136,322.161],[513.926,322.104],[550.136,225.461],[513.926,225.378]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[666.392,814.753],[666.392,920.098],[515.858,815.056],[515.858,920.517]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[659.749,435.456],[659.749,330.229],[519.098,435.349],[519.098,330.014]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[659.749,554.808],[659.749,449.581],[519.098,554.824],[519.098,449.488]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[659.749,572.362],[659.749,677.589],[519.098,572.396],[519.098,677.731]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[659.749,689.73],[659.749,794.957],[519.098,689.885],[519.098,795.22]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[590.668,310.94],[590.668,209.241],[540.697,316.62],[540.697,217.451]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[669.271,306.543],[669.271,202.886],[590.668,310.94],[590.668,209.241]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[795.069,824.265],[648.662,824.57],[795.069,933.247],[648.662,933.669]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[786.809,429.609],[786.809,318.453],[650.081,431.599],[650.081,322.462]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[786.809,555.684],[786.809,444.529],[650.081,555.386],[650.081,446.249]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[786.809,574.227],[786.809,685.382],[650.081,573.592],[650.081,682.729]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[786.809,698.207],[786.809,809.362],[650.081,695.321],[650.081,804.458]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[797.555,302.013],[797.555,196.338],[669.271,306.543],[669.271,202.886]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[788.651,434.308],[788.651,324.236],[1251.68,434.664],[1251.68,324.965]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[788.651,559.154],[788.651,449.083],[1251.68,559.087],[1251.68,449.388]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[788.651,577.517],[788.651,687.588],[1251.68,577.387],[1251.68,687.085]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[788.651,700.288],[788.651,810.36],[1251.68,699.742],[1251.68,809.441]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[944.726,826.265],[794.054,826.581],[944.726,936.012],[794.054,936.45]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[940.719,299.611],[940.719,192.866],[798.793,301.991],[798.793,196.306]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[940.719,299.611],[1106.61,299.903],[940.719,192.866],[1106.61,193.287]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1106.61,299.903],[1138.15,300.666],[1106.61,193.287],[1138.15,194.389]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1107.31,825.923],[1107.31,935.539],[1257.29,825.607],[1257.29,935.103]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1138.15,300.666],[1138.15,194.389],[1243.22,302.979],[1243.22,197.732]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1249.37,302.798],[1249.37,197.472],[1372.43,307.74],[1372.43,204.616]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1254.58,823.306],[1254.58,931.922],[1399.7,823.003],[1399.7,931.503]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1269.15,429.996],[1269.15,319.233],[1400.52,432.19],[1400.52,323.652]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1269.15,555.626],[1269.15,444.863],[1400.52,555.297],[1400.52,446.759]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1269.15,574.104],[1269.15,684.866],[1400.52,573.404],[1400.52,681.942]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1269.15,697.646],[1269.15,808.409],[1400.52,694.465],[1400.52,803.003]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1372.43,307.74],[1372.43,204.615],[1446.2,312.368],[1446.2,211.305]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1374.98,813.325],[1374.98,918.124],[1523.63,813.025],[1523.63,917.71]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1383.4,436.005],[1383.4,331.335],[1522.28,436.111],[1522.28,331.548]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1383.4,572.187],[1383.4,676.857],[1522.28,572.153],[1522.28,676.716]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1383.4,688.933],[1383.4,793.603],[1522.28,688.781],[1522.28,793.344]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1383.4,554.725],[1383.4,450.055],[1522.28,554.709],[1522.28,450.146]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1446.2,312.368],[1446.2,211.305],[1490.52,318.165],[1490.52,219.685]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1476.41,323.631],[1512.11,323.687],[1476.41,227.585],[1512.11,227.667]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1510.09,438.197],[1510.09,335.749],[1575.43,438.246],[1575.43,335.846]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1510.09,571.488],[1510.09,673.936],[1575.43,571.472],[1575.43,673.871]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1510.09,685.756],[1510.09,788.205],[1575.43,685.686],[1575.43,788.085]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1510.96,807.279],[1510.96,909.767],[1573.22,807.157],[1573.22,909.597]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1510.09,554.397],[1510.09,451.949],[1575.43,554.39],[1575.43,451.991]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1573.22,807.157],[1573.22,909.597],[1602.63,799.565],[1602.63,899.104]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1575.43,438.246],[1575.43,335.846],[1604.33,441.109],[1604.33,341.612]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1575.43,554.389],[1575.43,451.991],[1604.33,553.96],[1604.33,454.464]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1575.43,571.472],[1575.43,673.871],[1604.33,570.559],[1604.33,670.055]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:63,
                    verts:[[1575.43,685.686],[1575.43,788.085],[1604.33,681.535],[1604.33,781.032]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[481.667,435.095],[481.667,329.502],[437.853,437.837],[437.853,335.023]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[481.667,554.862],[481.667,449.269],[437.853,554.451],[437.853,451.637]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[481.667,572.477],[481.667,678.07],[437.853,571.602],[437.853,674.416]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[481.667,690.253],[481.667,795.846],[437.853,686.279],[437.853,789.092]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[482.046,815.505],[482.046,921.138],[437.748,808.243],[437.748,911.099]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[550.252,435.442],[481.667,435.095],[550.252,330.2],[481.667,329.502]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[550.252,554.81],[550.252,449.568],[481.667,554.862],[481.667,449.269]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[550.252,572.367],[550.252,677.608],[481.667,572.477],[481.667,678.07]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[550.252,689.751],[481.667,690.253],[550.252,794.992],[481.667,795.846]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[547.401,814.629],[482.046,815.505],[547.401,919.926],[482.046,921.138]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[504.84,326.538],[504.84,231.786],[501.5,331.851],[501.5,239.467]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[510.114,322.87],[510.114,226.486],[504.84,326.538],[504.84,231.786]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[520.106,317.609],[520.106,218.881],[510.114,322.87],[510.114,226.486]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[557.451,318.012],[520.106,317.609],[557.451,219.463],[520.106,218.881]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[698.471,818.545],[544.218,820.657],[698.471,925.34],[544.218,928.261]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[691.396,433.997],[547.247,433.253],[691.396,327.291],[547.247,325.793]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[691.396,555.026],[691.396,448.32],[547.247,555.138],[547.247,447.678]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[691.396,572.827],[691.396,679.533],[547.247,573.065],[547.247,680.525]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[691.396,691.845],[547.247,692.923],[691.396,798.551],[547.247,800.383]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[611.787,307.019],[611.787,203.574],[553.951,312.292],[553.951,211.195]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[697.172,303.356],[697.172,198.278],[611.787,307.019],[611.787,203.574]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[689.799,828.679],[838.073,826.576],[689.799,939.35],[838.073,936.441]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[835.154,428.689],[835.154,316.601],[691.343,430.055],[691.343,319.353]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[835.154,555.822],[835.154,443.734],[691.343,555.617],[691.343,444.915]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[835.154,574.521],[835.154,686.608],[691.343,574.085],[691.343,684.787]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[835.154,699.54],[835.154,811.628],[691.343,697.559],[691.343,808.262]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[832.343,300.089],[832.343,193.556],[697.172,303.356],[697.172,198.278]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[978.524,299.133],[833.616,300.079],[978.524,192.175],[833.616,193.542]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[834.312,433.432],[834.312,322.442],[1291.53,435.821],[1291.53,327.336]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[834.312,559.32],[834.312,448.33],[1291.53,558.867],[1291.53,450.383]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[834.312,577.836],[834.312,688.826],[1291.53,576.965],[1291.53,685.449]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[834.312,701.632],[834.312,812.622],[1291.53,697.966],[1291.53,806.451]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[839.256,828.915],[839.256,939.676],[838.073,826.576],[838.073,936.441]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[839.256,828.915],[989.932,826.76],[839.256,939.676],[989.932,936.696]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[978.524,299.133],[978.524,192.175],[1142.35,301.09],[1142.35,195.003]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1142.35,301.09],[1172.48,302.16],[1142.35,195.003],[1172.48,196.548]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1150.39,824.464],[1150.39,933.523],[1296.49,822.374],[1296.49,930.633]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1172.48,302.16],[1172.48,196.548],[1272.51,305.477],[1272.51,201.343]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1278.67,305.359],[1278.67,201.173],[1392.26,311.397],[1392.26,209.902]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1291.72,820.138],[1291.72,927.543],[1431.4,818.156],[1431.4,924.803]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1311.06,431.287],[1311.06,321.833],[1432.29,434.022],[1432.29,327.342]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1311.06,555.432],[1311.06,445.979],[1432.29,555.022],[1432.29,448.342]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1311.06,573.692],[1311.06,683.145],[1432.29,572.819],[1432.29,679.5]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1311.06,695.774],[1311.06,805.228],[1432.29,691.808],[1432.29,798.489]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1392.26,311.397],[1392.26,209.902],[1458.03,316.617],[1458.03,217.447]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1398.76,808.952],[1398.76,912.079],[1540.49,807.01],[1540.49,909.395]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1406.53,437.688],[1406.53,334.723],[1538.91,438.371],[1538.91,336.099]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1406.53,571.65],[1406.53,674.615],[1538.91,571.432],[1538.91,673.704]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1406.53,686.495],[1406.53,789.459],[1538.91,685.504],[1538.91,787.776]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1406.53,554.473],[1406.53,451.509],[1538.91,554.371],[1538.91,452.099]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1458.03,316.617],[1458.03,217.447],[1494.12,322.684],[1494.12,226.216]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1474.83,327.898],[1474.83,233.753],[1508.79,328.264],[1508.79,234.282]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1522.27,440.355],[1522.27,340.094],[1584.11,440.668],[1584.11,340.724]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1522.27,682.628],[1522.27,782.888],[1584.11,682.175],[1584.11,782.118]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1523.19,801.546],[1523.19,901.842],[1582.12,800.756],[1582.12,900.75]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1522.27,554.073],[1522.27,453.813],[1584.11,554.027],[1584.11,454.083]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1522.27,570.799],[1522.27,671.06],[1584.11,570.699],[1584.11,670.643]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1582.12,800.756],[1582.12,900.75],[1602.98,793.064],[1602.98,890.116]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1584.11,440.668],[1584.11,340.724],[1604.49,443.566],[1604.49,346.561]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1584.11,554.027],[1584.11,454.083],[1604.49,553.592],[1604.49,456.587]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1584.11,570.699],[1584.11,670.643],[1604.49,569.775],[1604.49,666.78]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:64,
                    verts:[[1584.11,682.175],[1584.11,782.118],[1604.49,677.972],[1604.49,774.977]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,433.043],[509.643,325.37],[457.181,435.629],[457.181,330.577]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,555.169],[509.643,447.496],[457.181,554.782],[457.181,449.73]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,573.132],[509.643,680.805],[457.181,572.307],[457.181,677.358]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,693.228],[509.643,800.901],[457.181,689.479],[457.181,794.531]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[510.135,820.941],[510.135,928.653],[457.18,814.099],[457.18,919.194]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[506.127,322.438],[506.127,225.86],[496.673,327.797],[496.673,233.606]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[515.715,318.769],[515.715,220.557],[506.127,322.438],[506.127,225.86]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,433.043],[579.473,433.705],[509.643,325.37],[579.473,326.703]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,555.169],[509.643,447.496],[579.473,555.07],[579.473,448.068]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,573.132],[579.473,572.92],[509.643,680.805],[579.473,679.922]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[509.643,693.228],[579.473,692.268],[509.643,800.901],[579.473,799.27]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[510.135,820.941],[576.684,819.268],[510.135,928.653],[576.684,926.339]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[531.964,313.533],[531.964,212.989],[515.715,318.769],[515.715,220.557]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[531.964,313.533],[569.984,314.301],[531.964,212.989],[569.984,214.099]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[550.673,756.575],[550.673,839.674],[549.197,753.018],[549.197,834.757]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[552.878,457.301],[552.878,374.22],[551.42,458.594],[551.42,376.824]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[552.878,565.394],[552.878,648.475],[551.42,564.981],[551.42,646.751]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[552.878,658.061],[552.878,741.142],[551.42,656.185],[551.42,737.955]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[557.405,342.327],[557.405,254.608],[555.312,346.58],[555.312,260.756]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[572.816,308.481],[572.816,205.687],[569.984,314.301],[569.984,214.099]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[638.058,303.733],[638.058,198.823],[572.816,308.481],[572.816,205.687]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[579.229,825.402],[579.229,934.819],[576.684,819.268],[576.684,926.339]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,431.479],[581.982,322.221],[579.473,433.705],[579.473,326.703]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,555.403],[581.982,446.145],[579.473,555.07],[579.473,448.068]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,573.63],[581.982,682.889],[579.473,572.92],[579.473,679.922]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,695.495],[581.982,804.754],[579.473,692.268],[579.473,799.27]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[579.229,825.402],[734.785,821.404],[579.229,934.819],[734.785,929.292]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,431.479],[581.982,322.221],[727.378,432.887],[727.378,325.056]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,555.404],[581.982,446.145],[727.378,555.193],[727.378,447.361]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,573.63],[581.982,682.889],[727.378,573.181],[727.378,681.013]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[581.982,695.495],[581.982,804.754],[727.378,693.454],[727.378,801.285]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[729.173,300.906],[729.173,194.737],[638.058,303.732],[638.058,198.823]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[659.86,751.121],[659.86,832.135],[654.646,745.58],[654.646,824.475]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[660.894,459.385],[660.894,378.418],[655.635,461.482],[655.635,382.639]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[660.894,564.729],[660.894,645.697],[655.635,564.06],[655.635,642.903]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[660.894,655.038],[660.894,736.006],[655.635,651.999],[655.635,730.842]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[735.669,831.69],[735.669,943.512],[725.834,821.237],[725.834,929.062]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[737.315,428.927],[737.315,317.081],[727.378,432.887],[727.378,325.056]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[737.315,555.786],[737.315,443.94],[727.378,555.193],[727.378,447.361]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[737.315,574.445],[737.315,686.291],[727.378,573.181],[727.378,681.013]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[737.315,699.195],[737.315,811.042],[727.378,693.454],[727.378,801.285]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[869.242,299.004],[869.242,191.988],[729.173,300.906],[729.173,194.737]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[735.669,831.69],[735.669,943.512],[883.247,827.759],[883.247,938.077]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[885.822,428.233],[885.822,315.683],[737.315,428.927],[737.315,317.081]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[885.822,555.89],[885.822,443.34],[737.315,555.786],[737.315,443.94]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[885.822,574.666],[885.822,687.216],[737.315,574.445],[737.315,686.291]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[885.822,700.202],[885.822,812.751],[737.315,699.195],[737.315,811.042]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[870.53,299.007],[1016.09,299.53],[870.53,191.992],[1016.09,192.749]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[882.26,432.986],[882.26,321.527],[1326,437.34],[1326,330.448]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[882.26,559.405],[882.26,447.947],[1326,558.579],[1326,451.688]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[882.26,577.999],[882.26,689.457],[1326,576.411],[1326,683.303]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[882.26,702.317],[882.26,813.775],[1326,695.636],[1326,802.527]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[886.648,830.079],[886.648,941.285],[883.247,827.759],[883.247,938.077]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[886.648,830.079],[886.648,941.285],[1034.7,826.102],[1034.7,935.787]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1016.09,299.53],[1016.09,192.749],[1175.25,303.097],[1175.25,197.905]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1175.25,303.097],[1175.25,197.905],[1203.52,304.448],[1203.52,199.855]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1190.32,821.921],[1190.32,930.008],[1330.24,818.163],[1330.24,924.812]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1203.52,304.448],[1203.52,199.855],[1297.13,308.677],[1297.13,205.967]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1303.21,308.619],[1303.21,205.886],[1406.11,315.596],[1406.11,215.971]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1323.58,816.027],[1323.58,921.86],[1455.87,812.503],[1455.87,916.988]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1347.16,432.964],[1347.16,325.21],[1456.79,436.159],[1456.79,331.645]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1347.16,555.181],[1347.16,447.427],[1456.79,554.702],[1456.79,450.188]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1347.16,573.157],[1347.16,680.911],[1456.79,572.138],[1456.79,676.652]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1347.16,693.343],[1347.16,801.097],[1456.79,688.71],[1456.79,793.225]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1406.11,315.596],[1406.11,215.971],[1463.43,321.286],[1463.43,224.195]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1416.24,803.889],[1416.24,905.08],[1549.42,800.466],[1549.42,900.348]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1423.29,439.625],[1423.29,338.625],[1547.66,440.83],[1547.66,341.05]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1423.29,571.032],[1423.29,672.032],[1547.66,570.648],[1547.66,670.427]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1423.29,683.685],[1423.29,784.685],[1547.66,681.939],[1547.66,781.719]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1423.29,554.183],[1423.29,453.183],[1547.66,554.002],[1547.66,454.223]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1463.43,321.286],[1463.43,224.195],[1491.37,327.51],[1491.37,233.192]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1467.47,332.42],[1467.47,240.289],[1499.4,333.064],[1499.4,241.22]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1527.12,442.69],[1527.12,344.796],[1584.87,443.237],[1584.87,345.898]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1527.12,679.243],[1527.12,777.137],[1584.87,678.449],[1584.87,775.788]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1528.08,795.344],[1528.08,893.268],[1583.11,793.961],[1583.11,891.355]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1527.12,553.724],[1527.12,455.83],[1584.87,553.641],[1584.87,456.303]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1527.12,570.055],[1527.12,667.948],[1584.87,569.88],[1584.87,667.219]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1583.11,793.961],[1583.11,891.355],[1595.83,786.294],[1595.83,880.757]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1584.87,443.237],[1584.87,345.898],[1597.14,446.124],[1597.14,351.712]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1584.87,553.641],[1584.87,456.303],[1597.14,553.209],[1597.14,458.797]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1584.87,569.88],[1584.87,667.219],[1597.14,568.959],[1597.14,663.371]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:65,
                    verts:[[1584.87,678.449],[1584.87,775.788],[1597.14,674.264],[1597.14,768.676]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[457.139,444.318],[457.139,348.074],[435.478,452.954],[435.478,365.467]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[457.139,553.479],[457.139,457.236],[435.478,552.185],[435.478,464.698]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[457.139,569.535],[457.139,665.778],[435.478,566.78],[435.478,654.268]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[457.139,676.883],[457.139,773.126],[435.478,664.362],[435.478,751.85]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[457.139,790.949],[457.139,887.192],[435.478,768.051],[435.478,855.539]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[483.786,433.693],[483.786,326.678],[457.276,444.263],[457.276,347.964]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[483.786,555.072],[483.786,448.057],[457.276,553.488],[457.276,457.189]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[483.786,572.924],[483.786,679.939],[457.276,569.553],[457.276,665.851]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[483.786,692.286],[483.786,799.301],[457.276,676.962],[457.276,773.261]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[483.895,819.234],[483.895,926.293],[457.364,791.187],[457.364,887.522]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,431.321],[544.536,321.902],[483.786,433.693],[483.786,326.678]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,555.427],[544.536,446.008],[483.786,555.072],[483.786,448.057]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,573.681],[544.536,683.1],[483.786,572.924],[483.786,679.939]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,695.725],[544.536,805.144],[483.786,692.286],[483.786,799.301]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[545.14,825.503],[545.14,934.958],[483.895,819.234],[483.895,926.293]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[512.887,318.713],[512.887,220.476],[497.092,324.04],[497.092,228.176]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[526.901,315.099],[526.901,215.252],[512.887,318.713],[512.887,220.476]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[524.745,760.103],[524.745,844.551],[519.79,756.524],[519.79,839.603]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[526.97,455.978],[526.97,371.556],[522.157,457.28],[522.157,374.177]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[526.97,565.816],[526.97,650.238],[522.157,565.401],[522.157,648.503]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[526.97,659.979],[526.97,744.401],[522.157,658.092],[522.157,741.194]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[549.513,309.973],[549.513,207.843],[526.901,315.099],[526.901,215.252]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[543.33,339.253],[543.33,250.166],[536.397,343.529],[536.397,256.346]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,431.321],[544.536,321.902],[614.499,432.307],[614.499,323.887]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,555.427],[544.536,446.008],[614.499,555.28],[614.499,446.86]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,573.681],[544.536,683.1],[614.499,573.366],[614.499,681.786]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[544.536,695.725],[544.536,805.144],[614.499,694.296],[614.499,802.715]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[545.14,825.503],[611.821,823.01],[545.14,934.958],[611.821,931.513]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[549.514,309.973],[587.691,311.117],[549.514,207.844],[587.691,209.496]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[597.112,305.287],[597.112,201.069],[587.691,311.117],[587.691,209.496]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[669.056,301.168],[669.056,195.117],[597.112,305.287],[597.112,201.069]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[620.315,829.147],[620.315,939.996],[611.821,823.01],[611.821,931.513]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,430.08],[622.731,319.404],[614.499,432.307],[614.499,323.887]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,555.613],[622.731,444.936],[614.499,555.28],[614.499,446.86]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,574.077],[622.731,684.753],[614.499,573.366],[614.499,681.786]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,697.523],[622.731,808.2],[614.499,694.296],[614.499,802.715]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[631.455,753.596],[631.455,835.556],[620.819,748.068],[620.819,827.914]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[620.315,829.147],[620.315,939.996],[774.561,823.251],[774.561,931.846]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[632.395,458.456],[632.395,376.546],[621.697,460.547],[621.697,380.757]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[632.395,565.025],[632.395,646.936],[621.697,564.358],[621.697,644.149]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[632.395,656.386],[632.395,738.297],[621.697,653.355],[621.697,733.145]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,430.081],[622.731,319.404],[766.939,432.157],[766.939,323.585]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,555.613],[622.731,444.937],[766.939,555.302],[766.939,446.73]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,574.077],[622.731,684.753],[766.939,573.414],[766.939,681.986]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[622.731,697.523],[622.731,808.2],[766.939,694.513],[766.939,803.084]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[764.62,299.259],[764.62,192.357],[669.056,301.168],[669.056,195.117]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[907.395,298.78],[764.62,299.259],[907.395,191.665],[764.62,192.357]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[785.218,833.511],[785.218,946.03],[765.363,823.192],[765.363,931.764]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[786.938,428.248],[786.938,315.713],[766.939,432.157],[766.939,323.585]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[786.938,555.888],[786.938,443.353],[766.939,555.302],[766.939,446.73]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[786.938,574.661],[786.938,687.196],[766.939,573.414],[766.939,681.986]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[786.938,700.18],[786.938,812.715],[766.939,694.513],[766.939,803.084]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[785.218,833.511],[785.218,946.03],[929.483,827.79],[929.483,938.12]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[937.528,428.25],[786.938,428.248],[937.528,315.718],[786.938,315.713]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[937.528,555.887],[937.528,443.355],[786.938,555.888],[786.938,443.353]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[937.528,574.66],[937.528,687.192],[786.938,574.661],[786.938,687.196]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[937.528,700.176],[786.938,700.18],[937.528,812.708],[786.938,812.715]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[908.677,298.796],[908.677,191.688],[1052.53,300.773],[1052.53,194.545]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[935.051,830.051],[935.051,941.246],[929.483,827.79],[929.483,938.12]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[931.299,432.978],[931.299,321.512],[1354.53,439.162],[1354.53,334.183]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[931.299,559.406],[931.299,447.94],[1354.53,558.234],[1354.53,453.254]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[931.299,578.001],[931.299,689.467],[1354.53,575.747],[1354.53,680.726]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[931.299,702.328],[931.299,813.794],[1354.53,692.839],[1354.53,797.818]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[935.051,830.051],[935.051,941.246],[1077.93,824.336],[1077.93,933.346]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1052.53,300.773],[1052.53,194.545],[1204.64,305.845],[1204.64,201.876]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1204.64,305.845],[1204.64,201.876],[1230.69,307.441],[1230.69,204.182]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1226.27,818.402],[1226.27,925.143],[1358.03,813.131],[1358.03,917.856]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1230.69,307.441],[1230.69,204.182],[1316.77,312.465],[1316.77,211.443]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1322.68,312.466],[1322.68,211.446],[1414.06,320.208],[1414.06,222.638]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1349.69,811.124],[1349.69,915.082],[1473.02,806.233],[1473.02,908.32]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1376.91,434.962],[1376.91,329.234],[1473.97,438.529],[1473.97,336.417]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1376.91,554.882],[1376.91,449.153],[1473.97,554.347],[1473.97,452.235]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1376.91,572.52],[1376.91,678.248],[1473.97,571.382],[1473.97,673.493]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1376.91,690.446],[1376.91,796.175],[1473.97,685.275],[1473.97,787.387]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1414.06,320.208],[1414.06,222.638],[1462.75,326.245],[1462.75,231.363]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1427.45,798.296],[1427.45,897.348],[1550.88,793.578],[1550.88,890.826]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1433.74,441.758],[1433.74,342.92],[1548.98,443.417],[1548.98,346.261]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1433.74,570.352],[1433.74,669.19],[1548.98,569.822],[1548.98,666.978]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1433.74,680.594],[1433.74,779.432],[1548.98,678.188],[1548.98,775.344]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1454.87,337.089],[1454.87,247.038],[1484.57,337.979],[1484.57,248.324]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1462.75,326.245],[1462.75,231.363],[1482.77,332.525],[1482.77,240.44]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1433.74,553.863],[1433.74,455.025],[1548.98,553.614],[1548.98,456.459]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1525.11,445.137],[1525.11,349.725],[1578.37,445.888],[1578.37,351.236]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1525.11,569.274],[1525.11,664.686],[1578.37,569.034],[1578.37,663.686]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1525.11,675.695],[1525.11,771.107],[1578.37,674.607],[1578.37,769.258]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1526.09,788.843],[1526.09,884.281],[1576.84,786.946],[1576.84,881.659]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1525.11,553.357],[1525.11,457.944],[1578.37,553.244],[1578.37,458.593]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1576.84,786.946],[1576.84,881.659],[1581.96,779.414],[1581.96,871.247]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1578.37,445.888],[1578.37,351.236],[1583.07,448.722],[1583.07,356.944]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1578.37,553.244],[1578.37,458.593],[1583.07,552.82],[1583.07,461.041]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1578.37,569.034],[1578.37,663.686],[1583.07,568.13],[1583.07,659.908]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:66,
                    verts:[[1578.37,674.607],[1578.37,769.258],[1583.07,670.498],[1583.07,762.276]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[462.648,442.663],[462.648,344.741],[418.035,451.3],[418.035,362.136]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[462.648,553.728],[462.648,455.806],[418.035,552.433],[418.035,463.269]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[462.648,570.063],[462.648,667.984],[418.035,567.308],[418.035,656.472]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[462.648,679.282],[462.648,777.203],[418.035,666.76],[418.035,755.924]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[462.648,795.337],[462.648,893.258],[418.035,772.436],[418.035,861.601]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[517.324,432.076],[517.324,323.423],[462.93,442.608],[462.93,344.632]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[517.324,555.314],[517.324,446.661],[462.93,553.736],[462.93,455.759]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[517.324,573.44],[517.324,682.093],[462.93,570.081],[462.93,668.057]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[517.324,694.629],[517.324,803.283],[462.93,679.361],[462.93,777.338]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[517.548,823.519],[517.548,932.216],[463.112,795.575],[463.112,893.587]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[502.629,763.547],[502.629,849.312],[494.072,759.985],[494.072,844.388]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[504.855,454.687],[504.855,368.956],[496.569,455.982],[496.569,371.564]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[504.855,566.227],[504.855,651.958],[496.569,565.814],[496.569,650.232]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[504.855,661.85],[504.855,747.581],[496.569,659.972],[496.569,744.39]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[498.294,326.633],[498.294,231.924],[498.012,330.282],[498.012,237.199]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[503.113,321.08],[503.113,223.898],[498.294,326.633],[498.294,231.924]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[525.16,315.436],[525.16,215.74],[502.923,320.651],[502.923,223.277]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,429.972],[585.719,319.186],[517.324,432.076],[517.324,323.423]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,555.629],[585.719,444.843],[517.324,555.314],[517.324,446.661]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,574.111],[585.719,684.897],[517.324,573.44],[517.324,682.093]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,697.68],[585.719,808.466],[517.324,694.63],[517.324,803.283]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[586.429,829.07],[586.429,939.891],[517.548,823.519],[517.548,932.216]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[533.433,336.378],[533.433,246.01],[521.513,340.623],[521.513,252.146]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[543.612,311.936],[543.612,210.681],[525.16,315.436],[525.16,215.74]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[572.539,307.007],[572.539,203.556],[543.612,311.936],[543.612,210.681]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[572.54,307.007],[610.317,308.526],[572.54,203.556],[610.317,205.752]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,429.972],[585.719,319.186],[654.626,431.28],[654.626,321.818]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,555.629],[585.719,444.843],[654.626,555.433],[654.626,445.972]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,574.111],[585.719,684.897],[654.626,573.694],[654.626,683.155]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[585.719,697.68],[585.719,808.466],[654.626,695.785],[654.626,805.246]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[586.429,829.07],[586.429,939.891],[652.107,825.766],[652.107,935.323]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[605.843,756.008],[605.843,838.89],[589.682,750.552],[589.682,831.348]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[606.679,457.549],[606.679,374.72],[590.44,459.613],[590.44,378.876]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[606.679,565.314],[606.679,648.143],[590.44,564.656],[590.44,645.393]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[606.679,657.7],[606.679,740.529],[590.44,654.708],[590.44,735.445]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[626.423,302.779],[626.423,197.444],[610.317,308.526],[610.317,205.752]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[704.143,299.382],[704.143,192.534],[626.423,302.779],[626.423,197.444]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[666.595,831.797],[666.595,943.659],[652.107,825.766],[652.107,935.323]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,429.092],[668.622,317.413],[654.626,431.279],[654.626,321.818]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,555.761],[668.622,444.083],[654.626,555.433],[654.626,445.972]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,574.392],[668.622,686.071],[654.626,573.694],[654.626,683.155]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,698.956],[668.622,810.635],[654.626,695.785],[654.626,805.246]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[666.595,831.797],[666.595,943.659],[816.864,824.057],[816.864,932.961]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,429.092],[668.622,317.413],[809.151,431.818],[809.151,322.904]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,555.761],[668.622,444.083],[809.151,555.353],[809.151,446.438]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,574.392],[668.622,686.071],[809.151,573.522],[809.151,682.437]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[668.622,698.956],[668.622,810.635],[809.151,695.003],[809.151,803.918]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[802.707,298.442],[802.707,191.176],[704.143,299.382],[704.143,192.534]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[802.707,298.442],[945.903,299.397],[802.707,191.176],[945.903,192.556]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[837.207,834.114],[837.207,946.862],[807.569,824.108],[807.569,933.031]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,428.029],[838.972,315.272],[809.151,431.818],[809.151,322.904]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,555.921],[838.972,443.164],[809.151,555.353],[809.151,446.438]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,574.731],[838.972,687.488],[809.151,573.522],[809.151,682.437]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,700.498],[838.972,813.255],[809.151,695.003],[809.151,803.918]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[837.207,834.114],[837.207,946.862],[975.643,826.705],[975.643,936.62]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,428.029],[838.972,315.272],[988.962,428.726],[988.962,316.676]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,555.921],[838.972,443.164],[988.962,555.816],[988.962,443.766]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,574.731],[838.972,687.488],[988.962,574.509],[988.962,686.559]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[838.972,700.498],[838.972,813.255],[988.962,699.487],[988.962,811.537]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[947.158,299.426],[947.158,192.598],[1087.07,302.792],[1087.07,197.464]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[983.262,828.869],[983.262,939.612],[975.643,826.705],[975.643,936.62]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[980.204,433.396],[980.204,322.369],[1376.93,441.222],[1376.93,338.402]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[980.204,559.327],[980.204,448.3],[1376.93,557.843],[1376.93,455.023]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[980.204,577.849],[980.204,688.876],[1376.93,574.996],[1376.93,677.815]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[980.204,701.687],[980.204,812.714],[1376.93,689.679],[1376.93,792.498]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[983.262,828.869],[983.262,939.612],[1118.67,821.558],[1118.67,929.505]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1087.07,302.792],[1087.07,197.464],[1230.07,309.221],[1230.07,206.756]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1230.07,309.221],[1230.07,206.756],[1253.62,311.025],[1253.62,209.361]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1253.62,311.025],[1253.62,209.361],[1331.35,316.713],[1331.35,217.584]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1257.62,814.054],[1257.62,919.132],[1379.68,807.463],[1379.68,910.021]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1337.03,316.767],[1337.03,217.664],[1416.42,325.099],[1416.42,229.707]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1369.88,805.606],[1369.88,907.454],[1483.12,799.546],[1483.12,899.076]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1400.11,437.207],[1400.11,333.756],[1484.07,441.056],[1484.07,341.506]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1400.11,554.545],[1400.11,451.094],[1484.07,553.968],[1484.07,454.418]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1400.11,571.803],[1400.11,675.255],[1484.07,570.576],[1484.07,670.126]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1400.11,687.191],[1400.11,790.642],[1484.07,681.612],[1484.07,781.162]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1416.42,325.099],[1416.42,229.707],[1456.51,331.365],[1456.51,238.764]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1432.67,792.341],[1432.67,889.117],[1545.54,786.528],[1545.54,881.081]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1437.69,341.804],[1437.69,253.853],[1465.02,342.904],[1465.02,255.442]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1438.15,444.022],[1438.15,347.478],[1543.53,446.066],[1543.53,351.595]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1438.15,569.63],[1438.15,666.173],[1543.53,568.978],[1543.53,663.448]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1438.15,677.312],[1438.15,773.855],[1543.53,674.348],[1543.53,768.819]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1456.51,331.365],[1456.51,238.764],[1469,337.61],[1469,247.791]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1438.15,553.524],[1438.15,456.981],[1543.53,553.218],[1543.53,458.747]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1516.91,447.636],[1516.91,354.757],[1565.44,448.557],[1565.44,356.61]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1516.91,568.477],[1516.91,661.356],[1565.44,568.183],[1565.44,660.129]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1516.91,672.072],[1516.91,764.951],[1565.44,670.738],[1565.44,762.684]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1517.89,782.206],[1517.89,875.106],[1564.13,779.879],[1564.13,871.89]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:67,
                    verts:[[1516.91,552.982],[1516.91,460.103],[1565.44,552.844],[1565.44,460.898]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[474.067,441.191],[474.067,341.779],[405.858,449.711],[405.858,358.936]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[474.067,553.948],[474.067,454.535],[405.858,552.671],[405.858,461.896]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[474.067,570.532],[474.067,669.945],[405.858,567.815],[405.858,658.59]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[474.067,681.415],[474.067,780.828],[405.858,669.063],[405.858,759.838]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[474.067,799.238],[474.067,898.65],[405.858,776.649],[405.858,867.424]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[484.703,766.871],[484.703,853.907],[472.458,763.368],[472.458,849.065]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[557.145,430.814],[557.145,320.88],[474.496,441.138],[474.496,341.671]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[486.909,453.442],[486.909,366.448],[475.071,454.715],[475.071,369.012]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[557.145,555.503],[557.145,445.57],[474.496,553.956],[474.496,454.489]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[486.909,566.625],[486.909,653.618],[475.071,566.219],[475.071,651.921]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[557.145,573.843],[557.145,683.776],[474.496,570.55],[474.496,670.017]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[486.909,663.655],[486.909,750.649],[475.071,661.81],[475.071,747.512]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[557.145,696.46],[557.145,806.393],[474.496,681.493],[474.496,780.96]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[557.483,826.863],[557.483,936.84],[474.773,799.472],[474.773,898.974]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[498.331,327.306],[498.331,232.897],[494.665,332.266],[494.665,240.067]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[502.701,323.644],[502.701,227.604],[498.331,327.306],[498.331,232.897]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[513.859,318.115],[513.859,219.612],[502.701,323.644],[502.701,227.604]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[527.924,333.735],[527.924,242.19],[510.941,337.896],[510.941,248.204]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[542.783,312.662],[542.783,211.731],[514.143,317.682],[514.143,218.986]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[565.578,309.333],[565.578,206.919],[542.783,312.662],[542.783,211.731]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,429.024],[632.274,317.277],[557.145,430.814],[557.145,320.88]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,555.771],[632.274,444.024],[557.145,555.503],[557.145,445.57]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,574.414],[632.274,686.161],[557.145,573.843],[557.145,683.776]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,699.054],[632.274,810.802],[557.145,696.46],[557.145,806.393]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[633.081,831.576],[633.081,943.354],[557.483,826.863],[557.483,936.84]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[583.376,758.339],[583.376,842.113],[561.642,753.015],[561.642,834.753]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[584.097,456.673],[584.097,372.956],[562.27,458.687],[562.27,377.011]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[584.097,565.594],[584.097,649.311],[562.27,564.952],[562.27,646.627]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[584.097,658.97],[584.097,742.688],[562.27,656.051],[562.27,737.727]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[600.608,304.685],[600.608,200.199],[565.578,309.333],[565.578,206.919]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[600.609,304.685],[600.609,200.199],[637.413,306.569],[637.413,202.923]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,429.024],[632.274,317.277],[698.927,430.639],[698.927,320.529]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,555.771],[632.274,444.024],[698.927,555.529],[698.927,445.419]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,574.414],[632.274,686.161],[698.927,573.898],[698.927,684.009]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[632.274,699.054],[632.274,810.802],[698.927,696.713],[698.927,806.823]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[633.081,831.576],[633.081,943.354],[696.613,827.493],[696.613,937.709]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[660.131,300.996],[660.131,194.867],[637.413,306.569],[637.413,202.923]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[742.513,298.389],[742.513,191.1],[660.131,300.996],[660.131,194.867]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[716.957,833.312],[716.957,945.754],[696.613,827.493],[696.613,937.709]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,428.528],[718.552,316.278],[698.927,430.639],[698.927,320.529]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,555.846],[718.552,443.596],[698.927,555.529],[698.927,445.419]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,574.572],[718.552,686.822],[698.927,573.898],[698.927,684.009]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,699.773],[718.552,812.023],[698.927,696.713],[698.927,806.823]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[716.957,833.312],[716.957,945.754],[860.676,823.846],[860.676,932.669]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,428.529],[718.552,316.278],[852.998,431.864],[852.998,322.996]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,555.846],[718.552,443.596],[852.998,555.346],[852.998,446.477]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,574.572],[718.552,686.822],[852.998,573.508],[852.998,682.376]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[718.552,699.773],[718.552,812.023],[852.998,694.937],[852.998,803.806]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[842.535,298.44],[742.513,298.389],[842.535,191.172],[742.513,191.099]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[842.535,298.44],[842.535,191.172],[983.899,300.793],[983.899,194.574]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[890.324,833.532],[890.324,946.058],[851.436,824.005],[851.436,932.889]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,428.256],[892.103,315.73],[852.998,431.864],[852.998,322.996]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,555.887],[892.103,443.36],[852.998,555.346],[852.998,446.477]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,574.659],[892.103,687.185],[852.998,573.508],[852.998,682.376]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,700.168],[892.103,812.694],[852.998,694.937],[852.998,803.806]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[890.324,833.532],[890.324,946.058],[1020.66,824.594],[1020.66,933.702]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,428.256],[892.103,315.73],[1038.9,429.621],[1038.9,318.479]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,555.887],[892.103,443.36],[1038.9,555.682],[1038.9,444.54]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,574.659],[892.103,687.185],[1038.9,574.223],[1038.9,685.365]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[892.103,700.168],[892.103,812.694],[1038.9,698.189],[1038.9,809.331]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[985.109,300.834],[985.109,194.633],[1119.05,305.486],[1119.05,201.358]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1030.15,826.628],[1030.15,936.514],[1020.66,824.594],[1020.66,933.702]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1027.82,434.205],[1027.82,324.026],[1393.26,443.447],[1393.26,342.962]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1027.82,559.174],[1027.82,448.995],[1393.26,557.421],[1393.26,456.935]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1027.82,577.554],[1027.82,687.733],[1393.26,574.184],[1393.26,674.67]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1027.82,700.445],[1027.82,810.625],[1393.26,686.264],[1393.26,786.749]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1030.15,826.628],[1030.15,936.514],[1156.12,817.908],[1156.12,924.46]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1119.05,305.486],[1119.05,201.358],[1251.28,313.095],[1251.28,212.356]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1251.28,313.095],[1251.28,212.356],[1272.14,315.065],[1272.14,215.201]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1272.14,315.064],[1272.14,215.201],[1341,321.283],[1341,224.19]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1284.03,809.053],[1284.03,912.219],[1395.27,801.353],[1395.27,901.574]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1346.39,321.386],[1346.39,224.34],[1413.67,330.138],[1413.67,236.99]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1384.25,799.659],[1384.25,899.233],[1486.67,792.636],[1486.67,889.524]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1413.67,330.138],[1413.67,236.99],[1445.36,336.527],[1445.36,246.225]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1416.64,346.471],[1416.64,260.598],[1441.54,347.746],[1441.54,262.441]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1416.84,439.623],[1416.84,338.621],[1487.62,443.666],[1487.62,346.763]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1416.84,554.183],[1416.84,453.181],[1487.62,553.577],[1487.62,456.674]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1416.84,571.033],[1416.84,672.035],[1487.62,569.743],[1487.62,666.646]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1416.84,683.688],[1416.84,784.691],[1487.62,677.827],[1487.62,774.73]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1432.36,786.191],[1432.36,880.615],[1534.24,779.481],[1534.24,871.339]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1437.05,446.354],[1437.05,352.175],[1532.15,448.714],[1532.15,356.927]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1437.05,568.885],[1437.05,663.064],[1532.15,568.133],[1532.15,659.92]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1437.05,673.93],[1437.05,768.109],[1532.15,670.51],[1532.15,762.297]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1445.36,336.527],[1445.36,246.225],[1450.79,342.66],[1450.79,255.091]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1437.05,553.174],[1437.05,458.996],[1532.15,552.821],[1532.15,461.034]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1503.32,450.13],[1503.32,359.779],[1547.01,451.189],[1547.01,361.911]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1503.32,567.681],[1503.32,658.032],[1547.01,567.343],[1547.01,656.621]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1503.32,668.457],[1503.32,758.808],[1547.01,666.922],[1547.01,756.199]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1504.3,775.583],[1504.3,865.95],[1545.93,772.907],[1545.93,862.251]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:68,
                    verts:[[1503.32,552.608],[1503.32,462.258],[1547.01,552.45],[1547.01,463.172]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[491.211,439.923],[491.211,339.224],[399.193,448.205],[399.193,355.902]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[491.211,554.138],[491.211,453.44],[399.193,552.897],[399.193,460.594]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[491.211,570.937],[491.211,671.636],[399.193,568.295],[399.193,660.598]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[491.211,683.254],[491.211,783.953],[399.193,671.248],[399.193,763.55]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[491.211,802.601],[491.211,903.299],[399.193,780.644],[399.193,872.946]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[471.222,770.048],[471.222,858.299],[455.254,766.647],[455.254,853.598]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[473.386,452.251],[473.386,364.051],[457.961,453.487],[457.961,366.54]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[473.386,567.004],[473.386,655.205],[457.961,566.61],[457.961,653.558]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[473.386,665.381],[473.386,753.581],[457.961,663.589],[457.961,750.537]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[602.343,429.921],[602.343,319.082],[491.788,439.871],[491.788,339.12]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[602.343,555.637],[602.343,444.799],[491.788,554.146],[491.788,453.395]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[602.343,574.128],[602.343,684.966],[491.788,570.954],[491.788,671.705]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[602.343,697.754],[602.343,808.593],[491.788,683.329],[491.788,784.081]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[602.793,829.226],[602.793,940.106],[492.161,802.827],[492.161,903.613]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[503.65,324.654],[503.65,229.064],[494.371,329.59],[494.371,236.199]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[512.203,321.027],[512.203,223.821],[503.65,324.654],[503.65,229.064]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[526.873,331.348],[526.873,238.739],[504.833,335.37],[504.833,244.552]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[529.778,315.598],[529.778,215.974],[512.203,321.027],[512.203,223.821]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[565.403,310.422],[565.403,208.492],[530.547,315.168],[530.547,215.353]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[564.311,760.579],[564.311,845.209],[537.017,755.445],[537.017,838.112]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[564.907,455.831],[564.907,371.26],[537.505,457.773],[537.505,375.17]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[564.907,565.863],[564.907,650.434],[537.505,565.243],[537.505,647.846]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[564.907,660.192],[564.907,744.763],[537.505,657.377],[537.505,739.98]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[592.338,307.317],[592.338,204.005],[565.403,310.422],[565.403,208.492]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[633.102,303.025],[633.102,197.801],[592.338,307.317],[592.338,204.005]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,428.482],[683.074,316.185],[602.343,429.921],[602.343,319.082]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,555.853],[683.074,443.556],[602.343,555.637],[602.343,444.799]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,574.586],[683.074,686.884],[602.343,574.128],[602.343,684.966]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,699.84],[683.074,812.137],[602.343,697.755],[602.343,808.593]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.964,833.003],[683.964,945.326],[602.793,829.226],[602.793,940.106]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[633.103,303.025],[633.103,197.801],[668.375,305.254],[668.375,201.023]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[697.458,299.941],[697.458,193.343],[668.375,305.254],[668.375,201.023]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,428.482],[683.074,316.185],[746.33,430.382],[746.33,320.01]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,555.853],[683.074,443.556],[746.33,555.568],[746.33,445.197]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,574.586],[683.074,686.884],[746.33,573.981],[746.33,684.352]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.074,699.84],[683.074,812.137],[746.33,697.086],[746.33,807.457]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[683.964,833.003],[683.964,945.326],[744.259,828.199],[744.259,938.686]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[783.264,298.169],[783.264,190.781],[697.458,299.941],[697.458,193.343]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[770.147,833.713],[770.147,946.308],[744.259,828.199],[744.259,938.686]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,428.382],[771.282,315.984],[746.33,430.382],[746.33,320.01]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,555.868],[771.282,443.47],[746.33,555.568],[746.33,445.197]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,574.618],[771.282,687.016],[746.33,573.98],[746.33,684.352]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,699.985],[771.282,812.383],[746.33,697.086],[746.33,807.457]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[770.147,833.713],[770.147,946.308],[904.976,822.689],[904.976,931.069]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,428.382],[771.282,315.984],[897.455,432.268],[897.455,323.809]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,555.868],[771.282,443.47],[897.455,555.285],[897.455,446.826]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,574.618],[771.282,687.016],[897.455,573.379],[897.455,681.838]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[771.282,699.985],[771.282,812.383],[897.455,694.352],[897.455,802.811]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[783.264,298.169],[883.185,299.199],[783.264,190.781],[883.185,192.27]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[883.185,299.199],[883.185,192.27],[1020.61,302.875],[1020.61,197.583]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,428.895],[945.052,317.017],[897.455,432.268],[897.455,323.809]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,555.791],[945.052,443.913],[897.455,555.285],[897.455,446.826]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,574.455],[945.052,686.333],[897.455,573.379],[897.455,681.838]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,699.241],[945.052,811.119],[897.455,694.352],[897.455,802.811]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[943.29,831.858],[943.29,943.745],[895.937,822.952],[895.937,931.433]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[943.29,831.858],[943.29,943.745],[1063.6,821.59],[1063.6,929.55]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,428.895],[945.052,317.017],[1086.3,430.88],[1086.3,321.015]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,555.791],[945.052,443.913],[1086.3,555.493],[1086.3,445.628]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,574.455],[945.052,686.333],[1086.3,573.821],[1086.3,683.687]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[945.052,699.241],[945.052,811.119],[1086.3,696.363],[1086.3,806.229]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1021.76,302.926],[1021.76,197.658],[1148,308.731],[1148,206.048]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1074.75,823.469],[1063.6,821.59],[1074.75,932.147],[1063.6,929.55]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1073.17,435.354],[1073.17,326.38],[1403.81,445.769],[1403.81,347.719]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1073.17,558.956],[1073.17,449.982],[1403.81,556.981],[1403.81,458.93]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1073.17,577.135],[1073.17,686.109],[1403.81,573.338],[1403.81,671.388]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1073.17,698.683],[1073.17,807.657],[1403.81,682.701],[1403.81,780.751]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1074.75,823.469],[1074.75,932.147],[1189.75,813.555],[1189.75,918.442]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1148,308.731],[1148,206.048],[1268.23,317.329],[1268.23,218.476]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1268.23,317.329],[1268.23,218.476],[1286.3,319.423],[1286.3,221.501]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1286.3,319.423],[1286.3,221.501],[1346.02,326.041],[1346.02,231.067]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1305.42,803.583],[1305.42,904.657],[1405.13,794.987],[1405.13,892.775]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1351.08,326.186],[1351.08,231.278],[1406.39,335.203],[1406.39,244.311]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1392.47,351.008],[1392.47,267.157],[1414.91,352.426],[1414.91,269.207]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1393.12,793.465],[1393.12,890.671],[1484.35,785.679],[1484.35,879.907]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1406.39,335.203],[1406.39,244.311],[1430.04,341.623],[1430.04,253.591]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1427.14,779.996],[1427.14,872.051],[1517.88,772.577],[1517.88,861.795]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1427.48,442.135],[1427.48,343.678],[1485.29,446.295],[1485.29,352.055]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1427.48,553.807],[1427.48,455.35],[1485.29,553.183],[1485.29,458.944]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1427.48,570.231],[1427.48,668.688],[1485.29,568.905],[1485.29,663.144]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1427.48,680.047],[1427.48,778.504],[1485.29,674.017],[1485.29,768.256]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1431.03,448.699],[1431.03,356.898],[1515.74,451.308],[1515.74,362.151]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1431.03,568.138],[1431.03,659.939],[1515.74,567.305],[1515.74,656.462]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1431.03,670.531],[1431.03,762.332],[1515.74,666.749],[1515.74,755.906]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1485.19,452.57],[1485.19,364.694],[1524.07,453.738],[1524.07,367.045]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1431.03,552.823],[1431.03,461.021],[1515.74,552.432],[1515.74,463.275]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1485.19,664.918],[1485.19,752.795],[1524.07,663.226],[1524.07,749.919]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1486.15,769.102],[1486.15,856.991],[1523.2,766.151],[1523.2,852.911]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1485.19,566.903],[1485.19,654.779],[1524.07,566.53],[1524.07,653.223]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:69,
                    verts:[[1485.19,552.243],[1485.19,464.366],[1524.07,552.068],[1524.07,465.375]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[513.721,438.866],[513.721,337.097],[398.135,446.792],[398.135,353.057]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[513.721,554.297],[513.721,452.527],[398.135,553.109],[398.135,459.374]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[513.721,571.274],[513.721,673.044],[398.135,568.746],[398.135,662.481]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[513.721,684.786],[513.721,786.556],[398.135,673.296],[398.135,767.031]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[513.721,805.402],[513.721,907.172],[398.135,784.389],[398.135,878.124]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[462.327,773.062],[462.327,862.466],[442.648,769.805],[442.648,857.964]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[464.427,451.122],[464.427,361.777],[445.429,452.306],[445.429,364.161]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[464.427,567.365],[464.427,656.709],[445.429,566.987],[445.429,655.132]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[464.427,667.018],[464.427,756.363],[445.429,665.302],[445.429,753.447]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[513.826,322.34],[513.826,225.719],[498.868,327.191],[498.868,232.73]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[530.23,329.225],[530.23,235.671],[503.221,333.056],[503.221,241.209]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[526.579,318.796],[526.579,220.597],[513.826,322.34],[513.826,225.719]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[651.845,429.396],[651.845,318.024],[514.443,438.817],[514.443,336.997]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[651.845,555.716],[651.845,444.345],[514.443,554.304],[514.443,452.484]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[651.845,574.295],[651.845,685.666],[514.443,571.29],[514.443,673.11]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[651.845,698.516],[651.845,809.887],[514.443,684.858],[514.443,786.678]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[652.401,830.613],[652.401,942.022],[514.908,805.618],[514.908,907.47]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[548.815,762.725],[548.815,848.175],[516.033,757.838],[516.033,841.42]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[549.279,455.023],[549.279,369.634],[516.375,456.872],[516.375,373.355]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[549.279,566.12],[549.279,651.51],[516.375,565.531],[516.375,649.047]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[549.279,661.362],[549.279,746.752],[516.375,658.683],[516.375,742.199]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[550.517,313.542],[550.517,213.002],[526.579,318.796],[526.579,220.597]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[592.516,308.719],[592.516,206.031],[551.774,313.121],[551.774,212.394]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[623.292,305.887],[623.292,201.938],[592.516,308.719],[592.516,206.031]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[669.279,302.017],[669.279,196.344],[623.292,305.887],[623.292,201.938]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,428.332],[736.883,315.883],[651.845,429.396],[651.845,318.025]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,555.875],[736.883,443.426],[651.845,555.716],[651.845,444.345]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,574.634],[736.883,687.083],[651.845,574.295],[651.845,685.666]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,700.057],[736.883,812.506],[651.845,698.516],[651.845,809.887]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[737.843,833.388],[737.843,945.859],[652.401,830.613],[652.401,942.022]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[669.279,302.017],[669.279,196.344],[702.497,304.561],[702.497,200.02]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[737.543,299.584],[737.543,192.827],[702.497,304.561],[702.497,200.02]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,428.332],[736.883,315.883],[795.713,430.485],[795.713,320.219]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,555.875],[736.883,443.426],[795.713,555.552],[795.713,445.286]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,574.634],[736.883,687.083],[795.713,573.948],[795.713,684.214]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[736.883,700.057],[736.883,812.506],[795.713,696.936],[795.713,807.202]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.47,298.665],[825.47,191.498],[737.543,299.584],[737.543,192.827]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[737.843,833.388],[737.843,945.859],[793.919,827.945],[793.919,938.334]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[824.885,833.07],[824.885,945.419],[793.919,827.945],[793.919,938.334]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,428.627],[825.545,316.477],[795.713,430.485],[795.713,320.219]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,555.831],[825.545,443.681],[795.713,555.552],[795.713,445.286]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,574.54],[825.545,686.691],[795.713,573.947],[795.713,684.214]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,699.63],[825.545,811.781],[795.713,696.936],[795.713,807.202]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.47,298.665],[825.47,191.498],[923.797,300.636],[923.797,194.347]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,428.627],[825.545,316.477],[941.572,432.989],[941.572,325.262]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,555.831],[825.545,443.681],[941.572,555.177],[941.572,447.45]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,574.54],[825.545,686.691],[941.572,573.149],[941.572,680.876]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[825.545,699.63],[825.545,811.781],[941.572,693.306],[941.572,801.034]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[824.885,833.07],[824.885,945.419],[948.824,820.696],[948.824,928.313]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[923.797,300.636],[923.797,194.347],[1055.4,305.527],[1055.4,201.416]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[994.961,829.23],[994.961,940.111],[940.121,821.055],[940.121,928.81]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,429.894],[996.678,319.029],[941.572,432.989],[941.572,325.262]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,555.641],[996.678,444.776],[941.572,555.177],[941.572,447.45]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,574.136],[996.678,685.002],[941.572,573.149],[941.572,680.876]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,697.793],[996.678,808.658],[941.572,693.306],[941.572,801.034]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[994.961,829.23],[994.961,940.111],[1103.74,817.854],[1103.74,924.385]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,429.894],[996.678,319.029],[1130.35,432.436],[1130.35,324.147]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,555.641],[996.678,444.776],[1130.35,555.26],[1130.35,446.971]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,574.136],[996.678,685.002],[1130.35,573.325],[1130.35,681.614]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[996.678,697.793],[996.678,808.659],[1130.35,694.108],[1130.35,802.397]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1056.48,305.587],[1056.48,201.504],[1173.63,312.393],[1173.63,211.341]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1116.31,819.559],[1103.74,817.854],[1116.31,926.742],[1103.74,924.385]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1115.46,436.781],[1115.46,329.303],[1409.08,448.125],[1409.08,352.545]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1115.46,558.685],[1115.46,451.207],[1409.08,556.534],[1409.08,460.954]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1115.46,576.615],[1115.46,684.093],[1409.08,572.479],[1409.08,668.058]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1115.46,696.494],[1115.46,803.972],[1409.08,679.086],[1409.08,774.666]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1116.31,819.559],[1116.31,926.742],[1219.23,808.679],[1219.23,911.702]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1173.63,312.393],[1173.63,211.341],[1281.04,321.786],[1281.04,224.919]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1281.04,321.786],[1281.04,224.919],[1296.29,323.967],[1296.29,228.069]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1296.29,323.967],[1296.29,228.069],[1346.85,330.863],[1346.85,238.036]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1321.9,797.825],[1321.9,896.697],[1409.74,788.539],[1409.74,883.86]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1351.53,331.044],[1351.53,238.3],[1395.22,340.19],[1395.22,251.52]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1365.85,355.35],[1365.85,273.433],[1385.86,356.882],[1385.86,275.647]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1395.22,340.19],[1395.22,251.52],[1411.26,346.564],[1411.26,260.734]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1396.96,787.189],[1396.96,881.995],[1476.95,778.825],[1476.95,870.432]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1417.66,773.888],[1417.66,863.607],[1497.37,765.929],[1497.37,852.605]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1420.79,451.007],[1420.79,361.546],[1495.21,453.806],[1495.21,367.181]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1420.79,552.477],[1420.79,463.016],[1495.21,552.058],[1495.21,465.433]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1420.79,567.401],[1420.79,656.862],[1495.21,566.509],[1495.21,653.133]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1420.79,667.184],[1420.79,756.646],[1495.21,663.128],[1495.21,749.752]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1432.53,444.674],[1432.53,348.793],[1477.86,448.883],[1477.86,357.269]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1432.53,553.426],[1432.53,457.544],[1477.86,552.795],[1477.86,461.181]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1432.53,569.421],[1432.53,665.303],[1477.86,568.079],[1477.86,659.693]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1432.53,676.366],[1432.53,772.247],[1477.86,670.264],[1477.86,761.878]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1463.36,454.919],[1463.36,369.422],[1497.52,456.169],[1497.52,371.94]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1463.36,566.154],[1463.36,651.65],[1497.52,565.755],[1497.52,649.983]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1463.36,661.514],[1463.36,747.01],[1497.52,659.702],[1497.52,743.93]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1464.3,762.866],[1464.3,848.371],[1496.86,759.706],[1496.86,844.003]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:70,
                    verts:[[1463.36,551.891],[1463.36,466.395],[1497.52,551.703],[1497.52,467.475]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[541.087,438.021],[541.087,335.394],[402.629,445.479],[402.629,350.414]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[541.087,554.423],[541.087,451.796],[402.629,553.305],[402.629,458.24]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[541.087,571.544],[541.087,674.17],[402.629,569.165],[402.629,664.23]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[541.087,686.011],[541.087,788.638],[402.629,675.199],[402.629,770.264]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[541.087,807.643],[541.087,910.27],[402.629,787.869],[402.629,882.935]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[458.037,775.909],[458.037,866.401],[434.71,772.836],[434.71,862.153]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[460.05,450.056],[460.05,359.63],[437.541,451.173],[437.541,361.879]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[460.05,567.705],[460.05,658.13],[437.541,567.349],[437.541,656.643]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[460.05,668.564],[460.05,758.989],[437.541,666.945],[437.541,756.239]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[537.282,454.248],[537.282,368.073],[499.008,455.983],[499.008,371.566]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[537.282,566.367],[537.282,652.543],[499.008,565.814],[499.008,650.231]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[537.282,662.486],[537.282,748.661],[499.008,659.971],[499.008,744.388]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[536.957,764.783],[536.957,851.021],[498.82,760.196],[498.82,844.68]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[537.825,327.363],[537.825,232.979],[506.014,330.956],[506.014,238.173]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[528.579,320.364],[528.579,222.862],[507.977,325.068],[507.977,229.662]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[545.472,316.947],[545.472,217.925],[528.579,320.364],[528.579,222.862]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[704.489,429.219],[704.489,317.669],[541.947,437.975],[541.947,335.301]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[704.489,555.742],[704.489,444.192],[541.947,554.43],[541.947,451.757]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[704.489,574.351],[704.489,685.901],[541.947,571.559],[541.947,674.232]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[704.489,698.772],[704.489,810.322],[541.947,686.079],[541.947,788.752]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[705.143,831.073],[705.143,942.659],[542.501,807.845],[542.501,910.549]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[575.594,311.938],[575.594,210.684],[545.472,316.947],[545.472,217.925]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[623.506,307.535],[623.506,204.32],[577.333,311.531],[577.333,210.095]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[657.737,305.016],[657.737,200.678],[623.506,307.535],[623.506,204.32]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[708.322,301.62],[708.322,195.77],[657.737,305.015],[657.737,200.678]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,428.543],[792.452,316.308],[704.489,429.219],[704.489,317.669]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,555.844],[792.452,443.609],[704.489,555.742],[704.489,444.192]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,574.567],[792.452,686.802],[704.489,574.351],[704.489,685.901]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,699.751],[792.452,811.986],[704.489,698.772],[704.489,810.322]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[793.466,832.816],[793.466,945.069],[705.143,831.073],[705.143,942.659]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[708.323,301.62],[708.323,195.77],[739.021,304.442],[739.021,199.849]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[779.5,299.866],[779.5,193.235],[739.021,304.442],[739.021,199.849]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[868.246,299.794],[779.5,299.866],[868.246,193.13],[779.5,193.235]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,428.543],[792.452,316.308],[845.985,430.913],[845.985,321.08]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,555.844],[792.452,443.609],[845.985,555.488],[845.985,445.656]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,574.567],[792.452,686.802],[845.985,573.811],[845.985,683.644]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[792.452,699.751],[792.452,811.986],[845.985,696.316],[845.985,806.149]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[793.466,832.816],[793.466,945.069],[844.491,826.825],[844.491,936.786]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[879.955,831.497],[879.955,943.246],[844.491,826.825],[844.491,936.786]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,429.219],[880.139,317.669],[845.985,430.913],[845.985,321.08]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,555.742],[880.139,444.192],[845.985,555.488],[845.985,445.656]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,574.351],[880.139,685.902],[845.985,573.811],[845.985,683.644]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,698.772],[880.139,810.322],[845.985,696.316],[845.985,806.149]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[868.246,299.794],[868.246,193.13],[963.61,302.646],[963.61,197.252]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,429.219],[880.139,317.669],[984.523,433.978],[984.523,327.252]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,555.742],[880.139,444.192],[984.523,555.029],[984.523,448.304]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,574.351],[880.139,685.902],[984.523,572.833],[984.523,679.559]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[880.139,698.772],[880.139,810.322],[984.523,691.873],[984.523,798.599]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[879.955,831.497],[879.955,943.246],[991.41,818.003],[991.41,924.591]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[963.61,302.646],[963.61,197.252],[1087.8,308.621],[1087.8,205.889]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,431.19],[1046.04,321.638],[984.523,433.978],[984.523,327.252]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,555.447],[1046.04,445.895],[984.523,555.029],[984.523,448.304]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,573.723],[1046.04,683.275],[984.523,572.833],[984.523,679.559]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,695.915],[1046.04,805.467],[984.523,691.873],[984.523,798.599]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1044.39,825.814],[1044.39,935.388],[983.157,818.449],[983.157,925.208]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1044.39,825.814],[1044.39,935.388],[1140.57,813.56],[1140.57,918.449]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,431.19],[1046.04,321.638],[1170.49,434.215],[1170.49,327.73]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,555.447],[1046.04,445.895],[1170.49,554.994],[1170.49,448.509]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,573.723],[1046.04,683.275],[1170.49,572.758],[1170.49,679.242]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1046.04,695.915],[1046.04,805.467],[1170.49,691.529],[1170.49,798.013]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1088.79,308.69],[1088.79,205.989],[1195.82,316.338],[1195.82,217.043]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1154.3,815.08],[1140.57,813.56],[1154.3,920.55],[1140.57,918.449]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1154.15,438.419],[1154.15,332.658],[1409.64,450.46],[1409.64,357.329]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1154.15,558.375],[1154.15,452.615],[1409.64,556.091],[1409.64,462.961]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1154.15,576.018],[1154.15,681.778],[1409.64,571.628],[1409.64,664.758]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1154.15,693.98],[1154.15,799.74],[1409.64,675.504],[1409.64,768.634]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1154.3,815.08],[1154.3,920.55],[1244.45,803.458],[1244.45,904.484]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1195.82,316.338],[1195.82,217.043],[1289.96,326.341],[1289.96,231.503]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1289.96,326.341],[1289.96,231.503],[1302.41,328.574],[1302.41,234.728]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1302.41,328.574],[1302.41,234.728],[1343.95,335.64],[1343.95,244.942]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1333.76,791.942],[1333.76,888.565],[1409.68,782.153],[1409.68,875.034]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1337.41,359.444],[1337.41,279.35],[1355.04,361.064],[1355.04,281.692]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1348.25,335.852],[1348.25,245.25],[1380.82,345.012],[1380.82,258.491]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1380.82,345.012],[1380.82,258.491],[1389.73,351.28],[1389.73,267.55]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1396.34,780.974],[1396.34,873.403],[1465.24,772.196],[1465.24,861.269]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1404.6,767.974],[1404.6,855.432],[1473.56,759.624],[1473.56,843.89]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1407,453.239],[1407,366.04],[1471.4,456.175],[1471.4,371.952]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1407,566.689],[1407,653.888],[1471.4,565.753],[1471.4,649.976]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1407,663.949],[1407,751.148],[1471.4,659.693],[1471.4,743.916]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1407,552.143],[1407,464.944],[1471.4,551.703],[1471.4,467.48]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1432.64,447.184],[1432.64,353.847],[1466.12,451.387],[1466.12,362.31]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1432.64,553.05],[1432.64,459.713],[1466.12,552.42],[1466.12,463.344]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1432.64,568.621],[1432.64,661.958],[1466.12,567.28],[1466.12,656.357]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1432.64,672.727],[1432.64,766.064],[1466.12,666.634],[1466.12,755.711]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1438.61,457.144],[1438.61,373.904],[1468.22,458.455],[1468.22,376.544]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1438.61,565.444],[1438.61,648.684],[1468.22,565.026],[1468.22,646.937]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1438.61,658.288],[1438.61,741.528],[1468.22,656.388],[1468.22,738.299]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:71,
                    verts:[[1439.53,756.957],[1439.53,840.202],[1467.74,753.644],[1467.74,835.623]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[572.706,437.377],[572.706,334.097],[412.497,444.268],[412.497,347.974]]
                },{
                    num:"402",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[572.706,554.52],[572.706,451.24],[412.497,553.487],[412.497,457.193]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[572.706,571.749],[572.706,675.029],[412.497,569.551],[412.497,665.845]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[572.706,686.945],[572.706,790.225],[412.497,676.955],[412.497,773.249]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[572.706,809.351],[572.706,912.631],[412.497,791.082],[412.497,887.375]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[458.273,778.595],[458.273,870.114],[431.411,775.743],[431.411,866.172]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[460.177,449.05],[460.177,357.604],[434.267,450.086],[434.267,359.69]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[460.177,568.026],[460.177,659.471],[434.267,567.695],[434.267,658.091]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[460.177,670.022],[460.177,761.468],[434.267,668.52],[434.267,758.916]]
                },{
                    num:"502",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[528.908,453.5],[528.908,366.566],[485.453,455.103],[485.453,369.794]]
                },{
                    num:"302",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[528.908,566.606],[528.908,653.54],[485.453,566.095],[485.453,651.404]]
                },{
                    num:"202",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[528.908,663.57],[528.908,750.505],[485.453,661.247],[485.453,746.556]]
                },{
                    num:"102",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[528.728,766.769],[528.728,853.767],[485.425,762.531],[485.425,847.908]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[549.404,325.745],[549.404,230.64],[513.032,329.056],[513.032,235.427]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[547.544,318.707],[547.544,220.467],[521.423,323.209],[521.423,226.976]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[568.443,315.46],[568.443,215.775],[547.544,318.707],[547.544,220.467]]
                },{
                    num:"602",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[604.456,310.758],[604.456,208.977],[568.443,315.46],[568.443,215.775]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[759.128,429.358],[759.128,317.95],[573.694,437.334],[573.694,334.011]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[759.128,555.721],[759.128,444.313],[573.694,554.526],[573.694,451.203]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[759.128,574.307],[759.128,685.716],[573.694,571.763],[573.694,675.086]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[759.128,698.57],[759.128,809.978],[573.694,687.007],[573.694,790.33]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[759.869,830.694],[759.869,942.135],[574.331,809.536],[574.331,912.887]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[657.704,306.831],[657.704,203.302],[606.657,310.37],[606.657,208.417]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[694.942,304.654],[694.941,200.155],[657.704,306.831],[657.704,203.302]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[749.419,301.772],[749.419,195.989],[694.942,304.654],[694.941,200.155]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[749.419,301.772],[749.419,195.989],[777.204,304.832],[777.204,200.412]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,429.071],[848.62,317.372],[759.128,429.358],[759.128,317.95]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,555.764],[848.62,444.065],[759.128,555.721],[759.128,444.313]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,574.398],[848.62,686.098],[759.128,574.307],[759.128,685.716]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,698.986],[848.62,810.686],[759.128,698.57],[759.128,809.978]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[849.67,831.404],[759.869,830.694],[849.67,943.117],[759.869,942.135]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[822.492,300.706],[822.492,194.448],[777.204,304.832],[777.204,200.412]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[822.492,300.706],[910.807,301.455],[822.492,194.448],[910.807,195.531]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,429.071],[848.62,317.372],[896.167,431.618],[896.167,322.5]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,555.764],[848.62,444.065],[896.167,555.383],[896.167,446.265]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,574.399],[848.62,686.098],[896.167,573.586],[896.167,682.704]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[848.62,698.986],[848.62,810.686],[896.167,695.294],[896.167,804.412]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[849.67,831.404],[849.67,943.117],[894.987,824.966],[894.987,934.216]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.294,829.139],[934.294,939.985],[894.987,824.966],[894.987,934.216]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,430.105],[934.013,319.452],[896.167,431.618],[896.167,322.5]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,555.609],[934.013,444.957],[896.167,555.383],[896.167,446.265]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,574.069],[934.013,684.721],[896.167,573.586],[896.167,682.704]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,697.488],[934.013,808.14],[896.167,695.294],[896.167,804.412]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[910.807,301.455],[910.807,195.53],[1002.01,305.11],[1002.01,200.815]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,430.105],[934.013,319.452],[1025.65,435.177],[1025.65,329.667]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,555.61],[934.013,444.957],[1025.65,554.849],[1025.65,449.34]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,574.069],[934.013,684.721],[1025.65,572.451],[1025.65,677.961]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.013,697.488],[934.013,808.14],[1025.65,690.134],[1025.65,795.644]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[934.294,829.139],[934.294,939.985],[1032.09,814.759],[1032.09,920.107]]
                },{
                    num:"601",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1002.01,305.11],[1002.01,200.815],[1117.51,312.03],[1117.51,210.816]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1090.87,821.788],[1090.87,929.824],[1024.39,815.282],[1024.39,920.829]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,432.714],[1092.42,324.707],[1025.65,435.177],[1025.65,329.667]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,555.219],[1092.42,447.212],[1025.65,554.849],[1025.65,449.34]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,573.237],[1092.42,681.243],[1025.65,572.451],[1025.65,677.961]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,693.705],[1092.42,801.712],[1025.65,690.134],[1025.65,795.644]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1090.87,821.788],[1090.87,929.824],[1173.78,808.881],[1173.78,911.981]]
                },{
                    num:"501",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,432.714],[1092.42,324.707],[1206.43,436.147],[1206.43,331.621]]
                },{
                    num:"401",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,555.219],[1092.42,447.212],[1206.43,554.704],[1206.43,450.178]]
                },{
                    num:"301",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,573.237],[1092.42,681.243],[1206.43,572.141],[1206.43,676.667]]
                },{
                    num:"201",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1092.42,693.705],[1092.42,801.712],[1206.43,688.727],[1206.43,793.253]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1118.4,312.105],[1118.4,210.925],[1214.58,320.438],[1214.58,222.97]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1188.43,810.211],[1173.78,808.881],[1188.43,913.82],[1173.78,911.981]]
                },{
                    num:"101",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1188.43,810.211],[1188.43,913.82],[1265.48,798.055],[1265.48,897.016]]
                },{
                    num:"506",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1188.95,440.202],[1188.95,336.312],[1406.1,452.729],[1406.1,361.979]]
                },{
                    num:"406",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1188.95,558.036],[1188.95,454.147],[1406.1,555.661],[1406.1,464.911]]
                },{
                    num:"306",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1188.95,575.368],[1188.95,679.257],[1406.1,570.8],[1406.1,661.55]]
                },{
                    num:"206",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1188.95,691.244],[1188.95,795.134],[1406.1,672.021],[1406.1,762.771]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1214.58,320.438],[1214.58,222.97],[1295.32,330.884],[1295.32,238.069]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1295.32,330.884],[1295.32,238.069],[1305.05,333.14],[1305.05,241.327]]
                },{
                    num:"606",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1305.05,333.14],[1305.05,241.327],[1337.84,340.284],[1337.84,251.654]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1307.68,363.251],[1307.68,284.853],[1322.99,364.937],[1322.99,287.29]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1341.39,786.079],[1341.39,880.461],[1405.58,775.952],[1405.58,866.461]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1341.75,340.521],[1341.75,251.998],[1363.78,349.603],[1363.78,265.125]]
                },{
                    num:"605",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1363.78,349.603],[1363.78,265.125],[1366.04,355.716],[1366.04,273.961]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1388.61,762.339],[1388.61,847.643],[1447.2,753.724],[1447.2,835.734]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1390.33,455.363],[1390.33,370.317],[1445.05,458.392],[1445.05,376.417]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1390.33,566.012],[1390.33,651.058],[1445.05,565.046],[1445.05,647.021]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1390.33,660.87],[1390.33,745.916],[1445.05,656.479],[1445.05,738.454]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1391.84,774.936],[1391.84,865.057],[1449.98,765.886],[1449.98,852.546]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1390.33,551.824],[1390.33,466.779],[1445.05,551.37],[1445.05,469.395]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1411.64,459.225],[1411.64,378.095],[1436.89,460.577],[1436.89,380.818]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1411.64,655.271],[1411.64,736.401],[1436.89,653.311],[1436.89,733.07]]
                },{
                    num:"105",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1412.53,751.431],[1412.53,832.564],[1436.58,748.014],[1436.58,827.84]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1411.64,564.78],[1411.64,645.91],[1436.89,564.349],[1436.89,644.108]]
                },{
                    num:"505",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1428.47,449.619],[1428.47,358.749],[1450.83,453.77],[1450.83,367.109]]
                },{
                    num:"405",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1428.47,552.685],[1428.47,461.816],[1450.83,552.063],[1450.83,465.402]]
                },{
                    num:"305",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1428.47,567.844],[1428.47,658.713],[1450.83,566.52],[1450.83,653.181]]
                },{
                    num:"205",
                    tipo:"TorreA",
                    frame:72,
                    verts:[[1428.47,669.198],[1428.47,760.067],[1450.83,663.179],[1450.83,749.84]]
                },
                ],
                [
                
                ]
        ]
    }
}